const tokens = {
  "fonts.nanumSquareRound": {
    "value": "var(--font-nanum-square-round), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--ids-fonts-nanum-square-round)"
  },
  "fonts.mildangPretendard": {
    "value": "var(--font-pretendard-variable), var(--font-yet-hangul), ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
    "variable": "var(--ids-fonts-mildang-pretendard)"
  },
  "fonts.pretendard": {
    "value": "var(--ids-fonts-pretendard)",
    "variable": "var(--ids-fonts-pretendard)"
  },
  "fonts.lineSeedSansKr": {
    "value": "var(--ids-fonts-line-seed-sans-kr)",
    "variable": "var(--ids-fonts-line-seed-sans-kr)"
  },
  "fontSizes.10": {
    "value": "var(--ids-font-sizes-10)",
    "variable": "var(--ids-font-sizes-10)"
  },
  "fontSizes.11": {
    "value": "var(--ids-font-sizes-11)",
    "variable": "var(--ids-font-sizes-11)"
  },
  "fontSizes.12": {
    "value": "var(--ids-font-sizes-12)",
    "variable": "var(--ids-font-sizes-12)"
  },
  "fontSizes.13": {
    "value": "var(--ids-font-sizes-13)",
    "variable": "var(--ids-font-sizes-13)"
  },
  "fontSizes.14": {
    "value": "var(--ids-font-sizes-14)",
    "variable": "var(--ids-font-sizes-14)"
  },
  "fontSizes.15": {
    "value": "var(--ids-font-sizes-15)",
    "variable": "var(--ids-font-sizes-15)"
  },
  "fontSizes.16": {
    "value": "var(--ids-font-sizes-16)",
    "variable": "var(--ids-font-sizes-16)"
  },
  "fontSizes.18": {
    "value": "var(--ids-font-sizes-18)",
    "variable": "var(--ids-font-sizes-18)"
  },
  "fontSizes.20": {
    "value": "var(--ids-font-sizes-20)",
    "variable": "var(--ids-font-sizes-20)"
  },
  "fontSizes.22": {
    "value": "var(--ids-font-sizes-22)",
    "variable": "var(--ids-font-sizes-22)"
  },
  "fontSizes.24": {
    "value": "var(--ids-font-sizes-24)",
    "variable": "var(--ids-font-sizes-24)"
  },
  "fontSizes.26": {
    "value": "var(--ids-font-sizes-26)",
    "variable": "var(--ids-font-sizes-26)"
  },
  "fontSizes.28": {
    "value": "var(--ids-font-sizes-28)",
    "variable": "var(--ids-font-sizes-28)"
  },
  "fontSizes.32": {
    "value": "var(--ids-font-sizes-32)",
    "variable": "var(--ids-font-sizes-32)"
  },
  "fontSizes.40": {
    "value": "var(--ids-font-sizes-40)",
    "variable": "var(--ids-font-sizes-40)"
  },
  "fontSizes.d1": {
    "value": "3rem",
    "variable": "var(--ids-font-sizes-d1)"
  },
  "fontSizes.h1": {
    "value": "2.5rem",
    "variable": "var(--ids-font-sizes-h1)"
  },
  "fontSizes.h2": {
    "value": "2rem",
    "variable": "var(--ids-font-sizes-h2)"
  },
  "fontSizes.h3": {
    "value": "1.75rem",
    "variable": "var(--ids-font-sizes-h3)"
  },
  "fontSizes.h4": {
    "value": "1.5rem",
    "variable": "var(--ids-font-sizes-h4)"
  },
  "fontSizes.h5": {
    "value": "1.375rem",
    "variable": "var(--ids-font-sizes-h5)"
  },
  "fontSizes.h6": {
    "value": "1.25rem",
    "variable": "var(--ids-font-sizes-h6)"
  },
  "fontSizes.subtitle1": {
    "value": "1.125rem",
    "variable": "var(--ids-font-sizes-subtitle1)"
  },
  "fontSizes.subtitle2": {
    "value": "1rem",
    "variable": "var(--ids-font-sizes-subtitle2)"
  },
  "fontSizes.subtitle3": {
    "value": "0.9375rem",
    "variable": "var(--ids-font-sizes-subtitle3)"
  },
  "fontSizes.subtitle4": {
    "value": "0.875rem",
    "variable": "var(--ids-font-sizes-subtitle4)"
  },
  "fontSizes.body1": {
    "value": "1.125rem",
    "variable": "var(--ids-font-sizes-body1)"
  },
  "fontSizes.body2": {
    "value": "1rem",
    "variable": "var(--ids-font-sizes-body2)"
  },
  "fontSizes.body3": {
    "value": "0.9375rem",
    "variable": "var(--ids-font-sizes-body3)"
  },
  "fontSizes.body4": {
    "value": "0.875rem",
    "variable": "var(--ids-font-sizes-body4)"
  },
  "fontSizes.caption1": {
    "value": "0.8125rem",
    "variable": "var(--ids-font-sizes-caption1)"
  },
  "fontSizes.caption2": {
    "value": "0.75rem",
    "variable": "var(--ids-font-sizes-caption2)"
  },
  "fontSizes.button-XL": {
    "value": "1.125rem",
    "variable": "var(--ids-font-sizes-button--x-l)"
  },
  "fontSizes.button-L": {
    "value": "0.9375rem",
    "variable": "var(--ids-font-sizes-button--l)"
  },
  "fontSizes.button-M": {
    "value": "0.875rem",
    "variable": "var(--ids-font-sizes-button--m)"
  },
  "fontSizes.button-S": {
    "value": "0.8125rem",
    "variable": "var(--ids-font-sizes-button--s)"
  },
  "fontSizes.chat-body1-R": {
    "value": "0.9375rem",
    "variable": "var(--ids-font-sizes-chat-body1--r)"
  },
  "fontSizes.nanum-h1": {
    "value": "3.5rem",
    "variable": "var(--ids-font-sizes-nanum-h1)"
  },
  "fontSizes.nanum-h2": {
    "value": "3rem",
    "variable": "var(--ids-font-sizes-nanum-h2)"
  },
  "fontSizes.nanum-title1": {
    "value": "2.5rem",
    "variable": "var(--ids-font-sizes-nanum-title1)"
  },
  "fontSizes.nanum-title2": {
    "value": "2rem",
    "variable": "var(--ids-font-sizes-nanum-title2)"
  },
  "fontSizes.nanum-title3": {
    "value": "1.75rem",
    "variable": "var(--ids-font-sizes-nanum-title3)"
  },
  "fontSizes.nanum-body1-EB": {
    "value": "1.75rem",
    "variable": "var(--ids-font-sizes-nanum-body1--e-b)"
  },
  "fontSizes.nanum-body1-B": {
    "value": "1.75rem",
    "variable": "var(--ids-font-sizes-nanum-body1--b)"
  },
  "fontSizes.nanum-body2-EB": {
    "value": "1.5rem",
    "variable": "var(--ids-font-sizes-nanum-body2--e-b)"
  },
  "fontSizes.nanum-body2-B": {
    "value": "1.5rem",
    "variable": "var(--ids-font-sizes-nanum-body2--b)"
  },
  "fontSizes.nanum-body3-EB": {
    "value": "1.375rem",
    "variable": "var(--ids-font-sizes-nanum-body3--e-b)"
  },
  "fontSizes.nanum-body3-B": {
    "value": "1.375rem",
    "variable": "var(--ids-font-sizes-nanum-body3--b)"
  },
  "fontSizes.nanum-body4-EB": {
    "value": "1.25rem",
    "variable": "var(--ids-font-sizes-nanum-body4--e-b)"
  },
  "fontSizes.nanum-body4-B": {
    "value": "1.25rem",
    "variable": "var(--ids-font-sizes-nanum-body4--b)"
  },
  "fontSizes.nanum-body5-EB": {
    "value": "1.125rem",
    "variable": "var(--ids-font-sizes-nanum-body5--e-b)"
  },
  "fontSizes.nanum-body5-B": {
    "value": "1.125rem",
    "variable": "var(--ids-font-sizes-nanum-body5--b)"
  },
  "fontSizes.nanum-caption1-EB": {
    "value": "1rem",
    "variable": "var(--ids-font-sizes-nanum-caption1--e-b)"
  },
  "fontSizes.nanum-caption1-B": {
    "value": "1rem",
    "variable": "var(--ids-font-sizes-nanum-caption1--b)"
  },
  "fontSizes.nanum-caption2-EB": {
    "value": "0.875rem",
    "variable": "var(--ids-font-sizes-nanum-caption2--e-b)"
  },
  "fontSizes.nanum-caption2-B": {
    "value": "0.875rem",
    "variable": "var(--ids-font-sizes-nanum-caption2--b)"
  },
  "fontSizes.nanum-caption3-EB": {
    "value": "0.75rem",
    "variable": "var(--ids-font-sizes-nanum-caption3--e-b)"
  },
  "fontSizes.nanum-caption3-B": {
    "value": "0.75rem",
    "variable": "var(--ids-font-sizes-nanum-caption3--b)"
  },
  "fontSizes.chat-subtitle": {
    "value": "var(--ids-font-sizes-chat-subtitle)",
    "variable": "var(--ids-font-sizes-chat-subtitle)"
  },
  "fontSizes.chat-body": {
    "value": "var(--ids-font-sizes-chat-body)",
    "variable": "var(--ids-font-sizes-chat-body)"
  },
  "fontSizes.chat-caption-M": {
    "value": "var(--ids-font-sizes-chat-caption--m)",
    "variable": "var(--ids-font-sizes-chat-caption--m)"
  },
  "fontSizes.chat-caption-R": {
    "value": "var(--ids-font-sizes-chat-caption--r)",
    "variable": "var(--ids-font-sizes-chat-caption--r)"
  },
  "fontSizes.chat-small-text-M": {
    "value": "var(--ids-font-sizes-chat-small-text--m)",
    "variable": "var(--ids-font-sizes-chat-small-text--m)"
  },
  "fontSizes.chat-small-text-R": {
    "value": "var(--ids-font-sizes-chat-small-text--r)",
    "variable": "var(--ids-font-sizes-chat-small-text--r)"
  },
  "fontWeights.display.default": {
    "value": "var(--ids-font-weights-semibold)",
    "variable": "var(--ids-font-weights-display-default)"
  },
  "fontWeights.headline.default": {
    "value": "var(--ids-font-weights-bold)",
    "variable": "var(--ids-font-weights-headline-default)"
  },
  "fontWeights.subtitle.default": {
    "value": "var(--ids-font-weights-medium)",
    "variable": "var(--ids-font-weights-subtitle-default)"
  },
  "fontWeights.subtitle.strong": {
    "value": "var(--ids-font-weights-bold)",
    "variable": "var(--ids-font-weights-subtitle-strong)"
  },
  "fontWeights.body.default": {
    "value": "var(--ids-font-weights-regular)",
    "variable": "var(--ids-font-weights-body-default)"
  },
  "fontWeights.body.strong": {
    "value": "var(--ids-font-weights-bold)",
    "variable": "var(--ids-font-weights-body-strong)"
  },
  "fontWeights.caption.default": {
    "value": "var(--ids-font-weights-regular)",
    "variable": "var(--ids-font-weights-caption-default)"
  },
  "fontWeights.caption.strong": {
    "value": "var(--ids-font-weights-medium)",
    "variable": "var(--ids-font-weights-caption-strong)"
  },
  "fontWeights.regular": {
    "value": "var(--ids-font-weights-regular)",
    "variable": "var(--ids-font-weights-regular)"
  },
  "fontWeights.medium": {
    "value": "var(--ids-font-weights-medium)",
    "variable": "var(--ids-font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "var(--ids-font-weights-semibold)",
    "variable": "var(--ids-font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "var(--ids-font-weights-bold)",
    "variable": "var(--ids-font-weights-bold)"
  },
  "letterSpacings.14": {
    "value": "var(--ids-letter-spacings-14)",
    "variable": "var(--ids-letter-spacings-14)"
  },
  "letterSpacings.15": {
    "value": "var(--ids-letter-spacings-15)",
    "variable": "var(--ids-letter-spacings-15)"
  },
  "letterSpacings.16": {
    "value": "var(--ids-letter-spacings-16)",
    "variable": "var(--ids-letter-spacings-16)"
  },
  "letterSpacings.18": {
    "value": "var(--ids-letter-spacings-18)",
    "variable": "var(--ids-letter-spacings-18)"
  },
  "letterSpacings.20": {
    "value": "var(--ids-letter-spacings-20)",
    "variable": "var(--ids-letter-spacings-20)"
  },
  "letterSpacings.22": {
    "value": "var(--ids-letter-spacings-22)",
    "variable": "var(--ids-letter-spacings-22)"
  },
  "letterSpacings.24": {
    "value": "var(--ids-letter-spacings-24)",
    "variable": "var(--ids-letter-spacings-24)"
  },
  "letterSpacings.26": {
    "value": "var(--ids-letter-spacings-26)",
    "variable": "var(--ids-letter-spacings-26)"
  },
  "letterSpacings.28": {
    "value": "var(--ids-letter-spacings-28)",
    "variable": "var(--ids-letter-spacings-28)"
  },
  "letterSpacings.32": {
    "value": "var(--ids-letter-spacings-32)",
    "variable": "var(--ids-letter-spacings-32)"
  },
  "letterSpacings.40": {
    "value": "var(--ids-letter-spacings-40)",
    "variable": "var(--ids-letter-spacings-40)"
  },
  "lineHeights.18": {
    "value": "var(--ids-line-heights-18)",
    "variable": "var(--ids-line-heights-18)"
  },
  "lineHeights.20": {
    "value": "var(--ids-line-heights-20)",
    "variable": "var(--ids-line-heights-20)"
  },
  "lineHeights.22": {
    "value": "var(--ids-line-heights-22)",
    "variable": "var(--ids-line-heights-22)"
  },
  "lineHeights.24": {
    "value": "var(--ids-line-heights-24)",
    "variable": "var(--ids-line-heights-24)"
  },
  "lineHeights.26": {
    "value": "var(--ids-line-heights-26)",
    "variable": "var(--ids-line-heights-26)"
  },
  "lineHeights.28": {
    "value": "var(--ids-line-heights-28)",
    "variable": "var(--ids-line-heights-28)"
  },
  "lineHeights.30": {
    "value": "var(--ids-line-heights-30)",
    "variable": "var(--ids-line-heights-30)"
  },
  "lineHeights.32": {
    "value": "var(--ids-line-heights-32)",
    "variable": "var(--ids-line-heights-32)"
  },
  "lineHeights.34": {
    "value": "var(--ids-line-heights-34)",
    "variable": "var(--ids-line-heights-34)"
  },
  "lineHeights.36": {
    "value": "var(--ids-line-heights-36)",
    "variable": "var(--ids-line-heights-36)"
  },
  "lineHeights.38": {
    "value": "var(--ids-line-heights-38)",
    "variable": "var(--ids-line-heights-38)"
  },
  "lineHeights.40": {
    "value": "var(--ids-line-heights-40)",
    "variable": "var(--ids-line-heights-40)"
  },
  "lineHeights.44": {
    "value": "var(--ids-line-heights-44)",
    "variable": "var(--ids-line-heights-44)"
  },
  "lineHeights.54": {
    "value": "var(--ids-line-heights-54)",
    "variable": "var(--ids-line-heights-54)"
  },
  "lineHeights.56": {
    "value": "var(--ids-line-heights-56)",
    "variable": "var(--ids-line-heights-56)"
  },
  "colors.black.1200": {
    "value": "var(--ids-colors-black-1200)",
    "variable": "var(--ids-colors-black-1200)"
  },
  "colors.black.a1300": {
    "value": "rgba(30, 32, 36, 1)",
    "variable": "var(--ids-colors-black-a1300)"
  },
  "colors.black.a000": {
    "value": "var(--ids-colors-black-a000)",
    "variable": "var(--ids-colors-black-a000)"
  },
  "colors.black.a100": {
    "value": "var(--ids-colors-black-a100)",
    "variable": "var(--ids-colors-black-a100)"
  },
  "colors.black.a200": {
    "value": "var(--ids-colors-black-a200)",
    "variable": "var(--ids-colors-black-a200)"
  },
  "colors.black.a300": {
    "value": "var(--ids-colors-black-a300)",
    "variable": "var(--ids-colors-black-a300)"
  },
  "colors.black.a400": {
    "value": "var(--ids-colors-black-a400)",
    "variable": "var(--ids-colors-black-a400)"
  },
  "colors.black.a500": {
    "value": "var(--ids-colors-black-a500)",
    "variable": "var(--ids-colors-black-a500)"
  },
  "colors.black.a600": {
    "value": "var(--ids-colors-black-a600)",
    "variable": "var(--ids-colors-black-a600)"
  },
  "colors.black.a700": {
    "value": "var(--ids-colors-black-a700)",
    "variable": "var(--ids-colors-black-a700)"
  },
  "colors.black.a800": {
    "value": "var(--ids-colors-black-a800)",
    "variable": "var(--ids-colors-black-a800)"
  },
  "colors.black.a900": {
    "value": "var(--ids-colors-black-a900)",
    "variable": "var(--ids-colors-black-a900)"
  },
  "colors.black.a1000": {
    "value": "var(--ids-colors-black-a1000)",
    "variable": "var(--ids-colors-black-a1000)"
  },
  "colors.black.a1100": {
    "value": "var(--ids-colors-black-a1100)",
    "variable": "var(--ids-colors-black-a1100)"
  },
  "colors.black.a1200": {
    "value": "var(--ids-colors-black-a1200)",
    "variable": "var(--ids-colors-black-a1200)"
  },
  "colors.white.1200": {
    "value": "var(--ids-colors-white-1200)",
    "variable": "var(--ids-colors-white-1200)"
  },
  "colors.white.a1300": {
    "value": "rgba(255, 255, 255, 1)",
    "variable": "var(--ids-colors-white-a1300)"
  },
  "colors.white.a000": {
    "value": "var(--ids-colors-white-a000)",
    "variable": "var(--ids-colors-white-a000)"
  },
  "colors.white.a100": {
    "value": "var(--ids-colors-white-a100)",
    "variable": "var(--ids-colors-white-a100)"
  },
  "colors.white.a200": {
    "value": "var(--ids-colors-white-a200)",
    "variable": "var(--ids-colors-white-a200)"
  },
  "colors.white.a300": {
    "value": "var(--ids-colors-white-a300)",
    "variable": "var(--ids-colors-white-a300)"
  },
  "colors.white.a400": {
    "value": "var(--ids-colors-white-a400)",
    "variable": "var(--ids-colors-white-a400)"
  },
  "colors.white.a500": {
    "value": "var(--ids-colors-white-a500)",
    "variable": "var(--ids-colors-white-a500)"
  },
  "colors.white.a600": {
    "value": "var(--ids-colors-white-a600)",
    "variable": "var(--ids-colors-white-a600)"
  },
  "colors.white.a700": {
    "value": "var(--ids-colors-white-a700)",
    "variable": "var(--ids-colors-white-a700)"
  },
  "colors.white.a800": {
    "value": "var(--ids-colors-white-a800)",
    "variable": "var(--ids-colors-white-a800)"
  },
  "colors.white.a900": {
    "value": "var(--ids-colors-white-a900)",
    "variable": "var(--ids-colors-white-a900)"
  },
  "colors.white.a1000": {
    "value": "var(--ids-colors-white-a1000)",
    "variable": "var(--ids-colors-white-a1000)"
  },
  "colors.white.a1100": {
    "value": "var(--ids-colors-white-a1100)",
    "variable": "var(--ids-colors-white-a1100)"
  },
  "colors.white.a1200": {
    "value": "var(--ids-colors-white-a1200)",
    "variable": "var(--ids-colors-white-a1200)"
  },
  "colors.gray.light.100": {
    "value": "var(--ids-colors-gray-light-100)",
    "variable": "var(--ids-colors-gray-light-100)"
  },
  "colors.gray.light.200": {
    "value": "var(--ids-colors-gray-light-200)",
    "variable": "var(--ids-colors-gray-light-200)"
  },
  "colors.gray.light.300": {
    "value": "var(--ids-colors-gray-light-300)",
    "variable": "var(--ids-colors-gray-light-300)"
  },
  "colors.gray.light.400": {
    "value": "var(--ids-colors-gray-light-400)",
    "variable": "var(--ids-colors-gray-light-400)"
  },
  "colors.gray.light.500": {
    "value": "var(--ids-colors-gray-light-500)",
    "variable": "var(--ids-colors-gray-light-500)"
  },
  "colors.gray.light.600": {
    "value": "var(--ids-colors-gray-light-600)",
    "variable": "var(--ids-colors-gray-light-600)"
  },
  "colors.gray.light.700": {
    "value": "var(--ids-colors-gray-light-700)",
    "variable": "var(--ids-colors-gray-light-700)"
  },
  "colors.gray.light.800": {
    "value": "var(--ids-colors-gray-light-800)",
    "variable": "var(--ids-colors-gray-light-800)"
  },
  "colors.gray.light.900": {
    "value": "var(--ids-colors-gray-light-900)",
    "variable": "var(--ids-colors-gray-light-900)"
  },
  "colors.gray.light.1000": {
    "value": "var(--ids-colors-gray-light-1000)",
    "variable": "var(--ids-colors-gray-light-1000)"
  },
  "colors.gray.light.1100": {
    "value": "var(--ids-colors-gray-light-1100)",
    "variable": "var(--ids-colors-gray-light-1100)"
  },
  "colors.gray.light.1200": {
    "value": "var(--ids-colors-gray-light-1200)",
    "variable": "var(--ids-colors-gray-light-1200)"
  },
  "colors.gray.light.a100": {
    "value": "rgba(30, 32, 36, 0.06)",
    "variable": "var(--ids-colors-gray-light-a100)"
  },
  "colors.gray.light.a200": {
    "value": "rgba(30, 32, 36, 0.09)",
    "variable": "var(--ids-colors-gray-light-a200)"
  },
  "colors.gray.light.a300": {
    "value": "rgba(30, 32, 36, 0.12)",
    "variable": "var(--ids-colors-gray-light-a300)"
  },
  "colors.gray.light.a400": {
    "value": "rgba(30, 32, 36, 0.16)",
    "variable": "var(--ids-colors-gray-light-a400)"
  },
  "colors.gray.light.a500": {
    "value": "rgba(30, 32, 36, 0.20)",
    "variable": "var(--ids-colors-gray-light-a500)"
  },
  "colors.gray.light.a600": {
    "value": "rgba(30, 32, 36, 0.24)",
    "variable": "var(--ids-colors-gray-light-a600)"
  },
  "colors.gray.dark.100": {
    "value": "var(--ids-colors-gray-dark-100)",
    "variable": "var(--ids-colors-gray-dark-100)"
  },
  "colors.gray.dark.200": {
    "value": "var(--ids-colors-gray-dark-200)",
    "variable": "var(--ids-colors-gray-dark-200)"
  },
  "colors.gray.dark.300": {
    "value": "var(--ids-colors-gray-dark-300)",
    "variable": "var(--ids-colors-gray-dark-300)"
  },
  "colors.gray.dark.400": {
    "value": "var(--ids-colors-gray-dark-400)",
    "variable": "var(--ids-colors-gray-dark-400)"
  },
  "colors.gray.dark.500": {
    "value": "var(--ids-colors-gray-dark-500)",
    "variable": "var(--ids-colors-gray-dark-500)"
  },
  "colors.gray.dark.600": {
    "value": "var(--ids-colors-gray-dark-600)",
    "variable": "var(--ids-colors-gray-dark-600)"
  },
  "colors.gray.dark.700": {
    "value": "var(--ids-colors-gray-dark-700)",
    "variable": "var(--ids-colors-gray-dark-700)"
  },
  "colors.gray.dark.800": {
    "value": "var(--ids-colors-gray-dark-800)",
    "variable": "var(--ids-colors-gray-dark-800)"
  },
  "colors.gray.dark.900": {
    "value": "var(--ids-colors-gray-dark-900)",
    "variable": "var(--ids-colors-gray-dark-900)"
  },
  "colors.gray.dark.1000": {
    "value": "var(--ids-colors-gray-dark-1000)",
    "variable": "var(--ids-colors-gray-dark-1000)"
  },
  "colors.gray.dark.1100": {
    "value": "var(--ids-colors-gray-dark-1100)",
    "variable": "var(--ids-colors-gray-dark-1100)"
  },
  "colors.gray.dark.1200": {
    "value": "var(--ids-colors-gray-dark-1200)",
    "variable": "var(--ids-colors-gray-dark-1200)"
  },
  "colors.gray.dark.a100": {
    "value": "rgba(255, 255, 255, 0.12)",
    "variable": "var(--ids-colors-gray-dark-a100)"
  },
  "colors.gray.dark.a200": {
    "value": "rgba(255, 255, 255, 0.16)",
    "variable": "var(--ids-colors-gray-dark-a200)"
  },
  "colors.gray.dark.a300": {
    "value": "rgba(255, 255, 255, 0.20)",
    "variable": "var(--ids-colors-gray-dark-a300)"
  },
  "colors.gray.dark.a400": {
    "value": "rgba(255, 255, 255, 0.24)",
    "variable": "var(--ids-colors-gray-dark-a400)"
  },
  "colors.gray.dark.a500": {
    "value": "rgba(255, 255, 255, 0.32)",
    "variable": "var(--ids-colors-gray-dark-a500)"
  },
  "colors.gray.dark.a600": {
    "value": "rgba(255, 255, 255, 0.40)",
    "variable": "var(--ids-colors-gray-dark-a600)"
  },
  "colors.orange.light.100": {
    "value": "var(--ids-colors-orange-light-100)",
    "variable": "var(--ids-colors-orange-light-100)"
  },
  "colors.orange.light.200": {
    "value": "var(--ids-colors-orange-light-200)",
    "variable": "var(--ids-colors-orange-light-200)"
  },
  "colors.orange.light.300": {
    "value": "var(--ids-colors-orange-light-300)",
    "variable": "var(--ids-colors-orange-light-300)"
  },
  "colors.orange.light.400": {
    "value": "var(--ids-colors-orange-light-400)",
    "variable": "var(--ids-colors-orange-light-400)"
  },
  "colors.orange.light.500": {
    "value": "var(--ids-colors-orange-light-500)",
    "variable": "var(--ids-colors-orange-light-500)"
  },
  "colors.orange.light.600": {
    "value": "var(--ids-colors-orange-light-600)",
    "variable": "var(--ids-colors-orange-light-600)"
  },
  "colors.orange.light.650": {
    "value": "var(--ids-colors-orange-light-650)",
    "variable": "var(--ids-colors-orange-light-650)"
  },
  "colors.orange.light.700": {
    "value": "var(--ids-colors-orange-light-700)",
    "variable": "var(--ids-colors-orange-light-700)"
  },
  "colors.orange.light.800": {
    "value": "var(--ids-colors-orange-light-800)",
    "variable": "var(--ids-colors-orange-light-800)"
  },
  "colors.orange.light.900": {
    "value": "var(--ids-colors-orange-light-900)",
    "variable": "var(--ids-colors-orange-light-900)"
  },
  "colors.orange.light.1000": {
    "value": "var(--ids-colors-orange-light-1000)",
    "variable": "var(--ids-colors-orange-light-1000)"
  },
  "colors.orange.light.1100": {
    "value": "var(--ids-colors-orange-light-1100)",
    "variable": "var(--ids-colors-orange-light-1100)"
  },
  "colors.orange.light.1200": {
    "value": "var(--ids-colors-orange-light-1200)",
    "variable": "var(--ids-colors-orange-light-1200)"
  },
  "colors.orange.light.a100": {
    "value": "var(--ids-colors-orange-light-a100)",
    "variable": "var(--ids-colors-orange-light-a100)"
  },
  "colors.orange.light.a200": {
    "value": "var(--ids-colors-orange-light-a200)",
    "variable": "var(--ids-colors-orange-light-a200)"
  },
  "colors.orange.light.a300": {
    "value": "var(--ids-colors-orange-light-a300)",
    "variable": "var(--ids-colors-orange-light-a300)"
  },
  "colors.orange.light.a400": {
    "value": "var(--ids-colors-orange-light-a400)",
    "variable": "var(--ids-colors-orange-light-a400)"
  },
  "colors.orange.light.a500": {
    "value": "var(--ids-colors-orange-light-a500)",
    "variable": "var(--ids-colors-orange-light-a500)"
  },
  "colors.orange.light.a600": {
    "value": "var(--ids-colors-orange-light-a600)",
    "variable": "var(--ids-colors-orange-light-a600)"
  },
  "colors.orange.dark.100": {
    "value": "var(--ids-colors-orange-dark-100)",
    "variable": "var(--ids-colors-orange-dark-100)"
  },
  "colors.orange.dark.200": {
    "value": "var(--ids-colors-orange-dark-200)",
    "variable": "var(--ids-colors-orange-dark-200)"
  },
  "colors.orange.dark.300": {
    "value": "var(--ids-colors-orange-dark-300)",
    "variable": "var(--ids-colors-orange-dark-300)"
  },
  "colors.orange.dark.400": {
    "value": "var(--ids-colors-orange-dark-400)",
    "variable": "var(--ids-colors-orange-dark-400)"
  },
  "colors.orange.dark.500": {
    "value": "var(--ids-colors-orange-dark-500)",
    "variable": "var(--ids-colors-orange-dark-500)"
  },
  "colors.orange.dark.600": {
    "value": "var(--ids-colors-orange-dark-600)",
    "variable": "var(--ids-colors-orange-dark-600)"
  },
  "colors.orange.dark.700": {
    "value": "var(--ids-colors-orange-dark-700)",
    "variable": "var(--ids-colors-orange-dark-700)"
  },
  "colors.orange.dark.800": {
    "value": "var(--ids-colors-orange-dark-800)",
    "variable": "var(--ids-colors-orange-dark-800)"
  },
  "colors.orange.dark.900": {
    "value": "var(--ids-colors-orange-dark-900)",
    "variable": "var(--ids-colors-orange-dark-900)"
  },
  "colors.orange.dark.1000": {
    "value": "var(--ids-colors-orange-dark-1000)",
    "variable": "var(--ids-colors-orange-dark-1000)"
  },
  "colors.orange.dark.1100": {
    "value": "var(--ids-colors-orange-dark-1100)",
    "variable": "var(--ids-colors-orange-dark-1100)"
  },
  "colors.orange.dark.1200": {
    "value": "var(--ids-colors-orange-dark-1200)",
    "variable": "var(--ids-colors-orange-dark-1200)"
  },
  "colors.orange.dark.a100": {
    "value": "var(--ids-colors-orange-dark-a100)",
    "variable": "var(--ids-colors-orange-dark-a100)"
  },
  "colors.orange.dark.a200": {
    "value": "var(--ids-colors-orange-dark-a200)",
    "variable": "var(--ids-colors-orange-dark-a200)"
  },
  "colors.orange.dark.a300": {
    "value": "var(--ids-colors-orange-dark-a300)",
    "variable": "var(--ids-colors-orange-dark-a300)"
  },
  "colors.orange.dark.a400": {
    "value": "var(--ids-colors-orange-dark-a400)",
    "variable": "var(--ids-colors-orange-dark-a400)"
  },
  "colors.orange.dark.a500": {
    "value": "var(--ids-colors-orange-dark-a500)",
    "variable": "var(--ids-colors-orange-dark-a500)"
  },
  "colors.orange.dark.a600": {
    "value": "var(--ids-colors-orange-dark-a600)",
    "variable": "var(--ids-colors-orange-dark-a600)"
  },
  "colors.blue.light.100": {
    "value": "var(--ids-colors-blue-light-100)",
    "variable": "var(--ids-colors-blue-light-100)"
  },
  "colors.blue.light.200": {
    "value": "var(--ids-colors-blue-light-200)",
    "variable": "var(--ids-colors-blue-light-200)"
  },
  "colors.blue.light.300": {
    "value": "var(--ids-colors-blue-light-300)",
    "variable": "var(--ids-colors-blue-light-300)"
  },
  "colors.blue.light.400": {
    "value": "var(--ids-colors-blue-light-400)",
    "variable": "var(--ids-colors-blue-light-400)"
  },
  "colors.blue.light.500": {
    "value": "var(--ids-colors-blue-light-500)",
    "variable": "var(--ids-colors-blue-light-500)"
  },
  "colors.blue.light.600": {
    "value": "var(--ids-colors-blue-light-600)",
    "variable": "var(--ids-colors-blue-light-600)"
  },
  "colors.blue.light.700": {
    "value": "var(--ids-colors-blue-light-700)",
    "variable": "var(--ids-colors-blue-light-700)"
  },
  "colors.blue.light.800": {
    "value": "var(--ids-colors-blue-light-800)",
    "variable": "var(--ids-colors-blue-light-800)"
  },
  "colors.blue.light.900": {
    "value": "var(--ids-colors-blue-light-900)",
    "variable": "var(--ids-colors-blue-light-900)"
  },
  "colors.blue.light.1000": {
    "value": "var(--ids-colors-blue-light-1000)",
    "variable": "var(--ids-colors-blue-light-1000)"
  },
  "colors.blue.light.1100": {
    "value": "var(--ids-colors-blue-light-1100)",
    "variable": "var(--ids-colors-blue-light-1100)"
  },
  "colors.blue.light.1200": {
    "value": "var(--ids-colors-blue-light-1200)",
    "variable": "var(--ids-colors-blue-light-1200)"
  },
  "colors.blue.light.a100": {
    "value": "var(--ids-colors-blue-light-a100)",
    "variable": "var(--ids-colors-blue-light-a100)"
  },
  "colors.blue.light.a200": {
    "value": "var(--ids-colors-blue-light-a200)",
    "variable": "var(--ids-colors-blue-light-a200)"
  },
  "colors.blue.light.a300": {
    "value": "var(--ids-colors-blue-light-a300)",
    "variable": "var(--ids-colors-blue-light-a300)"
  },
  "colors.blue.light.a400": {
    "value": "var(--ids-colors-blue-light-a400)",
    "variable": "var(--ids-colors-blue-light-a400)"
  },
  "colors.blue.light.a500": {
    "value": "var(--ids-colors-blue-light-a500)",
    "variable": "var(--ids-colors-blue-light-a500)"
  },
  "colors.blue.light.a600": {
    "value": "var(--ids-colors-blue-light-a600)",
    "variable": "var(--ids-colors-blue-light-a600)"
  },
  "colors.blue.dark.100": {
    "value": "var(--ids-colors-blue-dark-100)",
    "variable": "var(--ids-colors-blue-dark-100)"
  },
  "colors.blue.dark.200": {
    "value": "var(--ids-colors-blue-dark-200)",
    "variable": "var(--ids-colors-blue-dark-200)"
  },
  "colors.blue.dark.300": {
    "value": "var(--ids-colors-blue-dark-300)",
    "variable": "var(--ids-colors-blue-dark-300)"
  },
  "colors.blue.dark.400": {
    "value": "var(--ids-colors-blue-dark-400)",
    "variable": "var(--ids-colors-blue-dark-400)"
  },
  "colors.blue.dark.500": {
    "value": "var(--ids-colors-blue-dark-500)",
    "variable": "var(--ids-colors-blue-dark-500)"
  },
  "colors.blue.dark.600": {
    "value": "var(--ids-colors-blue-dark-600)",
    "variable": "var(--ids-colors-blue-dark-600)"
  },
  "colors.blue.dark.700": {
    "value": "var(--ids-colors-blue-dark-700)",
    "variable": "var(--ids-colors-blue-dark-700)"
  },
  "colors.blue.dark.800": {
    "value": "var(--ids-colors-blue-dark-800)",
    "variable": "var(--ids-colors-blue-dark-800)"
  },
  "colors.blue.dark.900": {
    "value": "var(--ids-colors-blue-dark-900)",
    "variable": "var(--ids-colors-blue-dark-900)"
  },
  "colors.blue.dark.1000": {
    "value": "var(--ids-colors-blue-dark-1000)",
    "variable": "var(--ids-colors-blue-dark-1000)"
  },
  "colors.blue.dark.1100": {
    "value": "var(--ids-colors-blue-dark-1100)",
    "variable": "var(--ids-colors-blue-dark-1100)"
  },
  "colors.blue.dark.1200": {
    "value": "var(--ids-colors-blue-dark-1200)",
    "variable": "var(--ids-colors-blue-dark-1200)"
  },
  "colors.blue.dark.a100": {
    "value": "var(--ids-colors-blue-dark-a100)",
    "variable": "var(--ids-colors-blue-dark-a100)"
  },
  "colors.blue.dark.a200": {
    "value": "var(--ids-colors-blue-dark-a200)",
    "variable": "var(--ids-colors-blue-dark-a200)"
  },
  "colors.blue.dark.a300": {
    "value": "var(--ids-colors-blue-dark-a300)",
    "variable": "var(--ids-colors-blue-dark-a300)"
  },
  "colors.blue.dark.a400": {
    "value": "var(--ids-colors-blue-dark-a400)",
    "variable": "var(--ids-colors-blue-dark-a400)"
  },
  "colors.blue.dark.a500": {
    "value": "var(--ids-colors-blue-dark-a500)",
    "variable": "var(--ids-colors-blue-dark-a500)"
  },
  "colors.blue.dark.a600": {
    "value": "var(--ids-colors-blue-dark-a600)",
    "variable": "var(--ids-colors-blue-dark-a600)"
  },
  "colors.green.light.100": {
    "value": "var(--ids-colors-green-light-100)",
    "variable": "var(--ids-colors-green-light-100)"
  },
  "colors.green.light.200": {
    "value": "var(--ids-colors-green-light-200)",
    "variable": "var(--ids-colors-green-light-200)"
  },
  "colors.green.light.300": {
    "value": "var(--ids-colors-green-light-300)",
    "variable": "var(--ids-colors-green-light-300)"
  },
  "colors.green.light.400": {
    "value": "var(--ids-colors-green-light-400)",
    "variable": "var(--ids-colors-green-light-400)"
  },
  "colors.green.light.500": {
    "value": "var(--ids-colors-green-light-500)",
    "variable": "var(--ids-colors-green-light-500)"
  },
  "colors.green.light.600": {
    "value": "var(--ids-colors-green-light-600)",
    "variable": "var(--ids-colors-green-light-600)"
  },
  "colors.green.light.700": {
    "value": "var(--ids-colors-green-light-700)",
    "variable": "var(--ids-colors-green-light-700)"
  },
  "colors.green.light.800": {
    "value": "var(--ids-colors-green-light-800)",
    "variable": "var(--ids-colors-green-light-800)"
  },
  "colors.green.light.900": {
    "value": "var(--ids-colors-green-light-900)",
    "variable": "var(--ids-colors-green-light-900)"
  },
  "colors.green.light.1000": {
    "value": "var(--ids-colors-green-light-1000)",
    "variable": "var(--ids-colors-green-light-1000)"
  },
  "colors.green.light.1100": {
    "value": "var(--ids-colors-green-light-1100)",
    "variable": "var(--ids-colors-green-light-1100)"
  },
  "colors.green.light.1200": {
    "value": "var(--ids-colors-green-light-1200)",
    "variable": "var(--ids-colors-green-light-1200)"
  },
  "colors.green.light.a100": {
    "value": "var(--ids-colors-green-light-a100)",
    "variable": "var(--ids-colors-green-light-a100)"
  },
  "colors.green.light.a200": {
    "value": "var(--ids-colors-green-light-a200)",
    "variable": "var(--ids-colors-green-light-a200)"
  },
  "colors.green.light.a300": {
    "value": "var(--ids-colors-green-light-a300)",
    "variable": "var(--ids-colors-green-light-a300)"
  },
  "colors.green.light.a400": {
    "value": "var(--ids-colors-green-light-a400)",
    "variable": "var(--ids-colors-green-light-a400)"
  },
  "colors.green.light.a500": {
    "value": "var(--ids-colors-green-light-a500)",
    "variable": "var(--ids-colors-green-light-a500)"
  },
  "colors.green.light.a600": {
    "value": "var(--ids-colors-green-light-a600)",
    "variable": "var(--ids-colors-green-light-a600)"
  },
  "colors.green.dark.100": {
    "value": "var(--ids-colors-green-dark-100)",
    "variable": "var(--ids-colors-green-dark-100)"
  },
  "colors.green.dark.200": {
    "value": "var(--ids-colors-green-dark-200)",
    "variable": "var(--ids-colors-green-dark-200)"
  },
  "colors.green.dark.300": {
    "value": "var(--ids-colors-green-dark-300)",
    "variable": "var(--ids-colors-green-dark-300)"
  },
  "colors.green.dark.400": {
    "value": "var(--ids-colors-green-dark-400)",
    "variable": "var(--ids-colors-green-dark-400)"
  },
  "colors.green.dark.500": {
    "value": "var(--ids-colors-green-dark-500)",
    "variable": "var(--ids-colors-green-dark-500)"
  },
  "colors.green.dark.600": {
    "value": "var(--ids-colors-green-dark-600)",
    "variable": "var(--ids-colors-green-dark-600)"
  },
  "colors.green.dark.700": {
    "value": "var(--ids-colors-green-dark-700)",
    "variable": "var(--ids-colors-green-dark-700)"
  },
  "colors.green.dark.800": {
    "value": "var(--ids-colors-green-dark-800)",
    "variable": "var(--ids-colors-green-dark-800)"
  },
  "colors.green.dark.900": {
    "value": "var(--ids-colors-green-dark-900)",
    "variable": "var(--ids-colors-green-dark-900)"
  },
  "colors.green.dark.1000": {
    "value": "var(--ids-colors-green-dark-1000)",
    "variable": "var(--ids-colors-green-dark-1000)"
  },
  "colors.green.dark.1100": {
    "value": "var(--ids-colors-green-dark-1100)",
    "variable": "var(--ids-colors-green-dark-1100)"
  },
  "colors.green.dark.1200": {
    "value": "var(--ids-colors-green-dark-1200)",
    "variable": "var(--ids-colors-green-dark-1200)"
  },
  "colors.green.dark.a100": {
    "value": "var(--ids-colors-green-dark-a100)",
    "variable": "var(--ids-colors-green-dark-a100)"
  },
  "colors.green.dark.a200": {
    "value": "var(--ids-colors-green-dark-a200)",
    "variable": "var(--ids-colors-green-dark-a200)"
  },
  "colors.green.dark.a300": {
    "value": "var(--ids-colors-green-dark-a300)",
    "variable": "var(--ids-colors-green-dark-a300)"
  },
  "colors.green.dark.a400": {
    "value": "var(--ids-colors-green-dark-a400)",
    "variable": "var(--ids-colors-green-dark-a400)"
  },
  "colors.green.dark.a500": {
    "value": "var(--ids-colors-green-dark-a500)",
    "variable": "var(--ids-colors-green-dark-a500)"
  },
  "colors.green.dark.a600": {
    "value": "var(--ids-colors-green-dark-a600)",
    "variable": "var(--ids-colors-green-dark-a600)"
  },
  "colors.red.light.100": {
    "value": "var(--ids-colors-red-light-100)",
    "variable": "var(--ids-colors-red-light-100)"
  },
  "colors.red.light.200": {
    "value": "var(--ids-colors-red-light-200)",
    "variable": "var(--ids-colors-red-light-200)"
  },
  "colors.red.light.300": {
    "value": "var(--ids-colors-red-light-300)",
    "variable": "var(--ids-colors-red-light-300)"
  },
  "colors.red.light.400": {
    "value": "var(--ids-colors-red-light-400)",
    "variable": "var(--ids-colors-red-light-400)"
  },
  "colors.red.light.500": {
    "value": "var(--ids-colors-red-light-500)",
    "variable": "var(--ids-colors-red-light-500)"
  },
  "colors.red.light.600": {
    "value": "var(--ids-colors-red-light-600)",
    "variable": "var(--ids-colors-red-light-600)"
  },
  "colors.red.light.700": {
    "value": "var(--ids-colors-red-light-700)",
    "variable": "var(--ids-colors-red-light-700)"
  },
  "colors.red.light.800": {
    "value": "var(--ids-colors-red-light-800)",
    "variable": "var(--ids-colors-red-light-800)"
  },
  "colors.red.light.900": {
    "value": "var(--ids-colors-red-light-900)",
    "variable": "var(--ids-colors-red-light-900)"
  },
  "colors.red.light.1000": {
    "value": "var(--ids-colors-red-light-1000)",
    "variable": "var(--ids-colors-red-light-1000)"
  },
  "colors.red.light.1100": {
    "value": "var(--ids-colors-red-light-1100)",
    "variable": "var(--ids-colors-red-light-1100)"
  },
  "colors.red.light.1200": {
    "value": "var(--ids-colors-red-light-1200)",
    "variable": "var(--ids-colors-red-light-1200)"
  },
  "colors.red.light.a100": {
    "value": "var(--ids-colors-red-light-a100)",
    "variable": "var(--ids-colors-red-light-a100)"
  },
  "colors.red.light.a200": {
    "value": "var(--ids-colors-red-light-a200)",
    "variable": "var(--ids-colors-red-light-a200)"
  },
  "colors.red.light.a300": {
    "value": "var(--ids-colors-red-light-a300)",
    "variable": "var(--ids-colors-red-light-a300)"
  },
  "colors.red.light.a400": {
    "value": "var(--ids-colors-red-light-a400)",
    "variable": "var(--ids-colors-red-light-a400)"
  },
  "colors.red.light.a500": {
    "value": "var(--ids-colors-red-light-a500)",
    "variable": "var(--ids-colors-red-light-a500)"
  },
  "colors.red.light.a600": {
    "value": "var(--ids-colors-red-light-a600)",
    "variable": "var(--ids-colors-red-light-a600)"
  },
  "colors.red.dark.100": {
    "value": "var(--ids-colors-red-dark-100)",
    "variable": "var(--ids-colors-red-dark-100)"
  },
  "colors.red.dark.200": {
    "value": "var(--ids-colors-red-dark-200)",
    "variable": "var(--ids-colors-red-dark-200)"
  },
  "colors.red.dark.300": {
    "value": "var(--ids-colors-red-dark-300)",
    "variable": "var(--ids-colors-red-dark-300)"
  },
  "colors.red.dark.400": {
    "value": "var(--ids-colors-red-dark-400)",
    "variable": "var(--ids-colors-red-dark-400)"
  },
  "colors.red.dark.500": {
    "value": "var(--ids-colors-red-dark-500)",
    "variable": "var(--ids-colors-red-dark-500)"
  },
  "colors.red.dark.600": {
    "value": "var(--ids-colors-red-dark-600)",
    "variable": "var(--ids-colors-red-dark-600)"
  },
  "colors.red.dark.700": {
    "value": "var(--ids-colors-red-dark-700)",
    "variable": "var(--ids-colors-red-dark-700)"
  },
  "colors.red.dark.800": {
    "value": "var(--ids-colors-red-dark-800)",
    "variable": "var(--ids-colors-red-dark-800)"
  },
  "colors.red.dark.900": {
    "value": "var(--ids-colors-red-dark-900)",
    "variable": "var(--ids-colors-red-dark-900)"
  },
  "colors.red.dark.1000": {
    "value": "var(--ids-colors-red-dark-1000)",
    "variable": "var(--ids-colors-red-dark-1000)"
  },
  "colors.red.dark.1100": {
    "value": "var(--ids-colors-red-dark-1100)",
    "variable": "var(--ids-colors-red-dark-1100)"
  },
  "colors.red.dark.1200": {
    "value": "var(--ids-colors-red-dark-1200)",
    "variable": "var(--ids-colors-red-dark-1200)"
  },
  "colors.red.dark.a100": {
    "value": "var(--ids-colors-red-dark-a100)",
    "variable": "var(--ids-colors-red-dark-a100)"
  },
  "colors.red.dark.a200": {
    "value": "var(--ids-colors-red-dark-a200)",
    "variable": "var(--ids-colors-red-dark-a200)"
  },
  "colors.red.dark.a300": {
    "value": "var(--ids-colors-red-dark-a300)",
    "variable": "var(--ids-colors-red-dark-a300)"
  },
  "colors.red.dark.a400": {
    "value": "var(--ids-colors-red-dark-a400)",
    "variable": "var(--ids-colors-red-dark-a400)"
  },
  "colors.red.dark.a500": {
    "value": "var(--ids-colors-red-dark-a500)",
    "variable": "var(--ids-colors-red-dark-a500)"
  },
  "colors.red.dark.a600": {
    "value": "var(--ids-colors-red-dark-a600)",
    "variable": "var(--ids-colors-red-dark-a600)"
  },
  "colors.purple.light.100": {
    "value": "var(--ids-colors-purple-light-100)",
    "variable": "var(--ids-colors-purple-light-100)"
  },
  "colors.purple.light.200": {
    "value": "var(--ids-colors-purple-light-200)",
    "variable": "var(--ids-colors-purple-light-200)"
  },
  "colors.purple.light.300": {
    "value": "var(--ids-colors-purple-light-300)",
    "variable": "var(--ids-colors-purple-light-300)"
  },
  "colors.purple.light.400": {
    "value": "var(--ids-colors-purple-light-400)",
    "variable": "var(--ids-colors-purple-light-400)"
  },
  "colors.purple.light.500": {
    "value": "var(--ids-colors-purple-light-500)",
    "variable": "var(--ids-colors-purple-light-500)"
  },
  "colors.purple.light.600": {
    "value": "var(--ids-colors-purple-light-600)",
    "variable": "var(--ids-colors-purple-light-600)"
  },
  "colors.purple.light.700": {
    "value": "var(--ids-colors-purple-light-700)",
    "variable": "var(--ids-colors-purple-light-700)"
  },
  "colors.purple.light.800": {
    "value": "var(--ids-colors-purple-light-800)",
    "variable": "var(--ids-colors-purple-light-800)"
  },
  "colors.purple.light.900": {
    "value": "var(--ids-colors-purple-light-900)",
    "variable": "var(--ids-colors-purple-light-900)"
  },
  "colors.purple.light.1000": {
    "value": "var(--ids-colors-purple-light-1000)",
    "variable": "var(--ids-colors-purple-light-1000)"
  },
  "colors.purple.light.1100": {
    "value": "var(--ids-colors-purple-light-1100)",
    "variable": "var(--ids-colors-purple-light-1100)"
  },
  "colors.purple.light.1200": {
    "value": "var(--ids-colors-purple-light-1200)",
    "variable": "var(--ids-colors-purple-light-1200)"
  },
  "colors.purple.light.a100": {
    "value": "var(--ids-colors-purple-light-a100)",
    "variable": "var(--ids-colors-purple-light-a100)"
  },
  "colors.purple.light.a200": {
    "value": "var(--ids-colors-purple-light-a200)",
    "variable": "var(--ids-colors-purple-light-a200)"
  },
  "colors.purple.light.a300": {
    "value": "var(--ids-colors-purple-light-a300)",
    "variable": "var(--ids-colors-purple-light-a300)"
  },
  "colors.purple.light.a400": {
    "value": "var(--ids-colors-purple-light-a400)",
    "variable": "var(--ids-colors-purple-light-a400)"
  },
  "colors.purple.light.a500": {
    "value": "var(--ids-colors-purple-light-a500)",
    "variable": "var(--ids-colors-purple-light-a500)"
  },
  "colors.purple.light.a600": {
    "value": "var(--ids-colors-purple-light-a600)",
    "variable": "var(--ids-colors-purple-light-a600)"
  },
  "colors.purple.dark.100": {
    "value": "var(--ids-colors-purple-dark-100)",
    "variable": "var(--ids-colors-purple-dark-100)"
  },
  "colors.purple.dark.200": {
    "value": "var(--ids-colors-purple-dark-200)",
    "variable": "var(--ids-colors-purple-dark-200)"
  },
  "colors.purple.dark.300": {
    "value": "var(--ids-colors-purple-dark-300)",
    "variable": "var(--ids-colors-purple-dark-300)"
  },
  "colors.purple.dark.400": {
    "value": "var(--ids-colors-purple-dark-400)",
    "variable": "var(--ids-colors-purple-dark-400)"
  },
  "colors.purple.dark.500": {
    "value": "var(--ids-colors-purple-dark-500)",
    "variable": "var(--ids-colors-purple-dark-500)"
  },
  "colors.purple.dark.600": {
    "value": "var(--ids-colors-purple-dark-600)",
    "variable": "var(--ids-colors-purple-dark-600)"
  },
  "colors.purple.dark.700": {
    "value": "var(--ids-colors-purple-dark-700)",
    "variable": "var(--ids-colors-purple-dark-700)"
  },
  "colors.purple.dark.800": {
    "value": "var(--ids-colors-purple-dark-800)",
    "variable": "var(--ids-colors-purple-dark-800)"
  },
  "colors.purple.dark.900": {
    "value": "var(--ids-colors-purple-dark-900)",
    "variable": "var(--ids-colors-purple-dark-900)"
  },
  "colors.purple.dark.1000": {
    "value": "var(--ids-colors-purple-dark-1000)",
    "variable": "var(--ids-colors-purple-dark-1000)"
  },
  "colors.purple.dark.1100": {
    "value": "var(--ids-colors-purple-dark-1100)",
    "variable": "var(--ids-colors-purple-dark-1100)"
  },
  "colors.purple.dark.1200": {
    "value": "var(--ids-colors-purple-dark-1200)",
    "variable": "var(--ids-colors-purple-dark-1200)"
  },
  "colors.purple.dark.a100": {
    "value": "var(--ids-colors-purple-dark-a100)",
    "variable": "var(--ids-colors-purple-dark-a100)"
  },
  "colors.purple.dark.a200": {
    "value": "var(--ids-colors-purple-dark-a200)",
    "variable": "var(--ids-colors-purple-dark-a200)"
  },
  "colors.purple.dark.a300": {
    "value": "var(--ids-colors-purple-dark-a300)",
    "variable": "var(--ids-colors-purple-dark-a300)"
  },
  "colors.purple.dark.a400": {
    "value": "var(--ids-colors-purple-dark-a400)",
    "variable": "var(--ids-colors-purple-dark-a400)"
  },
  "colors.purple.dark.a500": {
    "value": "var(--ids-colors-purple-dark-a500)",
    "variable": "var(--ids-colors-purple-dark-a500)"
  },
  "colors.purple.dark.a600": {
    "value": "var(--ids-colors-purple-dark-a600)",
    "variable": "var(--ids-colors-purple-dark-a600)"
  },
  "colors.yellow.light.100": {
    "value": "var(--ids-colors-yellow-light-100)",
    "variable": "var(--ids-colors-yellow-light-100)"
  },
  "colors.yellow.light.200": {
    "value": "var(--ids-colors-yellow-light-200)",
    "variable": "var(--ids-colors-yellow-light-200)"
  },
  "colors.yellow.light.300": {
    "value": "var(--ids-colors-yellow-light-300)",
    "variable": "var(--ids-colors-yellow-light-300)"
  },
  "colors.yellow.light.400": {
    "value": "var(--ids-colors-yellow-light-400)",
    "variable": "var(--ids-colors-yellow-light-400)"
  },
  "colors.yellow.light.500": {
    "value": "var(--ids-colors-yellow-light-500)",
    "variable": "var(--ids-colors-yellow-light-500)"
  },
  "colors.yellow.light.600": {
    "value": "var(--ids-colors-yellow-light-600)",
    "variable": "var(--ids-colors-yellow-light-600)"
  },
  "colors.yellow.light.700": {
    "value": "var(--ids-colors-yellow-light-700)",
    "variable": "var(--ids-colors-yellow-light-700)"
  },
  "colors.yellow.light.800": {
    "value": "var(--ids-colors-yellow-light-800)",
    "variable": "var(--ids-colors-yellow-light-800)"
  },
  "colors.yellow.light.900": {
    "value": "var(--ids-colors-yellow-light-900)",
    "variable": "var(--ids-colors-yellow-light-900)"
  },
  "colors.yellow.light.1000": {
    "value": "var(--ids-colors-yellow-light-1000)",
    "variable": "var(--ids-colors-yellow-light-1000)"
  },
  "colors.yellow.light.1100": {
    "value": "var(--ids-colors-yellow-light-1100)",
    "variable": "var(--ids-colors-yellow-light-1100)"
  },
  "colors.yellow.light.1200": {
    "value": "var(--ids-colors-yellow-light-1200)",
    "variable": "var(--ids-colors-yellow-light-1200)"
  },
  "colors.yellow.light.a100": {
    "value": "var(--ids-colors-yellow-light-a100)",
    "variable": "var(--ids-colors-yellow-light-a100)"
  },
  "colors.yellow.light.a200": {
    "value": "var(--ids-colors-yellow-light-a200)",
    "variable": "var(--ids-colors-yellow-light-a200)"
  },
  "colors.yellow.light.a300": {
    "value": "var(--ids-colors-yellow-light-a300)",
    "variable": "var(--ids-colors-yellow-light-a300)"
  },
  "colors.yellow.light.a400": {
    "value": "var(--ids-colors-yellow-light-a400)",
    "variable": "var(--ids-colors-yellow-light-a400)"
  },
  "colors.yellow.light.a500": {
    "value": "var(--ids-colors-yellow-light-a500)",
    "variable": "var(--ids-colors-yellow-light-a500)"
  },
  "colors.yellow.light.a600": {
    "value": "var(--ids-colors-yellow-light-a600)",
    "variable": "var(--ids-colors-yellow-light-a600)"
  },
  "colors.yellow.dark.100": {
    "value": "var(--ids-colors-yellow-dark-100)",
    "variable": "var(--ids-colors-yellow-dark-100)"
  },
  "colors.yellow.dark.200": {
    "value": "var(--ids-colors-yellow-dark-200)",
    "variable": "var(--ids-colors-yellow-dark-200)"
  },
  "colors.yellow.dark.300": {
    "value": "var(--ids-colors-yellow-dark-300)",
    "variable": "var(--ids-colors-yellow-dark-300)"
  },
  "colors.yellow.dark.400": {
    "value": "var(--ids-colors-yellow-dark-400)",
    "variable": "var(--ids-colors-yellow-dark-400)"
  },
  "colors.yellow.dark.500": {
    "value": "var(--ids-colors-yellow-dark-500)",
    "variable": "var(--ids-colors-yellow-dark-500)"
  },
  "colors.yellow.dark.600": {
    "value": "var(--ids-colors-yellow-dark-600)",
    "variable": "var(--ids-colors-yellow-dark-600)"
  },
  "colors.yellow.dark.700": {
    "value": "var(--ids-colors-yellow-dark-700)",
    "variable": "var(--ids-colors-yellow-dark-700)"
  },
  "colors.yellow.dark.800": {
    "value": "var(--ids-colors-yellow-dark-800)",
    "variable": "var(--ids-colors-yellow-dark-800)"
  },
  "colors.yellow.dark.900": {
    "value": "var(--ids-colors-yellow-dark-900)",
    "variable": "var(--ids-colors-yellow-dark-900)"
  },
  "colors.yellow.dark.1000": {
    "value": "var(--ids-colors-yellow-dark-1000)",
    "variable": "var(--ids-colors-yellow-dark-1000)"
  },
  "colors.yellow.dark.1100": {
    "value": "var(--ids-colors-yellow-dark-1100)",
    "variable": "var(--ids-colors-yellow-dark-1100)"
  },
  "colors.yellow.dark.1200": {
    "value": "var(--ids-colors-yellow-dark-1200)",
    "variable": "var(--ids-colors-yellow-dark-1200)"
  },
  "colors.yellow.dark.a100": {
    "value": "var(--ids-colors-yellow-dark-a100)",
    "variable": "var(--ids-colors-yellow-dark-a100)"
  },
  "colors.yellow.dark.a200": {
    "value": "var(--ids-colors-yellow-dark-a200)",
    "variable": "var(--ids-colors-yellow-dark-a200)"
  },
  "colors.yellow.dark.a300": {
    "value": "var(--ids-colors-yellow-dark-a300)",
    "variable": "var(--ids-colors-yellow-dark-a300)"
  },
  "colors.yellow.dark.a400": {
    "value": "var(--ids-colors-yellow-dark-a400)",
    "variable": "var(--ids-colors-yellow-dark-a400)"
  },
  "colors.yellow.dark.a500": {
    "value": "var(--ids-colors-yellow-dark-a500)",
    "variable": "var(--ids-colors-yellow-dark-a500)"
  },
  "colors.yellow.dark.a600": {
    "value": "var(--ids-colors-yellow-dark-a600)",
    "variable": "var(--ids-colors-yellow-dark-a600)"
  },
  "colors.schoolPT.light.100": {
    "value": "var(--ids-colors-school-p-t-light-100)",
    "variable": "var(--ids-colors-school-p-t-light-100)"
  },
  "colors.schoolPT.light.200": {
    "value": "var(--ids-colors-school-p-t-light-200)",
    "variable": "var(--ids-colors-school-p-t-light-200)"
  },
  "colors.schoolPT.light.300": {
    "value": "var(--ids-colors-school-p-t-light-300)",
    "variable": "var(--ids-colors-school-p-t-light-300)"
  },
  "colors.schoolPT.light.400": {
    "value": "var(--ids-colors-school-p-t-light-400)",
    "variable": "var(--ids-colors-school-p-t-light-400)"
  },
  "colors.schoolPT.light.500": {
    "value": "var(--ids-colors-school-p-t-light-500)",
    "variable": "var(--ids-colors-school-p-t-light-500)"
  },
  "colors.schoolPT.light.600": {
    "value": "var(--ids-colors-school-p-t-light-600)",
    "variable": "var(--ids-colors-school-p-t-light-600)"
  },
  "colors.schoolPT.light.700": {
    "value": "var(--ids-colors-school-p-t-light-700)",
    "variable": "var(--ids-colors-school-p-t-light-700)"
  },
  "colors.schoolPT.light.800": {
    "value": "var(--ids-colors-school-p-t-light-800)",
    "variable": "var(--ids-colors-school-p-t-light-800)"
  },
  "colors.schoolPT.light.900": {
    "value": "var(--ids-colors-school-p-t-light-900)",
    "variable": "var(--ids-colors-school-p-t-light-900)"
  },
  "colors.schoolPT.light.1000": {
    "value": "var(--ids-colors-school-p-t-light-1000)",
    "variable": "var(--ids-colors-school-p-t-light-1000)"
  },
  "colors.schoolPT.light.1100": {
    "value": "var(--ids-colors-school-p-t-light-1100)",
    "variable": "var(--ids-colors-school-p-t-light-1100)"
  },
  "colors.schoolPT.light.1200": {
    "value": "var(--ids-colors-school-p-t-light-1200)",
    "variable": "var(--ids-colors-school-p-t-light-1200)"
  },
  "colors.schoolPT.light.a100": {
    "value": "var(--ids-colors-school-p-t-light-a100)",
    "variable": "var(--ids-colors-school-p-t-light-a100)"
  },
  "colors.schoolPT.light.a200": {
    "value": "var(--ids-colors-school-p-t-light-a200)",
    "variable": "var(--ids-colors-school-p-t-light-a200)"
  },
  "colors.schoolPT.light.a300": {
    "value": "var(--ids-colors-school-p-t-light-a300)",
    "variable": "var(--ids-colors-school-p-t-light-a300)"
  },
  "colors.schoolPT.light.a400": {
    "value": "var(--ids-colors-school-p-t-light-a400)",
    "variable": "var(--ids-colors-school-p-t-light-a400)"
  },
  "colors.schoolPT.light.a500": {
    "value": "var(--ids-colors-school-p-t-light-a500)",
    "variable": "var(--ids-colors-school-p-t-light-a500)"
  },
  "colors.schoolPT.light.a600": {
    "value": "var(--ids-colors-school-p-t-light-a600)",
    "variable": "var(--ids-colors-school-p-t-light-a600)"
  },
  "colors.schoolPT.dark.100": {
    "value": "var(--ids-colors-school-p-t-dark-100)",
    "variable": "var(--ids-colors-school-p-t-dark-100)"
  },
  "colors.schoolPT.dark.200": {
    "value": "var(--ids-colors-school-p-t-dark-200)",
    "variable": "var(--ids-colors-school-p-t-dark-200)"
  },
  "colors.schoolPT.dark.300": {
    "value": "var(--ids-colors-school-p-t-dark-300)",
    "variable": "var(--ids-colors-school-p-t-dark-300)"
  },
  "colors.schoolPT.dark.400": {
    "value": "var(--ids-colors-school-p-t-dark-400)",
    "variable": "var(--ids-colors-school-p-t-dark-400)"
  },
  "colors.schoolPT.dark.500": {
    "value": "var(--ids-colors-school-p-t-dark-500)",
    "variable": "var(--ids-colors-school-p-t-dark-500)"
  },
  "colors.schoolPT.dark.600": {
    "value": "var(--ids-colors-school-p-t-dark-600)",
    "variable": "var(--ids-colors-school-p-t-dark-600)"
  },
  "colors.schoolPT.dark.700": {
    "value": "var(--ids-colors-school-p-t-dark-700)",
    "variable": "var(--ids-colors-school-p-t-dark-700)"
  },
  "colors.schoolPT.dark.800": {
    "value": "var(--ids-colors-school-p-t-dark-800)",
    "variable": "var(--ids-colors-school-p-t-dark-800)"
  },
  "colors.schoolPT.dark.900": {
    "value": "var(--ids-colors-school-p-t-dark-900)",
    "variable": "var(--ids-colors-school-p-t-dark-900)"
  },
  "colors.schoolPT.dark.1000": {
    "value": "var(--ids-colors-school-p-t-dark-1000)",
    "variable": "var(--ids-colors-school-p-t-dark-1000)"
  },
  "colors.schoolPT.dark.1100": {
    "value": "var(--ids-colors-school-p-t-dark-1100)",
    "variable": "var(--ids-colors-school-p-t-dark-1100)"
  },
  "colors.schoolPT.dark.1200": {
    "value": "var(--ids-colors-school-p-t-dark-1200)",
    "variable": "var(--ids-colors-school-p-t-dark-1200)"
  },
  "colors.schoolPT.dark.a100": {
    "value": "var(--ids-colors-school-p-t-dark-a100)",
    "variable": "var(--ids-colors-school-p-t-dark-a100)"
  },
  "colors.schoolPT.dark.a200": {
    "value": "var(--ids-colors-school-p-t-dark-a200)",
    "variable": "var(--ids-colors-school-p-t-dark-a200)"
  },
  "colors.schoolPT.dark.a300": {
    "value": "var(--ids-colors-school-p-t-dark-a300)",
    "variable": "var(--ids-colors-school-p-t-dark-a300)"
  },
  "colors.schoolPT.dark.a400": {
    "value": "var(--ids-colors-school-p-t-dark-a400)",
    "variable": "var(--ids-colors-school-p-t-dark-a400)"
  },
  "colors.schoolPT.dark.a500": {
    "value": "var(--ids-colors-school-p-t-dark-a500)",
    "variable": "var(--ids-colors-school-p-t-dark-a500)"
  },
  "colors.schoolPT.dark.a600": {
    "value": "var(--ids-colors-school-p-t-dark-a600)",
    "variable": "var(--ids-colors-school-p-t-dark-a600)"
  },
  "colors.mildangPT.light.100": {
    "value": "var(--ids-colors-mildang-p-t-light-100)",
    "variable": "var(--ids-colors-mildang-p-t-light-100)"
  },
  "colors.mildangPT.light.200": {
    "value": "var(--ids-colors-mildang-p-t-light-200)",
    "variable": "var(--ids-colors-mildang-p-t-light-200)"
  },
  "colors.mildangPT.light.300": {
    "value": "var(--ids-colors-mildang-p-t-light-300)",
    "variable": "var(--ids-colors-mildang-p-t-light-300)"
  },
  "colors.mildangPT.light.400": {
    "value": "var(--ids-colors-mildang-p-t-light-400)",
    "variable": "var(--ids-colors-mildang-p-t-light-400)"
  },
  "colors.mildangPT.light.500": {
    "value": "var(--ids-colors-mildang-p-t-light-500)",
    "variable": "var(--ids-colors-mildang-p-t-light-500)"
  },
  "colors.mildangPT.light.600": {
    "value": "var(--ids-colors-mildang-p-t-light-600)",
    "variable": "var(--ids-colors-mildang-p-t-light-600)"
  },
  "colors.mildangPT.light.700": {
    "value": "var(--ids-colors-mildang-p-t-light-700)",
    "variable": "var(--ids-colors-mildang-p-t-light-700)"
  },
  "colors.mildangPT.light.800": {
    "value": "var(--ids-colors-mildang-p-t-light-800)",
    "variable": "var(--ids-colors-mildang-p-t-light-800)"
  },
  "colors.mildangPT.light.900": {
    "value": "var(--ids-colors-mildang-p-t-light-900)",
    "variable": "var(--ids-colors-mildang-p-t-light-900)"
  },
  "colors.mildangPT.light.1000": {
    "value": "var(--ids-colors-mildang-p-t-light-1000)",
    "variable": "var(--ids-colors-mildang-p-t-light-1000)"
  },
  "colors.mildangPT.light.1100": {
    "value": "var(--ids-colors-mildang-p-t-light-1100)",
    "variable": "var(--ids-colors-mildang-p-t-light-1100)"
  },
  "colors.mildangPT.light.1200": {
    "value": "var(--ids-colors-mildang-p-t-light-1200)",
    "variable": "var(--ids-colors-mildang-p-t-light-1200)"
  },
  "colors.mildangPT.light.a100": {
    "value": "var(--ids-colors-mildang-p-t-light-a100)",
    "variable": "var(--ids-colors-mildang-p-t-light-a100)"
  },
  "colors.mildangPT.light.a200": {
    "value": "var(--ids-colors-mildang-p-t-light-a200)",
    "variable": "var(--ids-colors-mildang-p-t-light-a200)"
  },
  "colors.mildangPT.light.a300": {
    "value": "var(--ids-colors-mildang-p-t-light-a300)",
    "variable": "var(--ids-colors-mildang-p-t-light-a300)"
  },
  "colors.mildangPT.light.a400": {
    "value": "var(--ids-colors-mildang-p-t-light-a400)",
    "variable": "var(--ids-colors-mildang-p-t-light-a400)"
  },
  "colors.mildangPT.light.a500": {
    "value": "var(--ids-colors-mildang-p-t-light-a500)",
    "variable": "var(--ids-colors-mildang-p-t-light-a500)"
  },
  "colors.mildangPT.light.a600": {
    "value": "var(--ids-colors-mildang-p-t-light-a600)",
    "variable": "var(--ids-colors-mildang-p-t-light-a600)"
  },
  "colors.mildangPT.dark.100": {
    "value": "var(--ids-colors-mildang-p-t-dark-100)",
    "variable": "var(--ids-colors-mildang-p-t-dark-100)"
  },
  "colors.mildangPT.dark.200": {
    "value": "var(--ids-colors-mildang-p-t-dark-200)",
    "variable": "var(--ids-colors-mildang-p-t-dark-200)"
  },
  "colors.mildangPT.dark.300": {
    "value": "var(--ids-colors-mildang-p-t-dark-300)",
    "variable": "var(--ids-colors-mildang-p-t-dark-300)"
  },
  "colors.mildangPT.dark.400": {
    "value": "var(--ids-colors-mildang-p-t-dark-400)",
    "variable": "var(--ids-colors-mildang-p-t-dark-400)"
  },
  "colors.mildangPT.dark.500": {
    "value": "var(--ids-colors-mildang-p-t-dark-500)",
    "variable": "var(--ids-colors-mildang-p-t-dark-500)"
  },
  "colors.mildangPT.dark.600": {
    "value": "var(--ids-colors-mildang-p-t-dark-600)",
    "variable": "var(--ids-colors-mildang-p-t-dark-600)"
  },
  "colors.mildangPT.dark.700": {
    "value": "var(--ids-colors-mildang-p-t-dark-700)",
    "variable": "var(--ids-colors-mildang-p-t-dark-700)"
  },
  "colors.mildangPT.dark.800": {
    "value": "var(--ids-colors-mildang-p-t-dark-800)",
    "variable": "var(--ids-colors-mildang-p-t-dark-800)"
  },
  "colors.mildangPT.dark.900": {
    "value": "var(--ids-colors-mildang-p-t-dark-900)",
    "variable": "var(--ids-colors-mildang-p-t-dark-900)"
  },
  "colors.mildangPT.dark.1000": {
    "value": "var(--ids-colors-mildang-p-t-dark-1000)",
    "variable": "var(--ids-colors-mildang-p-t-dark-1000)"
  },
  "colors.mildangPT.dark.1100": {
    "value": "var(--ids-colors-mildang-p-t-dark-1100)",
    "variable": "var(--ids-colors-mildang-p-t-dark-1100)"
  },
  "colors.mildangPT.dark.1200": {
    "value": "var(--ids-colors-mildang-p-t-dark-1200)",
    "variable": "var(--ids-colors-mildang-p-t-dark-1200)"
  },
  "colors.mildangPT.dark.a100": {
    "value": "var(--ids-colors-mildang-p-t-dark-a100)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a100)"
  },
  "colors.mildangPT.dark.a200": {
    "value": "var(--ids-colors-mildang-p-t-dark-a200)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a200)"
  },
  "colors.mildangPT.dark.a300": {
    "value": "var(--ids-colors-mildang-p-t-dark-a300)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a300)"
  },
  "colors.mildangPT.dark.a400": {
    "value": "var(--ids-colors-mildang-p-t-dark-a400)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a400)"
  },
  "colors.mildangPT.dark.a500": {
    "value": "var(--ids-colors-mildang-p-t-dark-a500)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a500)"
  },
  "colors.mildangPT.dark.a600": {
    "value": "var(--ids-colors-mildang-p-t-dark-a600)",
    "variable": "var(--ids-colors-mildang-p-t-dark-a600)"
  },
  "colors.pink.light.100": {
    "value": "var(--ids-colors-pink-light-100)",
    "variable": "var(--ids-colors-pink-light-100)"
  },
  "colors.pink.light.200": {
    "value": "var(--ids-colors-pink-light-200)",
    "variable": "var(--ids-colors-pink-light-200)"
  },
  "colors.pink.light.300": {
    "value": "var(--ids-colors-pink-light-300)",
    "variable": "var(--ids-colors-pink-light-300)"
  },
  "colors.pink.light.400": {
    "value": "var(--ids-colors-pink-light-400)",
    "variable": "var(--ids-colors-pink-light-400)"
  },
  "colors.pink.light.500": {
    "value": "var(--ids-colors-pink-light-500)",
    "variable": "var(--ids-colors-pink-light-500)"
  },
  "colors.pink.light.600": {
    "value": "var(--ids-colors-pink-light-600)",
    "variable": "var(--ids-colors-pink-light-600)"
  },
  "colors.pink.light.700": {
    "value": "var(--ids-colors-pink-light-700)",
    "variable": "var(--ids-colors-pink-light-700)"
  },
  "colors.pink.light.800": {
    "value": "var(--ids-colors-pink-light-800)",
    "variable": "var(--ids-colors-pink-light-800)"
  },
  "colors.pink.light.900": {
    "value": "var(--ids-colors-pink-light-900)",
    "variable": "var(--ids-colors-pink-light-900)"
  },
  "colors.pink.light.1000": {
    "value": "var(--ids-colors-pink-light-1000)",
    "variable": "var(--ids-colors-pink-light-1000)"
  },
  "colors.pink.light.1100": {
    "value": "var(--ids-colors-pink-light-1100)",
    "variable": "var(--ids-colors-pink-light-1100)"
  },
  "colors.pink.light.1200": {
    "value": "var(--ids-colors-pink-light-1200)",
    "variable": "var(--ids-colors-pink-light-1200)"
  },
  "colors.pink.light.a100": {
    "value": "var(--ids-colors-pink-light-a100)",
    "variable": "var(--ids-colors-pink-light-a100)"
  },
  "colors.pink.light.a200": {
    "value": "var(--ids-colors-pink-light-a200)",
    "variable": "var(--ids-colors-pink-light-a200)"
  },
  "colors.pink.light.a300": {
    "value": "var(--ids-colors-pink-light-a300)",
    "variable": "var(--ids-colors-pink-light-a300)"
  },
  "colors.pink.light.a400": {
    "value": "var(--ids-colors-pink-light-a400)",
    "variable": "var(--ids-colors-pink-light-a400)"
  },
  "colors.pink.light.a500": {
    "value": "var(--ids-colors-pink-light-a500)",
    "variable": "var(--ids-colors-pink-light-a500)"
  },
  "colors.pink.light.a600": {
    "value": "var(--ids-colors-pink-light-a600)",
    "variable": "var(--ids-colors-pink-light-a600)"
  },
  "colors.pink.dark.100": {
    "value": "var(--ids-colors-pink-dark-100)",
    "variable": "var(--ids-colors-pink-dark-100)"
  },
  "colors.pink.dark.200": {
    "value": "var(--ids-colors-pink-dark-200)",
    "variable": "var(--ids-colors-pink-dark-200)"
  },
  "colors.pink.dark.300": {
    "value": "var(--ids-colors-pink-dark-300)",
    "variable": "var(--ids-colors-pink-dark-300)"
  },
  "colors.pink.dark.400": {
    "value": "var(--ids-colors-pink-dark-400)",
    "variable": "var(--ids-colors-pink-dark-400)"
  },
  "colors.pink.dark.500": {
    "value": "var(--ids-colors-pink-dark-500)",
    "variable": "var(--ids-colors-pink-dark-500)"
  },
  "colors.pink.dark.600": {
    "value": "var(--ids-colors-pink-dark-600)",
    "variable": "var(--ids-colors-pink-dark-600)"
  },
  "colors.pink.dark.700": {
    "value": "var(--ids-colors-pink-dark-700)",
    "variable": "var(--ids-colors-pink-dark-700)"
  },
  "colors.pink.dark.800": {
    "value": "var(--ids-colors-pink-dark-800)",
    "variable": "var(--ids-colors-pink-dark-800)"
  },
  "colors.pink.dark.900": {
    "value": "var(--ids-colors-pink-dark-900)",
    "variable": "var(--ids-colors-pink-dark-900)"
  },
  "colors.pink.dark.1000": {
    "value": "var(--ids-colors-pink-dark-1000)",
    "variable": "var(--ids-colors-pink-dark-1000)"
  },
  "colors.pink.dark.1100": {
    "value": "var(--ids-colors-pink-dark-1100)",
    "variable": "var(--ids-colors-pink-dark-1100)"
  },
  "colors.pink.dark.1200": {
    "value": "var(--ids-colors-pink-dark-1200)",
    "variable": "var(--ids-colors-pink-dark-1200)"
  },
  "colors.pink.dark.a100": {
    "value": "var(--ids-colors-pink-dark-a100)",
    "variable": "var(--ids-colors-pink-dark-a100)"
  },
  "colors.pink.dark.a200": {
    "value": "var(--ids-colors-pink-dark-a200)",
    "variable": "var(--ids-colors-pink-dark-a200)"
  },
  "colors.pink.dark.a300": {
    "value": "var(--ids-colors-pink-dark-a300)",
    "variable": "var(--ids-colors-pink-dark-a300)"
  },
  "colors.pink.dark.a400": {
    "value": "var(--ids-colors-pink-dark-a400)",
    "variable": "var(--ids-colors-pink-dark-a400)"
  },
  "colors.pink.dark.a500": {
    "value": "var(--ids-colors-pink-dark-a500)",
    "variable": "var(--ids-colors-pink-dark-a500)"
  },
  "colors.pink.dark.a600": {
    "value": "var(--ids-colors-pink-dark-a600)",
    "variable": "var(--ids-colors-pink-dark-a600)"
  },
  "colors.lime.light.100": {
    "value": "var(--ids-colors-lime-light-100)",
    "variable": "var(--ids-colors-lime-light-100)"
  },
  "colors.lime.light.200": {
    "value": "var(--ids-colors-lime-light-200)",
    "variable": "var(--ids-colors-lime-light-200)"
  },
  "colors.lime.light.300": {
    "value": "var(--ids-colors-lime-light-300)",
    "variable": "var(--ids-colors-lime-light-300)"
  },
  "colors.lime.light.400": {
    "value": "var(--ids-colors-lime-light-400)",
    "variable": "var(--ids-colors-lime-light-400)"
  },
  "colors.lime.light.500": {
    "value": "var(--ids-colors-lime-light-500)",
    "variable": "var(--ids-colors-lime-light-500)"
  },
  "colors.lime.light.600": {
    "value": "var(--ids-colors-lime-light-600)",
    "variable": "var(--ids-colors-lime-light-600)"
  },
  "colors.lime.light.700": {
    "value": "var(--ids-colors-lime-light-700)",
    "variable": "var(--ids-colors-lime-light-700)"
  },
  "colors.lime.light.800": {
    "value": "var(--ids-colors-lime-light-800)",
    "variable": "var(--ids-colors-lime-light-800)"
  },
  "colors.lime.light.900": {
    "value": "var(--ids-colors-lime-light-900)",
    "variable": "var(--ids-colors-lime-light-900)"
  },
  "colors.lime.light.1000": {
    "value": "var(--ids-colors-lime-light-1000)",
    "variable": "var(--ids-colors-lime-light-1000)"
  },
  "colors.lime.light.1100": {
    "value": "var(--ids-colors-lime-light-1100)",
    "variable": "var(--ids-colors-lime-light-1100)"
  },
  "colors.lime.light.1200": {
    "value": "var(--ids-colors-lime-light-1200)",
    "variable": "var(--ids-colors-lime-light-1200)"
  },
  "colors.lime.light.a100": {
    "value": "var(--ids-colors-lime-light-a100)",
    "variable": "var(--ids-colors-lime-light-a100)"
  },
  "colors.lime.light.a200": {
    "value": "var(--ids-colors-lime-light-a200)",
    "variable": "var(--ids-colors-lime-light-a200)"
  },
  "colors.lime.light.a300": {
    "value": "var(--ids-colors-lime-light-a300)",
    "variable": "var(--ids-colors-lime-light-a300)"
  },
  "colors.lime.light.a400": {
    "value": "var(--ids-colors-lime-light-a400)",
    "variable": "var(--ids-colors-lime-light-a400)"
  },
  "colors.lime.light.a500": {
    "value": "var(--ids-colors-lime-light-a500)",
    "variable": "var(--ids-colors-lime-light-a500)"
  },
  "colors.lime.light.a600": {
    "value": "var(--ids-colors-lime-light-a600)",
    "variable": "var(--ids-colors-lime-light-a600)"
  },
  "colors.lime.dark.100": {
    "value": "var(--ids-colors-lime-dark-100)",
    "variable": "var(--ids-colors-lime-dark-100)"
  },
  "colors.lime.dark.200": {
    "value": "var(--ids-colors-lime-dark-200)",
    "variable": "var(--ids-colors-lime-dark-200)"
  },
  "colors.lime.dark.300": {
    "value": "var(--ids-colors-lime-dark-300)",
    "variable": "var(--ids-colors-lime-dark-300)"
  },
  "colors.lime.dark.400": {
    "value": "var(--ids-colors-lime-dark-400)",
    "variable": "var(--ids-colors-lime-dark-400)"
  },
  "colors.lime.dark.500": {
    "value": "var(--ids-colors-lime-dark-500)",
    "variable": "var(--ids-colors-lime-dark-500)"
  },
  "colors.lime.dark.600": {
    "value": "var(--ids-colors-lime-dark-600)",
    "variable": "var(--ids-colors-lime-dark-600)"
  },
  "colors.lime.dark.700": {
    "value": "var(--ids-colors-lime-dark-700)",
    "variable": "var(--ids-colors-lime-dark-700)"
  },
  "colors.lime.dark.800": {
    "value": "var(--ids-colors-lime-dark-800)",
    "variable": "var(--ids-colors-lime-dark-800)"
  },
  "colors.lime.dark.900": {
    "value": "var(--ids-colors-lime-dark-900)",
    "variable": "var(--ids-colors-lime-dark-900)"
  },
  "colors.lime.dark.1000": {
    "value": "var(--ids-colors-lime-dark-1000)",
    "variable": "var(--ids-colors-lime-dark-1000)"
  },
  "colors.lime.dark.1100": {
    "value": "var(--ids-colors-lime-dark-1100)",
    "variable": "var(--ids-colors-lime-dark-1100)"
  },
  "colors.lime.dark.1200": {
    "value": "var(--ids-colors-lime-dark-1200)",
    "variable": "var(--ids-colors-lime-dark-1200)"
  },
  "colors.lime.dark.a100": {
    "value": "var(--ids-colors-lime-dark-a100)",
    "variable": "var(--ids-colors-lime-dark-a100)"
  },
  "colors.lime.dark.a200": {
    "value": "var(--ids-colors-lime-dark-a200)",
    "variable": "var(--ids-colors-lime-dark-a200)"
  },
  "colors.lime.dark.a300": {
    "value": "var(--ids-colors-lime-dark-a300)",
    "variable": "var(--ids-colors-lime-dark-a300)"
  },
  "colors.lime.dark.a400": {
    "value": "var(--ids-colors-lime-dark-a400)",
    "variable": "var(--ids-colors-lime-dark-a400)"
  },
  "colors.lime.dark.a500": {
    "value": "var(--ids-colors-lime-dark-a500)",
    "variable": "var(--ids-colors-lime-dark-a500)"
  },
  "colors.lime.dark.a600": {
    "value": "var(--ids-colors-lime-dark-a600)",
    "variable": "var(--ids-colors-lime-dark-a600)"
  },
  "colors.mui.stroke.school": {
    "value": "var(--ids-colors-mui-stroke-school)",
    "variable": "var(--ids-colors-mui-stroke-school)"
  },
  "colors.mui.stroke.mildang": {
    "value": "var(--ids-colors-mui-stroke-mildang)",
    "variable": "var(--ids-colors-mui-stroke-mildang)"
  },
  "colors.mui.snackbar": {
    "value": "var(--ids-colors-mui-snackbar)",
    "variable": "var(--ids-colors-mui-snackbar)"
  },
  "colors.mui.activeRating": {
    "value": "var(--ids-colors-mui-active-rating)",
    "variable": "var(--ids-colors-mui-active-rating)"
  },
  "colors.mui.divider": {
    "value": "var(--ids-colors-mui-divider)",
    "variable": "var(--ids-colors-mui-divider)"
  },
  "colors.mui.primary.dark": {
    "value": "var(--ids-colors-mui-primary-dark)",
    "variable": "var(--ids-colors-mui-primary-dark)"
  },
  "colors.mui.primary.darkActive": {
    "value": "var(--ids-colors-mui-primary-dark-active)",
    "variable": "var(--ids-colors-mui-primary-dark-active)"
  },
  "colors.mui.primary.darkHover": {
    "value": "var(--ids-colors-mui-primary-dark-hover)",
    "variable": "var(--ids-colors-mui-primary-dark-hover)"
  },
  "colors.mui.primary.main": {
    "value": "var(--ids-colors-mui-primary-main)",
    "variable": "var(--ids-colors-mui-primary-main)"
  },
  "colors.mui.primary.stroke": {
    "value": "var(--ids-colors-mui-primary-stroke)",
    "variable": "var(--ids-colors-mui-primary-stroke)"
  },
  "colors.mui.primary.strokeHover": {
    "value": "var(--ids-colors-mui-primary-stroke-hover)",
    "variable": "var(--ids-colors-mui-primary-stroke-hover)"
  },
  "colors.mui.primary.lightHover": {
    "value": "var(--ids-colors-mui-primary-light-hover)",
    "variable": "var(--ids-colors-mui-primary-light-hover)"
  },
  "colors.mui.primary.lightActive": {
    "value": "var(--ids-colors-mui-primary-light-active)",
    "variable": "var(--ids-colors-mui-primary-light-active)"
  },
  "colors.mui.primary.light": {
    "value": "var(--ids-colors-mui-primary-light)",
    "variable": "var(--ids-colors-mui-primary-light)"
  },
  "colors.mui.primary.contrastText": {
    "value": "var(--ids-colors-mui-primary-contrast-text)",
    "variable": "var(--ids-colors-mui-primary-contrast-text)"
  },
  "colors.mui.secondary.dark": {
    "value": "var(--ids-colors-mui-secondary-dark)",
    "variable": "var(--ids-colors-mui-secondary-dark)"
  },
  "colors.mui.secondary.darkActive": {
    "value": "var(--ids-colors-mui-secondary-dark-active)",
    "variable": "var(--ids-colors-mui-secondary-dark-active)"
  },
  "colors.mui.secondary.darkHover": {
    "value": "var(--ids-colors-mui-secondary-dark-hover)",
    "variable": "var(--ids-colors-mui-secondary-dark-hover)"
  },
  "colors.mui.secondary.main": {
    "value": "var(--ids-colors-mui-secondary-main)",
    "variable": "var(--ids-colors-mui-secondary-main)"
  },
  "colors.mui.secondary.stroke": {
    "value": "var(--ids-colors-mui-secondary-stroke)",
    "variable": "var(--ids-colors-mui-secondary-stroke)"
  },
  "colors.mui.secondary.strokeHover": {
    "value": "var(--ids-colors-mui-secondary-stroke-hover)",
    "variable": "var(--ids-colors-mui-secondary-stroke-hover)"
  },
  "colors.mui.secondary.lightActive": {
    "value": "var(--ids-colors-mui-secondary-light-active)",
    "variable": "var(--ids-colors-mui-secondary-light-active)"
  },
  "colors.mui.secondary.lightHover": {
    "value": "var(--ids-colors-mui-secondary-light-hover)",
    "variable": "var(--ids-colors-mui-secondary-light-hover)"
  },
  "colors.mui.secondary.light": {
    "value": "var(--ids-colors-mui-secondary-light)",
    "variable": "var(--ids-colors-mui-secondary-light)"
  },
  "colors.mui.secondary.contrastText": {
    "value": "var(--ids-colors-mui-secondary-contrast-text)",
    "variable": "var(--ids-colors-mui-secondary-contrast-text)"
  },
  "colors.mui.error.dark": {
    "value": "var(--ids-colors-mui-error-dark)",
    "variable": "var(--ids-colors-mui-error-dark)"
  },
  "colors.mui.error.darkActive": {
    "value": "var(--ids-colors-mui-error-dark-active)",
    "variable": "var(--ids-colors-mui-error-dark-active)"
  },
  "colors.mui.error.darkHover": {
    "value": "var(--ids-colors-mui-error-dark-hover)",
    "variable": "var(--ids-colors-mui-error-dark-hover)"
  },
  "colors.mui.error.main": {
    "value": "var(--ids-colors-mui-error-main)",
    "variable": "var(--ids-colors-mui-error-main)"
  },
  "colors.mui.error.stroke": {
    "value": "var(--ids-colors-mui-error-stroke)",
    "variable": "var(--ids-colors-mui-error-stroke)"
  },
  "colors.mui.error.strokeHover": {
    "value": "var(--ids-colors-mui-error-stroke-hover)",
    "variable": "var(--ids-colors-mui-error-stroke-hover)"
  },
  "colors.mui.error.lightHover": {
    "value": "var(--ids-colors-mui-error-light-hover)",
    "variable": "var(--ids-colors-mui-error-light-hover)"
  },
  "colors.mui.error.lightActive": {
    "value": "var(--ids-colors-mui-error-light-active)",
    "variable": "var(--ids-colors-mui-error-light-active)"
  },
  "colors.mui.error.light": {
    "value": "var(--ids-colors-mui-error-light)",
    "variable": "var(--ids-colors-mui-error-light)"
  },
  "colors.mui.error.contrastText": {
    "value": "var(--ids-colors-mui-error-contrast-text)",
    "variable": "var(--ids-colors-mui-error-contrast-text)"
  },
  "colors.mui.warning.dark": {
    "value": "var(--ids-colors-mui-warning-dark)",
    "variable": "var(--ids-colors-mui-warning-dark)"
  },
  "colors.mui.warning.darkActive": {
    "value": "var(--ids-colors-mui-warning-dark-active)",
    "variable": "var(--ids-colors-mui-warning-dark-active)"
  },
  "colors.mui.warning.darkHover": {
    "value": "var(--ids-colors-mui-warning-dark-hover)",
    "variable": "var(--ids-colors-mui-warning-dark-hover)"
  },
  "colors.mui.warning.main": {
    "value": "var(--ids-colors-mui-warning-main)",
    "variable": "var(--ids-colors-mui-warning-main)"
  },
  "colors.mui.warning.stroke": {
    "value": "var(--ids-colors-mui-warning-stroke)",
    "variable": "var(--ids-colors-mui-warning-stroke)"
  },
  "colors.mui.warning.strokeHover": {
    "value": "var(--ids-colors-mui-warning-stroke-hover)",
    "variable": "var(--ids-colors-mui-warning-stroke-hover)"
  },
  "colors.mui.warning.lightActive": {
    "value": "var(--ids-colors-mui-warning-light-active)",
    "variable": "var(--ids-colors-mui-warning-light-active)"
  },
  "colors.mui.warning.lightHover": {
    "value": "var(--ids-colors-mui-warning-light-hover)",
    "variable": "var(--ids-colors-mui-warning-light-hover)"
  },
  "colors.mui.warning.light": {
    "value": "var(--ids-colors-mui-warning-light)",
    "variable": "var(--ids-colors-mui-warning-light)"
  },
  "colors.mui.warning.contrastText": {
    "value": "var(--ids-colors-mui-warning-contrast-text)",
    "variable": "var(--ids-colors-mui-warning-contrast-text)"
  },
  "colors.mui.info.dark": {
    "value": "var(--ids-colors-mui-info-dark)",
    "variable": "var(--ids-colors-mui-info-dark)"
  },
  "colors.mui.info.darkActive": {
    "value": "var(--ids-colors-mui-info-dark-active)",
    "variable": "var(--ids-colors-mui-info-dark-active)"
  },
  "colors.mui.info.darkHover": {
    "value": "var(--ids-colors-mui-info-dark-hover)",
    "variable": "var(--ids-colors-mui-info-dark-hover)"
  },
  "colors.mui.info.main": {
    "value": "var(--ids-colors-mui-info-main)",
    "variable": "var(--ids-colors-mui-info-main)"
  },
  "colors.mui.info.stroke": {
    "value": "var(--ids-colors-mui-info-stroke)",
    "variable": "var(--ids-colors-mui-info-stroke)"
  },
  "colors.mui.info.strokeHover": {
    "value": "var(--ids-colors-mui-info-stroke-hover)",
    "variable": "var(--ids-colors-mui-info-stroke-hover)"
  },
  "colors.mui.info.lightActive": {
    "value": "var(--ids-colors-mui-info-light-active)",
    "variable": "var(--ids-colors-mui-info-light-active)"
  },
  "colors.mui.info.lightHover": {
    "value": "var(--ids-colors-mui-info-light-hover)",
    "variable": "var(--ids-colors-mui-info-light-hover)"
  },
  "colors.mui.info.light": {
    "value": "var(--ids-colors-mui-info-light)",
    "variable": "var(--ids-colors-mui-info-light)"
  },
  "colors.mui.info.contrastText": {
    "value": "var(--ids-colors-mui-info-contrast-text)",
    "variable": "var(--ids-colors-mui-info-contrast-text)"
  },
  "colors.mui.text.primary": {
    "value": "var(--ids-colors-mui-text-primary)",
    "variable": "var(--ids-colors-mui-text-primary)"
  },
  "colors.mui.text.secondary": {
    "value": "var(--ids-colors-mui-text-secondary)",
    "variable": "var(--ids-colors-mui-text-secondary)"
  },
  "colors.mui.text.tertiary": {
    "value": "var(--ids-colors-mui-text-tertiary)",
    "variable": "var(--ids-colors-mui-text-tertiary)"
  },
  "colors.mui.background.primary": {
    "value": "var(--ids-colors-mui-background-primary)",
    "variable": "var(--ids-colors-mui-background-primary)"
  },
  "colors.mui.background.secondary": {
    "value": "var(--ids-colors-mui-background-secondary)",
    "variable": "var(--ids-colors-mui-background-secondary)"
  },
  "colors.mui.background.tertiary": {
    "value": "var(--ids-colors-mui-background-tertiary)",
    "variable": "var(--ids-colors-mui-background-tertiary)"
  },
  "colors.mui.background.default": {
    "value": "var(--ids-colors-mui-background-default)",
    "variable": "var(--ids-colors-mui-background-default)"
  },
  "colors.gradient.purpleBlue": {
    "value": "var(--ids-colors-gradient-purple-blue)",
    "variable": "var(--ids-colors-gradient-purple-blue)"
  },
  "colors.gradient.purpleMagenta": {
    "value": "var(--ids-colors-gradient-purple-magenta)",
    "variable": "var(--ids-colors-gradient-purple-magenta)"
  },
  "colors.gradient.purpleBlueEnd": {
    "value": "var(--ids-colors-gradient-purple-blue-end)",
    "variable": "var(--ids-colors-gradient-purple-blue-end)"
  },
  "colors.goes.light.100": {
    "value": "var(--ids-colors-goes-light-100)",
    "variable": "var(--ids-colors-goes-light-100)"
  },
  "colors.goes.light.200": {
    "value": "var(--ids-colors-goes-light-200)",
    "variable": "var(--ids-colors-goes-light-200)"
  },
  "colors.goes.light.300": {
    "value": "var(--ids-colors-goes-light-300)",
    "variable": "var(--ids-colors-goes-light-300)"
  },
  "colors.goes.light.400": {
    "value": "var(--ids-colors-goes-light-400)",
    "variable": "var(--ids-colors-goes-light-400)"
  },
  "colors.goes.light.500": {
    "value": "var(--ids-colors-goes-light-500)",
    "variable": "var(--ids-colors-goes-light-500)"
  },
  "colors.goes.light.600": {
    "value": "var(--ids-colors-goes-light-600)",
    "variable": "var(--ids-colors-goes-light-600)"
  },
  "colors.goes.light.700": {
    "value": "var(--ids-colors-goes-light-700)",
    "variable": "var(--ids-colors-goes-light-700)"
  },
  "colors.goes.light.800": {
    "value": "var(--ids-colors-goes-light-800)",
    "variable": "var(--ids-colors-goes-light-800)"
  },
  "colors.goes.light.900": {
    "value": "var(--ids-colors-goes-light-900)",
    "variable": "var(--ids-colors-goes-light-900)"
  },
  "colors.goes.light.1000": {
    "value": "var(--ids-colors-goes-light-1000)",
    "variable": "var(--ids-colors-goes-light-1000)"
  },
  "colors.goes.light.1100": {
    "value": "var(--ids-colors-goes-light-1100)",
    "variable": "var(--ids-colors-goes-light-1100)"
  },
  "colors.goes.light.1200": {
    "value": "var(--ids-colors-goes-light-1200)",
    "variable": "var(--ids-colors-goes-light-1200)"
  },
  "colors.goes.light.a100": {
    "value": "var(--ids-colors-goes-light-a100)",
    "variable": "var(--ids-colors-goes-light-a100)"
  },
  "colors.goes.light.a200": {
    "value": "var(--ids-colors-goes-light-a200)",
    "variable": "var(--ids-colors-goes-light-a200)"
  },
  "colors.goes.light.a300": {
    "value": "var(--ids-colors-goes-light-a300)",
    "variable": "var(--ids-colors-goes-light-a300)"
  },
  "colors.goes.light.a400": {
    "value": "var(--ids-colors-goes-light-a400)",
    "variable": "var(--ids-colors-goes-light-a400)"
  },
  "colors.goes.light.a500": {
    "value": "var(--ids-colors-goes-light-a500)",
    "variable": "var(--ids-colors-goes-light-a500)"
  },
  "colors.goes.light.a600": {
    "value": "var(--ids-colors-goes-light-a600)",
    "variable": "var(--ids-colors-goes-light-a600)"
  },
  "colors.goes.blue.light.100": {
    "value": "var(--ids-colors-goes-blue-light-100)",
    "variable": "var(--ids-colors-goes-blue-light-100)"
  },
  "colors.goes.blue.light.200": {
    "value": "var(--ids-colors-goes-blue-light-200)",
    "variable": "var(--ids-colors-goes-blue-light-200)"
  },
  "colors.goes.blue.light.300": {
    "value": "var(--ids-colors-goes-blue-light-300)",
    "variable": "var(--ids-colors-goes-blue-light-300)"
  },
  "colors.goes.blue.light.400": {
    "value": "var(--ids-colors-goes-blue-light-400)",
    "variable": "var(--ids-colors-goes-blue-light-400)"
  },
  "colors.goes.blue.light.500": {
    "value": "var(--ids-colors-goes-blue-light-500)",
    "variable": "var(--ids-colors-goes-blue-light-500)"
  },
  "colors.goes.blue.light.600": {
    "value": "var(--ids-colors-goes-blue-light-600)",
    "variable": "var(--ids-colors-goes-blue-light-600)"
  },
  "colors.goes.blue.light.700": {
    "value": "var(--ids-colors-goes-blue-light-700)",
    "variable": "var(--ids-colors-goes-blue-light-700)"
  },
  "colors.goes.blue.light.800": {
    "value": "var(--ids-colors-goes-blue-light-800)",
    "variable": "var(--ids-colors-goes-blue-light-800)"
  },
  "colors.goes.blue.light.900": {
    "value": "var(--ids-colors-goes-blue-light-900)",
    "variable": "var(--ids-colors-goes-blue-light-900)"
  },
  "colors.goes.blue.light.1000": {
    "value": "var(--ids-colors-goes-blue-light-1000)",
    "variable": "var(--ids-colors-goes-blue-light-1000)"
  },
  "colors.goes.blue.light.1100": {
    "value": "var(--ids-colors-goes-blue-light-1100)",
    "variable": "var(--ids-colors-goes-blue-light-1100)"
  },
  "colors.goes.blue.light.1200": {
    "value": "var(--ids-colors-goes-blue-light-1200)",
    "variable": "var(--ids-colors-goes-blue-light-1200)"
  },
  "colors.goes.blue.light.a100": {
    "value": "var(--ids-colors-goes-blue-light-a100)",
    "variable": "var(--ids-colors-goes-blue-light-a100)"
  },
  "colors.goes.blue.light.a200": {
    "value": "var(--ids-colors-goes-blue-light-a200)",
    "variable": "var(--ids-colors-goes-blue-light-a200)"
  },
  "colors.goes.blue.light.a300": {
    "value": "var(--ids-colors-goes-blue-light-a300)",
    "variable": "var(--ids-colors-goes-blue-light-a300)"
  },
  "colors.goes.green.light.100": {
    "value": "var(--ids-colors-goes-green-light-100)",
    "variable": "var(--ids-colors-goes-green-light-100)"
  },
  "colors.goes.green.light.200": {
    "value": "var(--ids-colors-goes-green-light-200)",
    "variable": "var(--ids-colors-goes-green-light-200)"
  },
  "colors.goes.green.light.300": {
    "value": "var(--ids-colors-goes-green-light-300)",
    "variable": "var(--ids-colors-goes-green-light-300)"
  },
  "colors.goes.green.light.400": {
    "value": "var(--ids-colors-goes-green-light-400)",
    "variable": "var(--ids-colors-goes-green-light-400)"
  },
  "colors.goes.green.light.500": {
    "value": "var(--ids-colors-goes-green-light-500)",
    "variable": "var(--ids-colors-goes-green-light-500)"
  },
  "colors.goes.green.light.600": {
    "value": "var(--ids-colors-goes-green-light-600)",
    "variable": "var(--ids-colors-goes-green-light-600)"
  },
  "colors.goes.green.light.700": {
    "value": "var(--ids-colors-goes-green-light-700)",
    "variable": "var(--ids-colors-goes-green-light-700)"
  },
  "colors.goes.green.light.800": {
    "value": "var(--ids-colors-goes-green-light-800)",
    "variable": "var(--ids-colors-goes-green-light-800)"
  },
  "colors.goes.green.light.900": {
    "value": "var(--ids-colors-goes-green-light-900)",
    "variable": "var(--ids-colors-goes-green-light-900)"
  },
  "colors.goes.green.light.1000": {
    "value": "var(--ids-colors-goes-green-light-1000)",
    "variable": "var(--ids-colors-goes-green-light-1000)"
  },
  "colors.goes.green.light.1100": {
    "value": "var(--ids-colors-goes-green-light-1100)",
    "variable": "var(--ids-colors-goes-green-light-1100)"
  },
  "colors.goes.green.light.1200": {
    "value": "var(--ids-colors-goes-green-light-1200)",
    "variable": "var(--ids-colors-goes-green-light-1200)"
  },
  "colors.goes.green.light.a100": {
    "value": "var(--ids-colors-goes-green-light-a100)",
    "variable": "var(--ids-colors-goes-green-light-a100)"
  },
  "colors.goes.green.light.a200": {
    "value": "var(--ids-colors-goes-green-light-a200)",
    "variable": "var(--ids-colors-goes-green-light-a200)"
  },
  "colors.goes.green.light.a300": {
    "value": "var(--ids-colors-goes-green-light-a300)",
    "variable": "var(--ids-colors-goes-green-light-a300)"
  },
  "colors.goes.orange.light.100": {
    "value": "var(--ids-colors-goes-orange-light-100)",
    "variable": "var(--ids-colors-goes-orange-light-100)"
  },
  "colors.goes.orange.light.200": {
    "value": "var(--ids-colors-goes-orange-light-200)",
    "variable": "var(--ids-colors-goes-orange-light-200)"
  },
  "colors.goes.orange.light.300": {
    "value": "var(--ids-colors-goes-orange-light-300)",
    "variable": "var(--ids-colors-goes-orange-light-300)"
  },
  "colors.goes.orange.light.400": {
    "value": "var(--ids-colors-goes-orange-light-400)",
    "variable": "var(--ids-colors-goes-orange-light-400)"
  },
  "colors.goes.orange.light.500": {
    "value": "var(--ids-colors-goes-orange-light-500)",
    "variable": "var(--ids-colors-goes-orange-light-500)"
  },
  "colors.goes.orange.light.600": {
    "value": "var(--ids-colors-goes-orange-light-600)",
    "variable": "var(--ids-colors-goes-orange-light-600)"
  },
  "colors.goes.orange.light.650": {
    "value": "var(--ids-colors-goes-orange-light-650)",
    "variable": "var(--ids-colors-goes-orange-light-650)"
  },
  "colors.goes.orange.light.700": {
    "value": "var(--ids-colors-goes-orange-light-700)",
    "variable": "var(--ids-colors-goes-orange-light-700)"
  },
  "colors.goes.orange.light.800": {
    "value": "var(--ids-colors-goes-orange-light-800)",
    "variable": "var(--ids-colors-goes-orange-light-800)"
  },
  "colors.goes.orange.light.900": {
    "value": "var(--ids-colors-goes-orange-light-900)",
    "variable": "var(--ids-colors-goes-orange-light-900)"
  },
  "colors.goes.orange.light.1000": {
    "value": "var(--ids-colors-goes-orange-light-1000)",
    "variable": "var(--ids-colors-goes-orange-light-1000)"
  },
  "colors.goes.orange.light.1100": {
    "value": "var(--ids-colors-goes-orange-light-1100)",
    "variable": "var(--ids-colors-goes-orange-light-1100)"
  },
  "colors.goes.orange.light.1200": {
    "value": "var(--ids-colors-goes-orange-light-1200)",
    "variable": "var(--ids-colors-goes-orange-light-1200)"
  },
  "colors.goes.orange.light.a100": {
    "value": "var(--ids-colors-goes-orange-light-a100)",
    "variable": "var(--ids-colors-goes-orange-light-a100)"
  },
  "colors.goes.orange.light.a200": {
    "value": "var(--ids-colors-goes-orange-light-a200)",
    "variable": "var(--ids-colors-goes-orange-light-a200)"
  },
  "colors.goes.orange.light.a300": {
    "value": "var(--ids-colors-goes-orange-light-a300)",
    "variable": "var(--ids-colors-goes-orange-light-a300)"
  },
  "colors.goes.violet.light.100": {
    "value": "var(--ids-colors-goes-violet-light-100)",
    "variable": "var(--ids-colors-goes-violet-light-100)"
  },
  "colors.goes.violet.light.200": {
    "value": "var(--ids-colors-goes-violet-light-200)",
    "variable": "var(--ids-colors-goes-violet-light-200)"
  },
  "colors.goes.violet.light.300": {
    "value": "var(--ids-colors-goes-violet-light-300)",
    "variable": "var(--ids-colors-goes-violet-light-300)"
  },
  "colors.goes.violet.light.400": {
    "value": "var(--ids-colors-goes-violet-light-400)",
    "variable": "var(--ids-colors-goes-violet-light-400)"
  },
  "colors.goes.violet.light.500": {
    "value": "var(--ids-colors-goes-violet-light-500)",
    "variable": "var(--ids-colors-goes-violet-light-500)"
  },
  "colors.goes.violet.light.600": {
    "value": "var(--ids-colors-goes-violet-light-600)",
    "variable": "var(--ids-colors-goes-violet-light-600)"
  },
  "colors.goes.violet.light.700": {
    "value": "var(--ids-colors-goes-violet-light-700)",
    "variable": "var(--ids-colors-goes-violet-light-700)"
  },
  "colors.goes.violet.light.800": {
    "value": "var(--ids-colors-goes-violet-light-800)",
    "variable": "var(--ids-colors-goes-violet-light-800)"
  },
  "colors.goes.violet.light.900": {
    "value": "var(--ids-colors-goes-violet-light-900)",
    "variable": "var(--ids-colors-goes-violet-light-900)"
  },
  "colors.goes.violet.light.1000": {
    "value": "var(--ids-colors-goes-violet-light-1000)",
    "variable": "var(--ids-colors-goes-violet-light-1000)"
  },
  "colors.goes.violet.light.1100": {
    "value": "var(--ids-colors-goes-violet-light-1100)",
    "variable": "var(--ids-colors-goes-violet-light-1100)"
  },
  "colors.goes.violet.light.1200": {
    "value": "var(--ids-colors-goes-violet-light-1200)",
    "variable": "var(--ids-colors-goes-violet-light-1200)"
  },
  "colors.goes.violet.light.a100": {
    "value": "var(--ids-colors-goes-violet-light-a100)",
    "variable": "var(--ids-colors-goes-violet-light-a100)"
  },
  "colors.goes.violet.light.a200": {
    "value": "var(--ids-colors-goes-violet-light-a200)",
    "variable": "var(--ids-colors-goes-violet-light-a200)"
  },
  "colors.goes.violet.light.a300": {
    "value": "var(--ids-colors-goes-violet-light-a300)",
    "variable": "var(--ids-colors-goes-violet-light-a300)"
  },
  "colors.goes.red.light.100": {
    "value": "var(--ids-colors-goes-red-light-100)",
    "variable": "var(--ids-colors-goes-red-light-100)"
  },
  "colors.goes.red.light.200": {
    "value": "var(--ids-colors-goes-red-light-200)",
    "variable": "var(--ids-colors-goes-red-light-200)"
  },
  "colors.goes.red.light.300": {
    "value": "var(--ids-colors-goes-red-light-300)",
    "variable": "var(--ids-colors-goes-red-light-300)"
  },
  "colors.goes.red.light.400": {
    "value": "var(--ids-colors-goes-red-light-400)",
    "variable": "var(--ids-colors-goes-red-light-400)"
  },
  "colors.goes.red.light.500": {
    "value": "var(--ids-colors-goes-red-light-500)",
    "variable": "var(--ids-colors-goes-red-light-500)"
  },
  "colors.goes.red.light.600": {
    "value": "var(--ids-colors-goes-red-light-600)",
    "variable": "var(--ids-colors-goes-red-light-600)"
  },
  "colors.goes.red.light.700": {
    "value": "var(--ids-colors-goes-red-light-700)",
    "variable": "var(--ids-colors-goes-red-light-700)"
  },
  "colors.goes.red.light.800": {
    "value": "var(--ids-colors-goes-red-light-800)",
    "variable": "var(--ids-colors-goes-red-light-800)"
  },
  "colors.goes.red.light.900": {
    "value": "var(--ids-colors-goes-red-light-900)",
    "variable": "var(--ids-colors-goes-red-light-900)"
  },
  "colors.goes.red.light.1000": {
    "value": "var(--ids-colors-goes-red-light-1000)",
    "variable": "var(--ids-colors-goes-red-light-1000)"
  },
  "colors.goes.red.light.1100": {
    "value": "var(--ids-colors-goes-red-light-1100)",
    "variable": "var(--ids-colors-goes-red-light-1100)"
  },
  "colors.goes.red.light.1200": {
    "value": "var(--ids-colors-goes-red-light-1200)",
    "variable": "var(--ids-colors-goes-red-light-1200)"
  },
  "colors.goes.red.light.a100": {
    "value": "var(--ids-colors-goes-red-light-a100)",
    "variable": "var(--ids-colors-goes-red-light-a100)"
  },
  "colors.goes.red.light.a200": {
    "value": "var(--ids-colors-goes-red-light-a200)",
    "variable": "var(--ids-colors-goes-red-light-a200)"
  },
  "colors.goes.red.light.a300": {
    "value": "var(--ids-colors-goes-red-light-a300)",
    "variable": "var(--ids-colors-goes-red-light-a300)"
  },
  "radii.2": {
    "value": "var(--ids-radii-2)",
    "variable": "var(--ids-radii-2)"
  },
  "radii.4": {
    "value": "var(--ids-radii-4)",
    "variable": "var(--ids-radii-4)"
  },
  "radii.6": {
    "value": "var(--ids-radii-6)",
    "variable": "var(--ids-radii-6)"
  },
  "radii.8": {
    "value": "var(--ids-radii-8)",
    "variable": "var(--ids-radii-8)"
  },
  "radii.10": {
    "value": "var(--ids-radii-10)",
    "variable": "var(--ids-radii-10)"
  },
  "radii.12": {
    "value": "var(--ids-radii-12)",
    "variable": "var(--ids-radii-12)"
  },
  "radii.16": {
    "value": "var(--ids-radii-16)",
    "variable": "var(--ids-radii-16)"
  },
  "radii.20": {
    "value": "var(--ids-radii-20)",
    "variable": "var(--ids-radii-20)"
  },
  "radii.24": {
    "value": "var(--ids-radii-24)",
    "variable": "var(--ids-radii-24)"
  },
  "radii.32": {
    "value": "var(--ids-radii-32)",
    "variable": "var(--ids-radii-32)"
  },
  "radii.36": {
    "value": "var(--ids-radii-36)",
    "variable": "var(--ids-radii-36)"
  },
  "radii.xs": {
    "value": "var(--ids-radii-xs)",
    "variable": "var(--ids-radii-xs)"
  },
  "radii.sm": {
    "value": "var(--ids-radii-sm)",
    "variable": "var(--ids-radii-sm)"
  },
  "radii.md": {
    "value": "var(--ids-radii-md)",
    "variable": "var(--ids-radii-md)"
  },
  "radii.lg": {
    "value": "var(--ids-radii-lg)",
    "variable": "var(--ids-radii-lg)"
  },
  "radii.xl": {
    "value": "var(--ids-radii-xl)",
    "variable": "var(--ids-radii-xl)"
  },
  "radii.2xl": {
    "value": "var(--ids-radii-2xl)",
    "variable": "var(--ids-radii-2xl)"
  },
  "radii.full": {
    "value": "var(--ids-radii-full)",
    "variable": "var(--ids-radii-full)"
  },
  "shadows.1": {
    "value": "var(--ids-shadows-1)",
    "variable": "var(--ids-shadows-1)"
  },
  "shadows.2": {
    "value": "var(--ids-shadows-2)",
    "variable": "var(--ids-shadows-2)"
  },
  "shadows.3": {
    "value": "var(--ids-shadows-3)",
    "variable": "var(--ids-shadows-3)"
  },
  "shadows.4": {
    "value": "var(--ids-shadows-4)",
    "variable": "var(--ids-shadows-4)"
  },
  "shadows.5": {
    "value": "var(--ids-shadows-5)",
    "variable": "var(--ids-shadows-5)"
  },
  "shadows.none": {
    "value": "var(--ids-shadows-none)",
    "variable": "var(--ids-shadows-none)"
  },
  "shadows.core.1": {
    "value": "var(--ids-shadows-core-1)",
    "variable": "var(--ids-shadows-core-1)"
  },
  "shadows.core.2": {
    "value": "var(--ids-shadows-core-2)",
    "variable": "var(--ids-shadows-core-2)"
  },
  "shadows.core.3": {
    "value": "var(--ids-shadows-core-3)",
    "variable": "var(--ids-shadows-core-3)"
  },
  "shadows.core.4": {
    "value": "var(--ids-shadows-core-4)",
    "variable": "var(--ids-shadows-core-4)"
  },
  "shadows.core.5": {
    "value": "var(--ids-shadows-core-5)",
    "variable": "var(--ids-shadows-core-5)"
  },
  "zIndex.mobileStepper": {
    "value": "var(--ids-z-index-mobile-stepper)",
    "variable": "var(--ids-z-index-mobile-stepper)"
  },
  "zIndex.fab": {
    "value": "var(--ids-z-index-fab)",
    "variable": "var(--ids-z-index-fab)"
  },
  "zIndex.speedDial": {
    "value": "var(--ids-z-index-speed-dial)",
    "variable": "var(--ids-z-index-speed-dial)"
  },
  "zIndex.appBar": {
    "value": "var(--ids-z-index-app-bar)",
    "variable": "var(--ids-z-index-app-bar)"
  },
  "zIndex.drawer": {
    "value": "var(--ids-z-index-drawer)",
    "variable": "var(--ids-z-index-drawer)"
  },
  "zIndex.modal": {
    "value": "var(--ids-z-index-modal)",
    "variable": "var(--ids-z-index-modal)"
  },
  "zIndex.popoverOverModal": {
    "value": "var(--ids-z-index-popover-over-modal)",
    "variable": "var(--ids-z-index-popover-over-modal)"
  },
  "zIndex.snackbar": {
    "value": "var(--ids-z-index-snackbar)",
    "variable": "var(--ids-z-index-snackbar)"
  },
  "zIndex.tooltip": {
    "value": "var(--ids-z-index-tooltip)",
    "variable": "var(--ids-z-index-tooltip)"
  },
  "zIndex.syncBorder": {
    "value": "var(--ids-z-index-sync-border)",
    "variable": "var(--ids-z-index-sync-border)"
  },
  "aspectRatios.16:9": {
    "value": "var(--ids-aspect-ratios-16\\:9)",
    "variable": "var(--ids-aspect-ratios-16\\:9)"
  },
  "aspectRatios.4:3": {
    "value": "var(--ids-aspect-ratios-4\\:3)",
    "variable": "var(--ids-aspect-ratios-4\\:3)"
  },
  "aspectRatios.2:3": {
    "value": "var(--ids-aspect-ratios-2\\:3)",
    "variable": "var(--ids-aspect-ratios-2\\:3)"
  },
  "aspectRatios.3:4": {
    "value": "var(--ids-aspect-ratios-3\\:4)",
    "variable": "var(--ids-aspect-ratios-3\\:4)"
  },
  "aspectRatios.3:2": {
    "value": "var(--ids-aspect-ratios-3\\:2)",
    "variable": "var(--ids-aspect-ratios-3\\:2)"
  },
  "aspectRatios.2:1": {
    "value": "var(--ids-aspect-ratios-2\\:1)",
    "variable": "var(--ids-aspect-ratios-2\\:1)"
  },
  "aspectRatios.1:1": {
    "value": "var(--ids-aspect-ratios-1\\:1)",
    "variable": "var(--ids-aspect-ratios-1\\:1)"
  },
  "opacity.10": {
    "value": "var(--ids-opacity-10)",
    "variable": "var(--ids-opacity-10)"
  },
  "opacity.20": {
    "value": "var(--ids-opacity-20)",
    "variable": "var(--ids-opacity-20)"
  },
  "opacity.30": {
    "value": "var(--ids-opacity-30)",
    "variable": "var(--ids-opacity-30)"
  },
  "opacity.40": {
    "value": "var(--ids-opacity-40)",
    "variable": "var(--ids-opacity-40)"
  },
  "opacity.50": {
    "value": "var(--ids-opacity-50)",
    "variable": "var(--ids-opacity-50)"
  },
  "opacity.60": {
    "value": "var(--ids-opacity-60)",
    "variable": "var(--ids-opacity-60)"
  },
  "opacity.70": {
    "value": "var(--ids-opacity-70)",
    "variable": "var(--ids-opacity-70)"
  },
  "opacity.80": {
    "value": "var(--ids-opacity-80)",
    "variable": "var(--ids-opacity-80)"
  },
  "opacity.90": {
    "value": "var(--ids-opacity-90)",
    "variable": "var(--ids-opacity-90)"
  },
  "opacity.100": {
    "value": "var(--ids-opacity-100)",
    "variable": "var(--ids-opacity-100)"
  },
  "opacity.disable": {
    "value": "var(--ids-opacity-disable)",
    "variable": "var(--ids-opacity-disable)"
  },
  "spacing.0": {
    "value": "var(--ids-spacing-0)",
    "variable": "var(--ids-spacing-0)"
  },
  "spacing.2": {
    "value": "var(--ids-spacing-2)",
    "variable": "var(--ids-spacing-2)"
  },
  "spacing.4": {
    "value": "var(--ids-spacing-4)",
    "variable": "var(--ids-spacing-4)"
  },
  "spacing.6": {
    "value": "var(--ids-spacing-6)",
    "variable": "var(--ids-spacing-6)"
  },
  "spacing.8": {
    "value": "var(--ids-spacing-8)",
    "variable": "var(--ids-spacing-8)"
  },
  "spacing.10": {
    "value": "var(--ids-spacing-10)",
    "variable": "var(--ids-spacing-10)"
  },
  "spacing.12": {
    "value": "var(--ids-spacing-12)",
    "variable": "var(--ids-spacing-12)"
  },
  "spacing.16": {
    "value": "var(--ids-spacing-16)",
    "variable": "var(--ids-spacing-16)"
  },
  "spacing.20": {
    "value": "var(--ids-spacing-20)",
    "variable": "var(--ids-spacing-20)"
  },
  "spacing.24": {
    "value": "var(--ids-spacing-24)",
    "variable": "var(--ids-spacing-24)"
  },
  "spacing.26": {
    "value": "var(--ids-spacing-26)",
    "variable": "var(--ids-spacing-26)"
  },
  "spacing.28": {
    "value": "var(--ids-spacing-28)",
    "variable": "var(--ids-spacing-28)"
  },
  "spacing.32": {
    "value": "var(--ids-spacing-32)",
    "variable": "var(--ids-spacing-32)"
  },
  "spacing.36": {
    "value": "var(--ids-spacing-36)",
    "variable": "var(--ids-spacing-36)"
  },
  "spacing.40": {
    "value": "var(--ids-spacing-40)",
    "variable": "var(--ids-spacing-40)"
  },
  "spacing.44": {
    "value": "var(--ids-spacing-44)",
    "variable": "var(--ids-spacing-44)"
  },
  "spacing.48": {
    "value": "var(--ids-spacing-48)",
    "variable": "var(--ids-spacing-48)"
  },
  "spacing.56": {
    "value": "var(--ids-spacing-56)",
    "variable": "var(--ids-spacing-56)"
  },
  "spacing.64": {
    "value": "var(--ids-spacing-64)",
    "variable": "var(--ids-spacing-64)"
  },
  "spacing.80": {
    "value": "var(--ids-spacing-80)",
    "variable": "var(--ids-spacing-80)"
  },
  "spacing.-4": {
    "value": "var(--ids-spacing-4)",
    "variable": "var(--ids-spacing-4)"
  },
  "spacing.-6": {
    "value": "var(--ids-spacing-6)",
    "variable": "var(--ids-spacing-6)"
  },
  "spacing.-8": {
    "value": "var(--ids-spacing-8)",
    "variable": "var(--ids-spacing-8)"
  },
  "spacing.-10": {
    "value": "var(--ids-spacing-10)",
    "variable": "var(--ids-spacing-10)"
  },
  "spacing.-14": {
    "value": "var(--ids-spacing--14)",
    "variable": "var(--ids-spacing--14)"
  },
  "breakpoints.xs": {
    "value": "0px",
    "variable": "var(--ids-breakpoints-xs)"
  },
  "breakpoints.sm": {
    "value": "600px",
    "variable": "var(--ids-breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "960px",
    "variable": "var(--ids-breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "1280px",
    "variable": "var(--ids-breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "1920px",
    "variable": "var(--ids-breakpoints-xl)"
  },
  "sizes.breakpoint-xs": {
    "value": "0px",
    "variable": "var(--ids-sizes-breakpoint-xs)"
  },
  "sizes.breakpoint-sm": {
    "value": "600px",
    "variable": "var(--ids-sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "960px",
    "variable": "var(--ids-sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "1280px",
    "variable": "var(--ids-sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "1920px",
    "variable": "var(--ids-sizes-breakpoint-xl)"
  },
  "fontSizes.caption3": {
    "value": "var(--ids-font-sizes-caption3)",
    "variable": "var(--ids-font-sizes-caption3)"
  },
  "colors.other.focusIndicator": {
    "value": "var(--ids-colors-other-focus-indicator)",
    "variable": "var(--ids-colors-other-focus-indicator)"
  },
  "colors.other.chat.normal": {
    "value": "var(--ids-colors-other-chat-normal)",
    "variable": "var(--ids-colors-other-chat-normal)"
  },
  "colors.other.rating.normal": {
    "value": "var(--ids-colors-other-rating-normal)",
    "variable": "var(--ids-colors-other-rating-normal)"
  },
  "colors.other.text.inverse": {
    "value": "var(--ids-colors-other-text-inverse)",
    "variable": "var(--ids-colors-other-text-inverse)"
  },
  "colors.common.1": {
    "value": "var(--ids-colors-common-1)",
    "variable": "var(--ids-colors-common-1)"
  },
  "colors.common.2": {
    "value": "var(--ids-colors-common-2)",
    "variable": "var(--ids-colors-common-2)"
  },
  "colors.common.3": {
    "value": "var(--ids-colors-common-3)",
    "variable": "var(--ids-colors-common-3)"
  },
  "colors.common.4": {
    "value": "var(--ids-colors-common-4)",
    "variable": "var(--ids-colors-common-4)"
  },
  "colors.common.5": {
    "value": "var(--ids-colors-common-5)",
    "variable": "var(--ids-colors-common-5)"
  },
  "colors.common.6": {
    "value": "var(--ids-colors-common-6)",
    "variable": "var(--ids-colors-common-6)"
  },
  "colors.common.7": {
    "value": "var(--ids-colors-common-7)",
    "variable": "var(--ids-colors-common-7)"
  },
  "colors.common.8": {
    "value": "var(--ids-colors-common-8)",
    "variable": "var(--ids-colors-common-8)"
  },
  "colors.common.9": {
    "value": "var(--ids-colors-common-9)",
    "variable": "var(--ids-colors-common-9)"
  },
  "colors.common.10": {
    "value": "var(--ids-colors-common-10)",
    "variable": "var(--ids-colors-common-10)"
  },
  "colors.common.11": {
    "value": "var(--ids-colors-common-11)",
    "variable": "var(--ids-colors-common-11)"
  },
  "colors.common.12": {
    "value": "var(--ids-colors-common-12)",
    "variable": "var(--ids-colors-common-12)"
  },
  "colors.common.a1": {
    "value": "var(--ids-colors-common-a1)",
    "variable": "var(--ids-colors-common-a1)"
  },
  "colors.common.a2": {
    "value": "var(--ids-colors-common-a2)",
    "variable": "var(--ids-colors-common-a2)"
  },
  "colors.common.a3": {
    "value": "var(--ids-colors-common-a3)",
    "variable": "var(--ids-colors-common-a3)"
  },
  "colors.common.mediumBg.normal": {
    "value": "var(--ids-colors-common-medium-bg-normal)",
    "variable": "var(--ids-colors-common-medium-bg-normal)"
  },
  "colors.common.gradient.purpleBlue": {
    "value": "var(--ids-colors-common-gradient-purple-blue)",
    "variable": "var(--ids-colors-common-gradient-purple-blue)"
  },
  "colors.success.1": {
    "value": "var(--ids-colors-success-1)",
    "variable": "var(--ids-colors-success-1)"
  },
  "colors.success.2": {
    "value": "var(--ids-colors-success-2)",
    "variable": "var(--ids-colors-success-2)"
  },
  "colors.success.3": {
    "value": "var(--ids-colors-success-3)",
    "variable": "var(--ids-colors-success-3)"
  },
  "colors.success.4": {
    "value": "var(--ids-colors-success-4)",
    "variable": "var(--ids-colors-success-4)"
  },
  "colors.success.5": {
    "value": "var(--ids-colors-success-5)",
    "variable": "var(--ids-colors-success-5)"
  },
  "colors.success.6": {
    "value": "var(--ids-colors-success-6)",
    "variable": "var(--ids-colors-success-6)"
  },
  "colors.success.7": {
    "value": "var(--ids-colors-success-7)",
    "variable": "var(--ids-colors-success-7)"
  },
  "colors.success.8": {
    "value": "var(--ids-colors-success-8)",
    "variable": "var(--ids-colors-success-8)"
  },
  "colors.success.9": {
    "value": "var(--ids-colors-success-9)",
    "variable": "var(--ids-colors-success-9)"
  },
  "colors.success.10": {
    "value": "var(--ids-colors-success-10)",
    "variable": "var(--ids-colors-success-10)"
  },
  "colors.success.11": {
    "value": "var(--ids-colors-success-11)",
    "variable": "var(--ids-colors-success-11)"
  },
  "colors.success.12": {
    "value": "var(--ids-colors-success-12)",
    "variable": "var(--ids-colors-success-12)"
  },
  "colors.success.a1": {
    "value": "var(--ids-colors-success-a1)",
    "variable": "var(--ids-colors-success-a1)"
  },
  "colors.success.a2": {
    "value": "var(--ids-colors-success-a2)",
    "variable": "var(--ids-colors-success-a2)"
  },
  "colors.success.a3": {
    "value": "var(--ids-colors-success-a3)",
    "variable": "var(--ids-colors-success-a3)"
  },
  "colors.success.bg.base": {
    "value": "var(--ids-colors-success-bg-base)",
    "variable": "var(--ids-colors-success-bg-base)"
  },
  "colors.success.bg.highest": {
    "value": "var(--ids-colors-success-bg-highest)",
    "variable": "var(--ids-colors-success-bg-highest)"
  },
  "colors.success.bg.low": {
    "value": "var(--ids-colors-success-bg-low)",
    "variable": "var(--ids-colors-success-bg-low)"
  },
  "colors.success.border.base": {
    "value": "var(--ids-colors-success-border-base)",
    "variable": "var(--ids-colors-success-border-base)"
  },
  "colors.success.border.highest": {
    "value": "var(--ids-colors-success-border-highest)",
    "variable": "var(--ids-colors-success-border-highest)"
  },
  "colors.success.fg.base": {
    "value": "var(--ids-colors-success-fg-base)",
    "variable": "var(--ids-colors-success-fg-base)"
  },
  "colors.success.fg.low": {
    "value": "var(--ids-colors-success-fg-low)",
    "variable": "var(--ids-colors-success-fg-low)"
  },
  "colors.success.ghostBg.base": {
    "value": "var(--ids-colors-success-ghost-bg-base)",
    "variable": "var(--ids-colors-success-ghost-bg-base)"
  },
  "colors.success.text.base": {
    "value": "var(--ids-colors-success-text-base)",
    "variable": "var(--ids-colors-success-text-base)"
  },
  "colors.error.1": {
    "value": "var(--ids-colors-error-1)",
    "variable": "var(--ids-colors-error-1)"
  },
  "colors.error.2": {
    "value": "var(--ids-colors-error-2)",
    "variable": "var(--ids-colors-error-2)"
  },
  "colors.error.3": {
    "value": "var(--ids-colors-error-3)",
    "variable": "var(--ids-colors-error-3)"
  },
  "colors.error.4": {
    "value": "var(--ids-colors-error-4)",
    "variable": "var(--ids-colors-error-4)"
  },
  "colors.error.5": {
    "value": "var(--ids-colors-error-5)",
    "variable": "var(--ids-colors-error-5)"
  },
  "colors.error.6": {
    "value": "var(--ids-colors-error-6)",
    "variable": "var(--ids-colors-error-6)"
  },
  "colors.error.7": {
    "value": "var(--ids-colors-error-7)",
    "variable": "var(--ids-colors-error-7)"
  },
  "colors.error.8": {
    "value": "var(--ids-colors-error-8)",
    "variable": "var(--ids-colors-error-8)"
  },
  "colors.error.9": {
    "value": "var(--ids-colors-error-9)",
    "variable": "var(--ids-colors-error-9)"
  },
  "colors.error.10": {
    "value": "var(--ids-colors-error-10)",
    "variable": "var(--ids-colors-error-10)"
  },
  "colors.error.11": {
    "value": "var(--ids-colors-error-11)",
    "variable": "var(--ids-colors-error-11)"
  },
  "colors.error.12": {
    "value": "var(--ids-colors-error-12)",
    "variable": "var(--ids-colors-error-12)"
  },
  "colors.error.a1": {
    "value": "var(--ids-colors-error-a1)",
    "variable": "var(--ids-colors-error-a1)"
  },
  "colors.error.a2": {
    "value": "var(--ids-colors-error-a2)",
    "variable": "var(--ids-colors-error-a2)"
  },
  "colors.error.a3": {
    "value": "var(--ids-colors-error-a3)",
    "variable": "var(--ids-colors-error-a3)"
  },
  "colors.error.bg.base": {
    "value": "var(--ids-colors-error-bg-base)",
    "variable": "var(--ids-colors-error-bg-base)"
  },
  "colors.error.bg.high": {
    "value": "var(--ids-colors-error-bg-high)",
    "variable": "var(--ids-colors-error-bg-high)"
  },
  "colors.error.bg.low": {
    "value": "var(--ids-colors-error-bg-low)",
    "variable": "var(--ids-colors-error-bg-low)"
  },
  "colors.error.border.base": {
    "value": "var(--ids-colors-error-border-base)",
    "variable": "var(--ids-colors-error-border-base)"
  },
  "colors.error.border.high": {
    "value": "var(--ids-colors-error-border-high)",
    "variable": "var(--ids-colors-error-border-high)"
  },
  "colors.error.border.highest": {
    "value": "var(--ids-colors-error-border-highest)",
    "variable": "var(--ids-colors-error-border-highest)"
  },
  "colors.error.border.low": {
    "value": "var(--ids-colors-error-border-low)",
    "variable": "var(--ids-colors-error-border-low)"
  },
  "colors.error.fg.base": {
    "value": "var(--ids-colors-error-fg-base)",
    "variable": "var(--ids-colors-error-fg-base)"
  },
  "colors.error.fg.low": {
    "value": "var(--ids-colors-error-fg-low)",
    "variable": "var(--ids-colors-error-fg-low)"
  },
  "colors.error.ghostBg.base": {
    "value": "var(--ids-colors-error-ghost-bg-base)",
    "variable": "var(--ids-colors-error-ghost-bg-base)"
  },
  "colors.error.text.base": {
    "value": "var(--ids-colors-error-text-base)",
    "variable": "var(--ids-colors-error-text-base)"
  },
  "colors.accent.pink.1": {
    "value": "var(--ids-colors-accent-pink-1)",
    "variable": "var(--ids-colors-accent-pink-1)"
  },
  "colors.accent.pink.2": {
    "value": "var(--ids-colors-accent-pink-2)",
    "variable": "var(--ids-colors-accent-pink-2)"
  },
  "colors.accent.pink.3": {
    "value": "var(--ids-colors-accent-pink-3)",
    "variable": "var(--ids-colors-accent-pink-3)"
  },
  "colors.accent.pink.4": {
    "value": "var(--ids-colors-accent-pink-4)",
    "variable": "var(--ids-colors-accent-pink-4)"
  },
  "colors.accent.pink.5": {
    "value": "var(--ids-colors-accent-pink-5)",
    "variable": "var(--ids-colors-accent-pink-5)"
  },
  "colors.accent.pink.6": {
    "value": "var(--ids-colors-accent-pink-6)",
    "variable": "var(--ids-colors-accent-pink-6)"
  },
  "colors.accent.pink.7": {
    "value": "var(--ids-colors-accent-pink-7)",
    "variable": "var(--ids-colors-accent-pink-7)"
  },
  "colors.accent.pink.8": {
    "value": "var(--ids-colors-accent-pink-8)",
    "variable": "var(--ids-colors-accent-pink-8)"
  },
  "colors.accent.pink.9": {
    "value": "var(--ids-colors-accent-pink-9)",
    "variable": "var(--ids-colors-accent-pink-9)"
  },
  "colors.accent.pink.10": {
    "value": "var(--ids-colors-accent-pink-10)",
    "variable": "var(--ids-colors-accent-pink-10)"
  },
  "colors.accent.pink.11": {
    "value": "var(--ids-colors-accent-pink-11)",
    "variable": "var(--ids-colors-accent-pink-11)"
  },
  "colors.accent.pink.12": {
    "value": "var(--ids-colors-accent-pink-12)",
    "variable": "var(--ids-colors-accent-pink-12)"
  },
  "colors.accent.pink.a1": {
    "value": "var(--ids-colors-accent-pink-a1)",
    "variable": "var(--ids-colors-accent-pink-a1)"
  },
  "colors.accent.pink.a2": {
    "value": "var(--ids-colors-accent-pink-a2)",
    "variable": "var(--ids-colors-accent-pink-a2)"
  },
  "colors.accent.pink.a3": {
    "value": "var(--ids-colors-accent-pink-a3)",
    "variable": "var(--ids-colors-accent-pink-a3)"
  },
  "colors.accent.purple.1": {
    "value": "var(--ids-colors-accent-purple-1)",
    "variable": "var(--ids-colors-accent-purple-1)"
  },
  "colors.accent.purple.2": {
    "value": "var(--ids-colors-accent-purple-2)",
    "variable": "var(--ids-colors-accent-purple-2)"
  },
  "colors.accent.purple.3": {
    "value": "var(--ids-colors-accent-purple-3)",
    "variable": "var(--ids-colors-accent-purple-3)"
  },
  "colors.accent.purple.4": {
    "value": "var(--ids-colors-accent-purple-4)",
    "variable": "var(--ids-colors-accent-purple-4)"
  },
  "colors.accent.purple.5": {
    "value": "var(--ids-colors-accent-purple-5)",
    "variable": "var(--ids-colors-accent-purple-5)"
  },
  "colors.accent.purple.6": {
    "value": "var(--ids-colors-accent-purple-6)",
    "variable": "var(--ids-colors-accent-purple-6)"
  },
  "colors.accent.purple.7": {
    "value": "var(--ids-colors-accent-purple-7)",
    "variable": "var(--ids-colors-accent-purple-7)"
  },
  "colors.accent.purple.8": {
    "value": "var(--ids-colors-accent-purple-8)",
    "variable": "var(--ids-colors-accent-purple-8)"
  },
  "colors.accent.purple.9": {
    "value": "var(--ids-colors-accent-purple-9)",
    "variable": "var(--ids-colors-accent-purple-9)"
  },
  "colors.accent.purple.10": {
    "value": "var(--ids-colors-accent-purple-10)",
    "variable": "var(--ids-colors-accent-purple-10)"
  },
  "colors.accent.purple.11": {
    "value": "var(--ids-colors-accent-purple-11)",
    "variable": "var(--ids-colors-accent-purple-11)"
  },
  "colors.accent.purple.12": {
    "value": "var(--ids-colors-accent-purple-12)",
    "variable": "var(--ids-colors-accent-purple-12)"
  },
  "colors.accent.purple.a1": {
    "value": "var(--ids-colors-accent-purple-a1)",
    "variable": "var(--ids-colors-accent-purple-a1)"
  },
  "colors.accent.purple.a2": {
    "value": "var(--ids-colors-accent-purple-a2)",
    "variable": "var(--ids-colors-accent-purple-a2)"
  },
  "colors.accent.purple.a3": {
    "value": "var(--ids-colors-accent-purple-a3)",
    "variable": "var(--ids-colors-accent-purple-a3)"
  },
  "colors.primary.bg.base": {
    "value": "var(--ids-colors-primary-bg-base)",
    "variable": "var(--ids-colors-primary-bg-base)"
  },
  "colors.primary.bg.high": {
    "value": "var(--ids-colors-primary-bg-high)",
    "variable": "var(--ids-colors-primary-bg-high)"
  },
  "colors.primary.bg.highest": {
    "value": "var(--ids-colors-primary-bg-highest)",
    "variable": "var(--ids-colors-primary-bg-highest)"
  },
  "colors.primary.bg.low": {
    "value": "var(--ids-colors-primary-bg-low)",
    "variable": "var(--ids-colors-primary-bg-low)"
  },
  "colors.primary.fg.base": {
    "value": "var(--ids-colors-primary-fg-base)",
    "variable": "var(--ids-colors-primary-fg-base)"
  },
  "colors.primary.fg.low": {
    "value": "var(--ids-colors-primary-fg-low)",
    "variable": "var(--ids-colors-primary-fg-low)"
  },
  "colors.primary.fg.lower": {
    "value": "var(--ids-colors-primary-fg-lower)",
    "variable": "var(--ids-colors-primary-fg-lower)"
  },
  "colors.primary.fg.lowest": {
    "value": "var(--ids-colors-primary-fg-lowest)",
    "variable": "var(--ids-colors-primary-fg-lowest)"
  },
  "colors.primary.ghostBg.base": {
    "value": "var(--ids-colors-primary-ghost-bg-base)",
    "variable": "var(--ids-colors-primary-ghost-bg-base)"
  },
  "colors.primary.ghostBg.high": {
    "value": "var(--ids-colors-primary-ghost-bg-high)",
    "variable": "var(--ids-colors-primary-ghost-bg-high)"
  },
  "colors.primary.ghostBg.highest": {
    "value": "var(--ids-colors-primary-ghost-bg-highest)",
    "variable": "var(--ids-colors-primary-ghost-bg-highest)"
  },
  "colors.primary.surface.base": {
    "value": "var(--ids-colors-primary-surface-base)",
    "variable": "var(--ids-colors-primary-surface-base)"
  },
  "colors.primary.surface.high": {
    "value": "var(--ids-colors-primary-surface-high)",
    "variable": "var(--ids-colors-primary-surface-high)"
  },
  "colors.primary.border.low": {
    "value": "var(--ids-colors-primary-border-low)",
    "variable": "var(--ids-colors-primary-border-low)"
  },
  "colors.primary.border.base": {
    "value": "var(--ids-colors-primary-border-base)",
    "variable": "var(--ids-colors-primary-border-base)"
  },
  "colors.primary.border.high": {
    "value": "var(--ids-colors-primary-border-high)",
    "variable": "var(--ids-colors-primary-border-high)"
  },
  "colors.primary.border.highest": {
    "value": "var(--ids-colors-primary-border-highest)",
    "variable": "var(--ids-colors-primary-border-highest)"
  },
  "colors.primary.fill.base": {
    "value": "var(--ids-colors-primary-fill-base)",
    "variable": "var(--ids-colors-primary-fill-base)"
  },
  "colors.primary.icon.base": {
    "value": "var(--ids-colors-primary-icon-base)",
    "variable": "var(--ids-colors-primary-icon-base)"
  },
  "colors.primary.text.low": {
    "value": "var(--ids-colors-primary-text-low)",
    "variable": "var(--ids-colors-primary-text-low)"
  },
  "colors.primary.text.lower": {
    "value": "var(--ids-colors-primary-text-lower)",
    "variable": "var(--ids-colors-primary-text-lower)"
  },
  "colors.primary.text.lowest": {
    "value": "var(--ids-colors-primary-text-lowest)",
    "variable": "var(--ids-colors-primary-text-lowest)"
  },
  "colors.primary.text.base": {
    "value": "var(--ids-colors-primary-text-base)",
    "variable": "var(--ids-colors-primary-text-base)"
  },
  "colors.neutral.surface.low": {
    "value": "var(--ids-colors-neutral-surface-low)",
    "variable": "var(--ids-colors-neutral-surface-low)"
  },
  "colors.neutral.surface.base": {
    "value": "var(--ids-colors-neutral-surface-base)",
    "variable": "var(--ids-colors-neutral-surface-base)"
  },
  "colors.neutral.surface.high": {
    "value": "var(--ids-colors-neutral-surface-high)",
    "variable": "var(--ids-colors-neutral-surface-high)"
  },
  "colors.neutral.surface.highest": {
    "value": "var(--ids-colors-neutral-surface-highest)",
    "variable": "var(--ids-colors-neutral-surface-highest)"
  },
  "colors.neutral.surface.transparent": {
    "value": "var(--ids-colors-neutral-surface-transparent)",
    "variable": "var(--ids-colors-neutral-surface-transparent)"
  },
  "colors.neutral.fill.base": {
    "value": "var(--ids-colors-neutral-fill-base)",
    "variable": "var(--ids-colors-neutral-fill-base)"
  },
  "colors.neutral.fill.high": {
    "value": "var(--ids-colors-neutral-fill-high)",
    "variable": "var(--ids-colors-neutral-fill-high)"
  },
  "colors.neutral.icon.low": {
    "value": "var(--ids-colors-neutral-icon-low)",
    "variable": "var(--ids-colors-neutral-icon-low)"
  },
  "colors.neutral.icon.base": {
    "value": "var(--ids-colors-neutral-icon-base)",
    "variable": "var(--ids-colors-neutral-icon-base)"
  },
  "colors.neutral.border.low": {
    "value": "var(--ids-colors-neutral-border-low)",
    "variable": "var(--ids-colors-neutral-border-low)"
  },
  "colors.neutral.border.base": {
    "value": "var(--ids-colors-neutral-border-base)",
    "variable": "var(--ids-colors-neutral-border-base)"
  },
  "colors.neutral.border.high": {
    "value": "var(--ids-colors-neutral-border-high)",
    "variable": "var(--ids-colors-neutral-border-high)"
  },
  "colors.neutral.border.highest": {
    "value": "var(--ids-colors-neutral-border-highest)",
    "variable": "var(--ids-colors-neutral-border-highest)"
  },
  "colors.neutral.text.lowest": {
    "value": "var(--ids-colors-neutral-text-lowest)",
    "variable": "var(--ids-colors-neutral-text-lowest)"
  },
  "colors.neutral.text.low": {
    "value": "var(--ids-colors-neutral-text-low)",
    "variable": "var(--ids-colors-neutral-text-low)"
  },
  "colors.neutral.text.base": {
    "value": "var(--ids-colors-neutral-text-base)",
    "variable": "var(--ids-colors-neutral-text-base)"
  },
  "colors.neutral.ghostBg.base": {
    "value": "var(--ids-colors-neutral-ghost-bg-base)",
    "variable": "var(--ids-colors-neutral-ghost-bg-base)"
  },
  "colors.neutral.ghostBg.high": {
    "value": "var(--ids-colors-neutral-ghost-bg-high)",
    "variable": "var(--ids-colors-neutral-ghost-bg-high)"
  },
  "colors.neutral.ghostBg.highest": {
    "value": "var(--ids-colors-neutral-ghost-bg-highest)",
    "variable": "var(--ids-colors-neutral-ghost-bg-highest)"
  },
  "colors.inverse.bg.base": {
    "value": "var(--ids-colors-inverse-bg-base)",
    "variable": "var(--ids-colors-inverse-bg-base)"
  },
  "colors.inverse.text.base": {
    "value": "var(--ids-colors-inverse-text-base)",
    "variable": "var(--ids-colors-inverse-text-base)"
  },
  "colors.inverse.icon.base": {
    "value": "var(--ids-colors-inverse-icon-base)",
    "variable": "var(--ids-colors-inverse-icon-base)"
  },
  "colors.warning.1": {
    "value": "var(--ids-colors-warning-1)",
    "variable": "var(--ids-colors-warning-1)"
  },
  "colors.warning.2": {
    "value": "var(--ids-colors-warning-2)",
    "variable": "var(--ids-colors-warning-2)"
  },
  "colors.warning.3": {
    "value": "var(--ids-colors-warning-3)",
    "variable": "var(--ids-colors-warning-3)"
  },
  "colors.warning.4": {
    "value": "var(--ids-colors-warning-4)",
    "variable": "var(--ids-colors-warning-4)"
  },
  "colors.warning.5": {
    "value": "var(--ids-colors-warning-5)",
    "variable": "var(--ids-colors-warning-5)"
  },
  "colors.warning.6": {
    "value": "var(--ids-colors-warning-6)",
    "variable": "var(--ids-colors-warning-6)"
  },
  "colors.warning.7": {
    "value": "var(--ids-colors-warning-7)",
    "variable": "var(--ids-colors-warning-7)"
  },
  "colors.warning.8": {
    "value": "var(--ids-colors-warning-8)",
    "variable": "var(--ids-colors-warning-8)"
  },
  "colors.warning.9": {
    "value": "var(--ids-colors-warning-9)",
    "variable": "var(--ids-colors-warning-9)"
  },
  "colors.warning.10": {
    "value": "var(--ids-colors-warning-10)",
    "variable": "var(--ids-colors-warning-10)"
  },
  "colors.warning.11": {
    "value": "var(--ids-colors-warning-11)",
    "variable": "var(--ids-colors-warning-11)"
  },
  "colors.warning.12": {
    "value": "var(--ids-colors-warning-12)",
    "variable": "var(--ids-colors-warning-12)"
  },
  "colors.warning.a1": {
    "value": "var(--ids-colors-warning-a1)",
    "variable": "var(--ids-colors-warning-a1)"
  },
  "colors.warning.a2": {
    "value": "var(--ids-colors-warning-a2)",
    "variable": "var(--ids-colors-warning-a2)"
  },
  "colors.warning.a3": {
    "value": "var(--ids-colors-warning-a3)",
    "variable": "var(--ids-colors-warning-a3)"
  },
  "colors.warning.mediumBg.normal": {
    "value": "var(--ids-colors-warning-medium-bg-normal)",
    "variable": "var(--ids-colors-warning-medium-bg-normal)"
  },
  "colors.warning.bg.base": {
    "value": "var(--ids-colors-warning-bg-base)",
    "variable": "var(--ids-colors-warning-bg-base)"
  },
  "colors.warning.bg.high": {
    "value": "var(--ids-colors-warning-bg-high)",
    "variable": "var(--ids-colors-warning-bg-high)"
  },
  "colors.warning.bg.highest": {
    "value": "var(--ids-colors-warning-bg-highest)",
    "variable": "var(--ids-colors-warning-bg-highest)"
  },
  "colors.warning.bg.low": {
    "value": "var(--ids-colors-warning-bg-low)",
    "variable": "var(--ids-colors-warning-bg-low)"
  },
  "colors.warning.fg.base": {
    "value": "var(--ids-colors-warning-fg-base)",
    "variable": "var(--ids-colors-warning-fg-base)"
  },
  "colors.warning.fg.low": {
    "value": "var(--ids-colors-warning-fg-low)",
    "variable": "var(--ids-colors-warning-fg-low)"
  },
  "colors.warning.fg.lowest": {
    "value": "var(--ids-colors-warning-fg-lowest)",
    "variable": "var(--ids-colors-warning-fg-lowest)"
  },
  "colors.warning.surface.base": {
    "value": "var(--ids-colors-warning-surface-base)",
    "variable": "var(--ids-colors-warning-surface-base)"
  },
  "colors.warning.surface.high": {
    "value": "var(--ids-colors-warning-surface-high)",
    "variable": "var(--ids-colors-warning-surface-high)"
  },
  "colors.warning.border.low": {
    "value": "var(--ids-colors-warning-border-low)",
    "variable": "var(--ids-colors-warning-border-low)"
  },
  "colors.warning.border.base": {
    "value": "var(--ids-colors-warning-border-base)",
    "variable": "var(--ids-colors-warning-border-base)"
  },
  "colors.warning.border.high": {
    "value": "var(--ids-colors-warning-border-high)",
    "variable": "var(--ids-colors-warning-border-high)"
  },
  "colors.warning.border.highest": {
    "value": "var(--ids-colors-warning-border-highest)",
    "variable": "var(--ids-colors-warning-border-highest)"
  },
  "colors.warning.fill.base": {
    "value": "var(--ids-colors-warning-fill-base)",
    "variable": "var(--ids-colors-warning-fill-base)"
  },
  "colors.warning.icon.base": {
    "value": "var(--ids-colors-warning-icon-base)",
    "variable": "var(--ids-colors-warning-icon-base)"
  },
  "colors.warning.ghostBg.base": {
    "value": "var(--ids-colors-warning-ghost-bg-base)",
    "variable": "var(--ids-colors-warning-ghost-bg-base)"
  },
  "colors.warning.ghostBg.high": {
    "value": "var(--ids-colors-warning-ghost-bg-high)",
    "variable": "var(--ids-colors-warning-ghost-bg-high)"
  },
  "colors.warning.ghostBg.highest": {
    "value": "var(--ids-colors-warning-ghost-bg-highest)",
    "variable": "var(--ids-colors-warning-ghost-bg-highest)"
  },
  "colors.warning.text.base": {
    "value": "var(--ids-colors-warning-text-base)",
    "variable": "var(--ids-colors-warning-text-base)"
  },
  "colors.info.1": {
    "value": "var(--ids-colors-info-1)",
    "variable": "var(--ids-colors-info-1)"
  },
  "colors.info.2": {
    "value": "var(--ids-colors-info-2)",
    "variable": "var(--ids-colors-info-2)"
  },
  "colors.info.3": {
    "value": "var(--ids-colors-info-3)",
    "variable": "var(--ids-colors-info-3)"
  },
  "colors.info.4": {
    "value": "var(--ids-colors-info-4)",
    "variable": "var(--ids-colors-info-4)"
  },
  "colors.info.5": {
    "value": "var(--ids-colors-info-5)",
    "variable": "var(--ids-colors-info-5)"
  },
  "colors.info.6": {
    "value": "var(--ids-colors-info-6)",
    "variable": "var(--ids-colors-info-6)"
  },
  "colors.info.7": {
    "value": "var(--ids-colors-info-7)",
    "variable": "var(--ids-colors-info-7)"
  },
  "colors.info.8": {
    "value": "var(--ids-colors-info-8)",
    "variable": "var(--ids-colors-info-8)"
  },
  "colors.info.9": {
    "value": "var(--ids-colors-info-9)",
    "variable": "var(--ids-colors-info-9)"
  },
  "colors.info.10": {
    "value": "var(--ids-colors-info-10)",
    "variable": "var(--ids-colors-info-10)"
  },
  "colors.info.11": {
    "value": "var(--ids-colors-info-11)",
    "variable": "var(--ids-colors-info-11)"
  },
  "colors.info.12": {
    "value": "var(--ids-colors-info-12)",
    "variable": "var(--ids-colors-info-12)"
  },
  "colors.info.a1": {
    "value": "var(--ids-colors-info-a1)",
    "variable": "var(--ids-colors-info-a1)"
  },
  "colors.info.a2": {
    "value": "var(--ids-colors-info-a2)",
    "variable": "var(--ids-colors-info-a2)"
  },
  "colors.info.a3": {
    "value": "var(--ids-colors-info-a3)",
    "variable": "var(--ids-colors-info-a3)"
  },
  "colors.info.bg.base": {
    "value": "var(--ids-colors-info-bg-base)",
    "variable": "var(--ids-colors-info-bg-base)"
  },
  "colors.info.bg.highest": {
    "value": "var(--ids-colors-info-bg-highest)",
    "variable": "var(--ids-colors-info-bg-highest)"
  },
  "colors.info.bg.low": {
    "value": "var(--ids-colors-info-bg-low)",
    "variable": "var(--ids-colors-info-bg-low)"
  },
  "colors.info.fg.base": {
    "value": "var(--ids-colors-info-fg-base)",
    "variable": "var(--ids-colors-info-fg-base)"
  },
  "colors.info.fg.low": {
    "value": "var(--ids-colors-info-fg-low)",
    "variable": "var(--ids-colors-info-fg-low)"
  },
  "colors.info.surface.base": {
    "value": "var(--ids-colors-info-surface-base)",
    "variable": "var(--ids-colors-info-surface-base)"
  },
  "colors.info.surface.high": {
    "value": "var(--ids-colors-info-surface-high)",
    "variable": "var(--ids-colors-info-surface-high)"
  },
  "colors.info.border.low": {
    "value": "var(--ids-colors-info-border-low)",
    "variable": "var(--ids-colors-info-border-low)"
  },
  "colors.info.border.base": {
    "value": "var(--ids-colors-info-border-base)",
    "variable": "var(--ids-colors-info-border-base)"
  },
  "colors.info.border.high": {
    "value": "var(--ids-colors-info-border-high)",
    "variable": "var(--ids-colors-info-border-high)"
  },
  "colors.info.border.highest": {
    "value": "var(--ids-colors-info-border-highest)",
    "variable": "var(--ids-colors-info-border-highest)"
  },
  "colors.info.fill.base": {
    "value": "var(--ids-colors-info-fill-base)",
    "variable": "var(--ids-colors-info-fill-base)"
  },
  "colors.info.icon.base": {
    "value": "var(--ids-colors-info-icon-base)",
    "variable": "var(--ids-colors-info-icon-base)"
  },
  "colors.info.ghostBg.base": {
    "value": "var(--ids-colors-info-ghost-bg-base)",
    "variable": "var(--ids-colors-info-ghost-bg-base)"
  },
  "colors.info.ghostBg.high": {
    "value": "var(--ids-colors-info-ghost-bg-high)",
    "variable": "var(--ids-colors-info-ghost-bg-high)"
  },
  "colors.info.ghostBg.highest": {
    "value": "var(--ids-colors-info-ghost-bg-highest)",
    "variable": "var(--ids-colors-info-ghost-bg-highest)"
  },
  "colors.info.text.base": {
    "value": "var(--ids-colors-info-text-base)",
    "variable": "var(--ids-colors-info-text-base)"
  },
  "colors.positive.surface.low": {
    "value": "var(--ids-colors-positive-surface-low)",
    "variable": "var(--ids-colors-positive-surface-low)"
  },
  "colors.positive.surface.base": {
    "value": "var(--ids-colors-positive-surface-base)",
    "variable": "var(--ids-colors-positive-surface-base)"
  },
  "colors.positive.surface.high": {
    "value": "var(--ids-colors-positive-surface-high)",
    "variable": "var(--ids-colors-positive-surface-high)"
  },
  "colors.positive.border.base": {
    "value": "var(--ids-colors-positive-border-base)",
    "variable": "var(--ids-colors-positive-border-base)"
  },
  "colors.positive.border.high": {
    "value": "var(--ids-colors-positive-border-high)",
    "variable": "var(--ids-colors-positive-border-high)"
  },
  "colors.positive.border.highest": {
    "value": "var(--ids-colors-positive-border-highest)",
    "variable": "var(--ids-colors-positive-border-highest)"
  },
  "colors.positive.fill.base": {
    "value": "var(--ids-colors-positive-fill-base)",
    "variable": "var(--ids-colors-positive-fill-base)"
  },
  "colors.positive.icon.base": {
    "value": "var(--ids-colors-positive-icon-base)",
    "variable": "var(--ids-colors-positive-icon-base)"
  },
  "colors.positive.ghostBg.base": {
    "value": "var(--ids-colors-positive-ghost-bg-base)",
    "variable": "var(--ids-colors-positive-ghost-bg-base)"
  },
  "colors.positive.ghostBg.high": {
    "value": "var(--ids-colors-positive-ghost-bg-high)",
    "variable": "var(--ids-colors-positive-ghost-bg-high)"
  },
  "colors.positive.ghostBg.highest": {
    "value": "var(--ids-colors-positive-ghost-bg-highest)",
    "variable": "var(--ids-colors-positive-ghost-bg-highest)"
  },
  "colors.positive.text.base": {
    "value": "var(--ids-colors-positive-text-base)",
    "variable": "var(--ids-colors-positive-text-base)"
  },
  "colors.critical.surface.base": {
    "value": "var(--ids-colors-critical-surface-base)",
    "variable": "var(--ids-colors-critical-surface-base)"
  },
  "colors.critical.surface.high": {
    "value": "var(--ids-colors-critical-surface-high)",
    "variable": "var(--ids-colors-critical-surface-high)"
  },
  "colors.critical.border.base": {
    "value": "var(--ids-colors-critical-border-base)",
    "variable": "var(--ids-colors-critical-border-base)"
  },
  "colors.critical.border.high": {
    "value": "var(--ids-colors-critical-border-high)",
    "variable": "var(--ids-colors-critical-border-high)"
  },
  "colors.critical.border.highest": {
    "value": "var(--ids-colors-critical-border-highest)",
    "variable": "var(--ids-colors-critical-border-highest)"
  },
  "colors.critical.fill.base": {
    "value": "var(--ids-colors-critical-fill-base)",
    "variable": "var(--ids-colors-critical-fill-base)"
  },
  "colors.critical.icon.base": {
    "value": "var(--ids-colors-critical-icon-base)",
    "variable": "var(--ids-colors-critical-icon-base)"
  },
  "colors.critical.ghostBg.base": {
    "value": "var(--ids-colors-critical-ghost-bg-base)",
    "variable": "var(--ids-colors-critical-ghost-bg-base)"
  },
  "colors.critical.ghostBg.high": {
    "value": "var(--ids-colors-critical-ghost-bg-high)",
    "variable": "var(--ids-colors-critical-ghost-bg-high)"
  },
  "colors.critical.ghostBg.highest": {
    "value": "var(--ids-colors-critical-ghost-bg-highest)",
    "variable": "var(--ids-colors-critical-ghost-bg-highest)"
  },
  "colors.critical.text.base": {
    "value": "var(--ids-colors-critical-text-base)",
    "variable": "var(--ids-colors-critical-text-base)"
  },
  "colors.gradient.primary.stop1": {
    "value": "var(--ids-colors-gradient-primary-stop1)",
    "variable": "var(--ids-colors-gradient-primary-stop1)"
  },
  "colors.gradient.primary.stop2": {
    "value": "var(--ids-colors-gradient-primary-stop2)",
    "variable": "var(--ids-colors-gradient-primary-stop2)"
  },
  "colors.gradient.primary.default": {
    "value": "var(--ids-colors-gradient-primary-default)",
    "variable": "var(--ids-colors-gradient-primary-default)"
  },
  "colors.gradient.primary.horizontal": {
    "value": "var(--ids-colors-gradient-primary-horizontal)",
    "variable": "var(--ids-colors-gradient-primary-horizontal)"
  },
  "colors.gradient.primary.vertical": {
    "value": "var(--ids-colors-gradient-primary-vertical)",
    "variable": "var(--ids-colors-gradient-primary-vertical)"
  },
  "colors.gradient.glow.stop1": {
    "value": "var(--ids-colors-gradient-glow-stop1)",
    "variable": "var(--ids-colors-gradient-glow-stop1)"
  },
  "colors.gradient.glow.stop2": {
    "value": "var(--ids-colors-gradient-glow-stop2)",
    "variable": "var(--ids-colors-gradient-glow-stop2)"
  },
  "colors.gradient.secondary.stop1": {
    "value": "var(--ids-colors-gradient-secondary-stop1)",
    "variable": "var(--ids-colors-gradient-secondary-stop1)"
  },
  "colors.gradient.secondary.stop2": {
    "value": "var(--ids-colors-gradient-secondary-stop2)",
    "variable": "var(--ids-colors-gradient-secondary-stop2)"
  },
  "colors.gradient.secondary.default": {
    "value": "var(--ids-colors-gradient-secondary-default)",
    "variable": "var(--ids-colors-gradient-secondary-default)"
  },
  "colors.gradient.tertiary.stop1": {
    "value": "var(--ids-colors-gradient-tertiary-stop1)",
    "variable": "var(--ids-colors-gradient-tertiary-stop1)"
  },
  "colors.gradient.tertiary.stop2": {
    "value": "var(--ids-colors-gradient-tertiary-stop2)",
    "variable": "var(--ids-colors-gradient-tertiary-stop2)"
  },
  "colors.gradient.tertiary.default": {
    "value": "var(--ids-colors-gradient-tertiary-default)",
    "variable": "var(--ids-colors-gradient-tertiary-default)"
  },
  "colors.gradient.dim.stop1": {
    "value": "var(--ids-colors-gradient-dim-stop1)",
    "variable": "var(--ids-colors-gradient-dim-stop1)"
  },
  "colors.gradient.dim.stop2": {
    "value": "var(--ids-colors-gradient-dim-stop2)",
    "variable": "var(--ids-colors-gradient-dim-stop2)"
  },
  "colors.gradient.dim.fadeOutLeft": {
    "value": "var(--ids-colors-gradient-dim-fade-out-left)",
    "variable": "var(--ids-colors-gradient-dim-fade-out-left)"
  },
  "colors.gradient.dim.fadeOutRight": {
    "value": "var(--ids-colors-gradient-dim-fade-out-right)",
    "variable": "var(--ids-colors-gradient-dim-fade-out-right)"
  },
  "colors.gradient.dim.fadeOutTop": {
    "value": "var(--ids-colors-gradient-dim-fade-out-top)",
    "variable": "var(--ids-colors-gradient-dim-fade-out-top)"
  },
  "colors.gradient.dim.fadeOutBottom": {
    "value": "var(--ids-colors-gradient-dim-fade-out-bottom)",
    "variable": "var(--ids-colors-gradient-dim-fade-out-bottom)"
  },
  "colors.brand.1": {
    "value": "var(--ids-colors-brand-1)",
    "variable": "var(--ids-colors-brand-1)"
  },
  "colors.brand.2": {
    "value": "var(--ids-colors-brand-2)",
    "variable": "var(--ids-colors-brand-2)"
  },
  "colors.brand.3": {
    "value": "var(--ids-colors-brand-3)",
    "variable": "var(--ids-colors-brand-3)"
  },
  "colors.brand.4": {
    "value": "var(--ids-colors-brand-4)",
    "variable": "var(--ids-colors-brand-4)"
  },
  "colors.brand.5": {
    "value": "var(--ids-colors-brand-5)",
    "variable": "var(--ids-colors-brand-5)"
  },
  "colors.brand.6": {
    "value": "var(--ids-colors-brand-6)",
    "variable": "var(--ids-colors-brand-6)"
  },
  "colors.brand.7": {
    "value": "var(--ids-colors-brand-7)",
    "variable": "var(--ids-colors-brand-7)"
  },
  "colors.brand.8": {
    "value": "var(--ids-colors-brand-8)",
    "variable": "var(--ids-colors-brand-8)"
  },
  "colors.brand.9": {
    "value": "var(--ids-colors-brand-9)",
    "variable": "var(--ids-colors-brand-9)"
  },
  "colors.brand.10": {
    "value": "var(--ids-colors-brand-10)",
    "variable": "var(--ids-colors-brand-10)"
  },
  "colors.brand.11": {
    "value": "var(--ids-colors-brand-11)",
    "variable": "var(--ids-colors-brand-11)"
  },
  "colors.brand.12": {
    "value": "var(--ids-colors-brand-12)",
    "variable": "var(--ids-colors-brand-12)"
  },
  "colors.brand.a1": {
    "value": "var(--ids-colors-brand-a1)",
    "variable": "var(--ids-colors-brand-a1)"
  },
  "colors.brand.a2": {
    "value": "var(--ids-colors-brand-a2)",
    "variable": "var(--ids-colors-brand-a2)"
  },
  "colors.brand.a3": {
    "value": "var(--ids-colors-brand-a3)",
    "variable": "var(--ids-colors-brand-a3)"
  },
  "colors.brand.bg.base": {
    "value": "var(--ids-colors-brand-bg-base)",
    "variable": "var(--ids-colors-brand-bg-base)"
  },
  "colors.brand.bg.high": {
    "value": "var(--ids-colors-brand-bg-high)",
    "variable": "var(--ids-colors-brand-bg-high)"
  },
  "colors.brand.bg.low": {
    "value": "var(--ids-colors-brand-bg-low)",
    "variable": "var(--ids-colors-brand-bg-low)"
  },
  "colors.brand.fg.base": {
    "value": "var(--ids-colors-brand-fg-base)",
    "variable": "var(--ids-colors-brand-fg-base)"
  },
  "colors.brand.surface.low": {
    "value": "var(--ids-colors-brand-surface-low)",
    "variable": "var(--ids-colors-brand-surface-low)"
  },
  "colors.brand.surface.base": {
    "value": "var(--ids-colors-brand-surface-base)",
    "variable": "var(--ids-colors-brand-surface-base)"
  },
  "colors.brand.surface.high": {
    "value": "var(--ids-colors-brand-surface-high)",
    "variable": "var(--ids-colors-brand-surface-high)"
  },
  "colors.brand.surface.highest": {
    "value": "var(--ids-colors-brand-surface-highest)",
    "variable": "var(--ids-colors-brand-surface-highest)"
  },
  "colors.brand.border.low": {
    "value": "var(--ids-colors-brand-border-low)",
    "variable": "var(--ids-colors-brand-border-low)"
  },
  "colors.brand.border.base": {
    "value": "var(--ids-colors-brand-border-base)",
    "variable": "var(--ids-colors-brand-border-base)"
  },
  "colors.brand.border.high": {
    "value": "var(--ids-colors-brand-border-high)",
    "variable": "var(--ids-colors-brand-border-high)"
  },
  "colors.brand.border.highest": {
    "value": "var(--ids-colors-brand-border-highest)",
    "variable": "var(--ids-colors-brand-border-highest)"
  },
  "colors.brand.fill.low": {
    "value": "var(--ids-colors-brand-fill-low)",
    "variable": "var(--ids-colors-brand-fill-low)"
  },
  "colors.brand.fill.base": {
    "value": "var(--ids-colors-brand-fill-base)",
    "variable": "var(--ids-colors-brand-fill-base)"
  },
  "colors.brand.icon.base": {
    "value": "var(--ids-colors-brand-icon-base)",
    "variable": "var(--ids-colors-brand-icon-base)"
  },
  "colors.brand.ghostBg.base": {
    "value": "var(--ids-colors-brand-ghost-bg-base)",
    "variable": "var(--ids-colors-brand-ghost-bg-base)"
  },
  "colors.brand.ghostBg.high": {
    "value": "var(--ids-colors-brand-ghost-bg-high)",
    "variable": "var(--ids-colors-brand-ghost-bg-high)"
  },
  "colors.brand.ghostBg.highest": {
    "value": "var(--ids-colors-brand-ghost-bg-highest)",
    "variable": "var(--ids-colors-brand-ghost-bg-highest)"
  },
  "colors.brand.text.base": {
    "value": "var(--ids-colors-brand-text-base)",
    "variable": "var(--ids-colors-brand-text-base)"
  },
  "colors.button.filled.bg.default": {
    "value": "var(--ids-colors-button-filled-bg-default)",
    "variable": "var(--ids-colors-button-filled-bg-default)"
  },
  "colors.button.filled.bg.selected": {
    "value": "var(--ids-colors-button-filled-bg-selected)",
    "variable": "var(--ids-colors-button-filled-bg-selected)"
  },
  "colors.button.filled.fg.default": {
    "value": "var(--ids-colors-button-filled-fg-default)",
    "variable": "var(--ids-colors-button-filled-fg-default)"
  },
  "colors.button.filled.fg.selected": {
    "value": "var(--ids-colors-button-filled-fg-selected)",
    "variable": "var(--ids-colors-button-filled-fg-selected)"
  },
  "colors.button.filled.text.default": {
    "value": "var(--ids-colors-button-filled-text-default)",
    "variable": "var(--ids-colors-button-filled-text-default)"
  },
  "colors.button.filled.text.selected": {
    "value": "var(--ids-colors-button-filled-text-selected)",
    "variable": "var(--ids-colors-button-filled-text-selected)"
  },
  "colors.button.outlined.bg.default": {
    "value": "var(--ids-colors-button-outlined-bg-default)",
    "variable": "var(--ids-colors-button-outlined-bg-default)"
  },
  "colors.button.outlined.bg.selected": {
    "value": "var(--ids-colors-button-outlined-bg-selected)",
    "variable": "var(--ids-colors-button-outlined-bg-selected)"
  },
  "colors.button.outlined.border.default": {
    "value": "var(--ids-colors-button-outlined-border-default)",
    "variable": "var(--ids-colors-button-outlined-border-default)"
  },
  "colors.button.outlined.border.selected": {
    "value": "var(--ids-colors-button-outlined-border-selected)",
    "variable": "var(--ids-colors-button-outlined-border-selected)"
  },
  "colors.button.outlined.fg.default": {
    "value": "var(--ids-colors-button-outlined-fg-default)",
    "variable": "var(--ids-colors-button-outlined-fg-default)"
  },
  "colors.button.outlined.fg.selected": {
    "value": "var(--ids-colors-button-outlined-fg-selected)",
    "variable": "var(--ids-colors-button-outlined-fg-selected)"
  },
  "colors.button.outlined.text.default": {
    "value": "var(--ids-colors-button-outlined-text-default)",
    "variable": "var(--ids-colors-button-outlined-text-default)"
  },
  "colors.button.outlined.text.selected": {
    "value": "var(--ids-colors-button-outlined-text-selected)",
    "variable": "var(--ids-colors-button-outlined-text-selected)"
  },
  "colors.button.subtle.bg.default": {
    "value": "var(--ids-colors-button-subtle-bg-default)",
    "variable": "var(--ids-colors-button-subtle-bg-default)"
  },
  "colors.button.subtle.bg.selected": {
    "value": "var(--ids-colors-button-subtle-bg-selected)",
    "variable": "var(--ids-colors-button-subtle-bg-selected)"
  },
  "colors.button.subtle.border.default": {
    "value": "var(--ids-colors-button-subtle-border-default)",
    "variable": "var(--ids-colors-button-subtle-border-default)"
  },
  "colors.button.subtle.border.selected": {
    "value": "var(--ids-colors-button-subtle-border-selected)",
    "variable": "var(--ids-colors-button-subtle-border-selected)"
  },
  "colors.button.subtle.fg.default": {
    "value": "var(--ids-colors-button-subtle-fg-default)",
    "variable": "var(--ids-colors-button-subtle-fg-default)"
  },
  "colors.button.subtle.fg.selected": {
    "value": "var(--ids-colors-button-subtle-fg-selected)",
    "variable": "var(--ids-colors-button-subtle-fg-selected)"
  },
  "colors.button.subtle.text.default": {
    "value": "var(--ids-colors-button-subtle-text-default)",
    "variable": "var(--ids-colors-button-subtle-text-default)"
  },
  "colors.button.subtle.text.selected": {
    "value": "var(--ids-colors-button-subtle-text-selected)",
    "variable": "var(--ids-colors-button-subtle-text-selected)"
  },
  "colors.button.impact.fg.default": {
    "value": "var(--ids-colors-button-impact-fg-default)",
    "variable": "var(--ids-colors-button-impact-fg-default)"
  },
  "colors.button.impact.text.default": {
    "value": "var(--ids-colors-button-impact-text-default)",
    "variable": "var(--ids-colors-button-impact-text-default)"
  },
  "colors.relatedSites.surface.base": {
    "value": "var(--ids-colors-related-sites-surface-base)",
    "variable": "var(--ids-colors-related-sites-surface-base)"
  },
  "colors.relatedSites.text.base": {
    "value": "var(--ids-colors-related-sites-text-base)",
    "variable": "var(--ids-colors-related-sites-text-base)"
  },
  "colors.relatedSites.text.low": {
    "value": "var(--ids-colors-related-sites-text-low)",
    "variable": "var(--ids-colors-related-sites-text-low)"
  },
  "colors.relatedSites.icon.base": {
    "value": "var(--ids-colors-related-sites-icon-base)",
    "variable": "var(--ids-colors-related-sites-icon-base)"
  },
  "colors.relatedSites.icon.low": {
    "value": "var(--ids-colors-related-sites-icon-low)",
    "variable": "var(--ids-colors-related-sites-icon-low)"
  },
  "colors.relatedSites.ghostBg.base": {
    "value": "var(--ids-colors-related-sites-ghost-bg-base)",
    "variable": "var(--ids-colors-related-sites-ghost-bg-base)"
  },
  "colors.relatedSites.ghostBg.high": {
    "value": "var(--ids-colors-related-sites-ghost-bg-high)",
    "variable": "var(--ids-colors-related-sites-ghost-bg-high)"
  },
  "colors.card.surface.bg": {
    "value": "var(--ids-colors-card-surface-bg)",
    "variable": "var(--ids-colors-card-surface-bg)"
  },
  "colors.card.surface.border": {
    "value": "var(--ids-colors-card-surface-border)",
    "variable": "var(--ids-colors-card-surface-border)"
  },
  "colors.chip.fill.bg.brand": {
    "value": "var(--ids-colors-chip-fill-bg-brand)",
    "variable": "var(--ids-colors-chip-fill-bg-brand)"
  },
  "colors.chip.fill.bg.neutral": {
    "value": "var(--ids-colors-chip-fill-bg-neutral)",
    "variable": "var(--ids-colors-chip-fill-bg-neutral)"
  },
  "colors.chip.fill.bg.green": {
    "value": "var(--ids-colors-chip-fill-bg-green)",
    "variable": "var(--ids-colors-chip-fill-bg-green)"
  },
  "colors.chip.fill.bg.orange": {
    "value": "var(--ids-colors-chip-fill-bg-orange)",
    "variable": "var(--ids-colors-chip-fill-bg-orange)"
  },
  "colors.chip.fill.bg.blue": {
    "value": "var(--ids-colors-chip-fill-bg-blue)",
    "variable": "var(--ids-colors-chip-fill-bg-blue)"
  },
  "colors.chip.fill.bg.red": {
    "value": "var(--ids-colors-chip-fill-bg-red)",
    "variable": "var(--ids-colors-chip-fill-bg-red)"
  },
  "colors.chip.fill.fg.default": {
    "value": "var(--ids-colors-chip-fill-fg-default)",
    "variable": "var(--ids-colors-chip-fill-fg-default)"
  },
  "colors.chip.fill.fg.icon": {
    "value": "var(--ids-colors-chip-fill-fg-icon)",
    "variable": "var(--ids-colors-chip-fill-fg-icon)"
  },
  "colors.chip.fill.fg.text": {
    "value": "var(--ids-colors-chip-fill-fg-text)",
    "variable": "var(--ids-colors-chip-fill-fg-text)"
  },
  "colors.chip.fill.fg.orange": {
    "value": "var(--ids-colors-chip-fill-fg-orange)",
    "variable": "var(--ids-colors-chip-fill-fg-orange)"
  },
  "colors.chip.outlined.bg.brand": {
    "value": "var(--ids-colors-chip-outlined-bg-brand)",
    "variable": "var(--ids-colors-chip-outlined-bg-brand)"
  },
  "colors.chip.outlined.bg.neutral": {
    "value": "var(--ids-colors-chip-outlined-bg-neutral)",
    "variable": "var(--ids-colors-chip-outlined-bg-neutral)"
  },
  "colors.chip.outlined.bg.green": {
    "value": "var(--ids-colors-chip-outlined-bg-green)",
    "variable": "var(--ids-colors-chip-outlined-bg-green)"
  },
  "colors.chip.outlined.bg.orange": {
    "value": "var(--ids-colors-chip-outlined-bg-orange)",
    "variable": "var(--ids-colors-chip-outlined-bg-orange)"
  },
  "colors.chip.outlined.bg.blue": {
    "value": "var(--ids-colors-chip-outlined-bg-blue)",
    "variable": "var(--ids-colors-chip-outlined-bg-blue)"
  },
  "colors.chip.outlined.bg.red": {
    "value": "var(--ids-colors-chip-outlined-bg-red)",
    "variable": "var(--ids-colors-chip-outlined-bg-red)"
  },
  "colors.chip.outlined.border.brand": {
    "value": "var(--ids-colors-chip-outlined-border-brand)",
    "variable": "var(--ids-colors-chip-outlined-border-brand)"
  },
  "colors.chip.outlined.border.neutral": {
    "value": "var(--ids-colors-chip-outlined-border-neutral)",
    "variable": "var(--ids-colors-chip-outlined-border-neutral)"
  },
  "colors.chip.outlined.border.green": {
    "value": "var(--ids-colors-chip-outlined-border-green)",
    "variable": "var(--ids-colors-chip-outlined-border-green)"
  },
  "colors.chip.outlined.border.orange": {
    "value": "var(--ids-colors-chip-outlined-border-orange)",
    "variable": "var(--ids-colors-chip-outlined-border-orange)"
  },
  "colors.chip.outlined.border.blue": {
    "value": "var(--ids-colors-chip-outlined-border-blue)",
    "variable": "var(--ids-colors-chip-outlined-border-blue)"
  },
  "colors.chip.outlined.border.red": {
    "value": "var(--ids-colors-chip-outlined-border-red)",
    "variable": "var(--ids-colors-chip-outlined-border-red)"
  },
  "colors.chip.outlined.fg.brand": {
    "value": "var(--ids-colors-chip-outlined-fg-brand)",
    "variable": "var(--ids-colors-chip-outlined-fg-brand)"
  },
  "colors.chip.outlined.fg.neutral": {
    "value": "var(--ids-colors-chip-outlined-fg-neutral)",
    "variable": "var(--ids-colors-chip-outlined-fg-neutral)"
  },
  "colors.chip.outlined.fg.green": {
    "value": "var(--ids-colors-chip-outlined-fg-green)",
    "variable": "var(--ids-colors-chip-outlined-fg-green)"
  },
  "colors.chip.outlined.fg.orange": {
    "value": "var(--ids-colors-chip-outlined-fg-orange)",
    "variable": "var(--ids-colors-chip-outlined-fg-orange)"
  },
  "colors.chip.outlined.fg.blue": {
    "value": "var(--ids-colors-chip-outlined-fg-blue)",
    "variable": "var(--ids-colors-chip-outlined-fg-blue)"
  },
  "colors.chip.outlined.fg.red": {
    "value": "var(--ids-colors-chip-outlined-fg-red)",
    "variable": "var(--ids-colors-chip-outlined-fg-red)"
  },
  "colors.chip.outlined.text.brand": {
    "value": "var(--ids-colors-chip-outlined-text-brand)",
    "variable": "var(--ids-colors-chip-outlined-text-brand)"
  },
  "colors.chip.outlined.text.neutral": {
    "value": "var(--ids-colors-chip-outlined-text-neutral)",
    "variable": "var(--ids-colors-chip-outlined-text-neutral)"
  },
  "colors.chip.outlined.text.green": {
    "value": "var(--ids-colors-chip-outlined-text-green)",
    "variable": "var(--ids-colors-chip-outlined-text-green)"
  },
  "colors.chip.outlined.text.orange": {
    "value": "var(--ids-colors-chip-outlined-text-orange)",
    "variable": "var(--ids-colors-chip-outlined-text-orange)"
  },
  "colors.chip.outlined.text.blue": {
    "value": "var(--ids-colors-chip-outlined-text-blue)",
    "variable": "var(--ids-colors-chip-outlined-text-blue)"
  },
  "colors.chip.outlined.text.red": {
    "value": "var(--ids-colors-chip-outlined-text-red)",
    "variable": "var(--ids-colors-chip-outlined-text-red)"
  },
  "colors.chip.text.bg.brand": {
    "value": "var(--ids-colors-chip-text-bg-brand)",
    "variable": "var(--ids-colors-chip-text-bg-brand)"
  },
  "colors.chip.text.bg.neutral": {
    "value": "var(--ids-colors-chip-text-bg-neutral)",
    "variable": "var(--ids-colors-chip-text-bg-neutral)"
  },
  "colors.chip.text.bg.green": {
    "value": "var(--ids-colors-chip-text-bg-green)",
    "variable": "var(--ids-colors-chip-text-bg-green)"
  },
  "colors.chip.text.bg.orange": {
    "value": "var(--ids-colors-chip-text-bg-orange)",
    "variable": "var(--ids-colors-chip-text-bg-orange)"
  },
  "colors.chip.text.bg.blue": {
    "value": "var(--ids-colors-chip-text-bg-blue)",
    "variable": "var(--ids-colors-chip-text-bg-blue)"
  },
  "colors.chip.text.bg.red": {
    "value": "var(--ids-colors-chip-text-bg-red)",
    "variable": "var(--ids-colors-chip-text-bg-red)"
  },
  "colors.chip.text.fg.brand": {
    "value": "var(--ids-colors-chip-text-fg-brand)",
    "variable": "var(--ids-colors-chip-text-fg-brand)"
  },
  "colors.chip.text.fg.neutral": {
    "value": "var(--ids-colors-chip-text-fg-neutral)",
    "variable": "var(--ids-colors-chip-text-fg-neutral)"
  },
  "colors.chip.text.fg.green": {
    "value": "var(--ids-colors-chip-text-fg-green)",
    "variable": "var(--ids-colors-chip-text-fg-green)"
  },
  "colors.chip.text.fg.orange": {
    "value": "var(--ids-colors-chip-text-fg-orange)",
    "variable": "var(--ids-colors-chip-text-fg-orange)"
  },
  "colors.chip.text.fg.blue": {
    "value": "var(--ids-colors-chip-text-fg-blue)",
    "variable": "var(--ids-colors-chip-text-fg-blue)"
  },
  "colors.chip.text.fg.red": {
    "value": "var(--ids-colors-chip-text-fg-red)",
    "variable": "var(--ids-colors-chip-text-fg-red)"
  },
  "colors.chip.text.text.brand": {
    "value": "var(--ids-colors-chip-text-text-brand)",
    "variable": "var(--ids-colors-chip-text-text-brand)"
  },
  "colors.chip.text.text.neutral": {
    "value": "var(--ids-colors-chip-text-text-neutral)",
    "variable": "var(--ids-colors-chip-text-text-neutral)"
  },
  "colors.chip.text.text.green": {
    "value": "var(--ids-colors-chip-text-text-green)",
    "variable": "var(--ids-colors-chip-text-text-green)"
  },
  "colors.chip.text.text.orange": {
    "value": "var(--ids-colors-chip-text-text-orange)",
    "variable": "var(--ids-colors-chip-text-text-orange)"
  },
  "colors.chip.text.text.blue": {
    "value": "var(--ids-colors-chip-text-text-blue)",
    "variable": "var(--ids-colors-chip-text-text-blue)"
  },
  "colors.chip.text.text.red": {
    "value": "var(--ids-colors-chip-text-text-red)",
    "variable": "var(--ids-colors-chip-text-text-red)"
  },
  "colors.chip.transparency.text.brand": {
    "value": "var(--ids-colors-chip-transparency-text-brand)",
    "variable": "var(--ids-colors-chip-transparency-text-brand)"
  },
  "colors.chip.transparency.text.neutral": {
    "value": "var(--ids-colors-chip-transparency-text-neutral)",
    "variable": "var(--ids-colors-chip-transparency-text-neutral)"
  },
  "colors.chip.transparency.text.green": {
    "value": "var(--ids-colors-chip-transparency-text-green)",
    "variable": "var(--ids-colors-chip-transparency-text-green)"
  },
  "colors.chip.transparency.text.orange": {
    "value": "var(--ids-colors-chip-transparency-text-orange)",
    "variable": "var(--ids-colors-chip-transparency-text-orange)"
  },
  "colors.chip.transparency.text.blue": {
    "value": "var(--ids-colors-chip-transparency-text-blue)",
    "variable": "var(--ids-colors-chip-transparency-text-blue)"
  },
  "colors.chip.transparency.text.red": {
    "value": "var(--ids-colors-chip-transparency-text-red)",
    "variable": "var(--ids-colors-chip-transparency-text-red)"
  },
  "colors.chip.transparency.icon.brand": {
    "value": "var(--ids-colors-chip-transparency-icon-brand)",
    "variable": "var(--ids-colors-chip-transparency-icon-brand)"
  },
  "colors.chip.transparency.icon.neutral": {
    "value": "var(--ids-colors-chip-transparency-icon-neutral)",
    "variable": "var(--ids-colors-chip-transparency-icon-neutral)"
  },
  "colors.chip.transparency.icon.green": {
    "value": "var(--ids-colors-chip-transparency-icon-green)",
    "variable": "var(--ids-colors-chip-transparency-icon-green)"
  },
  "colors.chip.transparency.icon.orange": {
    "value": "var(--ids-colors-chip-transparency-icon-orange)",
    "variable": "var(--ids-colors-chip-transparency-icon-orange)"
  },
  "colors.chip.transparency.icon.blue": {
    "value": "var(--ids-colors-chip-transparency-icon-blue)",
    "variable": "var(--ids-colors-chip-transparency-icon-blue)"
  },
  "colors.chip.transparency.icon.red": {
    "value": "var(--ids-colors-chip-transparency-icon-red)",
    "variable": "var(--ids-colors-chip-transparency-icon-red)"
  },
  "colors.progressBar.track.default": {
    "value": "var(--ids-colors-progress-bar-track-default)",
    "variable": "var(--ids-colors-progress-bar-track-default)"
  },
  "colors.progressBar.indicator.brand.bg": {
    "value": "var(--ids-colors-progress-bar-indicator-brand-bg)",
    "variable": "var(--ids-colors-progress-bar-indicator-brand-bg)"
  },
  "colors.progressBar.indicator.brand.border": {
    "value": "var(--ids-colors-progress-bar-indicator-brand-border)",
    "variable": "var(--ids-colors-progress-bar-indicator-brand-border)"
  },
  "colors.progressBar.indicator.green.bg": {
    "value": "var(--ids-colors-progress-bar-indicator-green-bg)",
    "variable": "var(--ids-colors-progress-bar-indicator-green-bg)"
  },
  "colors.progressBar.indicator.green.border": {
    "value": "var(--ids-colors-progress-bar-indicator-green-border)",
    "variable": "var(--ids-colors-progress-bar-indicator-green-border)"
  },
  "colors.progressBar.indicator.orange.bg": {
    "value": "var(--ids-colors-progress-bar-indicator-orange-bg)",
    "variable": "var(--ids-colors-progress-bar-indicator-orange-bg)"
  },
  "colors.progressBar.indicator.orange.border": {
    "value": "var(--ids-colors-progress-bar-indicator-orange-border)",
    "variable": "var(--ids-colors-progress-bar-indicator-orange-border)"
  },
  "colors.tabs.list.border": {
    "value": "var(--ids-colors-tabs-list-border)",
    "variable": "var(--ids-colors-tabs-list-border)"
  },
  "colors.tabs.thumb.default": {
    "value": "var(--ids-colors-tabs-thumb-default)",
    "variable": "var(--ids-colors-tabs-thumb-default)"
  },
  "colors.tabs.trigger.default": {
    "value": "var(--ids-colors-tabs-trigger-default)",
    "variable": "var(--ids-colors-tabs-trigger-default)"
  },
  "colors.tabs.trigger.hover": {
    "value": "var(--ids-colors-tabs-trigger-hover)",
    "variable": "var(--ids-colors-tabs-trigger-hover)"
  },
  "colors.tabs.trigger.selected": {
    "value": "var(--ids-colors-tabs-trigger-selected)",
    "variable": "var(--ids-colors-tabs-trigger-selected)"
  },
  "colors.tooltip.bg": {
    "value": "var(--ids-colors-tooltip-bg)",
    "variable": "var(--ids-colors-tooltip-bg)"
  },
  "colors.tooltip.text": {
    "value": "var(--ids-colors-tooltip-text)",
    "variable": "var(--ids-colors-tooltip-text)"
  },
  "colors.tooltip.dismiss": {
    "value": "var(--ids-colors-tooltip-dismiss)",
    "variable": "var(--ids-colors-tooltip-dismiss)"
  },
  "colors.input.container.bg.default": {
    "value": "var(--ids-colors-input-container-bg-default)",
    "variable": "var(--ids-colors-input-container-bg-default)"
  },
  "colors.input.container.bg.disabled": {
    "value": "var(--ids-colors-input-container-bg-disabled)",
    "variable": "var(--ids-colors-input-container-bg-disabled)"
  },
  "colors.input.container.bg.errorDisabled": {
    "value": "var(--ids-colors-input-container-bg-error-disabled)",
    "variable": "var(--ids-colors-input-container-bg-error-disabled)"
  },
  "colors.input.container.bg.warningDisabled": {
    "value": "var(--ids-colors-input-container-bg-warning-disabled)",
    "variable": "var(--ids-colors-input-container-bg-warning-disabled)"
  },
  "colors.input.container.bg.successDisabled": {
    "value": "var(--ids-colors-input-container-bg-success-disabled)",
    "variable": "var(--ids-colors-input-container-bg-success-disabled)"
  },
  "colors.input.container.border.default": {
    "value": "var(--ids-colors-input-container-border-default)",
    "variable": "var(--ids-colors-input-container-border-default)"
  },
  "colors.input.container.border.hover": {
    "value": "var(--ids-colors-input-container-border-hover)",
    "variable": "var(--ids-colors-input-container-border-hover)"
  },
  "colors.input.container.border.focus": {
    "value": "var(--ids-colors-input-container-border-focus)",
    "variable": "var(--ids-colors-input-container-border-focus)"
  },
  "colors.input.container.border.error": {
    "value": "var(--ids-colors-input-container-border-error)",
    "variable": "var(--ids-colors-input-container-border-error)"
  },
  "colors.input.container.border.errorHover": {
    "value": "var(--ids-colors-input-container-border-error-hover)",
    "variable": "var(--ids-colors-input-container-border-error-hover)"
  },
  "colors.input.container.border.errorFocus": {
    "value": "var(--ids-colors-input-container-border-error-focus)",
    "variable": "var(--ids-colors-input-container-border-error-focus)"
  },
  "colors.input.container.border.warning": {
    "value": "var(--ids-colors-input-container-border-warning)",
    "variable": "var(--ids-colors-input-container-border-warning)"
  },
  "colors.input.container.border.warningHover": {
    "value": "var(--ids-colors-input-container-border-warning-hover)",
    "variable": "var(--ids-colors-input-container-border-warning-hover)"
  },
  "colors.input.container.border.warningFocus": {
    "value": "var(--ids-colors-input-container-border-warning-focus)",
    "variable": "var(--ids-colors-input-container-border-warning-focus)"
  },
  "colors.input.container.border.success": {
    "value": "var(--ids-colors-input-container-border-success)",
    "variable": "var(--ids-colors-input-container-border-success)"
  },
  "colors.input.container.border.successHover": {
    "value": "var(--ids-colors-input-container-border-success-hover)",
    "variable": "var(--ids-colors-input-container-border-success-hover)"
  },
  "colors.input.container.border.successFocus": {
    "value": "var(--ids-colors-input-container-border-success-focus)",
    "variable": "var(--ids-colors-input-container-border-success-focus)"
  },
  "colors.input.container.icon.error": {
    "value": "var(--ids-colors-input-container-icon-error)",
    "variable": "var(--ids-colors-input-container-icon-error)"
  },
  "colors.input.container.icon.warning": {
    "value": "var(--ids-colors-input-container-icon-warning)",
    "variable": "var(--ids-colors-input-container-icon-warning)"
  },
  "colors.input.container.icon.success": {
    "value": "var(--ids-colors-input-container-icon-success)",
    "variable": "var(--ids-colors-input-container-icon-success)"
  },
  "colors.input.container.text.disabled": {
    "value": "var(--ids-colors-input-container-text-disabled)",
    "variable": "var(--ids-colors-input-container-text-disabled)"
  },
  "colors.input.container.text.errorDisabled": {
    "value": "var(--ids-colors-input-container-text-error-disabled)",
    "variable": "var(--ids-colors-input-container-text-error-disabled)"
  },
  "colors.input.container.text.warningDisabled": {
    "value": "var(--ids-colors-input-container-text-warning-disabled)",
    "variable": "var(--ids-colors-input-container-text-warning-disabled)"
  },
  "colors.input.container.text.successDisabled": {
    "value": "var(--ids-colors-input-container-text-success-disabled)",
    "variable": "var(--ids-colors-input-container-text-success-disabled)"
  },
  "colors.textArea.container.bg.default": {
    "value": "var(--ids-colors-text-area-container-bg-default)",
    "variable": "var(--ids-colors-text-area-container-bg-default)"
  },
  "colors.textArea.container.bg.disabled": {
    "value": "var(--ids-colors-text-area-container-bg-disabled)",
    "variable": "var(--ids-colors-text-area-container-bg-disabled)"
  },
  "colors.textArea.container.bg.errorDisabled": {
    "value": "var(--ids-colors-text-area-container-bg-error-disabled)",
    "variable": "var(--ids-colors-text-area-container-bg-error-disabled)"
  },
  "colors.textArea.container.bg.warningDisabled": {
    "value": "var(--ids-colors-text-area-container-bg-warning-disabled)",
    "variable": "var(--ids-colors-text-area-container-bg-warning-disabled)"
  },
  "colors.textArea.container.bg.successDisabled": {
    "value": "var(--ids-colors-text-area-container-bg-success-disabled)",
    "variable": "var(--ids-colors-text-area-container-bg-success-disabled)"
  },
  "colors.textArea.container.border.default": {
    "value": "var(--ids-colors-text-area-container-border-default)",
    "variable": "var(--ids-colors-text-area-container-border-default)"
  },
  "colors.textArea.container.border.hover": {
    "value": "var(--ids-colors-text-area-container-border-hover)",
    "variable": "var(--ids-colors-text-area-container-border-hover)"
  },
  "colors.textArea.container.border.focus": {
    "value": "var(--ids-colors-text-area-container-border-focus)",
    "variable": "var(--ids-colors-text-area-container-border-focus)"
  },
  "colors.textArea.container.border.error": {
    "value": "var(--ids-colors-text-area-container-border-error)",
    "variable": "var(--ids-colors-text-area-container-border-error)"
  },
  "colors.textArea.container.border.errorHover": {
    "value": "var(--ids-colors-text-area-container-border-error-hover)",
    "variable": "var(--ids-colors-text-area-container-border-error-hover)"
  },
  "colors.textArea.container.border.errorFocus": {
    "value": "var(--ids-colors-text-area-container-border-error-focus)",
    "variable": "var(--ids-colors-text-area-container-border-error-focus)"
  },
  "colors.textArea.container.border.warning": {
    "value": "var(--ids-colors-text-area-container-border-warning)",
    "variable": "var(--ids-colors-text-area-container-border-warning)"
  },
  "colors.textArea.container.border.warningHover": {
    "value": "var(--ids-colors-text-area-container-border-warning-hover)",
    "variable": "var(--ids-colors-text-area-container-border-warning-hover)"
  },
  "colors.textArea.container.border.warningFocus": {
    "value": "var(--ids-colors-text-area-container-border-warning-focus)",
    "variable": "var(--ids-colors-text-area-container-border-warning-focus)"
  },
  "colors.textArea.container.border.success": {
    "value": "var(--ids-colors-text-area-container-border-success)",
    "variable": "var(--ids-colors-text-area-container-border-success)"
  },
  "colors.textArea.container.border.successHover": {
    "value": "var(--ids-colors-text-area-container-border-success-hover)",
    "variable": "var(--ids-colors-text-area-container-border-success-hover)"
  },
  "colors.textArea.container.border.successFocus": {
    "value": "var(--ids-colors-text-area-container-border-success-focus)",
    "variable": "var(--ids-colors-text-area-container-border-success-focus)"
  },
  "colors.textArea.container.icon.error": {
    "value": "var(--ids-colors-text-area-container-icon-error)",
    "variable": "var(--ids-colors-text-area-container-icon-error)"
  },
  "colors.textArea.container.icon.warning": {
    "value": "var(--ids-colors-text-area-container-icon-warning)",
    "variable": "var(--ids-colors-text-area-container-icon-warning)"
  },
  "colors.textArea.container.icon.success": {
    "value": "var(--ids-colors-text-area-container-icon-success)",
    "variable": "var(--ids-colors-text-area-container-icon-success)"
  },
  "colors.textArea.container.text.disabled": {
    "value": "var(--ids-colors-text-area-container-text-disabled)",
    "variable": "var(--ids-colors-text-area-container-text-disabled)"
  },
  "colors.textArea.container.text.errorDisabled": {
    "value": "var(--ids-colors-text-area-container-text-error-disabled)",
    "variable": "var(--ids-colors-text-area-container-text-error-disabled)"
  },
  "colors.textArea.container.text.warningDisabled": {
    "value": "var(--ids-colors-text-area-container-text-warning-disabled)",
    "variable": "var(--ids-colors-text-area-container-text-warning-disabled)"
  },
  "colors.textArea.container.text.successDisabled": {
    "value": "var(--ids-colors-text-area-container-text-success-disabled)",
    "variable": "var(--ids-colors-text-area-container-text-success-disabled)"
  },
  "colors.radio.icon": {
    "value": "var(--ids-colors-radio-icon)",
    "variable": "var(--ids-colors-radio-icon)"
  },
  "colors.radio.iconChecked": {
    "value": "var(--ids-colors-radio-icon-checked)",
    "variable": "var(--ids-colors-radio-icon-checked)"
  },
  "colors.radio.hoverBg": {
    "value": "var(--ids-colors-radio-hover-bg)",
    "variable": "var(--ids-colors-radio-hover-bg)"
  },
  "colors.radio.label": {
    "value": "var(--ids-colors-radio-label)",
    "variable": "var(--ids-colors-radio-label)"
  },
  "colors.radio.description": {
    "value": "var(--ids-colors-radio-description)",
    "variable": "var(--ids-colors-radio-description)"
  },
  "colors.radio.endIcon": {
    "value": "var(--ids-colors-radio-end-icon)",
    "variable": "var(--ids-colors-radio-end-icon)"
  },
  "colors.radioBox.border": {
    "value": "var(--ids-colors-radio-box-border)",
    "variable": "var(--ids-colors-radio-box-border)"
  },
  "colors.radioBox.checkedBg": {
    "value": "var(--ids-colors-radio-box-checked-bg)",
    "variable": "var(--ids-colors-radio-box-checked-bg)"
  },
  "colors.radioBox.checkedBorder": {
    "value": "var(--ids-colors-radio-box-checked-border)",
    "variable": "var(--ids-colors-radio-box-checked-border)"
  },
  "colors.radioBox.checkIcon": {
    "value": "var(--ids-colors-radio-box-check-icon)",
    "variable": "var(--ids-colors-radio-box-check-icon)"
  },
  "colors.radioBox.checkedText": {
    "value": "var(--ids-colors-radio-box-checked-text)",
    "variable": "var(--ids-colors-radio-box-checked-text)"
  },
  "colors.radioCard.checkedBg": {
    "value": "var(--ids-colors-radio-card-checked-bg)",
    "variable": "var(--ids-colors-radio-card-checked-bg)"
  },
  "colors.radioCard.checkedBorder": {
    "value": "var(--ids-colors-radio-card-checked-border)",
    "variable": "var(--ids-colors-radio-card-checked-border)"
  },
  "colors.checkbox.icon": {
    "value": "var(--ids-colors-checkbox-icon)",
    "variable": "var(--ids-colors-checkbox-icon)"
  },
  "colors.checkbox.iconChecked": {
    "value": "var(--ids-colors-checkbox-icon-checked)",
    "variable": "var(--ids-colors-checkbox-icon-checked)"
  },
  "colors.checkbox.hoverBg": {
    "value": "var(--ids-colors-checkbox-hover-bg)",
    "variable": "var(--ids-colors-checkbox-hover-bg)"
  },
  "colors.checkbox.label": {
    "value": "var(--ids-colors-checkbox-label)",
    "variable": "var(--ids-colors-checkbox-label)"
  },
  "colors.toggleSwitch.track": {
    "value": "var(--ids-colors-toggle-switch-track)",
    "variable": "var(--ids-colors-toggle-switch-track)"
  },
  "colors.toggleSwitch.checkedTrack": {
    "value": "var(--ids-colors-toggle-switch-checked-track)",
    "variable": "var(--ids-colors-toggle-switch-checked-track)"
  },
  "colors.toggleSwitch.thumb": {
    "value": "var(--ids-colors-toggle-switch-thumb)",
    "variable": "var(--ids-colors-toggle-switch-thumb)"
  },
  "colors.select.trigger.bg": {
    "value": "var(--ids-colors-select-trigger-bg)",
    "variable": "var(--ids-colors-select-trigger-bg)"
  },
  "colors.select.trigger.border.focused": {
    "value": "var(--ids-colors-select-trigger-border-focused)",
    "variable": "var(--ids-colors-select-trigger-border-focused)"
  },
  "colors.select.trigger.border.filled": {
    "value": "var(--ids-colors-select-trigger-border-filled)",
    "variable": "var(--ids-colors-select-trigger-border-filled)"
  },
  "colors.select.trigger.border.hoverFilled": {
    "value": "var(--ids-colors-select-trigger-border-hover-filled)",
    "variable": "var(--ids-colors-select-trigger-border-hover-filled)"
  },
  "colors.select.trigger.border.hover": {
    "value": "var(--ids-colors-select-trigger-border-hover)",
    "variable": "var(--ids-colors-select-trigger-border-hover)"
  },
  "colors.select.trigger.text.focused": {
    "value": "var(--ids-colors-select-trigger-text-focused)",
    "variable": "var(--ids-colors-select-trigger-text-focused)"
  },
  "colors.select.valueText.filled": {
    "value": "var(--ids-colors-select-value-text-filled)",
    "variable": "var(--ids-colors-select-value-text-filled)"
  },
  "colors.select.indicator.color": {
    "value": "var(--ids-colors-select-indicator-color)",
    "variable": "var(--ids-colors-select-indicator-color)"
  },
  "colors.select.indicator.colorFocused": {
    "value": "var(--ids-colors-select-indicator-color-focused)",
    "variable": "var(--ids-colors-select-indicator-color-focused)"
  },
  "colors.select.clearTrigger.color": {
    "value": "var(--ids-colors-select-clear-trigger-color)",
    "variable": "var(--ids-colors-select-clear-trigger-color)"
  },
  "colors.menu.content.bg": {
    "value": "var(--ids-colors-menu-content-bg)",
    "variable": "var(--ids-colors-menu-content-bg)"
  },
  "colors.menu.item.bg.selected": {
    "value": "var(--ids-colors-menu-item-bg-selected)",
    "variable": "var(--ids-colors-menu-item-bg-selected)"
  },
  "colors.menu.item.bg.selectedHover": {
    "value": "var(--ids-colors-menu-item-bg-selected-hover)",
    "variable": "var(--ids-colors-menu-item-bg-selected-hover)"
  },
  "colors.menu.item.color.selected": {
    "value": "var(--ids-colors-menu-item-color-selected)",
    "variable": "var(--ids-colors-menu-item-color-selected)"
  },
  "colors.menu.item.color.hover": {
    "value": "var(--ids-colors-menu-item-color-hover)",
    "variable": "var(--ids-colors-menu-item-color-hover)"
  },
  "colors.menu.item.iconColor.hover": {
    "value": "var(--ids-colors-menu-item-icon-color-hover)",
    "variable": "var(--ids-colors-menu-item-icon-color-hover)"
  },
  "colors.menu.item.iconColor.selected": {
    "value": "var(--ids-colors-menu-item-icon-color-selected)",
    "variable": "var(--ids-colors-menu-item-icon-color-selected)"
  },
  "colors.menu.item.indicator.color": {
    "value": "var(--ids-colors-menu-item-indicator-color)",
    "variable": "var(--ids-colors-menu-item-indicator-color)"
  },
  "colors.menu.separator.color": {
    "value": "var(--ids-colors-menu-separator-color)",
    "variable": "var(--ids-colors-menu-separator-color)"
  },
  "colors.menu.active.bg": {
    "value": "var(--ids-colors-menu-active-bg)",
    "variable": "var(--ids-colors-menu-active-bg)"
  },
  "colors.menu.active.color": {
    "value": "var(--ids-colors-menu-active-color)",
    "variable": "var(--ids-colors-menu-active-color)"
  },
  "colors.menu.active.iconColor": {
    "value": "var(--ids-colors-menu-active-icon-color)",
    "variable": "var(--ids-colors-menu-active-icon-color)"
  },
  "colors.menu.emptyState.color": {
    "value": "var(--ids-colors-menu-empty-state-color)",
    "variable": "var(--ids-colors-menu-empty-state-color)"
  },
  "colors.combobox.trigger.bg.default": {
    "value": "var(--ids-colors-combobox-trigger-bg-default)",
    "variable": "var(--ids-colors-combobox-trigger-bg-default)"
  },
  "colors.combobox.trigger.bg.disabled": {
    "value": "var(--ids-colors-combobox-trigger-bg-disabled)",
    "variable": "var(--ids-colors-combobox-trigger-bg-disabled)"
  },
  "colors.combobox.trigger.placeholderColor": {
    "value": "var(--ids-colors-combobox-trigger-placeholder-color)",
    "variable": "var(--ids-colors-combobox-trigger-placeholder-color)"
  },
  "colors.combobox.icon.color": {
    "value": "var(--ids-colors-combobox-icon-color)",
    "variable": "var(--ids-colors-combobox-icon-color)"
  },
  "colors.notice.error.bg": {
    "value": "var(--ids-colors-notice-error-bg)",
    "variable": "var(--ids-colors-notice-error-bg)"
  },
  "colors.notice.error.text": {
    "value": "var(--ids-colors-notice-error-text)",
    "variable": "var(--ids-colors-notice-error-text)"
  },
  "colors.notice.error.icon": {
    "value": "var(--ids-colors-notice-error-icon)",
    "variable": "var(--ids-colors-notice-error-icon)"
  },
  "colors.notice.error.border": {
    "value": "var(--ids-colors-notice-error-border)",
    "variable": "var(--ids-colors-notice-error-border)"
  },
  "colors.notice.error.confirmButton": {
    "value": "var(--ids-colors-notice-error-confirm-button)",
    "variable": "var(--ids-colors-notice-error-confirm-button)"
  },
  "colors.notice.error.closeButtonIcon": {
    "value": "var(--ids-colors-notice-error-close-button-icon)",
    "variable": "var(--ids-colors-notice-error-close-button-icon)"
  },
  "colors.notice.warning.bg": {
    "value": "var(--ids-colors-notice-warning-bg)",
    "variable": "var(--ids-colors-notice-warning-bg)"
  },
  "colors.notice.warning.text": {
    "value": "var(--ids-colors-notice-warning-text)",
    "variable": "var(--ids-colors-notice-warning-text)"
  },
  "colors.notice.warning.icon": {
    "value": "var(--ids-colors-notice-warning-icon)",
    "variable": "var(--ids-colors-notice-warning-icon)"
  },
  "colors.notice.warning.border": {
    "value": "var(--ids-colors-notice-warning-border)",
    "variable": "var(--ids-colors-notice-warning-border)"
  },
  "colors.notice.warning.confirmButton": {
    "value": "var(--ids-colors-notice-warning-confirm-button)",
    "variable": "var(--ids-colors-notice-warning-confirm-button)"
  },
  "colors.notice.warning.closeButtonIcon": {
    "value": "var(--ids-colors-notice-warning-close-button-icon)",
    "variable": "var(--ids-colors-notice-warning-close-button-icon)"
  },
  "colors.notice.success.bg": {
    "value": "var(--ids-colors-notice-success-bg)",
    "variable": "var(--ids-colors-notice-success-bg)"
  },
  "colors.notice.success.text": {
    "value": "var(--ids-colors-notice-success-text)",
    "variable": "var(--ids-colors-notice-success-text)"
  },
  "colors.notice.success.icon": {
    "value": "var(--ids-colors-notice-success-icon)",
    "variable": "var(--ids-colors-notice-success-icon)"
  },
  "colors.notice.success.border": {
    "value": "var(--ids-colors-notice-success-border)",
    "variable": "var(--ids-colors-notice-success-border)"
  },
  "colors.notice.success.confirmButton": {
    "value": "var(--ids-colors-notice-success-confirm-button)",
    "variable": "var(--ids-colors-notice-success-confirm-button)"
  },
  "colors.notice.success.closeButtonIcon": {
    "value": "var(--ids-colors-notice-success-close-button-icon)",
    "variable": "var(--ids-colors-notice-success-close-button-icon)"
  },
  "colors.notice.info.bg": {
    "value": "var(--ids-colors-notice-info-bg)",
    "variable": "var(--ids-colors-notice-info-bg)"
  },
  "colors.notice.info.text": {
    "value": "var(--ids-colors-notice-info-text)",
    "variable": "var(--ids-colors-notice-info-text)"
  },
  "colors.notice.info.icon": {
    "value": "var(--ids-colors-notice-info-icon)",
    "variable": "var(--ids-colors-notice-info-icon)"
  },
  "colors.notice.info.border": {
    "value": "var(--ids-colors-notice-info-border)",
    "variable": "var(--ids-colors-notice-info-border)"
  },
  "colors.notice.info.confirmButton": {
    "value": "var(--ids-colors-notice-info-confirm-button)",
    "variable": "var(--ids-colors-notice-info-confirm-button)"
  },
  "colors.notice.info.closeButtonIcon": {
    "value": "var(--ids-colors-notice-info-close-button-icon)",
    "variable": "var(--ids-colors-notice-info-close-button-icon)"
  },
  "colors.notice.basic.bg": {
    "value": "var(--ids-colors-notice-basic-bg)",
    "variable": "var(--ids-colors-notice-basic-bg)"
  },
  "colors.notice.basic.text": {
    "value": "var(--ids-colors-notice-basic-text)",
    "variable": "var(--ids-colors-notice-basic-text)"
  },
  "colors.notice.basic.icon": {
    "value": "var(--ids-colors-notice-basic-icon)",
    "variable": "var(--ids-colors-notice-basic-icon)"
  },
  "colors.notice.basic.border": {
    "value": "var(--ids-colors-notice-basic-border)",
    "variable": "var(--ids-colors-notice-basic-border)"
  },
  "colors.notice.basic.confirmButton": {
    "value": "var(--ids-colors-notice-basic-confirm-button)",
    "variable": "var(--ids-colors-notice-basic-confirm-button)"
  },
  "colors.notice.basic.closeButtonIcon": {
    "value": "var(--ids-colors-notice-basic-close-button-icon)",
    "variable": "var(--ids-colors-notice-basic-close-button-icon)"
  },
  "colors.errorState.bg": {
    "value": "var(--ids-colors-error-state-bg)",
    "variable": "var(--ids-colors-error-state-bg)"
  },
  "colors.spinner.track.white": {
    "value": "var(--ids-colors-spinner-track-white)",
    "variable": "var(--ids-colors-spinner-track-white)"
  },
  "colors.spinner.track.green": {
    "value": "var(--ids-colors-spinner-track-green)",
    "variable": "var(--ids-colors-spinner-track-green)"
  },
  "colors.spinner.track.neutral": {
    "value": "var(--ids-colors-spinner-track-neutral)",
    "variable": "var(--ids-colors-spinner-track-neutral)"
  },
  "colors.spinner.track.brand": {
    "value": "var(--ids-colors-spinner-track-brand)",
    "variable": "var(--ids-colors-spinner-track-brand)"
  },
  "colors.spinner.track.inverse": {
    "value": "var(--ids-colors-spinner-track-inverse)",
    "variable": "var(--ids-colors-spinner-track-inverse)"
  },
  "colors.spinner.indicator.white": {
    "value": "var(--ids-colors-spinner-indicator-white)",
    "variable": "var(--ids-colors-spinner-indicator-white)"
  },
  "colors.spinner.indicator.green": {
    "value": "var(--ids-colors-spinner-indicator-green)",
    "variable": "var(--ids-colors-spinner-indicator-green)"
  },
  "colors.spinner.indicator.neutral": {
    "value": "var(--ids-colors-spinner-indicator-neutral)",
    "variable": "var(--ids-colors-spinner-indicator-neutral)"
  },
  "colors.spinner.indicator.brand": {
    "value": "var(--ids-colors-spinner-indicator-brand)",
    "variable": "var(--ids-colors-spinner-indicator-brand)"
  },
  "colors.spinner.indicator.inverse": {
    "value": "var(--ids-colors-spinner-indicator-inverse)",
    "variable": "var(--ids-colors-spinner-indicator-inverse)"
  },
  "colors.table.line.color": {
    "value": "var(--ids-colors-table-line-color)",
    "variable": "var(--ids-colors-table-line-color)"
  },
  "colors.table.pinned.borderColor": {
    "value": "var(--ids-colors-table-pinned-border-color)",
    "variable": "var(--ids-colors-table-pinned-border-color)"
  },
  "colors.table.row.selected.bg": {
    "value": "var(--ids-colors-table-row-selected-bg)",
    "variable": "var(--ids-colors-table-row-selected-bg)"
  },
  "colors.table.row.selected.outlineColor": {
    "value": "var(--ids-colors-table-row-selected-outline-color)",
    "variable": "var(--ids-colors-table-row-selected-outline-color)"
  },
  "colors.table.cell.focus.outlineColor": {
    "value": "var(--ids-colors-table-cell-focus-outline-color)",
    "variable": "var(--ids-colors-table-cell-focus-outline-color)"
  },
  "colors.table.dragging.bg": {
    "value": "var(--ids-colors-table-dragging-bg)",
    "variable": "var(--ids-colors-table-dragging-bg)"
  },
  "colors.datePicker.content.bg": {
    "value": "var(--ids-colors-date-picker-content-bg)",
    "variable": "var(--ids-colors-date-picker-content-bg)"
  },
  "colors.datePicker.content.border": {
    "value": "var(--ids-colors-date-picker-content-border)",
    "variable": "var(--ids-colors-date-picker-content-border)"
  },
  "colors.datePicker.day.text.default": {
    "value": "var(--ids-colors-date-picker-day-text-default)",
    "variable": "var(--ids-colors-date-picker-day-text-default)"
  },
  "colors.datePicker.day.text.today": {
    "value": "var(--ids-colors-date-picker-day-text-today)",
    "variable": "var(--ids-colors-date-picker-day-text-today)"
  },
  "colors.datePicker.day.text.selected": {
    "value": "var(--ids-colors-date-picker-day-text-selected)",
    "variable": "var(--ids-colors-date-picker-day-text-selected)"
  },
  "colors.datePicker.day.text.inRange": {
    "value": "var(--ids-colors-date-picker-day-text-in-range)",
    "variable": "var(--ids-colors-date-picker-day-text-in-range)"
  },
  "colors.datePicker.day.text.rangeEnd": {
    "value": "var(--ids-colors-date-picker-day-text-range-end)",
    "variable": "var(--ids-colors-date-picker-day-text-range-end)"
  },
  "colors.datePicker.day.text.disabled": {
    "value": "var(--ids-colors-date-picker-day-text-disabled)",
    "variable": "var(--ids-colors-date-picker-day-text-disabled)"
  },
  "colors.datePicker.day.bg.hover": {
    "value": "var(--ids-colors-date-picker-day-bg-hover)",
    "variable": "var(--ids-colors-date-picker-day-bg-hover)"
  },
  "colors.datePicker.day.bg.selected": {
    "value": "var(--ids-colors-date-picker-day-bg-selected)",
    "variable": "var(--ids-colors-date-picker-day-bg-selected)"
  },
  "colors.datePicker.day.bg.inRange": {
    "value": "var(--ids-colors-date-picker-day-bg-in-range)",
    "variable": "var(--ids-colors-date-picker-day-bg-in-range)"
  },
  "colors.datePicker.day.bg.rangeEnd": {
    "value": "var(--ids-colors-date-picker-day-bg-range-end)",
    "variable": "var(--ids-colors-date-picker-day-bg-range-end)"
  },
  "colors.datePicker.day.border.hover": {
    "value": "var(--ids-colors-date-picker-day-border-hover)",
    "variable": "var(--ids-colors-date-picker-day-border-hover)"
  },
  "colors.datePicker.day.border.focus": {
    "value": "var(--ids-colors-date-picker-day-border-focus)",
    "variable": "var(--ids-colors-date-picker-day-border-focus)"
  },
  "colors.datePicker.weekday.text": {
    "value": "var(--ids-colors-date-picker-weekday-text)",
    "variable": "var(--ids-colors-date-picker-weekday-text)"
  },
  "colors.datePicker.footer.bg": {
    "value": "var(--ids-colors-date-picker-footer-bg)",
    "variable": "var(--ids-colors-date-picker-footer-bg)"
  },
  "colors.datePicker.footer.borderTop": {
    "value": "var(--ids-colors-date-picker-footer-border-top)",
    "variable": "var(--ids-colors-date-picker-footer-border-top)"
  },
  "colors.datePicker.gridBorderBottom.color": {
    "value": "var(--ids-colors-date-picker-grid-border-bottom-color)",
    "variable": "var(--ids-colors-date-picker-grid-border-bottom-color)"
  },
  "colors.datePicker.input.borderOpen": {
    "value": "var(--ids-colors-date-picker-input-border-open)",
    "variable": "var(--ids-colors-date-picker-input-border-open)"
  },
  "colors.dialog.footer.bg": {
    "value": "var(--ids-colors-dialog-footer-bg)",
    "variable": "var(--ids-colors-dialog-footer-bg)"
  },
  "colors.timePicker.footer.bg": {
    "value": "var(--ids-colors-time-picker-footer-bg)",
    "variable": "var(--ids-colors-time-picker-footer-bg)"
  },
  "colors.timePicker.gridBorderBottom.color": {
    "value": "var(--ids-colors-time-picker-grid-border-bottom-color)",
    "variable": "var(--ids-colors-time-picker-grid-border-bottom-color)"
  },
  "colors.timePicker.input.text.default": {
    "value": "var(--ids-colors-time-picker-input-text-default)",
    "variable": "var(--ids-colors-time-picker-input-text-default)"
  },
  "colors.timePicker.input.text.filled": {
    "value": "var(--ids-colors-time-picker-input-text-filled)",
    "variable": "var(--ids-colors-time-picker-input-text-filled)"
  },
  "colors.timePicker.input.text.disabled": {
    "value": "var(--ids-colors-time-picker-input-text-disabled)",
    "variable": "var(--ids-colors-time-picker-input-text-disabled)"
  },
  "colors.timePicker.input.borderOpen": {
    "value": "var(--ids-colors-time-picker-input-border-open)",
    "variable": "var(--ids-colors-time-picker-input-border-open)"
  },
  "colors.badge.ring": {
    "value": "var(--ids-colors-badge-ring)",
    "variable": "var(--ids-colors-badge-ring)"
  },
  "colors.skeleton.color.base": {
    "value": "var(--ids-colors-skeleton-color-base)",
    "variable": "var(--ids-colors-skeleton-color-base)"
  },
  "colors.skeleton.color.highlight": {
    "value": "var(--ids-colors-skeleton-color-highlight)",
    "variable": "var(--ids-colors-skeleton-color-highlight)"
  },
  "colors.propertyPanel.field.label": {
    "value": "var(--ids-colors-property-panel-field-label)",
    "variable": "var(--ids-colors-property-panel-field-label)"
  },
  "colors.focusRing.border.default": {
    "value": "var(--ids-colors-focus-ring-border-default)",
    "variable": "var(--ids-colors-focus-ring-border-default)"
  },
  "colors.overlay.scrim": {
    "value": "var(--ids-colors-overlay-scrim)",
    "variable": "var(--ids-colors-overlay-scrim)"
  },
  "colors.overlay.darken.hover": {
    "value": "var(--ids-colors-overlay-darken-hover)",
    "variable": "var(--ids-colors-overlay-darken-hover)"
  },
  "colors.overlay.darken.pressed": {
    "value": "var(--ids-colors-overlay-darken-pressed)",
    "variable": "var(--ids-colors-overlay-darken-pressed)"
  },
  "colors.overlay.lighten.hover": {
    "value": "var(--ids-colors-overlay-lighten-hover)",
    "variable": "var(--ids-colors-overlay-lighten-hover)"
  },
  "colors.overlay.lighten.pressed": {
    "value": "var(--ids-colors-overlay-lighten-pressed)",
    "variable": "var(--ids-colors-overlay-lighten-pressed)"
  },
  "spacing.chip.size.xs.rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-xs-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-xs-root-padding-x)"
  },
  "spacing.chip.size.xs.gap": {
    "value": "var(--ids-spacing-chip-size-xs-gap)",
    "variable": "var(--ids-spacing-chip-size-xs-gap)"
  },
  "spacing.chip.size.xs.labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-xs-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-xs-label-padding-x)"
  },
  "spacing.chip.size.sm.rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-sm-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-sm-root-padding-x)"
  },
  "spacing.chip.size.sm.gap": {
    "value": "var(--ids-spacing-chip-size-sm-gap)",
    "variable": "var(--ids-spacing-chip-size-sm-gap)"
  },
  "spacing.chip.size.sm.labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-sm-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-sm-label-padding-x)"
  },
  "spacing.chip.size.md.rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-md-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-md-root-padding-x)"
  },
  "spacing.chip.size.md.gap": {
    "value": "var(--ids-spacing-chip-size-md-gap)",
    "variable": "var(--ids-spacing-chip-size-md-gap)"
  },
  "spacing.chip.size.md.labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-md-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-md-label-padding-x)"
  },
  "spacing.chip.size.lg.rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-lg-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-lg-root-padding-x)"
  },
  "spacing.chip.size.lg.gap": {
    "value": "var(--ids-spacing-chip-size-lg-gap)",
    "variable": "var(--ids-spacing-chip-size-lg-gap)"
  },
  "spacing.chip.size.lg.labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-lg-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-lg-label-padding-x)"
  },
  "spacing.progressBar.size.sm.gap": {
    "value": "var(--ids-spacing-progress-bar-size-sm-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-sm-gap)"
  },
  "spacing.progressBar.size.md.gap": {
    "value": "var(--ids-spacing-progress-bar-size-md-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-md-gap)"
  },
  "spacing.progressBar.size.lg.gap": {
    "value": "var(--ids-spacing-progress-bar-size-lg-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-lg-gap)"
  },
  "spacing.tabs.list.gap": {
    "value": "var(--ids-spacing-tabs-list-gap)",
    "variable": "var(--ids-spacing-tabs-list-gap)"
  },
  "spacing.tabs.list.stretchGap": {
    "value": "var(--ids-spacing-tabs-list-stretch-gap)",
    "variable": "var(--ids-spacing-tabs-list-stretch-gap)"
  },
  "spacing.tabs.trigger.gap": {
    "value": "var(--ids-spacing-tabs-trigger-gap)",
    "variable": "var(--ids-spacing-tabs-trigger-gap)"
  },
  "spacing.tabs.trigger.paddingTop": {
    "value": "var(--ids-spacing-tabs-trigger-padding-top)",
    "variable": "var(--ids-spacing-tabs-trigger-padding-top)"
  },
  "spacing.tabs.trigger.paddingBottom": {
    "value": "var(--ids-spacing-tabs-trigger-padding-bottom)",
    "variable": "var(--ids-spacing-tabs-trigger-padding-bottom)"
  },
  "spacing.button.size.xl.paddingX": {
    "value": "var(--ids-spacing-button-size-xl-padding-x)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x)"
  },
  "spacing.button.size.xl.paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-with-icon)"
  },
  "spacing.button.size.xl.paddingY": {
    "value": "var(--ids-spacing-button-size-xl-padding-y)",
    "variable": "var(--ids-spacing-button-size-xl-padding-y)"
  },
  "spacing.button.size.xl.paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-narrow)"
  },
  "spacing.button.size.xl.paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.xl.gap": {
    "value": "var(--ids-spacing-button-size-xl-gap)",
    "variable": "var(--ids-spacing-button-size-xl-gap)"
  },
  "spacing.button.size.lg.paddingX": {
    "value": "var(--ids-spacing-button-size-lg-padding-x)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x)"
  },
  "spacing.button.size.lg.paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-with-icon)"
  },
  "spacing.button.size.lg.paddingY": {
    "value": "var(--ids-spacing-button-size-lg-padding-y)",
    "variable": "var(--ids-spacing-button-size-lg-padding-y)"
  },
  "spacing.button.size.lg.paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-narrow)"
  },
  "spacing.button.size.lg.paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.lg.gap": {
    "value": "var(--ids-spacing-button-size-lg-gap)",
    "variable": "var(--ids-spacing-button-size-lg-gap)"
  },
  "spacing.button.size.md.paddingX": {
    "value": "var(--ids-spacing-button-size-md-padding-x)",
    "variable": "var(--ids-spacing-button-size-md-padding-x)"
  },
  "spacing.button.size.md.paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-md-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-with-icon)"
  },
  "spacing.button.size.md.paddingY": {
    "value": "var(--ids-spacing-button-size-md-padding-y)",
    "variable": "var(--ids-spacing-button-size-md-padding-y)"
  },
  "spacing.button.size.md.paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-md-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-narrow)"
  },
  "spacing.button.size.md.paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-md-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.md.gap": {
    "value": "var(--ids-spacing-button-size-md-gap)",
    "variable": "var(--ids-spacing-button-size-md-gap)"
  },
  "spacing.button.size.sm.paddingX": {
    "value": "var(--ids-spacing-button-size-sm-padding-x)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x)"
  },
  "spacing.button.size.sm.paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-with-icon)"
  },
  "spacing.button.size.sm.paddingY": {
    "value": "var(--ids-spacing-button-size-sm-padding-y)",
    "variable": "var(--ids-spacing-button-size-sm-padding-y)"
  },
  "spacing.button.size.sm.paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-narrow)"
  },
  "spacing.button.size.sm.paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.sm.gap": {
    "value": "var(--ids-spacing-button-size-sm-gap)",
    "variable": "var(--ids-spacing-button-size-sm-gap)"
  },
  "spacing.button.size.xs.paddingX": {
    "value": "var(--ids-spacing-button-size-xs-padding-x)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x)"
  },
  "spacing.button.size.xs.paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-with-icon)"
  },
  "spacing.button.size.xs.paddingY": {
    "value": "var(--ids-spacing-button-size-xs-padding-y)",
    "variable": "var(--ids-spacing-button-size-xs-padding-y)"
  },
  "spacing.button.size.xs.paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-narrow)"
  },
  "spacing.button.size.xs.paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.xs.gap": {
    "value": "var(--ids-spacing-button-size-xs-gap)",
    "variable": "var(--ids-spacing-button-size-xs-gap)"
  },
  "spacing.tooltip.paddingLeft": {
    "value": "var(--ids-spacing-tooltip-padding-left)",
    "variable": "var(--ids-spacing-tooltip-padding-left)"
  },
  "spacing.tooltip.paddingRight": {
    "value": "var(--ids-spacing-tooltip-padding-right)",
    "variable": "var(--ids-spacing-tooltip-padding-right)"
  },
  "spacing.tooltip.paddingY": {
    "value": "var(--ids-spacing-tooltip-padding-y)",
    "variable": "var(--ids-spacing-tooltip-padding-y)"
  },
  "spacing.tooltip.paddingRightClosable": {
    "value": "var(--ids-spacing-tooltip-padding-right-closable)",
    "variable": "var(--ids-spacing-tooltip-padding-right-closable)"
  },
  "spacing.iconButton.size.xs.padding": {
    "value": "var(--ids-spacing-icon-button-size-xs-padding)",
    "variable": "var(--ids-spacing-icon-button-size-xs-padding)"
  },
  "spacing.iconButton.size.sm.padding": {
    "value": "var(--ids-spacing-icon-button-size-sm-padding)",
    "variable": "var(--ids-spacing-icon-button-size-sm-padding)"
  },
  "spacing.iconButton.size.md.padding": {
    "value": "var(--ids-spacing-icon-button-size-md-padding)",
    "variable": "var(--ids-spacing-icon-button-size-md-padding)"
  },
  "spacing.iconButton.size.lg.padding": {
    "value": "var(--ids-spacing-icon-button-size-lg-padding)",
    "variable": "var(--ids-spacing-icon-button-size-lg-padding)"
  },
  "spacing.iconButton.size.xl.padding": {
    "value": "var(--ids-spacing-icon-button-size-xl-padding)",
    "variable": "var(--ids-spacing-icon-button-size-xl-padding)"
  },
  "spacing.floatingButton.size.md.paddingY": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-y)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-y)"
  },
  "spacing.floatingButton.size.md.paddingLeft": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-left)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-left)"
  },
  "spacing.floatingButton.size.md.paddingRight": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right)"
  },
  "spacing.floatingButton.size.md.paddingLeftWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-left-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-left-with-icon)"
  },
  "spacing.floatingButton.size.md.paddingRightWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right-with-icon)"
  },
  "spacing.floatingButton.size.md.paddingRightWithEndIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right-with-end-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right-with-end-icon)"
  },
  "spacing.floatingButton.size.md.gap": {
    "value": "var(--ids-spacing-floating-button-size-md-gap)",
    "variable": "var(--ids-spacing-floating-button-size-md-gap)"
  },
  "spacing.floatingButton.size.sm.paddingY": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-y)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-y)"
  },
  "spacing.floatingButton.size.sm.paddingLeft": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-left)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-left)"
  },
  "spacing.floatingButton.size.sm.paddingRight": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right)"
  },
  "spacing.floatingButton.size.sm.paddingLeftWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-left-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-left-with-icon)"
  },
  "spacing.floatingButton.size.sm.paddingRightWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right-with-icon)"
  },
  "spacing.floatingButton.size.sm.paddingRightWithEndIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right-with-end-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right-with-end-icon)"
  },
  "spacing.floatingButton.size.sm.gap": {
    "value": "var(--ids-spacing-floating-button-size-sm-gap)",
    "variable": "var(--ids-spacing-floating-button-size-sm-gap)"
  },
  "spacing.input.container.paddingX": {
    "value": "var(--ids-spacing-input-container-padding-x)",
    "variable": "var(--ids-spacing-input-container-padding-x)"
  },
  "spacing.input.size.xs.paddingY": {
    "value": "var(--ids-spacing-input-size-xs-padding-y)",
    "variable": "var(--ids-spacing-input-size-xs-padding-y)"
  },
  "spacing.input.size.sm.paddingY": {
    "value": "var(--ids-spacing-input-size-sm-padding-y)",
    "variable": "var(--ids-spacing-input-size-sm-padding-y)"
  },
  "spacing.input.size.md.paddingY": {
    "value": "var(--ids-spacing-input-size-md-padding-y)",
    "variable": "var(--ids-spacing-input-size-md-padding-y)"
  },
  "spacing.input.size.lg.paddingY": {
    "value": "var(--ids-spacing-input-size-lg-padding-y)",
    "variable": "var(--ids-spacing-input-size-lg-padding-y)"
  },
  "spacing.input.size.xl.paddingY": {
    "value": "var(--ids-spacing-input-size-xl-padding-y)",
    "variable": "var(--ids-spacing-input-size-xl-padding-y)"
  },
  "spacing.textArea.container.paddingX": {
    "value": "var(--ids-spacing-text-area-container-padding-x)",
    "variable": "var(--ids-spacing-text-area-container-padding-x)"
  },
  "spacing.textArea.size.sm.paddingY": {
    "value": "var(--ids-spacing-text-area-size-sm-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-sm-padding-y)"
  },
  "spacing.textArea.size.md.paddingY": {
    "value": "var(--ids-spacing-text-area-size-md-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-md-padding-y)"
  },
  "spacing.textArea.size.lg.paddingY": {
    "value": "var(--ids-spacing-text-area-size-lg-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-lg-padding-y)"
  },
  "spacing.textArea.size.xl.paddingY": {
    "value": "var(--ids-spacing-text-area-size-xl-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-xl-padding-y)"
  },
  "spacing.radio.size.sm.gap": {
    "value": "var(--ids-spacing-radio-size-sm-gap)",
    "variable": "var(--ids-spacing-radio-size-sm-gap)"
  },
  "spacing.radio.size.sm.indicatorAreaPadding": {
    "value": "var(--ids-spacing-radio-size-sm-indicator-area-padding)",
    "variable": "var(--ids-spacing-radio-size-sm-indicator-area-padding)"
  },
  "spacing.radio.size.md.gap": {
    "value": "var(--ids-spacing-radio-size-md-gap)",
    "variable": "var(--ids-spacing-radio-size-md-gap)"
  },
  "spacing.radio.size.md.indicatorAreaPadding": {
    "value": "var(--ids-spacing-radio-size-md-indicator-area-padding)",
    "variable": "var(--ids-spacing-radio-size-md-indicator-area-padding)"
  },
  "spacing.checkbox.contentGap": {
    "value": "var(--ids-spacing-checkbox-content-gap)",
    "variable": "var(--ids-spacing-checkbox-content-gap)"
  },
  "spacing.checkbox.size.sm.gap": {
    "value": "var(--ids-spacing-checkbox-size-sm-gap)",
    "variable": "var(--ids-spacing-checkbox-size-sm-gap)"
  },
  "spacing.checkbox.size.sm.padding": {
    "value": "var(--ids-spacing-checkbox-size-sm-padding)",
    "variable": "var(--ids-spacing-checkbox-size-sm-padding)"
  },
  "spacing.checkbox.size.md.gap": {
    "value": "var(--ids-spacing-checkbox-size-md-gap)",
    "variable": "var(--ids-spacing-checkbox-size-md-gap)"
  },
  "spacing.checkbox.size.md.padding": {
    "value": "var(--ids-spacing-checkbox-size-md-padding)",
    "variable": "var(--ids-spacing-checkbox-size-md-padding)"
  },
  "spacing.menu.content.paddingY": {
    "value": "var(--ids-spacing-menu-content-padding-y)",
    "variable": "var(--ids-spacing-menu-content-padding-y)"
  },
  "spacing.menu.content.paddingX": {
    "value": "var(--ids-spacing-menu-content-padding-x)",
    "variable": "var(--ids-spacing-menu-content-padding-x)"
  },
  "spacing.menu.content.sideOffset": {
    "value": "var(--ids-spacing-menu-content-side-offset)",
    "variable": "var(--ids-spacing-menu-content-side-offset)"
  },
  "spacing.menu.item.padding.y": {
    "value": "var(--ids-spacing-menu-item-padding-y)",
    "variable": "var(--ids-spacing-menu-item-padding-y)"
  },
  "spacing.menu.item.padding.yWithDescription": {
    "value": "var(--ids-spacing-menu-item-padding-y-with-description)",
    "variable": "var(--ids-spacing-menu-item-padding-y-with-description)"
  },
  "spacing.menu.item.padding.left": {
    "value": "var(--ids-spacing-menu-item-padding-left)",
    "variable": "var(--ids-spacing-menu-item-padding-left)"
  },
  "spacing.menu.item.padding.right": {
    "value": "var(--ids-spacing-menu-item-padding-right)",
    "variable": "var(--ids-spacing-menu-item-padding-right)"
  },
  "spacing.menu.groupLabel.padding.left": {
    "value": "var(--ids-spacing-menu-group-label-padding-left)",
    "variable": "var(--ids-spacing-menu-group-label-padding-left)"
  },
  "spacing.menu.groupLabel.padding.right": {
    "value": "var(--ids-spacing-menu-group-label-padding-right)",
    "variable": "var(--ids-spacing-menu-group-label-padding-right)"
  },
  "spacing.menu.groupLabel.padding.top": {
    "value": "var(--ids-spacing-menu-group-label-padding-top)",
    "variable": "var(--ids-spacing-menu-group-label-padding-top)"
  },
  "spacing.menu.separator.marginY": {
    "value": "var(--ids-spacing-menu-separator-margin-y)",
    "variable": "var(--ids-spacing-menu-separator-margin-y)"
  },
  "spacing.combobox.trigger.paddingX": {
    "value": "var(--ids-spacing-combobox-trigger-padding-x)",
    "variable": "var(--ids-spacing-combobox-trigger-padding-x)"
  },
  "spacing.notice.iconPaddingY": {
    "value": "var(--ids-spacing-notice-icon-padding-y)",
    "variable": "var(--ids-spacing-notice-icon-padding-y)"
  },
  "spacing.errorState.paddingY": {
    "value": "var(--ids-spacing-error-state-padding-y)",
    "variable": "var(--ids-spacing-error-state-padding-y)"
  },
  "spacing.datePicker.content.paddingTop": {
    "value": "var(--ids-spacing-date-picker-content-padding-top)",
    "variable": "var(--ids-spacing-date-picker-content-padding-top)"
  },
  "spacing.datePicker.content.paddingX": {
    "value": "var(--ids-spacing-date-picker-content-padding-x)",
    "variable": "var(--ids-spacing-date-picker-content-padding-x)"
  },
  "spacing.datePicker.content.paddingBottom": {
    "value": "var(--ids-spacing-date-picker-content-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-content-padding-bottom)"
  },
  "spacing.datePicker.content.gap": {
    "value": "var(--ids-spacing-date-picker-content-gap)",
    "variable": "var(--ids-spacing-date-picker-content-gap)"
  },
  "spacing.datePicker.viewControl.paddingTop": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-top)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-top)"
  },
  "spacing.datePicker.viewControl.paddingX": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-x)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-x)"
  },
  "spacing.datePicker.viewControl.paddingBottom": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-bottom)"
  },
  "spacing.datePicker.table.paddingTop": {
    "value": "var(--ids-spacing-date-picker-table-padding-top)",
    "variable": "var(--ids-spacing-date-picker-table-padding-top)"
  },
  "spacing.datePicker.table.paddingX": {
    "value": "var(--ids-spacing-date-picker-table-padding-x)",
    "variable": "var(--ids-spacing-date-picker-table-padding-x)"
  },
  "spacing.datePicker.table.paddingBottom": {
    "value": "var(--ids-spacing-date-picker-table-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-table-padding-bottom)"
  },
  "spacing.datePicker.table.cellGapY": {
    "value": "var(--ids-spacing-date-picker-table-cell-gap-y)",
    "variable": "var(--ids-spacing-date-picker-table-cell-gap-y)"
  },
  "spacing.datePicker.tableHeader.paddingBottom": {
    "value": "var(--ids-spacing-date-picker-table-header-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-table-header-padding-bottom)"
  },
  "spacing.datePicker.footer.paddingX": {
    "value": "var(--ids-spacing-date-picker-footer-padding-x)",
    "variable": "var(--ids-spacing-date-picker-footer-padding-x)"
  },
  "spacing.datePicker.footer.paddingY": {
    "value": "var(--ids-spacing-date-picker-footer-padding-y)",
    "variable": "var(--ids-spacing-date-picker-footer-padding-y)"
  },
  "spacing.datePicker.presetList.paddingRight": {
    "value": "var(--ids-spacing-date-picker-preset-list-padding-right)",
    "variable": "var(--ids-spacing-date-picker-preset-list-padding-right)"
  },
  "spacing.dialog.xs.header.pt": {
    "value": "var(--ids-spacing-dialog-xs-header-pt)",
    "variable": "var(--ids-spacing-dialog-xs-header-pt)"
  },
  "spacing.dialog.xs.header.pb": {
    "value": "var(--ids-spacing-dialog-xs-header-pb)",
    "variable": "var(--ids-spacing-dialog-xs-header-pb)"
  },
  "spacing.dialog.xs.header.px": {
    "value": "var(--ids-spacing-dialog-xs-header-px)",
    "variable": "var(--ids-spacing-dialog-xs-header-px)"
  },
  "spacing.dialog.xs.body.pt": {
    "value": "var(--ids-spacing-dialog-xs-body-pt)",
    "variable": "var(--ids-spacing-dialog-xs-body-pt)"
  },
  "spacing.dialog.xs.body.pb": {
    "value": "var(--ids-spacing-dialog-xs-body-pb)",
    "variable": "var(--ids-spacing-dialog-xs-body-pb)"
  },
  "spacing.dialog.xs.body.px": {
    "value": "var(--ids-spacing-dialog-xs-body-px)",
    "variable": "var(--ids-spacing-dialog-xs-body-px)"
  },
  "spacing.dialog.xs.footer.pt": {
    "value": "var(--ids-spacing-dialog-xs-footer-pt)",
    "variable": "var(--ids-spacing-dialog-xs-footer-pt)"
  },
  "spacing.dialog.xs.footer.pb": {
    "value": "var(--ids-spacing-dialog-xs-footer-pb)",
    "variable": "var(--ids-spacing-dialog-xs-footer-pb)"
  },
  "spacing.dialog.xs.footer.px": {
    "value": "var(--ids-spacing-dialog-xs-footer-px)",
    "variable": "var(--ids-spacing-dialog-xs-footer-px)"
  },
  "spacing.dialog.sm.header.pt": {
    "value": "var(--ids-spacing-dialog-sm-header-pt)",
    "variable": "var(--ids-spacing-dialog-sm-header-pt)"
  },
  "spacing.dialog.sm.header.pb": {
    "value": "var(--ids-spacing-dialog-sm-header-pb)",
    "variable": "var(--ids-spacing-dialog-sm-header-pb)"
  },
  "spacing.dialog.sm.header.px": {
    "value": "var(--ids-spacing-dialog-sm-header-px)",
    "variable": "var(--ids-spacing-dialog-sm-header-px)"
  },
  "spacing.dialog.sm.body.pt": {
    "value": "var(--ids-spacing-dialog-sm-body-pt)",
    "variable": "var(--ids-spacing-dialog-sm-body-pt)"
  },
  "spacing.dialog.sm.body.pb": {
    "value": "var(--ids-spacing-dialog-sm-body-pb)",
    "variable": "var(--ids-spacing-dialog-sm-body-pb)"
  },
  "spacing.dialog.sm.body.px": {
    "value": "var(--ids-spacing-dialog-sm-body-px)",
    "variable": "var(--ids-spacing-dialog-sm-body-px)"
  },
  "spacing.dialog.sm.footer.pt": {
    "value": "var(--ids-spacing-dialog-sm-footer-pt)",
    "variable": "var(--ids-spacing-dialog-sm-footer-pt)"
  },
  "spacing.dialog.sm.footer.pb": {
    "value": "var(--ids-spacing-dialog-sm-footer-pb)",
    "variable": "var(--ids-spacing-dialog-sm-footer-pb)"
  },
  "spacing.dialog.sm.footer.px": {
    "value": "var(--ids-spacing-dialog-sm-footer-px)",
    "variable": "var(--ids-spacing-dialog-sm-footer-px)"
  },
  "spacing.dialog.md.header.pt": {
    "value": "var(--ids-spacing-dialog-md-header-pt)",
    "variable": "var(--ids-spacing-dialog-md-header-pt)"
  },
  "spacing.dialog.md.header.pb": {
    "value": "var(--ids-spacing-dialog-md-header-pb)",
    "variable": "var(--ids-spacing-dialog-md-header-pb)"
  },
  "spacing.dialog.md.header.px": {
    "value": "var(--ids-spacing-dialog-md-header-px)",
    "variable": "var(--ids-spacing-dialog-md-header-px)"
  },
  "spacing.dialog.md.body.pt": {
    "value": "var(--ids-spacing-dialog-md-body-pt)",
    "variable": "var(--ids-spacing-dialog-md-body-pt)"
  },
  "spacing.dialog.md.body.pb": {
    "value": "var(--ids-spacing-dialog-md-body-pb)",
    "variable": "var(--ids-spacing-dialog-md-body-pb)"
  },
  "spacing.dialog.md.body.px": {
    "value": "var(--ids-spacing-dialog-md-body-px)",
    "variable": "var(--ids-spacing-dialog-md-body-px)"
  },
  "spacing.dialog.md.footer.pt": {
    "value": "var(--ids-spacing-dialog-md-footer-pt)",
    "variable": "var(--ids-spacing-dialog-md-footer-pt)"
  },
  "spacing.dialog.md.footer.pb": {
    "value": "var(--ids-spacing-dialog-md-footer-pb)",
    "variable": "var(--ids-spacing-dialog-md-footer-pb)"
  },
  "spacing.dialog.md.footer.px": {
    "value": "var(--ids-spacing-dialog-md-footer-px)",
    "variable": "var(--ids-spacing-dialog-md-footer-px)"
  },
  "spacing.dialog.lg.header.pt": {
    "value": "var(--ids-spacing-dialog-lg-header-pt)",
    "variable": "var(--ids-spacing-dialog-lg-header-pt)"
  },
  "spacing.dialog.lg.header.pb": {
    "value": "var(--ids-spacing-dialog-lg-header-pb)",
    "variable": "var(--ids-spacing-dialog-lg-header-pb)"
  },
  "spacing.dialog.lg.header.px": {
    "value": "var(--ids-spacing-dialog-lg-header-px)",
    "variable": "var(--ids-spacing-dialog-lg-header-px)"
  },
  "spacing.dialog.lg.body.pt": {
    "value": "var(--ids-spacing-dialog-lg-body-pt)",
    "variable": "var(--ids-spacing-dialog-lg-body-pt)"
  },
  "spacing.dialog.lg.body.pb": {
    "value": "var(--ids-spacing-dialog-lg-body-pb)",
    "variable": "var(--ids-spacing-dialog-lg-body-pb)"
  },
  "spacing.dialog.lg.body.px": {
    "value": "var(--ids-spacing-dialog-lg-body-px)",
    "variable": "var(--ids-spacing-dialog-lg-body-px)"
  },
  "spacing.dialog.lg.footer.pt": {
    "value": "var(--ids-spacing-dialog-lg-footer-pt)",
    "variable": "var(--ids-spacing-dialog-lg-footer-pt)"
  },
  "spacing.dialog.lg.footer.pb": {
    "value": "var(--ids-spacing-dialog-lg-footer-pb)",
    "variable": "var(--ids-spacing-dialog-lg-footer-pb)"
  },
  "spacing.dialog.lg.footer.px": {
    "value": "var(--ids-spacing-dialog-lg-footer-px)",
    "variable": "var(--ids-spacing-dialog-lg-footer-px)"
  },
  "spacing.dialog.xl.header.pt": {
    "value": "var(--ids-spacing-dialog-xl-header-pt)",
    "variable": "var(--ids-spacing-dialog-xl-header-pt)"
  },
  "spacing.dialog.xl.header.pb": {
    "value": "var(--ids-spacing-dialog-xl-header-pb)",
    "variable": "var(--ids-spacing-dialog-xl-header-pb)"
  },
  "spacing.dialog.xl.header.px": {
    "value": "var(--ids-spacing-dialog-xl-header-px)",
    "variable": "var(--ids-spacing-dialog-xl-header-px)"
  },
  "spacing.dialog.xl.body.pt": {
    "value": "var(--ids-spacing-dialog-xl-body-pt)",
    "variable": "var(--ids-spacing-dialog-xl-body-pt)"
  },
  "spacing.dialog.xl.body.pb": {
    "value": "var(--ids-spacing-dialog-xl-body-pb)",
    "variable": "var(--ids-spacing-dialog-xl-body-pb)"
  },
  "spacing.dialog.xl.body.px": {
    "value": "var(--ids-spacing-dialog-xl-body-px)",
    "variable": "var(--ids-spacing-dialog-xl-body-px)"
  },
  "spacing.dialog.xl.footer.pt": {
    "value": "var(--ids-spacing-dialog-xl-footer-pt)",
    "variable": "var(--ids-spacing-dialog-xl-footer-pt)"
  },
  "spacing.dialog.xl.footer.pb": {
    "value": "var(--ids-spacing-dialog-xl-footer-pb)",
    "variable": "var(--ids-spacing-dialog-xl-footer-pb)"
  },
  "spacing.dialog.xl.footer.px": {
    "value": "var(--ids-spacing-dialog-xl-footer-px)",
    "variable": "var(--ids-spacing-dialog-xl-footer-px)"
  },
  "spacing.dialog.full.header.pt": {
    "value": "var(--ids-spacing-dialog-full-header-pt)",
    "variable": "var(--ids-spacing-dialog-full-header-pt)"
  },
  "spacing.dialog.full.header.pb": {
    "value": "var(--ids-spacing-dialog-full-header-pb)",
    "variable": "var(--ids-spacing-dialog-full-header-pb)"
  },
  "spacing.dialog.full.header.px": {
    "value": "var(--ids-spacing-dialog-full-header-px)",
    "variable": "var(--ids-spacing-dialog-full-header-px)"
  },
  "spacing.dialog.full.body.pt": {
    "value": "var(--ids-spacing-dialog-full-body-pt)",
    "variable": "var(--ids-spacing-dialog-full-body-pt)"
  },
  "spacing.dialog.full.body.pb": {
    "value": "var(--ids-spacing-dialog-full-body-pb)",
    "variable": "var(--ids-spacing-dialog-full-body-pb)"
  },
  "spacing.dialog.full.body.px": {
    "value": "var(--ids-spacing-dialog-full-body-px)",
    "variable": "var(--ids-spacing-dialog-full-body-px)"
  },
  "spacing.dialog.full.footer.pt": {
    "value": "var(--ids-spacing-dialog-full-footer-pt)",
    "variable": "var(--ids-spacing-dialog-full-footer-pt)"
  },
  "spacing.dialog.full.footer.pb": {
    "value": "var(--ids-spacing-dialog-full-footer-pb)",
    "variable": "var(--ids-spacing-dialog-full-footer-pb)"
  },
  "spacing.dialog.full.footer.px": {
    "value": "var(--ids-spacing-dialog-full-footer-px)",
    "variable": "var(--ids-spacing-dialog-full-footer-px)"
  },
  "spacing.timePicker.input.container.paddingX": {
    "value": "var(--ids-spacing-time-picker-input-container-padding-x)",
    "variable": "var(--ids-spacing-time-picker-input-container-padding-x)"
  },
  "spacing.segmentedControl.size.sm.paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-sm-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-sm-padding-y)"
  },
  "spacing.segmentedControl.size.md.paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-md-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-md-padding-y)"
  },
  "spacing.segmentedControl.size.lg.paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-lg-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-lg-padding-y)"
  },
  "spacing.chat.bubble.compact.paddingX": {
    "value": "var(--ids-spacing-chat-bubble-compact-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-compact-padding-x)"
  },
  "spacing.chat.bubble.compact.paddingY": {
    "value": "var(--ids-spacing-chat-bubble-compact-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-compact-padding-y)"
  },
  "spacing.chat.bubble.compact.gap": {
    "value": "var(--ids-spacing-chat-bubble-compact-gap)",
    "variable": "var(--ids-spacing-chat-bubble-compact-gap)"
  },
  "spacing.chat.bubble.balanced.paddingX": {
    "value": "var(--ids-spacing-chat-bubble-balanced-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-padding-x)"
  },
  "spacing.chat.bubble.balanced.paddingY": {
    "value": "var(--ids-spacing-chat-bubble-balanced-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-padding-y)"
  },
  "spacing.chat.bubble.balanced.gap": {
    "value": "var(--ids-spacing-chat-bubble-balanced-gap)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-gap)"
  },
  "spacing.chat.bubble.spacious.paddingX": {
    "value": "var(--ids-spacing-chat-bubble-spacious-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-padding-x)"
  },
  "spacing.chat.bubble.spacious.paddingY": {
    "value": "var(--ids-spacing-chat-bubble-spacious-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-padding-y)"
  },
  "spacing.chat.bubble.spacious.gap": {
    "value": "var(--ids-spacing-chat-bubble-spacious-gap)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-gap)"
  },
  "spacing.propertyPanel.field.gap": {
    "value": "var(--ids-spacing-property-panel-field-gap)",
    "variable": "var(--ids-spacing-property-panel-field-gap)"
  },
  "sizes.chip.size.xs.height": {
    "value": "var(--ids-sizes-chip-size-xs-height)",
    "variable": "var(--ids-sizes-chip-size-xs-height)"
  },
  "sizes.chip.size.xs.icon": {
    "value": "var(--ids-sizes-chip-size-xs-icon)",
    "variable": "var(--ids-sizes-chip-size-xs-icon)"
  },
  "sizes.chip.size.sm.height": {
    "value": "var(--ids-sizes-chip-size-sm-height)",
    "variable": "var(--ids-sizes-chip-size-sm-height)"
  },
  "sizes.chip.size.sm.icon": {
    "value": "var(--ids-sizes-chip-size-sm-icon)",
    "variable": "var(--ids-sizes-chip-size-sm-icon)"
  },
  "sizes.chip.size.md.height": {
    "value": "var(--ids-sizes-chip-size-md-height)",
    "variable": "var(--ids-sizes-chip-size-md-height)"
  },
  "sizes.chip.size.md.icon": {
    "value": "var(--ids-sizes-chip-size-md-icon)",
    "variable": "var(--ids-sizes-chip-size-md-icon)"
  },
  "sizes.chip.size.lg.height": {
    "value": "var(--ids-sizes-chip-size-lg-height)",
    "variable": "var(--ids-sizes-chip-size-lg-height)"
  },
  "sizes.chip.size.lg.icon": {
    "value": "var(--ids-sizes-chip-size-lg-icon)",
    "variable": "var(--ids-sizes-chip-size-lg-icon)"
  },
  "sizes.progressBar.size.sm.height": {
    "value": "var(--ids-sizes-progress-bar-size-sm-height)",
    "variable": "var(--ids-sizes-progress-bar-size-sm-height)"
  },
  "sizes.progressBar.size.md.height": {
    "value": "var(--ids-sizes-progress-bar-size-md-height)",
    "variable": "var(--ids-sizes-progress-bar-size-md-height)"
  },
  "sizes.progressBar.size.lg.height": {
    "value": "var(--ids-sizes-progress-bar-size-lg-height)",
    "variable": "var(--ids-sizes-progress-bar-size-lg-height)"
  },
  "sizes.tabs.list.height": {
    "value": "var(--ids-sizes-tabs-list-height)",
    "variable": "var(--ids-sizes-tabs-list-height)"
  },
  "sizes.tabs.trigger.height": {
    "value": "var(--ids-sizes-tabs-trigger-height)",
    "variable": "var(--ids-sizes-tabs-trigger-height)"
  },
  "sizes.tabs.icon.size": {
    "value": "var(--ids-sizes-tabs-icon-size)",
    "variable": "var(--ids-sizes-tabs-icon-size)"
  },
  "sizes.tabs.fade.width": {
    "value": "var(--ids-sizes-tabs-fade-width)",
    "variable": "var(--ids-sizes-tabs-fade-width)"
  },
  "sizes.tabs.fade.height": {
    "value": "var(--ids-sizes-tabs-fade-height)",
    "variable": "var(--ids-sizes-tabs-fade-height)"
  },
  "sizes.tabs.thumb.height": {
    "value": "var(--ids-sizes-tabs-thumb-height)",
    "variable": "var(--ids-sizes-tabs-thumb-height)"
  },
  "sizes.button.size.xl.icon": {
    "value": "var(--ids-sizes-button-size-xl-icon)",
    "variable": "var(--ids-sizes-button-size-xl-icon)"
  },
  "sizes.button.size.lg.icon": {
    "value": "var(--ids-sizes-button-size-lg-icon)",
    "variable": "var(--ids-sizes-button-size-lg-icon)"
  },
  "sizes.button.size.md.icon": {
    "value": "var(--ids-sizes-button-size-md-icon)",
    "variable": "var(--ids-sizes-button-size-md-icon)"
  },
  "sizes.button.size.sm.icon": {
    "value": "var(--ids-sizes-button-size-sm-icon)",
    "variable": "var(--ids-sizes-button-size-sm-icon)"
  },
  "sizes.button.size.xs.icon": {
    "value": "var(--ids-sizes-button-size-xs-icon)",
    "variable": "var(--ids-sizes-button-size-xs-icon)"
  },
  "sizes.iconButton.size.xs.container": {
    "value": "var(--ids-sizes-icon-button-size-xs-container)",
    "variable": "var(--ids-sizes-icon-button-size-xs-container)"
  },
  "sizes.iconButton.size.xs.icon": {
    "value": "var(--ids-sizes-icon-button-size-xs-icon)",
    "variable": "var(--ids-sizes-icon-button-size-xs-icon)"
  },
  "sizes.iconButton.size.sm.container": {
    "value": "var(--ids-sizes-icon-button-size-sm-container)",
    "variable": "var(--ids-sizes-icon-button-size-sm-container)"
  },
  "sizes.iconButton.size.sm.icon": {
    "value": "var(--ids-sizes-icon-button-size-sm-icon)",
    "variable": "var(--ids-sizes-icon-button-size-sm-icon)"
  },
  "sizes.iconButton.size.md.container": {
    "value": "var(--ids-sizes-icon-button-size-md-container)",
    "variable": "var(--ids-sizes-icon-button-size-md-container)"
  },
  "sizes.iconButton.size.md.icon": {
    "value": "var(--ids-sizes-icon-button-size-md-icon)",
    "variable": "var(--ids-sizes-icon-button-size-md-icon)"
  },
  "sizes.iconButton.size.lg.container": {
    "value": "var(--ids-sizes-icon-button-size-lg-container)",
    "variable": "var(--ids-sizes-icon-button-size-lg-container)"
  },
  "sizes.iconButton.size.lg.icon": {
    "value": "var(--ids-sizes-icon-button-size-lg-icon)",
    "variable": "var(--ids-sizes-icon-button-size-lg-icon)"
  },
  "sizes.iconButton.size.xl.container": {
    "value": "var(--ids-sizes-icon-button-size-xl-container)",
    "variable": "var(--ids-sizes-icon-button-size-xl-container)"
  },
  "sizes.iconButton.size.xl.icon": {
    "value": "var(--ids-sizes-icon-button-size-xl-icon)",
    "variable": "var(--ids-sizes-icon-button-size-xl-icon)"
  },
  "sizes.floatingButton.size.md.container": {
    "value": "var(--ids-sizes-floating-button-size-md-container)",
    "variable": "var(--ids-sizes-floating-button-size-md-container)"
  },
  "sizes.floatingButton.size.md.icon.iconOnly": {
    "value": "var(--ids-sizes-floating-button-size-md-icon-icon-only)",
    "variable": "var(--ids-sizes-floating-button-size-md-icon-icon-only)"
  },
  "sizes.floatingButton.size.md.icon.extended": {
    "value": "var(--ids-sizes-floating-button-size-md-icon-extended)",
    "variable": "var(--ids-sizes-floating-button-size-md-icon-extended)"
  },
  "sizes.floatingButton.size.md.spinner.iconOnly": {
    "value": "var(--ids-sizes-floating-button-size-md-spinner-icon-only)",
    "variable": "var(--ids-sizes-floating-button-size-md-spinner-icon-only)"
  },
  "sizes.floatingButton.size.md.spinner.extended": {
    "value": "var(--ids-sizes-floating-button-size-md-spinner-extended)",
    "variable": "var(--ids-sizes-floating-button-size-md-spinner-extended)"
  },
  "sizes.floatingButton.size.sm.container": {
    "value": "var(--ids-sizes-floating-button-size-sm-container)",
    "variable": "var(--ids-sizes-floating-button-size-sm-container)"
  },
  "sizes.floatingButton.size.sm.icon.iconOnly": {
    "value": "var(--ids-sizes-floating-button-size-sm-icon-icon-only)",
    "variable": "var(--ids-sizes-floating-button-size-sm-icon-icon-only)"
  },
  "sizes.floatingButton.size.sm.icon.extended": {
    "value": "var(--ids-sizes-floating-button-size-sm-icon-extended)",
    "variable": "var(--ids-sizes-floating-button-size-sm-icon-extended)"
  },
  "sizes.floatingButton.size.sm.spinner.iconOnly": {
    "value": "var(--ids-sizes-floating-button-size-sm-spinner-icon-only)",
    "variable": "var(--ids-sizes-floating-button-size-sm-spinner-icon-only)"
  },
  "sizes.floatingButton.size.sm.spinner.extended": {
    "value": "var(--ids-sizes-floating-button-size-sm-spinner-extended)",
    "variable": "var(--ids-sizes-floating-button-size-sm-spinner-extended)"
  },
  "sizes.input.size.xs.height": {
    "value": "var(--ids-sizes-input-size-xs-height)",
    "variable": "var(--ids-sizes-input-size-xs-height)"
  },
  "sizes.input.size.sm.height": {
    "value": "var(--ids-sizes-input-size-sm-height)",
    "variable": "var(--ids-sizes-input-size-sm-height)"
  },
  "sizes.input.size.md.height": {
    "value": "var(--ids-sizes-input-size-md-height)",
    "variable": "var(--ids-sizes-input-size-md-height)"
  },
  "sizes.input.size.lg.height": {
    "value": "var(--ids-sizes-input-size-lg-height)",
    "variable": "var(--ids-sizes-input-size-lg-height)"
  },
  "sizes.input.size.xl.height": {
    "value": "var(--ids-sizes-input-size-xl-height)",
    "variable": "var(--ids-sizes-input-size-xl-height)"
  },
  "sizes.textArea.size.sm.minHeight": {
    "value": "var(--ids-sizes-text-area-size-sm-min-height)",
    "variable": "var(--ids-sizes-text-area-size-sm-min-height)"
  },
  "sizes.textArea.size.md.minHeight": {
    "value": "var(--ids-sizes-text-area-size-md-min-height)",
    "variable": "var(--ids-sizes-text-area-size-md-min-height)"
  },
  "sizes.textArea.size.lg.minHeight": {
    "value": "var(--ids-sizes-text-area-size-lg-min-height)",
    "variable": "var(--ids-sizes-text-area-size-lg-min-height)"
  },
  "sizes.textArea.size.xl.minHeight": {
    "value": "var(--ids-sizes-text-area-size-xl-min-height)",
    "variable": "var(--ids-sizes-text-area-size-xl-min-height)"
  },
  "sizes.radio.size.sm.iconSize": {
    "value": "var(--ids-sizes-radio-size-sm-icon-size)",
    "variable": "var(--ids-sizes-radio-size-sm-icon-size)"
  },
  "sizes.radio.size.sm.endIconSize": {
    "value": "var(--ids-sizes-radio-size-sm-end-icon-size)",
    "variable": "var(--ids-sizes-radio-size-sm-end-icon-size)"
  },
  "sizes.radio.size.md.iconSize": {
    "value": "var(--ids-sizes-radio-size-md-icon-size)",
    "variable": "var(--ids-sizes-radio-size-md-icon-size)"
  },
  "sizes.radio.size.md.endIconSize": {
    "value": "var(--ids-sizes-radio-size-md-end-icon-size)",
    "variable": "var(--ids-sizes-radio-size-md-end-icon-size)"
  },
  "sizes.checkbox.size.sm.controlSize": {
    "value": "var(--ids-sizes-checkbox-size-sm-control-size)",
    "variable": "var(--ids-sizes-checkbox-size-sm-control-size)"
  },
  "sizes.checkbox.size.md.controlSize": {
    "value": "var(--ids-sizes-checkbox-size-md-control-size)",
    "variable": "var(--ids-sizes-checkbox-size-md-control-size)"
  },
  "sizes.select.size.sm.height": {
    "value": "var(--ids-sizes-select-size-sm-height)",
    "variable": "var(--ids-sizes-select-size-sm-height)"
  },
  "sizes.select.size.md.height": {
    "value": "var(--ids-sizes-select-size-md-height)",
    "variable": "var(--ids-sizes-select-size-md-height)"
  },
  "sizes.select.size.lg.height": {
    "value": "var(--ids-sizes-select-size-lg-height)",
    "variable": "var(--ids-sizes-select-size-lg-height)"
  },
  "sizes.select.size.xl.height": {
    "value": "var(--ids-sizes-select-size-xl-height)",
    "variable": "var(--ids-sizes-select-size-xl-height)"
  },
  "sizes.menu.content.maxHeight": {
    "value": "var(--ids-sizes-menu-content-max-height)",
    "variable": "var(--ids-sizes-menu-content-max-height)"
  },
  "sizes.menu.item.minHeight": {
    "value": "var(--ids-sizes-menu-item-min-height)",
    "variable": "var(--ids-sizes-menu-item-min-height)"
  },
  "sizes.menu.item.indicator.size": {
    "value": "var(--ids-sizes-menu-item-indicator-size)",
    "variable": "var(--ids-sizes-menu-item-indicator-size)"
  },
  "sizes.combobox.root.width": {
    "value": "var(--ids-sizes-combobox-root-width)",
    "variable": "var(--ids-sizes-combobox-root-width)"
  },
  "sizes.combobox.trigger.height": {
    "value": "var(--ids-sizes-combobox-trigger-height)",
    "variable": "var(--ids-sizes-combobox-trigger-height)"
  },
  "sizes.notice.icon": {
    "value": "var(--ids-sizes-notice-icon)",
    "variable": "var(--ids-sizes-notice-icon)"
  },
  "sizes.errorState.minHeight": {
    "value": "var(--ids-sizes-error-state-min-height)",
    "variable": "var(--ids-sizes-error-state-min-height)"
  },
  "sizes.errorState.icon": {
    "value": "var(--ids-sizes-error-state-icon)",
    "variable": "var(--ids-sizes-error-state-icon)"
  },
  "sizes.datePicker.content.width": {
    "value": "var(--ids-sizes-date-picker-content-width)",
    "variable": "var(--ids-sizes-date-picker-content-width)"
  },
  "sizes.datePicker.day.size": {
    "value": "var(--ids-sizes-date-picker-day-size)",
    "variable": "var(--ids-sizes-date-picker-day-size)"
  },
  "sizes.datePicker.tableHeader.height": {
    "value": "var(--ids-sizes-date-picker-table-header-height)",
    "variable": "var(--ids-sizes-date-picker-table-header-height)"
  },
  "sizes.datePicker.trigger.root.size": {
    "value": "var(--ids-sizes-date-picker-trigger-root-size)",
    "variable": "var(--ids-sizes-date-picker-trigger-root-size)"
  },
  "sizes.datePicker.trigger.iconWrapper.size": {
    "value": "var(--ids-sizes-date-picker-trigger-icon-wrapper-size)",
    "variable": "var(--ids-sizes-date-picker-trigger-icon-wrapper-size)"
  },
  "sizes.datePicker.trigger.icon.size": {
    "value": "var(--ids-sizes-date-picker-trigger-icon-size)",
    "variable": "var(--ids-sizes-date-picker-trigger-icon-size)"
  },
  "sizes.timePicker.input.container.minHeight": {
    "value": "var(--ids-sizes-time-picker-input-container-min-height)",
    "variable": "var(--ids-sizes-time-picker-input-container-min-height)"
  },
  "sizes.badge.size.xs.icon": {
    "value": "var(--ids-sizes-badge-size-xs-icon)",
    "variable": "var(--ids-sizes-badge-size-xs-icon)"
  },
  "sizes.badge.size.sm.icon": {
    "value": "var(--ids-sizes-badge-size-sm-icon)",
    "variable": "var(--ids-sizes-badge-size-sm-icon)"
  },
  "sizes.badge.size.md.icon": {
    "value": "var(--ids-sizes-badge-size-md-icon)",
    "variable": "var(--ids-sizes-badge-size-md-icon)"
  },
  "sizes.badge.size.lg.icon": {
    "value": "var(--ids-sizes-badge-size-lg-icon)",
    "variable": "var(--ids-sizes-badge-size-lg-icon)"
  },
  "sizes.badge.size.xl.icon": {
    "value": "var(--ids-sizes-badge-size-xl-icon)",
    "variable": "var(--ids-sizes-badge-size-xl-icon)"
  },
  "sizes.avatarBadge.size.xs.dot": {
    "value": "var(--ids-sizes-avatar-badge-size-xs-dot)",
    "variable": "var(--ids-sizes-avatar-badge-size-xs-dot)"
  },
  "sizes.avatarBadge.size.sm.dot": {
    "value": "var(--ids-sizes-avatar-badge-size-sm-dot)",
    "variable": "var(--ids-sizes-avatar-badge-size-sm-dot)"
  },
  "sizes.avatarBadge.size.md.dot": {
    "value": "var(--ids-sizes-avatar-badge-size-md-dot)",
    "variable": "var(--ids-sizes-avatar-badge-size-md-dot)"
  },
  "sizes.avatarBadge.size.lg.dot": {
    "value": "var(--ids-sizes-avatar-badge-size-lg-dot)",
    "variable": "var(--ids-sizes-avatar-badge-size-lg-dot)"
  },
  "sizes.avatarBadge.size.xl.dot": {
    "value": "var(--ids-sizes-avatar-badge-size-xl-dot)",
    "variable": "var(--ids-sizes-avatar-badge-size-xl-dot)"
  },
  "sizes.chat.thread.maxWidth": {
    "value": "var(--ids-sizes-chat-thread-max-width)",
    "variable": "var(--ids-sizes-chat-thread-max-width)"
  },
  "sizes.chat.message.maxWidth": {
    "value": "var(--ids-sizes-chat-message-max-width)",
    "variable": "var(--ids-sizes-chat-message-max-width)"
  },
  "sizes.chat.composer.input.minHeight": {
    "value": "var(--ids-sizes-chat-composer-input-min-height)",
    "variable": "var(--ids-sizes-chat-composer-input-min-height)"
  },
  "sizes.chat.composer.input.maxHeight": {
    "value": "var(--ids-sizes-chat-composer-input-max-height)",
    "variable": "var(--ids-sizes-chat-composer-input-max-height)"
  },
  "sizes.chat.chainOfThought.previewMaxHeight": {
    "value": "var(--ids-sizes-chat-chain-of-thought-preview-max-height)",
    "variable": "var(--ids-sizes-chat-chain-of-thought-preview-max-height)"
  },
  "sizes.chat.actionBar.button": {
    "value": "var(--ids-sizes-chat-action-bar-button)",
    "variable": "var(--ids-sizes-chat-action-bar-button)"
  },
  "sizes.chat.actionBar.icon": {
    "value": "var(--ids-sizes-chat-action-bar-icon)",
    "variable": "var(--ids-sizes-chat-action-bar-icon)"
  },
  "sizes.chat.branchPicker.button": {
    "value": "var(--ids-sizes-chat-branch-picker-button)",
    "variable": "var(--ids-sizes-chat-branch-picker-button)"
  },
  "sizes.chat.branchPicker.icon": {
    "value": "var(--ids-sizes-chat-branch-picker-icon)",
    "variable": "var(--ids-sizes-chat-branch-picker-icon)"
  },
  "sizes.chat.attachment.thumb": {
    "value": "var(--ids-sizes-chat-attachment-thumb)",
    "variable": "var(--ids-sizes-chat-attachment-thumb)"
  },
  "sizes.chat.attachment.thumbIcon": {
    "value": "var(--ids-sizes-chat-attachment-thumb-icon)",
    "variable": "var(--ids-sizes-chat-attachment-thumb-icon)"
  },
  "sizes.chat.attachment.remove": {
    "value": "var(--ids-sizes-chat-attachment-remove)",
    "variable": "var(--ids-sizes-chat-attachment-remove)"
  },
  "sizes.chat.attachment.removeIcon": {
    "value": "var(--ids-sizes-chat-attachment-remove-icon)",
    "variable": "var(--ids-sizes-chat-attachment-remove-icon)"
  },
  "sizes.chat.attachment.maxWidth": {
    "value": "var(--ids-sizes-chat-attachment-max-width)",
    "variable": "var(--ids-sizes-chat-attachment-max-width)"
  },
  "sizes.propertyPanel.field.label.fontSize": {
    "value": "var(--ids-sizes-property-panel-field-label-font-size)",
    "variable": "var(--ids-sizes-property-panel-field-label-font-size)"
  },
  "sizes.propertyPanel.field.label.lineHeight": {
    "value": "var(--ids-sizes-property-panel-field-label-line-height)",
    "variable": "var(--ids-sizes-property-panel-field-label-line-height)"
  },
  "radii.chip.root": {
    "value": "var(--ids-radii-chip-root)",
    "variable": "var(--ids-radii-chip-root)"
  },
  "radii.button.root": {
    "value": "var(--ids-radii-button-root)",
    "variable": "var(--ids-radii-button-root)"
  },
  "radii.button.rootXs": {
    "value": "var(--ids-radii-button-root-xs)",
    "variable": "var(--ids-radii-button-root-xs)"
  },
  "radii.progressBar.root": {
    "value": "var(--ids-radii-progress-bar-root)",
    "variable": "var(--ids-radii-progress-bar-root)"
  },
  "radii.tooltip.root": {
    "value": "var(--ids-radii-tooltip-root)",
    "variable": "var(--ids-radii-tooltip-root)"
  },
  "radii.iconButton.root": {
    "value": "var(--ids-radii-icon-button-root)",
    "variable": "var(--ids-radii-icon-button-root)"
  },
  "radii.input.container": {
    "value": "var(--ids-radii-input-container)",
    "variable": "var(--ids-radii-input-container)"
  },
  "radii.input.size.xs.radius": {
    "value": "var(--ids-radii-input-size-xs-radius)",
    "variable": "var(--ids-radii-input-size-xs-radius)"
  },
  "radii.input.size.sm.radius": {
    "value": "var(--ids-radii-input-size-sm-radius)",
    "variable": "var(--ids-radii-input-size-sm-radius)"
  },
  "radii.input.size.md.radius": {
    "value": "var(--ids-radii-input-size-md-radius)",
    "variable": "var(--ids-radii-input-size-md-radius)"
  },
  "radii.input.size.lg.radius": {
    "value": "var(--ids-radii-input-size-lg-radius)",
    "variable": "var(--ids-radii-input-size-lg-radius)"
  },
  "radii.input.size.xl.radius": {
    "value": "var(--ids-radii-input-size-xl-radius)",
    "variable": "var(--ids-radii-input-size-xl-radius)"
  },
  "radii.textArea.container": {
    "value": "var(--ids-radii-text-area-container)",
    "variable": "var(--ids-radii-text-area-container)"
  },
  "radii.textArea.size.sm.radius": {
    "value": "var(--ids-radii-text-area-size-sm-radius)",
    "variable": "var(--ids-radii-text-area-size-sm-radius)"
  },
  "radii.textArea.size.md.radius": {
    "value": "var(--ids-radii-text-area-size-md-radius)",
    "variable": "var(--ids-radii-text-area-size-md-radius)"
  },
  "radii.textArea.size.lg.radius": {
    "value": "var(--ids-radii-text-area-size-lg-radius)",
    "variable": "var(--ids-radii-text-area-size-lg-radius)"
  },
  "radii.textArea.size.xl.radius": {
    "value": "var(--ids-radii-text-area-size-xl-radius)",
    "variable": "var(--ids-radii-text-area-size-xl-radius)"
  },
  "radii.select.trigger.radius": {
    "value": "var(--ids-radii-select-trigger-radius)",
    "variable": "var(--ids-radii-select-trigger-radius)"
  },
  "radii.select.size.sm.radius": {
    "value": "var(--ids-radii-select-size-sm-radius)",
    "variable": "var(--ids-radii-select-size-sm-radius)"
  },
  "radii.select.size.md.radius": {
    "value": "var(--ids-radii-select-size-md-radius)",
    "variable": "var(--ids-radii-select-size-md-radius)"
  },
  "radii.select.size.lg.radius": {
    "value": "var(--ids-radii-select-size-lg-radius)",
    "variable": "var(--ids-radii-select-size-lg-radius)"
  },
  "radii.select.size.xl.radius": {
    "value": "var(--ids-radii-select-size-xl-radius)",
    "variable": "var(--ids-radii-select-size-xl-radius)"
  },
  "radii.menu.content.radius": {
    "value": "var(--ids-radii-menu-content-radius)",
    "variable": "var(--ids-radii-menu-content-radius)"
  },
  "radii.menu.item.radius": {
    "value": "var(--ids-radii-menu-item-radius)",
    "variable": "var(--ids-radii-menu-item-radius)"
  },
  "radii.combobox.trigger.radius": {
    "value": "var(--ids-radii-combobox-trigger-radius)",
    "variable": "var(--ids-radii-combobox-trigger-radius)"
  },
  "radii.combobox.trigger.size.sm.radius": {
    "value": "var(--ids-radii-combobox-trigger-size-sm-radius)",
    "variable": "var(--ids-radii-combobox-trigger-size-sm-radius)"
  },
  "radii.combobox.trigger.size.md.radius": {
    "value": "var(--ids-radii-combobox-trigger-size-md-radius)",
    "variable": "var(--ids-radii-combobox-trigger-size-md-radius)"
  },
  "radii.combobox.trigger.size.lg.radius": {
    "value": "var(--ids-radii-combobox-trigger-size-lg-radius)",
    "variable": "var(--ids-radii-combobox-trigger-size-lg-radius)"
  },
  "radii.combobox.trigger.size.xl.radius": {
    "value": "var(--ids-radii-combobox-trigger-size-xl-radius)",
    "variable": "var(--ids-radii-combobox-trigger-size-xl-radius)"
  },
  "radii.notice.root": {
    "value": "var(--ids-radii-notice-root)",
    "variable": "var(--ids-radii-notice-root)"
  },
  "radii.errorState.root": {
    "value": "var(--ids-radii-error-state-root)",
    "variable": "var(--ids-radii-error-state-root)"
  },
  "radii.table.cell.focus.radius": {
    "value": "var(--ids-radii-table-cell-focus-radius)",
    "variable": "var(--ids-radii-table-cell-focus-radius)"
  },
  "radii.datePicker.content.radius": {
    "value": "var(--ids-radii-date-picker-content-radius)",
    "variable": "var(--ids-radii-date-picker-content-radius)"
  },
  "radii.dialog.content": {
    "value": "var(--ids-radii-dialog-content)",
    "variable": "var(--ids-radii-dialog-content)"
  },
  "radii.timePicker.input.container.radius": {
    "value": "var(--ids-radii-time-picker-input-container-radius)",
    "variable": "var(--ids-radii-time-picker-input-container-radius)"
  },
  "radii.chat.bubble.compact": {
    "value": "var(--ids-radii-chat-bubble-compact)",
    "variable": "var(--ids-radii-chat-bubble-compact)"
  },
  "radii.chat.bubble.balanced": {
    "value": "var(--ids-radii-chat-bubble-balanced)",
    "variable": "var(--ids-radii-chat-bubble-balanced)"
  },
  "radii.chat.bubble.spacious": {
    "value": "var(--ids-radii-chat-bubble-spacious)",
    "variable": "var(--ids-radii-chat-bubble-spacious)"
  },
  "shadows.relatedSites.panel": {
    "value": "var(--ids-shadows-related-sites-panel)",
    "variable": "var(--ids-shadows-related-sites-panel)"
  },
  "shadows.menu.content.shadow": {
    "value": "var(--ids-shadows-menu-content-shadow)",
    "variable": "var(--ids-shadows-menu-content-shadow)"
  },
  "shadows.combobox.trigger.shadow.default": {
    "value": "var(--ids-shadows-combobox-trigger-shadow-default)",
    "variable": "var(--ids-shadows-combobox-trigger-shadow-default)"
  },
  "shadows.combobox.trigger.shadow.focused": {
    "value": "var(--ids-shadows-combobox-trigger-shadow-focused)",
    "variable": "var(--ids-shadows-combobox-trigger-shadow-focused)"
  },
  "shadows.combobox.trigger.shadow.open": {
    "value": "var(--ids-shadows-combobox-trigger-shadow-open)",
    "variable": "var(--ids-shadows-combobox-trigger-shadow-open)"
  },
  "shadows.notice.root": {
    "value": "var(--ids-shadows-notice-root)",
    "variable": "var(--ids-shadows-notice-root)"
  },
  "shadows.table.cell.focus.shadow": {
    "value": "var(--ids-shadows-table-cell-focus-shadow)",
    "variable": "var(--ids-shadows-table-cell-focus-shadow)"
  },
  "shadows.table.dragging.shadow": {
    "value": "var(--ids-shadows-table-dragging-shadow)",
    "variable": "var(--ids-shadows-table-dragging-shadow)"
  },
  "shadows.tooltip.root": {
    "value": "var(--ids-shadows-tooltip-root)",
    "variable": "var(--ids-shadows-tooltip-root)"
  },
  "shadows.datePicker.content.shadow": {
    "value": "var(--ids-shadows-date-picker-content-shadow)",
    "variable": "var(--ids-shadows-date-picker-content-shadow)"
  },
  "borderWidths.datePicker.content.width": {
    "value": "var(--ids-border-widths-date-picker-content-width)",
    "variable": "var(--ids-border-widths-date-picker-content-width)"
  },
  "borderWidths.datePicker.gridBorderBottom.width": {
    "value": "var(--ids-border-widths-date-picker-grid-border-bottom-width)",
    "variable": "var(--ids-border-widths-date-picker-grid-border-bottom-width)"
  },
  "borderWidths.timePicker.gridBorderBottom.width": {
    "value": "var(--ids-border-widths-time-picker-grid-border-bottom-width)",
    "variable": "var(--ids-border-widths-time-picker-grid-border-bottom-width)"
  },
  "fonts.default": {
    "value": "var(--ids-fonts-default)",
    "variable": "var(--ids-fonts-default)"
  },
  "fonts.headline": {
    "value": "var(--ids-fonts-headline)",
    "variable": "var(--ids-fonts-headline)"
  },
  "fonts.title": {
    "value": "var(--ids-fonts-title)",
    "variable": "var(--ids-fonts-title)"
  },
  "fonts.display": {
    "value": "var(--ids-fonts-display)",
    "variable": "var(--ids-fonts-display)"
  },
  "fontWeights.button.default": {
    "value": "var(--ids-font-weights-button-default)",
    "variable": "var(--ids-font-weights-button-default)"
  },
  "fontWeights.title.default": {
    "value": "var(--ids-font-weights-title-default)",
    "variable": "var(--ids-font-weights-title-default)"
  },
  "fontWeights.title.medium": {
    "value": "var(--ids-font-weights-title-medium)",
    "variable": "var(--ids-font-weights-title-medium)"
  },
  "spacing.-0": {
    "value": "var(--ids-spacing-0)",
    "variable": "var(--ids-spacing-0)"
  },
  "spacing.-2": {
    "value": "var(--ids-spacing-2)",
    "variable": "var(--ids-spacing-2)"
  },
  "spacing.-12": {
    "value": "var(--ids-spacing-12)",
    "variable": "var(--ids-spacing-12)"
  },
  "spacing.-16": {
    "value": "var(--ids-spacing-16)",
    "variable": "var(--ids-spacing-16)"
  },
  "spacing.-20": {
    "value": "var(--ids-spacing-20)",
    "variable": "var(--ids-spacing-20)"
  },
  "spacing.-24": {
    "value": "var(--ids-spacing-24)",
    "variable": "var(--ids-spacing-24)"
  },
  "spacing.-26": {
    "value": "var(--ids-spacing-26)",
    "variable": "var(--ids-spacing-26)"
  },
  "spacing.-28": {
    "value": "var(--ids-spacing-28)",
    "variable": "var(--ids-spacing-28)"
  },
  "spacing.-32": {
    "value": "var(--ids-spacing-32)",
    "variable": "var(--ids-spacing-32)"
  },
  "spacing.-36": {
    "value": "var(--ids-spacing-36)",
    "variable": "var(--ids-spacing-36)"
  },
  "spacing.-40": {
    "value": "var(--ids-spacing-40)",
    "variable": "var(--ids-spacing-40)"
  },
  "spacing.-44": {
    "value": "var(--ids-spacing-44)",
    "variable": "var(--ids-spacing-44)"
  },
  "spacing.-48": {
    "value": "var(--ids-spacing-48)",
    "variable": "var(--ids-spacing-48)"
  },
  "spacing.-56": {
    "value": "var(--ids-spacing-56)",
    "variable": "var(--ids-spacing-56)"
  },
  "spacing.-64": {
    "value": "var(--ids-spacing-64)",
    "variable": "var(--ids-spacing-64)"
  },
  "spacing.-80": {
    "value": "var(--ids-spacing-80)",
    "variable": "var(--ids-spacing-80)"
  },
  "spacing.--4": {
    "value": "var(--ids-spacing--4)",
    "variable": "var(--ids-spacing--4)"
  },
  "spacing.--6": {
    "value": "var(--ids-spacing--6)",
    "variable": "var(--ids-spacing--6)"
  },
  "spacing.--8": {
    "value": "var(--ids-spacing--8)",
    "variable": "var(--ids-spacing--8)"
  },
  "spacing.--10": {
    "value": "var(--ids-spacing--10)",
    "variable": "var(--ids-spacing--10)"
  },
  "spacing.--14": {
    "value": "var(--ids-spacing--14)",
    "variable": "var(--ids-spacing--14)"
  },
  "spacing.chip.size.xs.-rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-xs-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-xs-root-padding-x)"
  },
  "spacing.chip.size.xs.-gap": {
    "value": "var(--ids-spacing-chip-size-xs-gap)",
    "variable": "var(--ids-spacing-chip-size-xs-gap)"
  },
  "spacing.chip.size.xs.-labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-xs-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-xs-label-padding-x)"
  },
  "spacing.chip.size.sm.-rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-sm-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-sm-root-padding-x)"
  },
  "spacing.chip.size.sm.-gap": {
    "value": "var(--ids-spacing-chip-size-sm-gap)",
    "variable": "var(--ids-spacing-chip-size-sm-gap)"
  },
  "spacing.chip.size.sm.-labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-sm-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-sm-label-padding-x)"
  },
  "spacing.chip.size.md.-rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-md-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-md-root-padding-x)"
  },
  "spacing.chip.size.md.-gap": {
    "value": "var(--ids-spacing-chip-size-md-gap)",
    "variable": "var(--ids-spacing-chip-size-md-gap)"
  },
  "spacing.chip.size.md.-labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-md-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-md-label-padding-x)"
  },
  "spacing.chip.size.lg.-rootPaddingX": {
    "value": "var(--ids-spacing-chip-size-lg-root-padding-x)",
    "variable": "var(--ids-spacing-chip-size-lg-root-padding-x)"
  },
  "spacing.chip.size.lg.-gap": {
    "value": "var(--ids-spacing-chip-size-lg-gap)",
    "variable": "var(--ids-spacing-chip-size-lg-gap)"
  },
  "spacing.chip.size.lg.-labelPaddingX": {
    "value": "var(--ids-spacing-chip-size-lg-label-padding-x)",
    "variable": "var(--ids-spacing-chip-size-lg-label-padding-x)"
  },
  "spacing.progressBar.size.sm.-gap": {
    "value": "var(--ids-spacing-progress-bar-size-sm-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-sm-gap)"
  },
  "spacing.progressBar.size.md.-gap": {
    "value": "var(--ids-spacing-progress-bar-size-md-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-md-gap)"
  },
  "spacing.progressBar.size.lg.-gap": {
    "value": "var(--ids-spacing-progress-bar-size-lg-gap)",
    "variable": "var(--ids-spacing-progress-bar-size-lg-gap)"
  },
  "spacing.tabs.list.-gap": {
    "value": "var(--ids-spacing-tabs-list-gap)",
    "variable": "var(--ids-spacing-tabs-list-gap)"
  },
  "spacing.tabs.list.-stretchGap": {
    "value": "var(--ids-spacing-tabs-list-stretch-gap)",
    "variable": "var(--ids-spacing-tabs-list-stretch-gap)"
  },
  "spacing.tabs.trigger.-gap": {
    "value": "var(--ids-spacing-tabs-trigger-gap)",
    "variable": "var(--ids-spacing-tabs-trigger-gap)"
  },
  "spacing.tabs.trigger.-paddingTop": {
    "value": "var(--ids-spacing-tabs-trigger-padding-top)",
    "variable": "var(--ids-spacing-tabs-trigger-padding-top)"
  },
  "spacing.tabs.trigger.-paddingBottom": {
    "value": "var(--ids-spacing-tabs-trigger-padding-bottom)",
    "variable": "var(--ids-spacing-tabs-trigger-padding-bottom)"
  },
  "spacing.button.size.xl.-paddingX": {
    "value": "var(--ids-spacing-button-size-xl-padding-x)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x)"
  },
  "spacing.button.size.xl.-paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-with-icon)"
  },
  "spacing.button.size.xl.-paddingY": {
    "value": "var(--ids-spacing-button-size-xl-padding-y)",
    "variable": "var(--ids-spacing-button-size-xl-padding-y)"
  },
  "spacing.button.size.xl.-paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-narrow)"
  },
  "spacing.button.size.xl.-paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-xl-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-xl-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.xl.-gap": {
    "value": "var(--ids-spacing-button-size-xl-gap)",
    "variable": "var(--ids-spacing-button-size-xl-gap)"
  },
  "spacing.button.size.lg.-paddingX": {
    "value": "var(--ids-spacing-button-size-lg-padding-x)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x)"
  },
  "spacing.button.size.lg.-paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-with-icon)"
  },
  "spacing.button.size.lg.-paddingY": {
    "value": "var(--ids-spacing-button-size-lg-padding-y)",
    "variable": "var(--ids-spacing-button-size-lg-padding-y)"
  },
  "spacing.button.size.lg.-paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-narrow)"
  },
  "spacing.button.size.lg.-paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-lg-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-lg-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.lg.-gap": {
    "value": "var(--ids-spacing-button-size-lg-gap)",
    "variable": "var(--ids-spacing-button-size-lg-gap)"
  },
  "spacing.button.size.md.-paddingX": {
    "value": "var(--ids-spacing-button-size-md-padding-x)",
    "variable": "var(--ids-spacing-button-size-md-padding-x)"
  },
  "spacing.button.size.md.-paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-md-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-with-icon)"
  },
  "spacing.button.size.md.-paddingY": {
    "value": "var(--ids-spacing-button-size-md-padding-y)",
    "variable": "var(--ids-spacing-button-size-md-padding-y)"
  },
  "spacing.button.size.md.-paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-md-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-narrow)"
  },
  "spacing.button.size.md.-paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-md-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-md-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.md.-gap": {
    "value": "var(--ids-spacing-button-size-md-gap)",
    "variable": "var(--ids-spacing-button-size-md-gap)"
  },
  "spacing.button.size.sm.-paddingX": {
    "value": "var(--ids-spacing-button-size-sm-padding-x)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x)"
  },
  "spacing.button.size.sm.-paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-with-icon)"
  },
  "spacing.button.size.sm.-paddingY": {
    "value": "var(--ids-spacing-button-size-sm-padding-y)",
    "variable": "var(--ids-spacing-button-size-sm-padding-y)"
  },
  "spacing.button.size.sm.-paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-narrow)"
  },
  "spacing.button.size.sm.-paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-sm-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-sm-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.sm.-gap": {
    "value": "var(--ids-spacing-button-size-sm-gap)",
    "variable": "var(--ids-spacing-button-size-sm-gap)"
  },
  "spacing.button.size.xs.-paddingX": {
    "value": "var(--ids-spacing-button-size-xs-padding-x)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x)"
  },
  "spacing.button.size.xs.-paddingXWithIcon": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-with-icon)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-with-icon)"
  },
  "spacing.button.size.xs.-paddingY": {
    "value": "var(--ids-spacing-button-size-xs-padding-y)",
    "variable": "var(--ids-spacing-button-size-xs-padding-y)"
  },
  "spacing.button.size.xs.-paddingXNarrow": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-narrow)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-narrow)"
  },
  "spacing.button.size.xs.-paddingXNarrowWithIcon": {
    "value": "var(--ids-spacing-button-size-xs-padding-x-narrow-with-icon)",
    "variable": "var(--ids-spacing-button-size-xs-padding-x-narrow-with-icon)"
  },
  "spacing.button.size.xs.-gap": {
    "value": "var(--ids-spacing-button-size-xs-gap)",
    "variable": "var(--ids-spacing-button-size-xs-gap)"
  },
  "spacing.tooltip.-paddingLeft": {
    "value": "var(--ids-spacing-tooltip-padding-left)",
    "variable": "var(--ids-spacing-tooltip-padding-left)"
  },
  "spacing.tooltip.-paddingRight": {
    "value": "var(--ids-spacing-tooltip-padding-right)",
    "variable": "var(--ids-spacing-tooltip-padding-right)"
  },
  "spacing.tooltip.-paddingY": {
    "value": "var(--ids-spacing-tooltip-padding-y)",
    "variable": "var(--ids-spacing-tooltip-padding-y)"
  },
  "spacing.tooltip.-paddingRightClosable": {
    "value": "var(--ids-spacing-tooltip-padding-right-closable)",
    "variable": "var(--ids-spacing-tooltip-padding-right-closable)"
  },
  "spacing.iconButton.size.xs.-padding": {
    "value": "var(--ids-spacing-icon-button-size-xs-padding)",
    "variable": "var(--ids-spacing-icon-button-size-xs-padding)"
  },
  "spacing.iconButton.size.sm.-padding": {
    "value": "var(--ids-spacing-icon-button-size-sm-padding)",
    "variable": "var(--ids-spacing-icon-button-size-sm-padding)"
  },
  "spacing.iconButton.size.md.-padding": {
    "value": "var(--ids-spacing-icon-button-size-md-padding)",
    "variable": "var(--ids-spacing-icon-button-size-md-padding)"
  },
  "spacing.iconButton.size.lg.-padding": {
    "value": "var(--ids-spacing-icon-button-size-lg-padding)",
    "variable": "var(--ids-spacing-icon-button-size-lg-padding)"
  },
  "spacing.iconButton.size.xl.-padding": {
    "value": "var(--ids-spacing-icon-button-size-xl-padding)",
    "variable": "var(--ids-spacing-icon-button-size-xl-padding)"
  },
  "spacing.floatingButton.size.md.-paddingY": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-y)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-y)"
  },
  "spacing.floatingButton.size.md.-paddingLeft": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-left)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-left)"
  },
  "spacing.floatingButton.size.md.-paddingRight": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right)"
  },
  "spacing.floatingButton.size.md.-paddingLeftWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-left-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-left-with-icon)"
  },
  "spacing.floatingButton.size.md.-paddingRightWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right-with-icon)"
  },
  "spacing.floatingButton.size.md.-paddingRightWithEndIcon": {
    "value": "var(--ids-spacing-floating-button-size-md-padding-right-with-end-icon)",
    "variable": "var(--ids-spacing-floating-button-size-md-padding-right-with-end-icon)"
  },
  "spacing.floatingButton.size.md.-gap": {
    "value": "var(--ids-spacing-floating-button-size-md-gap)",
    "variable": "var(--ids-spacing-floating-button-size-md-gap)"
  },
  "spacing.floatingButton.size.sm.-paddingY": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-y)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-y)"
  },
  "spacing.floatingButton.size.sm.-paddingLeft": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-left)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-left)"
  },
  "spacing.floatingButton.size.sm.-paddingRight": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right)"
  },
  "spacing.floatingButton.size.sm.-paddingLeftWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-left-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-left-with-icon)"
  },
  "spacing.floatingButton.size.sm.-paddingRightWithIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right-with-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right-with-icon)"
  },
  "spacing.floatingButton.size.sm.-paddingRightWithEndIcon": {
    "value": "var(--ids-spacing-floating-button-size-sm-padding-right-with-end-icon)",
    "variable": "var(--ids-spacing-floating-button-size-sm-padding-right-with-end-icon)"
  },
  "spacing.floatingButton.size.sm.-gap": {
    "value": "var(--ids-spacing-floating-button-size-sm-gap)",
    "variable": "var(--ids-spacing-floating-button-size-sm-gap)"
  },
  "spacing.input.container.-paddingX": {
    "value": "var(--ids-spacing-input-container-padding-x)",
    "variable": "var(--ids-spacing-input-container-padding-x)"
  },
  "spacing.input.size.xs.-paddingY": {
    "value": "var(--ids-spacing-input-size-xs-padding-y)",
    "variable": "var(--ids-spacing-input-size-xs-padding-y)"
  },
  "spacing.input.size.sm.-paddingY": {
    "value": "var(--ids-spacing-input-size-sm-padding-y)",
    "variable": "var(--ids-spacing-input-size-sm-padding-y)"
  },
  "spacing.input.size.md.-paddingY": {
    "value": "var(--ids-spacing-input-size-md-padding-y)",
    "variable": "var(--ids-spacing-input-size-md-padding-y)"
  },
  "spacing.input.size.lg.-paddingY": {
    "value": "var(--ids-spacing-input-size-lg-padding-y)",
    "variable": "var(--ids-spacing-input-size-lg-padding-y)"
  },
  "spacing.input.size.xl.-paddingY": {
    "value": "var(--ids-spacing-input-size-xl-padding-y)",
    "variable": "var(--ids-spacing-input-size-xl-padding-y)"
  },
  "spacing.textArea.container.-paddingX": {
    "value": "var(--ids-spacing-text-area-container-padding-x)",
    "variable": "var(--ids-spacing-text-area-container-padding-x)"
  },
  "spacing.textArea.size.sm.-paddingY": {
    "value": "var(--ids-spacing-text-area-size-sm-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-sm-padding-y)"
  },
  "spacing.textArea.size.md.-paddingY": {
    "value": "var(--ids-spacing-text-area-size-md-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-md-padding-y)"
  },
  "spacing.textArea.size.lg.-paddingY": {
    "value": "var(--ids-spacing-text-area-size-lg-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-lg-padding-y)"
  },
  "spacing.textArea.size.xl.-paddingY": {
    "value": "var(--ids-spacing-text-area-size-xl-padding-y)",
    "variable": "var(--ids-spacing-text-area-size-xl-padding-y)"
  },
  "spacing.radio.size.sm.-gap": {
    "value": "var(--ids-spacing-radio-size-sm-gap)",
    "variable": "var(--ids-spacing-radio-size-sm-gap)"
  },
  "spacing.radio.size.sm.-indicatorAreaPadding": {
    "value": "var(--ids-spacing-radio-size-sm-indicator-area-padding)",
    "variable": "var(--ids-spacing-radio-size-sm-indicator-area-padding)"
  },
  "spacing.radio.size.md.-gap": {
    "value": "var(--ids-spacing-radio-size-md-gap)",
    "variable": "var(--ids-spacing-radio-size-md-gap)"
  },
  "spacing.radio.size.md.-indicatorAreaPadding": {
    "value": "var(--ids-spacing-radio-size-md-indicator-area-padding)",
    "variable": "var(--ids-spacing-radio-size-md-indicator-area-padding)"
  },
  "spacing.checkbox.-contentGap": {
    "value": "var(--ids-spacing-checkbox-content-gap)",
    "variable": "var(--ids-spacing-checkbox-content-gap)"
  },
  "spacing.checkbox.size.sm.-gap": {
    "value": "var(--ids-spacing-checkbox-size-sm-gap)",
    "variable": "var(--ids-spacing-checkbox-size-sm-gap)"
  },
  "spacing.checkbox.size.sm.-padding": {
    "value": "var(--ids-spacing-checkbox-size-sm-padding)",
    "variable": "var(--ids-spacing-checkbox-size-sm-padding)"
  },
  "spacing.checkbox.size.md.-gap": {
    "value": "var(--ids-spacing-checkbox-size-md-gap)",
    "variable": "var(--ids-spacing-checkbox-size-md-gap)"
  },
  "spacing.checkbox.size.md.-padding": {
    "value": "var(--ids-spacing-checkbox-size-md-padding)",
    "variable": "var(--ids-spacing-checkbox-size-md-padding)"
  },
  "spacing.menu.content.-paddingY": {
    "value": "var(--ids-spacing-menu-content-padding-y)",
    "variable": "var(--ids-spacing-menu-content-padding-y)"
  },
  "spacing.menu.content.-paddingX": {
    "value": "var(--ids-spacing-menu-content-padding-x)",
    "variable": "var(--ids-spacing-menu-content-padding-x)"
  },
  "spacing.menu.content.-sideOffset": {
    "value": "var(--ids-spacing-menu-content-side-offset)",
    "variable": "var(--ids-spacing-menu-content-side-offset)"
  },
  "spacing.menu.item.padding.-y": {
    "value": "var(--ids-spacing-menu-item-padding-y)",
    "variable": "var(--ids-spacing-menu-item-padding-y)"
  },
  "spacing.menu.item.padding.-yWithDescription": {
    "value": "var(--ids-spacing-menu-item-padding-y-with-description)",
    "variable": "var(--ids-spacing-menu-item-padding-y-with-description)"
  },
  "spacing.menu.item.padding.-left": {
    "value": "var(--ids-spacing-menu-item-padding-left)",
    "variable": "var(--ids-spacing-menu-item-padding-left)"
  },
  "spacing.menu.item.padding.-right": {
    "value": "var(--ids-spacing-menu-item-padding-right)",
    "variable": "var(--ids-spacing-menu-item-padding-right)"
  },
  "spacing.menu.groupLabel.padding.-left": {
    "value": "var(--ids-spacing-menu-group-label-padding-left)",
    "variable": "var(--ids-spacing-menu-group-label-padding-left)"
  },
  "spacing.menu.groupLabel.padding.-right": {
    "value": "var(--ids-spacing-menu-group-label-padding-right)",
    "variable": "var(--ids-spacing-menu-group-label-padding-right)"
  },
  "spacing.menu.groupLabel.padding.-top": {
    "value": "var(--ids-spacing-menu-group-label-padding-top)",
    "variable": "var(--ids-spacing-menu-group-label-padding-top)"
  },
  "spacing.menu.separator.-marginY": {
    "value": "var(--ids-spacing-menu-separator-margin-y)",
    "variable": "var(--ids-spacing-menu-separator-margin-y)"
  },
  "spacing.combobox.trigger.-paddingX": {
    "value": "var(--ids-spacing-combobox-trigger-padding-x)",
    "variable": "var(--ids-spacing-combobox-trigger-padding-x)"
  },
  "spacing.notice.-iconPaddingY": {
    "value": "var(--ids-spacing-notice-icon-padding-y)",
    "variable": "var(--ids-spacing-notice-icon-padding-y)"
  },
  "spacing.errorState.-paddingY": {
    "value": "var(--ids-spacing-error-state-padding-y)",
    "variable": "var(--ids-spacing-error-state-padding-y)"
  },
  "spacing.datePicker.content.-paddingTop": {
    "value": "var(--ids-spacing-date-picker-content-padding-top)",
    "variable": "var(--ids-spacing-date-picker-content-padding-top)"
  },
  "spacing.datePicker.content.-paddingX": {
    "value": "var(--ids-spacing-date-picker-content-padding-x)",
    "variable": "var(--ids-spacing-date-picker-content-padding-x)"
  },
  "spacing.datePicker.content.-paddingBottom": {
    "value": "var(--ids-spacing-date-picker-content-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-content-padding-bottom)"
  },
  "spacing.datePicker.content.-gap": {
    "value": "var(--ids-spacing-date-picker-content-gap)",
    "variable": "var(--ids-spacing-date-picker-content-gap)"
  },
  "spacing.datePicker.viewControl.-paddingTop": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-top)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-top)"
  },
  "spacing.datePicker.viewControl.-paddingX": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-x)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-x)"
  },
  "spacing.datePicker.viewControl.-paddingBottom": {
    "value": "var(--ids-spacing-date-picker-view-control-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-view-control-padding-bottom)"
  },
  "spacing.datePicker.table.-paddingTop": {
    "value": "var(--ids-spacing-date-picker-table-padding-top)",
    "variable": "var(--ids-spacing-date-picker-table-padding-top)"
  },
  "spacing.datePicker.table.-paddingX": {
    "value": "var(--ids-spacing-date-picker-table-padding-x)",
    "variable": "var(--ids-spacing-date-picker-table-padding-x)"
  },
  "spacing.datePicker.table.-paddingBottom": {
    "value": "var(--ids-spacing-date-picker-table-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-table-padding-bottom)"
  },
  "spacing.datePicker.table.-cellGapY": {
    "value": "var(--ids-spacing-date-picker-table-cell-gap-y)",
    "variable": "var(--ids-spacing-date-picker-table-cell-gap-y)"
  },
  "spacing.datePicker.tableHeader.-paddingBottom": {
    "value": "var(--ids-spacing-date-picker-table-header-padding-bottom)",
    "variable": "var(--ids-spacing-date-picker-table-header-padding-bottom)"
  },
  "spacing.datePicker.footer.-paddingX": {
    "value": "var(--ids-spacing-date-picker-footer-padding-x)",
    "variable": "var(--ids-spacing-date-picker-footer-padding-x)"
  },
  "spacing.datePicker.footer.-paddingY": {
    "value": "var(--ids-spacing-date-picker-footer-padding-y)",
    "variable": "var(--ids-spacing-date-picker-footer-padding-y)"
  },
  "spacing.datePicker.presetList.-paddingRight": {
    "value": "var(--ids-spacing-date-picker-preset-list-padding-right)",
    "variable": "var(--ids-spacing-date-picker-preset-list-padding-right)"
  },
  "spacing.dialog.xs.header.-pt": {
    "value": "var(--ids-spacing-dialog-xs-header-pt)",
    "variable": "var(--ids-spacing-dialog-xs-header-pt)"
  },
  "spacing.dialog.xs.header.-pb": {
    "value": "var(--ids-spacing-dialog-xs-header-pb)",
    "variable": "var(--ids-spacing-dialog-xs-header-pb)"
  },
  "spacing.dialog.xs.header.-px": {
    "value": "var(--ids-spacing-dialog-xs-header-px)",
    "variable": "var(--ids-spacing-dialog-xs-header-px)"
  },
  "spacing.dialog.xs.body.-pt": {
    "value": "var(--ids-spacing-dialog-xs-body-pt)",
    "variable": "var(--ids-spacing-dialog-xs-body-pt)"
  },
  "spacing.dialog.xs.body.-pb": {
    "value": "var(--ids-spacing-dialog-xs-body-pb)",
    "variable": "var(--ids-spacing-dialog-xs-body-pb)"
  },
  "spacing.dialog.xs.body.-px": {
    "value": "var(--ids-spacing-dialog-xs-body-px)",
    "variable": "var(--ids-spacing-dialog-xs-body-px)"
  },
  "spacing.dialog.xs.footer.-pt": {
    "value": "var(--ids-spacing-dialog-xs-footer-pt)",
    "variable": "var(--ids-spacing-dialog-xs-footer-pt)"
  },
  "spacing.dialog.xs.footer.-pb": {
    "value": "var(--ids-spacing-dialog-xs-footer-pb)",
    "variable": "var(--ids-spacing-dialog-xs-footer-pb)"
  },
  "spacing.dialog.xs.footer.-px": {
    "value": "var(--ids-spacing-dialog-xs-footer-px)",
    "variable": "var(--ids-spacing-dialog-xs-footer-px)"
  },
  "spacing.dialog.sm.header.-pt": {
    "value": "var(--ids-spacing-dialog-sm-header-pt)",
    "variable": "var(--ids-spacing-dialog-sm-header-pt)"
  },
  "spacing.dialog.sm.header.-pb": {
    "value": "var(--ids-spacing-dialog-sm-header-pb)",
    "variable": "var(--ids-spacing-dialog-sm-header-pb)"
  },
  "spacing.dialog.sm.header.-px": {
    "value": "var(--ids-spacing-dialog-sm-header-px)",
    "variable": "var(--ids-spacing-dialog-sm-header-px)"
  },
  "spacing.dialog.sm.body.-pt": {
    "value": "var(--ids-spacing-dialog-sm-body-pt)",
    "variable": "var(--ids-spacing-dialog-sm-body-pt)"
  },
  "spacing.dialog.sm.body.-pb": {
    "value": "var(--ids-spacing-dialog-sm-body-pb)",
    "variable": "var(--ids-spacing-dialog-sm-body-pb)"
  },
  "spacing.dialog.sm.body.-px": {
    "value": "var(--ids-spacing-dialog-sm-body-px)",
    "variable": "var(--ids-spacing-dialog-sm-body-px)"
  },
  "spacing.dialog.sm.footer.-pt": {
    "value": "var(--ids-spacing-dialog-sm-footer-pt)",
    "variable": "var(--ids-spacing-dialog-sm-footer-pt)"
  },
  "spacing.dialog.sm.footer.-pb": {
    "value": "var(--ids-spacing-dialog-sm-footer-pb)",
    "variable": "var(--ids-spacing-dialog-sm-footer-pb)"
  },
  "spacing.dialog.sm.footer.-px": {
    "value": "var(--ids-spacing-dialog-sm-footer-px)",
    "variable": "var(--ids-spacing-dialog-sm-footer-px)"
  },
  "spacing.dialog.md.header.-pt": {
    "value": "var(--ids-spacing-dialog-md-header-pt)",
    "variable": "var(--ids-spacing-dialog-md-header-pt)"
  },
  "spacing.dialog.md.header.-pb": {
    "value": "var(--ids-spacing-dialog-md-header-pb)",
    "variable": "var(--ids-spacing-dialog-md-header-pb)"
  },
  "spacing.dialog.md.header.-px": {
    "value": "var(--ids-spacing-dialog-md-header-px)",
    "variable": "var(--ids-spacing-dialog-md-header-px)"
  },
  "spacing.dialog.md.body.-pt": {
    "value": "var(--ids-spacing-dialog-md-body-pt)",
    "variable": "var(--ids-spacing-dialog-md-body-pt)"
  },
  "spacing.dialog.md.body.-pb": {
    "value": "var(--ids-spacing-dialog-md-body-pb)",
    "variable": "var(--ids-spacing-dialog-md-body-pb)"
  },
  "spacing.dialog.md.body.-px": {
    "value": "var(--ids-spacing-dialog-md-body-px)",
    "variable": "var(--ids-spacing-dialog-md-body-px)"
  },
  "spacing.dialog.md.footer.-pt": {
    "value": "var(--ids-spacing-dialog-md-footer-pt)",
    "variable": "var(--ids-spacing-dialog-md-footer-pt)"
  },
  "spacing.dialog.md.footer.-pb": {
    "value": "var(--ids-spacing-dialog-md-footer-pb)",
    "variable": "var(--ids-spacing-dialog-md-footer-pb)"
  },
  "spacing.dialog.md.footer.-px": {
    "value": "var(--ids-spacing-dialog-md-footer-px)",
    "variable": "var(--ids-spacing-dialog-md-footer-px)"
  },
  "spacing.dialog.lg.header.-pt": {
    "value": "var(--ids-spacing-dialog-lg-header-pt)",
    "variable": "var(--ids-spacing-dialog-lg-header-pt)"
  },
  "spacing.dialog.lg.header.-pb": {
    "value": "var(--ids-spacing-dialog-lg-header-pb)",
    "variable": "var(--ids-spacing-dialog-lg-header-pb)"
  },
  "spacing.dialog.lg.header.-px": {
    "value": "var(--ids-spacing-dialog-lg-header-px)",
    "variable": "var(--ids-spacing-dialog-lg-header-px)"
  },
  "spacing.dialog.lg.body.-pt": {
    "value": "var(--ids-spacing-dialog-lg-body-pt)",
    "variable": "var(--ids-spacing-dialog-lg-body-pt)"
  },
  "spacing.dialog.lg.body.-pb": {
    "value": "var(--ids-spacing-dialog-lg-body-pb)",
    "variable": "var(--ids-spacing-dialog-lg-body-pb)"
  },
  "spacing.dialog.lg.body.-px": {
    "value": "var(--ids-spacing-dialog-lg-body-px)",
    "variable": "var(--ids-spacing-dialog-lg-body-px)"
  },
  "spacing.dialog.lg.footer.-pt": {
    "value": "var(--ids-spacing-dialog-lg-footer-pt)",
    "variable": "var(--ids-spacing-dialog-lg-footer-pt)"
  },
  "spacing.dialog.lg.footer.-pb": {
    "value": "var(--ids-spacing-dialog-lg-footer-pb)",
    "variable": "var(--ids-spacing-dialog-lg-footer-pb)"
  },
  "spacing.dialog.lg.footer.-px": {
    "value": "var(--ids-spacing-dialog-lg-footer-px)",
    "variable": "var(--ids-spacing-dialog-lg-footer-px)"
  },
  "spacing.dialog.xl.header.-pt": {
    "value": "var(--ids-spacing-dialog-xl-header-pt)",
    "variable": "var(--ids-spacing-dialog-xl-header-pt)"
  },
  "spacing.dialog.xl.header.-pb": {
    "value": "var(--ids-spacing-dialog-xl-header-pb)",
    "variable": "var(--ids-spacing-dialog-xl-header-pb)"
  },
  "spacing.dialog.xl.header.-px": {
    "value": "var(--ids-spacing-dialog-xl-header-px)",
    "variable": "var(--ids-spacing-dialog-xl-header-px)"
  },
  "spacing.dialog.xl.body.-pt": {
    "value": "var(--ids-spacing-dialog-xl-body-pt)",
    "variable": "var(--ids-spacing-dialog-xl-body-pt)"
  },
  "spacing.dialog.xl.body.-pb": {
    "value": "var(--ids-spacing-dialog-xl-body-pb)",
    "variable": "var(--ids-spacing-dialog-xl-body-pb)"
  },
  "spacing.dialog.xl.body.-px": {
    "value": "var(--ids-spacing-dialog-xl-body-px)",
    "variable": "var(--ids-spacing-dialog-xl-body-px)"
  },
  "spacing.dialog.xl.footer.-pt": {
    "value": "var(--ids-spacing-dialog-xl-footer-pt)",
    "variable": "var(--ids-spacing-dialog-xl-footer-pt)"
  },
  "spacing.dialog.xl.footer.-pb": {
    "value": "var(--ids-spacing-dialog-xl-footer-pb)",
    "variable": "var(--ids-spacing-dialog-xl-footer-pb)"
  },
  "spacing.dialog.xl.footer.-px": {
    "value": "var(--ids-spacing-dialog-xl-footer-px)",
    "variable": "var(--ids-spacing-dialog-xl-footer-px)"
  },
  "spacing.dialog.full.header.-pt": {
    "value": "var(--ids-spacing-dialog-full-header-pt)",
    "variable": "var(--ids-spacing-dialog-full-header-pt)"
  },
  "spacing.dialog.full.header.-pb": {
    "value": "var(--ids-spacing-dialog-full-header-pb)",
    "variable": "var(--ids-spacing-dialog-full-header-pb)"
  },
  "spacing.dialog.full.header.-px": {
    "value": "var(--ids-spacing-dialog-full-header-px)",
    "variable": "var(--ids-spacing-dialog-full-header-px)"
  },
  "spacing.dialog.full.body.-pt": {
    "value": "var(--ids-spacing-dialog-full-body-pt)",
    "variable": "var(--ids-spacing-dialog-full-body-pt)"
  },
  "spacing.dialog.full.body.-pb": {
    "value": "var(--ids-spacing-dialog-full-body-pb)",
    "variable": "var(--ids-spacing-dialog-full-body-pb)"
  },
  "spacing.dialog.full.body.-px": {
    "value": "var(--ids-spacing-dialog-full-body-px)",
    "variable": "var(--ids-spacing-dialog-full-body-px)"
  },
  "spacing.dialog.full.footer.-pt": {
    "value": "var(--ids-spacing-dialog-full-footer-pt)",
    "variable": "var(--ids-spacing-dialog-full-footer-pt)"
  },
  "spacing.dialog.full.footer.-pb": {
    "value": "var(--ids-spacing-dialog-full-footer-pb)",
    "variable": "var(--ids-spacing-dialog-full-footer-pb)"
  },
  "spacing.dialog.full.footer.-px": {
    "value": "var(--ids-spacing-dialog-full-footer-px)",
    "variable": "var(--ids-spacing-dialog-full-footer-px)"
  },
  "spacing.timePicker.input.container.-paddingX": {
    "value": "var(--ids-spacing-time-picker-input-container-padding-x)",
    "variable": "var(--ids-spacing-time-picker-input-container-padding-x)"
  },
  "spacing.segmentedControl.size.sm.-paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-sm-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-sm-padding-y)"
  },
  "spacing.segmentedControl.size.md.-paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-md-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-md-padding-y)"
  },
  "spacing.segmentedControl.size.lg.-paddingY": {
    "value": "var(--ids-spacing-segmented-control-size-lg-padding-y)",
    "variable": "var(--ids-spacing-segmented-control-size-lg-padding-y)"
  },
  "spacing.chat.bubble.compact.-paddingX": {
    "value": "var(--ids-spacing-chat-bubble-compact-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-compact-padding-x)"
  },
  "spacing.chat.bubble.compact.-paddingY": {
    "value": "var(--ids-spacing-chat-bubble-compact-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-compact-padding-y)"
  },
  "spacing.chat.bubble.compact.-gap": {
    "value": "var(--ids-spacing-chat-bubble-compact-gap)",
    "variable": "var(--ids-spacing-chat-bubble-compact-gap)"
  },
  "spacing.chat.bubble.balanced.-paddingX": {
    "value": "var(--ids-spacing-chat-bubble-balanced-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-padding-x)"
  },
  "spacing.chat.bubble.balanced.-paddingY": {
    "value": "var(--ids-spacing-chat-bubble-balanced-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-padding-y)"
  },
  "spacing.chat.bubble.balanced.-gap": {
    "value": "var(--ids-spacing-chat-bubble-balanced-gap)",
    "variable": "var(--ids-spacing-chat-bubble-balanced-gap)"
  },
  "spacing.chat.bubble.spacious.-paddingX": {
    "value": "var(--ids-spacing-chat-bubble-spacious-padding-x)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-padding-x)"
  },
  "spacing.chat.bubble.spacious.-paddingY": {
    "value": "var(--ids-spacing-chat-bubble-spacious-padding-y)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-padding-y)"
  },
  "spacing.chat.bubble.spacious.-gap": {
    "value": "var(--ids-spacing-chat-bubble-spacious-gap)",
    "variable": "var(--ids-spacing-chat-bubble-spacious-gap)"
  },
  "spacing.propertyPanel.field.-gap": {
    "value": "var(--ids-spacing-property-panel-field-gap)",
    "variable": "var(--ids-spacing-property-panel-field-gap)"
  },
  "colors.button.subtle.bg.active": {
    "value": "var(--ids-colors-button-subtle-bg-active)",
    "variable": "var(--ids-colors-button-subtle-bg-active)"
  },
  "colors.primary.surface.low": {
    "value": "var(--ids-colors-primary-surface-low)",
    "variable": "var(--ids-colors-primary-surface-low)"
  },
  "colors.primary.surface.highest": {
    "value": "var(--ids-colors-primary-surface-highest)",
    "variable": "var(--ids-colors-primary-surface-highest)"
  },
  "colors.primary.fill.low": {
    "value": "var(--ids-colors-primary-fill-low)",
    "variable": "var(--ids-colors-primary-fill-low)"
  },
  "colors.colorPalette.1200": {
    "value": "var(--ids-colors-color-palette-1200)",
    "variable": "var(--ids-colors-color-palette-1200)"
  },
  "colors.colorPalette.a1300": {
    "value": "var(--ids-colors-color-palette-a1300)",
    "variable": "var(--ids-colors-color-palette-a1300)"
  },
  "colors.colorPalette.a000": {
    "value": "var(--ids-colors-color-palette-a000)",
    "variable": "var(--ids-colors-color-palette-a000)"
  },
  "colors.colorPalette.a100": {
    "value": "var(--ids-colors-color-palette-a100)",
    "variable": "var(--ids-colors-color-palette-a100)"
  },
  "colors.colorPalette.a200": {
    "value": "var(--ids-colors-color-palette-a200)",
    "variable": "var(--ids-colors-color-palette-a200)"
  },
  "colors.colorPalette.a300": {
    "value": "var(--ids-colors-color-palette-a300)",
    "variable": "var(--ids-colors-color-palette-a300)"
  },
  "colors.colorPalette.a400": {
    "value": "var(--ids-colors-color-palette-a400)",
    "variable": "var(--ids-colors-color-palette-a400)"
  },
  "colors.colorPalette.a500": {
    "value": "var(--ids-colors-color-palette-a500)",
    "variable": "var(--ids-colors-color-palette-a500)"
  },
  "colors.colorPalette.a600": {
    "value": "var(--ids-colors-color-palette-a600)",
    "variable": "var(--ids-colors-color-palette-a600)"
  },
  "colors.colorPalette.a700": {
    "value": "var(--ids-colors-color-palette-a700)",
    "variable": "var(--ids-colors-color-palette-a700)"
  },
  "colors.colorPalette.a800": {
    "value": "var(--ids-colors-color-palette-a800)",
    "variable": "var(--ids-colors-color-palette-a800)"
  },
  "colors.colorPalette.a900": {
    "value": "var(--ids-colors-color-palette-a900)",
    "variable": "var(--ids-colors-color-palette-a900)"
  },
  "colors.colorPalette.a1000": {
    "value": "var(--ids-colors-color-palette-a1000)",
    "variable": "var(--ids-colors-color-palette-a1000)"
  },
  "colors.colorPalette.a1100": {
    "value": "var(--ids-colors-color-palette-a1100)",
    "variable": "var(--ids-colors-color-palette-a1100)"
  },
  "colors.colorPalette.a1200": {
    "value": "var(--ids-colors-color-palette-a1200)",
    "variable": "var(--ids-colors-color-palette-a1200)"
  },
  "colors.colorPalette.light.100": {
    "value": "var(--ids-colors-color-palette-light-100)",
    "variable": "var(--ids-colors-color-palette-light-100)"
  },
  "colors.colorPalette.100": {
    "value": "var(--ids-colors-color-palette-100)",
    "variable": "var(--ids-colors-color-palette-100)"
  },
  "colors.colorPalette.light.200": {
    "value": "var(--ids-colors-color-palette-light-200)",
    "variable": "var(--ids-colors-color-palette-light-200)"
  },
  "colors.colorPalette.200": {
    "value": "var(--ids-colors-color-palette-200)",
    "variable": "var(--ids-colors-color-palette-200)"
  },
  "colors.colorPalette.light.300": {
    "value": "var(--ids-colors-color-palette-light-300)",
    "variable": "var(--ids-colors-color-palette-light-300)"
  },
  "colors.colorPalette.300": {
    "value": "var(--ids-colors-color-palette-300)",
    "variable": "var(--ids-colors-color-palette-300)"
  },
  "colors.colorPalette.light.400": {
    "value": "var(--ids-colors-color-palette-light-400)",
    "variable": "var(--ids-colors-color-palette-light-400)"
  },
  "colors.colorPalette.400": {
    "value": "var(--ids-colors-color-palette-400)",
    "variable": "var(--ids-colors-color-palette-400)"
  },
  "colors.colorPalette.light.500": {
    "value": "var(--ids-colors-color-palette-light-500)",
    "variable": "var(--ids-colors-color-palette-light-500)"
  },
  "colors.colorPalette.500": {
    "value": "var(--ids-colors-color-palette-500)",
    "variable": "var(--ids-colors-color-palette-500)"
  },
  "colors.colorPalette.light.600": {
    "value": "var(--ids-colors-color-palette-light-600)",
    "variable": "var(--ids-colors-color-palette-light-600)"
  },
  "colors.colorPalette.600": {
    "value": "var(--ids-colors-color-palette-600)",
    "variable": "var(--ids-colors-color-palette-600)"
  },
  "colors.colorPalette.light.700": {
    "value": "var(--ids-colors-color-palette-light-700)",
    "variable": "var(--ids-colors-color-palette-light-700)"
  },
  "colors.colorPalette.700": {
    "value": "var(--ids-colors-color-palette-700)",
    "variable": "var(--ids-colors-color-palette-700)"
  },
  "colors.colorPalette.light.800": {
    "value": "var(--ids-colors-color-palette-light-800)",
    "variable": "var(--ids-colors-color-palette-light-800)"
  },
  "colors.colorPalette.800": {
    "value": "var(--ids-colors-color-palette-800)",
    "variable": "var(--ids-colors-color-palette-800)"
  },
  "colors.colorPalette.light.900": {
    "value": "var(--ids-colors-color-palette-light-900)",
    "variable": "var(--ids-colors-color-palette-light-900)"
  },
  "colors.colorPalette.900": {
    "value": "var(--ids-colors-color-palette-900)",
    "variable": "var(--ids-colors-color-palette-900)"
  },
  "colors.colorPalette.light.1000": {
    "value": "var(--ids-colors-color-palette-light-1000)",
    "variable": "var(--ids-colors-color-palette-light-1000)"
  },
  "colors.colorPalette.1000": {
    "value": "var(--ids-colors-color-palette-1000)",
    "variable": "var(--ids-colors-color-palette-1000)"
  },
  "colors.colorPalette.light.1100": {
    "value": "var(--ids-colors-color-palette-light-1100)",
    "variable": "var(--ids-colors-color-palette-light-1100)"
  },
  "colors.colorPalette.1100": {
    "value": "var(--ids-colors-color-palette-1100)",
    "variable": "var(--ids-colors-color-palette-1100)"
  },
  "colors.colorPalette.light.1200": {
    "value": "var(--ids-colors-color-palette-light-1200)",
    "variable": "var(--ids-colors-color-palette-light-1200)"
  },
  "colors.colorPalette.light.a100": {
    "value": "var(--ids-colors-color-palette-light-a100)",
    "variable": "var(--ids-colors-color-palette-light-a100)"
  },
  "colors.colorPalette.light.a200": {
    "value": "var(--ids-colors-color-palette-light-a200)",
    "variable": "var(--ids-colors-color-palette-light-a200)"
  },
  "colors.colorPalette.light.a300": {
    "value": "var(--ids-colors-color-palette-light-a300)",
    "variable": "var(--ids-colors-color-palette-light-a300)"
  },
  "colors.colorPalette.light.a400": {
    "value": "var(--ids-colors-color-palette-light-a400)",
    "variable": "var(--ids-colors-color-palette-light-a400)"
  },
  "colors.colorPalette.light.a500": {
    "value": "var(--ids-colors-color-palette-light-a500)",
    "variable": "var(--ids-colors-color-palette-light-a500)"
  },
  "colors.colorPalette.light.a600": {
    "value": "var(--ids-colors-color-palette-light-a600)",
    "variable": "var(--ids-colors-color-palette-light-a600)"
  },
  "colors.colorPalette.dark.100": {
    "value": "var(--ids-colors-color-palette-dark-100)",
    "variable": "var(--ids-colors-color-palette-dark-100)"
  },
  "colors.colorPalette.dark.200": {
    "value": "var(--ids-colors-color-palette-dark-200)",
    "variable": "var(--ids-colors-color-palette-dark-200)"
  },
  "colors.colorPalette.dark.300": {
    "value": "var(--ids-colors-color-palette-dark-300)",
    "variable": "var(--ids-colors-color-palette-dark-300)"
  },
  "colors.colorPalette.dark.400": {
    "value": "var(--ids-colors-color-palette-dark-400)",
    "variable": "var(--ids-colors-color-palette-dark-400)"
  },
  "colors.colorPalette.dark.500": {
    "value": "var(--ids-colors-color-palette-dark-500)",
    "variable": "var(--ids-colors-color-palette-dark-500)"
  },
  "colors.colorPalette.dark.600": {
    "value": "var(--ids-colors-color-palette-dark-600)",
    "variable": "var(--ids-colors-color-palette-dark-600)"
  },
  "colors.colorPalette.dark.700": {
    "value": "var(--ids-colors-color-palette-dark-700)",
    "variable": "var(--ids-colors-color-palette-dark-700)"
  },
  "colors.colorPalette.dark.800": {
    "value": "var(--ids-colors-color-palette-dark-800)",
    "variable": "var(--ids-colors-color-palette-dark-800)"
  },
  "colors.colorPalette.dark.900": {
    "value": "var(--ids-colors-color-palette-dark-900)",
    "variable": "var(--ids-colors-color-palette-dark-900)"
  },
  "colors.colorPalette.dark.1000": {
    "value": "var(--ids-colors-color-palette-dark-1000)",
    "variable": "var(--ids-colors-color-palette-dark-1000)"
  },
  "colors.colorPalette.dark.1100": {
    "value": "var(--ids-colors-color-palette-dark-1100)",
    "variable": "var(--ids-colors-color-palette-dark-1100)"
  },
  "colors.colorPalette.dark.1200": {
    "value": "var(--ids-colors-color-palette-dark-1200)",
    "variable": "var(--ids-colors-color-palette-dark-1200)"
  },
  "colors.colorPalette.dark.a100": {
    "value": "var(--ids-colors-color-palette-dark-a100)",
    "variable": "var(--ids-colors-color-palette-dark-a100)"
  },
  "colors.colorPalette.dark.a200": {
    "value": "var(--ids-colors-color-palette-dark-a200)",
    "variable": "var(--ids-colors-color-palette-dark-a200)"
  },
  "colors.colorPalette.dark.a300": {
    "value": "var(--ids-colors-color-palette-dark-a300)",
    "variable": "var(--ids-colors-color-palette-dark-a300)"
  },
  "colors.colorPalette.dark.a400": {
    "value": "var(--ids-colors-color-palette-dark-a400)",
    "variable": "var(--ids-colors-color-palette-dark-a400)"
  },
  "colors.colorPalette.dark.a500": {
    "value": "var(--ids-colors-color-palette-dark-a500)",
    "variable": "var(--ids-colors-color-palette-dark-a500)"
  },
  "colors.colorPalette.dark.a600": {
    "value": "var(--ids-colors-color-palette-dark-a600)",
    "variable": "var(--ids-colors-color-palette-dark-a600)"
  },
  "colors.colorPalette.light.650": {
    "value": "var(--ids-colors-color-palette-light-650)",
    "variable": "var(--ids-colors-color-palette-light-650)"
  },
  "colors.colorPalette.650": {
    "value": "var(--ids-colors-color-palette-650)",
    "variable": "var(--ids-colors-color-palette-650)"
  },
  "colors.colorPalette.stroke.school": {
    "value": "var(--ids-colors-color-palette-stroke-school)",
    "variable": "var(--ids-colors-color-palette-stroke-school)"
  },
  "colors.colorPalette.school": {
    "value": "var(--ids-colors-color-palette-school)",
    "variable": "var(--ids-colors-color-palette-school)"
  },
  "colors.colorPalette.stroke.mildang": {
    "value": "var(--ids-colors-color-palette-stroke-mildang)",
    "variable": "var(--ids-colors-color-palette-stroke-mildang)"
  },
  "colors.colorPalette.mildang": {
    "value": "var(--ids-colors-color-palette-mildang)",
    "variable": "var(--ids-colors-color-palette-mildang)"
  },
  "colors.colorPalette.snackbar": {
    "value": "var(--ids-colors-color-palette-snackbar)",
    "variable": "var(--ids-colors-color-palette-snackbar)"
  },
  "colors.colorPalette.activeRating": {
    "value": "var(--ids-colors-color-palette-active-rating)",
    "variable": "var(--ids-colors-color-palette-active-rating)"
  },
  "colors.colorPalette.divider": {
    "value": "var(--ids-colors-color-palette-divider)",
    "variable": "var(--ids-colors-color-palette-divider)"
  },
  "colors.colorPalette.primary.dark": {
    "value": "var(--ids-colors-color-palette-primary-dark)",
    "variable": "var(--ids-colors-color-palette-primary-dark)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--ids-colors-color-palette-dark)",
    "variable": "var(--ids-colors-color-palette-dark)"
  },
  "colors.colorPalette.primary.darkActive": {
    "value": "var(--ids-colors-color-palette-primary-dark-active)",
    "variable": "var(--ids-colors-color-palette-primary-dark-active)"
  },
  "colors.colorPalette.darkActive": {
    "value": "var(--ids-colors-color-palette-dark-active)",
    "variable": "var(--ids-colors-color-palette-dark-active)"
  },
  "colors.colorPalette.primary.darkHover": {
    "value": "var(--ids-colors-color-palette-primary-dark-hover)",
    "variable": "var(--ids-colors-color-palette-primary-dark-hover)"
  },
  "colors.colorPalette.darkHover": {
    "value": "var(--ids-colors-color-palette-dark-hover)",
    "variable": "var(--ids-colors-color-palette-dark-hover)"
  },
  "colors.colorPalette.primary.main": {
    "value": "var(--ids-colors-color-palette-primary-main)",
    "variable": "var(--ids-colors-color-palette-primary-main)"
  },
  "colors.colorPalette.main": {
    "value": "var(--ids-colors-color-palette-main)",
    "variable": "var(--ids-colors-color-palette-main)"
  },
  "colors.colorPalette.primary.stroke": {
    "value": "var(--ids-colors-color-palette-primary-stroke)",
    "variable": "var(--ids-colors-color-palette-primary-stroke)"
  },
  "colors.colorPalette.stroke": {
    "value": "var(--ids-colors-color-palette-stroke)",
    "variable": "var(--ids-colors-color-palette-stroke)"
  },
  "colors.colorPalette.primary.strokeHover": {
    "value": "var(--ids-colors-color-palette-primary-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-primary-stroke-hover)"
  },
  "colors.colorPalette.strokeHover": {
    "value": "var(--ids-colors-color-palette-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-stroke-hover)"
  },
  "colors.colorPalette.primary.lightHover": {
    "value": "var(--ids-colors-color-palette-primary-light-hover)",
    "variable": "var(--ids-colors-color-palette-primary-light-hover)"
  },
  "colors.colorPalette.lightHover": {
    "value": "var(--ids-colors-color-palette-light-hover)",
    "variable": "var(--ids-colors-color-palette-light-hover)"
  },
  "colors.colorPalette.primary.lightActive": {
    "value": "var(--ids-colors-color-palette-primary-light-active)",
    "variable": "var(--ids-colors-color-palette-primary-light-active)"
  },
  "colors.colorPalette.lightActive": {
    "value": "var(--ids-colors-color-palette-light-active)",
    "variable": "var(--ids-colors-color-palette-light-active)"
  },
  "colors.colorPalette.primary.light": {
    "value": "var(--ids-colors-color-palette-primary-light)",
    "variable": "var(--ids-colors-color-palette-primary-light)"
  },
  "colors.colorPalette.light": {
    "value": "var(--ids-colors-color-palette-light)",
    "variable": "var(--ids-colors-color-palette-light)"
  },
  "colors.colorPalette.primary.contrastText": {
    "value": "var(--ids-colors-color-palette-primary-contrast-text)",
    "variable": "var(--ids-colors-color-palette-primary-contrast-text)"
  },
  "colors.colorPalette.contrastText": {
    "value": "var(--ids-colors-color-palette-contrast-text)",
    "variable": "var(--ids-colors-color-palette-contrast-text)"
  },
  "colors.colorPalette.secondary.dark": {
    "value": "var(--ids-colors-color-palette-secondary-dark)",
    "variable": "var(--ids-colors-color-palette-secondary-dark)"
  },
  "colors.colorPalette.secondary.darkActive": {
    "value": "var(--ids-colors-color-palette-secondary-dark-active)",
    "variable": "var(--ids-colors-color-palette-secondary-dark-active)"
  },
  "colors.colorPalette.secondary.darkHover": {
    "value": "var(--ids-colors-color-palette-secondary-dark-hover)",
    "variable": "var(--ids-colors-color-palette-secondary-dark-hover)"
  },
  "colors.colorPalette.secondary.main": {
    "value": "var(--ids-colors-color-palette-secondary-main)",
    "variable": "var(--ids-colors-color-palette-secondary-main)"
  },
  "colors.colorPalette.secondary.stroke": {
    "value": "var(--ids-colors-color-palette-secondary-stroke)",
    "variable": "var(--ids-colors-color-palette-secondary-stroke)"
  },
  "colors.colorPalette.secondary.strokeHover": {
    "value": "var(--ids-colors-color-palette-secondary-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-secondary-stroke-hover)"
  },
  "colors.colorPalette.secondary.lightActive": {
    "value": "var(--ids-colors-color-palette-secondary-light-active)",
    "variable": "var(--ids-colors-color-palette-secondary-light-active)"
  },
  "colors.colorPalette.secondary.lightHover": {
    "value": "var(--ids-colors-color-palette-secondary-light-hover)",
    "variable": "var(--ids-colors-color-palette-secondary-light-hover)"
  },
  "colors.colorPalette.secondary.light": {
    "value": "var(--ids-colors-color-palette-secondary-light)",
    "variable": "var(--ids-colors-color-palette-secondary-light)"
  },
  "colors.colorPalette.secondary.contrastText": {
    "value": "var(--ids-colors-color-palette-secondary-contrast-text)",
    "variable": "var(--ids-colors-color-palette-secondary-contrast-text)"
  },
  "colors.colorPalette.error.dark": {
    "value": "var(--ids-colors-color-palette-error-dark)",
    "variable": "var(--ids-colors-color-palette-error-dark)"
  },
  "colors.colorPalette.error.darkActive": {
    "value": "var(--ids-colors-color-palette-error-dark-active)",
    "variable": "var(--ids-colors-color-palette-error-dark-active)"
  },
  "colors.colorPalette.error.darkHover": {
    "value": "var(--ids-colors-color-palette-error-dark-hover)",
    "variable": "var(--ids-colors-color-palette-error-dark-hover)"
  },
  "colors.colorPalette.error.main": {
    "value": "var(--ids-colors-color-palette-error-main)",
    "variable": "var(--ids-colors-color-palette-error-main)"
  },
  "colors.colorPalette.error.stroke": {
    "value": "var(--ids-colors-color-palette-error-stroke)",
    "variable": "var(--ids-colors-color-palette-error-stroke)"
  },
  "colors.colorPalette.error.strokeHover": {
    "value": "var(--ids-colors-color-palette-error-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-error-stroke-hover)"
  },
  "colors.colorPalette.error.lightHover": {
    "value": "var(--ids-colors-color-palette-error-light-hover)",
    "variable": "var(--ids-colors-color-palette-error-light-hover)"
  },
  "colors.colorPalette.error.lightActive": {
    "value": "var(--ids-colors-color-palette-error-light-active)",
    "variable": "var(--ids-colors-color-palette-error-light-active)"
  },
  "colors.colorPalette.error.light": {
    "value": "var(--ids-colors-color-palette-error-light)",
    "variable": "var(--ids-colors-color-palette-error-light)"
  },
  "colors.colorPalette.error.contrastText": {
    "value": "var(--ids-colors-color-palette-error-contrast-text)",
    "variable": "var(--ids-colors-color-palette-error-contrast-text)"
  },
  "colors.colorPalette.warning.dark": {
    "value": "var(--ids-colors-color-palette-warning-dark)",
    "variable": "var(--ids-colors-color-palette-warning-dark)"
  },
  "colors.colorPalette.warning.darkActive": {
    "value": "var(--ids-colors-color-palette-warning-dark-active)",
    "variable": "var(--ids-colors-color-palette-warning-dark-active)"
  },
  "colors.colorPalette.warning.darkHover": {
    "value": "var(--ids-colors-color-palette-warning-dark-hover)",
    "variable": "var(--ids-colors-color-palette-warning-dark-hover)"
  },
  "colors.colorPalette.warning.main": {
    "value": "var(--ids-colors-color-palette-warning-main)",
    "variable": "var(--ids-colors-color-palette-warning-main)"
  },
  "colors.colorPalette.warning.stroke": {
    "value": "var(--ids-colors-color-palette-warning-stroke)",
    "variable": "var(--ids-colors-color-palette-warning-stroke)"
  },
  "colors.colorPalette.warning.strokeHover": {
    "value": "var(--ids-colors-color-palette-warning-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-warning-stroke-hover)"
  },
  "colors.colorPalette.warning.lightActive": {
    "value": "var(--ids-colors-color-palette-warning-light-active)",
    "variable": "var(--ids-colors-color-palette-warning-light-active)"
  },
  "colors.colorPalette.warning.lightHover": {
    "value": "var(--ids-colors-color-palette-warning-light-hover)",
    "variable": "var(--ids-colors-color-palette-warning-light-hover)"
  },
  "colors.colorPalette.warning.light": {
    "value": "var(--ids-colors-color-palette-warning-light)",
    "variable": "var(--ids-colors-color-palette-warning-light)"
  },
  "colors.colorPalette.warning.contrastText": {
    "value": "var(--ids-colors-color-palette-warning-contrast-text)",
    "variable": "var(--ids-colors-color-palette-warning-contrast-text)"
  },
  "colors.colorPalette.info.dark": {
    "value": "var(--ids-colors-color-palette-info-dark)",
    "variable": "var(--ids-colors-color-palette-info-dark)"
  },
  "colors.colorPalette.info.darkActive": {
    "value": "var(--ids-colors-color-palette-info-dark-active)",
    "variable": "var(--ids-colors-color-palette-info-dark-active)"
  },
  "colors.colorPalette.info.darkHover": {
    "value": "var(--ids-colors-color-palette-info-dark-hover)",
    "variable": "var(--ids-colors-color-palette-info-dark-hover)"
  },
  "colors.colorPalette.info.main": {
    "value": "var(--ids-colors-color-palette-info-main)",
    "variable": "var(--ids-colors-color-palette-info-main)"
  },
  "colors.colorPalette.info.stroke": {
    "value": "var(--ids-colors-color-palette-info-stroke)",
    "variable": "var(--ids-colors-color-palette-info-stroke)"
  },
  "colors.colorPalette.info.strokeHover": {
    "value": "var(--ids-colors-color-palette-info-stroke-hover)",
    "variable": "var(--ids-colors-color-palette-info-stroke-hover)"
  },
  "colors.colorPalette.info.lightActive": {
    "value": "var(--ids-colors-color-palette-info-light-active)",
    "variable": "var(--ids-colors-color-palette-info-light-active)"
  },
  "colors.colorPalette.info.lightHover": {
    "value": "var(--ids-colors-color-palette-info-light-hover)",
    "variable": "var(--ids-colors-color-palette-info-light-hover)"
  },
  "colors.colorPalette.info.light": {
    "value": "var(--ids-colors-color-palette-info-light)",
    "variable": "var(--ids-colors-color-palette-info-light)"
  },
  "colors.colorPalette.info.contrastText": {
    "value": "var(--ids-colors-color-palette-info-contrast-text)",
    "variable": "var(--ids-colors-color-palette-info-contrast-text)"
  },
  "colors.colorPalette.text.primary": {
    "value": "var(--ids-colors-color-palette-text-primary)",
    "variable": "var(--ids-colors-color-palette-text-primary)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--ids-colors-color-palette-primary)",
    "variable": "var(--ids-colors-color-palette-primary)"
  },
  "colors.colorPalette.text.secondary": {
    "value": "var(--ids-colors-color-palette-text-secondary)",
    "variable": "var(--ids-colors-color-palette-text-secondary)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--ids-colors-color-palette-secondary)",
    "variable": "var(--ids-colors-color-palette-secondary)"
  },
  "colors.colorPalette.text.tertiary": {
    "value": "var(--ids-colors-color-palette-text-tertiary)",
    "variable": "var(--ids-colors-color-palette-text-tertiary)"
  },
  "colors.colorPalette.tertiary": {
    "value": "var(--ids-colors-color-palette-tertiary)",
    "variable": "var(--ids-colors-color-palette-tertiary)"
  },
  "colors.colorPalette.background.primary": {
    "value": "var(--ids-colors-color-palette-background-primary)",
    "variable": "var(--ids-colors-color-palette-background-primary)"
  },
  "colors.colorPalette.background.secondary": {
    "value": "var(--ids-colors-color-palette-background-secondary)",
    "variable": "var(--ids-colors-color-palette-background-secondary)"
  },
  "colors.colorPalette.background.tertiary": {
    "value": "var(--ids-colors-color-palette-background-tertiary)",
    "variable": "var(--ids-colors-color-palette-background-tertiary)"
  },
  "colors.colorPalette.background.default": {
    "value": "var(--ids-colors-color-palette-background-default)",
    "variable": "var(--ids-colors-color-palette-background-default)"
  },
  "colors.colorPalette.default": {
    "value": "var(--ids-colors-color-palette-default)",
    "variable": "var(--ids-colors-color-palette-default)"
  },
  "colors.colorPalette.purpleBlue": {
    "value": "var(--ids-colors-color-palette-purple-blue)",
    "variable": "var(--ids-colors-color-palette-purple-blue)"
  },
  "colors.colorPalette.purpleMagenta": {
    "value": "var(--ids-colors-color-palette-purple-magenta)",
    "variable": "var(--ids-colors-color-palette-purple-magenta)"
  },
  "colors.colorPalette.purpleBlueEnd": {
    "value": "var(--ids-colors-color-palette-purple-blue-end)",
    "variable": "var(--ids-colors-color-palette-purple-blue-end)"
  },
  "colors.colorPalette.blue.light.100": {
    "value": "var(--ids-colors-color-palette-blue-light-100)",
    "variable": "var(--ids-colors-color-palette-blue-light-100)"
  },
  "colors.colorPalette.blue.light.200": {
    "value": "var(--ids-colors-color-palette-blue-light-200)",
    "variable": "var(--ids-colors-color-palette-blue-light-200)"
  },
  "colors.colorPalette.blue.light.300": {
    "value": "var(--ids-colors-color-palette-blue-light-300)",
    "variable": "var(--ids-colors-color-palette-blue-light-300)"
  },
  "colors.colorPalette.blue.light.400": {
    "value": "var(--ids-colors-color-palette-blue-light-400)",
    "variable": "var(--ids-colors-color-palette-blue-light-400)"
  },
  "colors.colorPalette.blue.light.500": {
    "value": "var(--ids-colors-color-palette-blue-light-500)",
    "variable": "var(--ids-colors-color-palette-blue-light-500)"
  },
  "colors.colorPalette.blue.light.600": {
    "value": "var(--ids-colors-color-palette-blue-light-600)",
    "variable": "var(--ids-colors-color-palette-blue-light-600)"
  },
  "colors.colorPalette.blue.light.700": {
    "value": "var(--ids-colors-color-palette-blue-light-700)",
    "variable": "var(--ids-colors-color-palette-blue-light-700)"
  },
  "colors.colorPalette.blue.light.800": {
    "value": "var(--ids-colors-color-palette-blue-light-800)",
    "variable": "var(--ids-colors-color-palette-blue-light-800)"
  },
  "colors.colorPalette.blue.light.900": {
    "value": "var(--ids-colors-color-palette-blue-light-900)",
    "variable": "var(--ids-colors-color-palette-blue-light-900)"
  },
  "colors.colorPalette.blue.light.1000": {
    "value": "var(--ids-colors-color-palette-blue-light-1000)",
    "variable": "var(--ids-colors-color-palette-blue-light-1000)"
  },
  "colors.colorPalette.blue.light.1100": {
    "value": "var(--ids-colors-color-palette-blue-light-1100)",
    "variable": "var(--ids-colors-color-palette-blue-light-1100)"
  },
  "colors.colorPalette.blue.light.1200": {
    "value": "var(--ids-colors-color-palette-blue-light-1200)",
    "variable": "var(--ids-colors-color-palette-blue-light-1200)"
  },
  "colors.colorPalette.blue.light.a100": {
    "value": "var(--ids-colors-color-palette-blue-light-a100)",
    "variable": "var(--ids-colors-color-palette-blue-light-a100)"
  },
  "colors.colorPalette.blue.light.a200": {
    "value": "var(--ids-colors-color-palette-blue-light-a200)",
    "variable": "var(--ids-colors-color-palette-blue-light-a200)"
  },
  "colors.colorPalette.blue.light.a300": {
    "value": "var(--ids-colors-color-palette-blue-light-a300)",
    "variable": "var(--ids-colors-color-palette-blue-light-a300)"
  },
  "colors.colorPalette.green.light.100": {
    "value": "var(--ids-colors-color-palette-green-light-100)",
    "variable": "var(--ids-colors-color-palette-green-light-100)"
  },
  "colors.colorPalette.green.light.200": {
    "value": "var(--ids-colors-color-palette-green-light-200)",
    "variable": "var(--ids-colors-color-palette-green-light-200)"
  },
  "colors.colorPalette.green.light.300": {
    "value": "var(--ids-colors-color-palette-green-light-300)",
    "variable": "var(--ids-colors-color-palette-green-light-300)"
  },
  "colors.colorPalette.green.light.400": {
    "value": "var(--ids-colors-color-palette-green-light-400)",
    "variable": "var(--ids-colors-color-palette-green-light-400)"
  },
  "colors.colorPalette.green.light.500": {
    "value": "var(--ids-colors-color-palette-green-light-500)",
    "variable": "var(--ids-colors-color-palette-green-light-500)"
  },
  "colors.colorPalette.green.light.600": {
    "value": "var(--ids-colors-color-palette-green-light-600)",
    "variable": "var(--ids-colors-color-palette-green-light-600)"
  },
  "colors.colorPalette.green.light.700": {
    "value": "var(--ids-colors-color-palette-green-light-700)",
    "variable": "var(--ids-colors-color-palette-green-light-700)"
  },
  "colors.colorPalette.green.light.800": {
    "value": "var(--ids-colors-color-palette-green-light-800)",
    "variable": "var(--ids-colors-color-palette-green-light-800)"
  },
  "colors.colorPalette.green.light.900": {
    "value": "var(--ids-colors-color-palette-green-light-900)",
    "variable": "var(--ids-colors-color-palette-green-light-900)"
  },
  "colors.colorPalette.green.light.1000": {
    "value": "var(--ids-colors-color-palette-green-light-1000)",
    "variable": "var(--ids-colors-color-palette-green-light-1000)"
  },
  "colors.colorPalette.green.light.1100": {
    "value": "var(--ids-colors-color-palette-green-light-1100)",
    "variable": "var(--ids-colors-color-palette-green-light-1100)"
  },
  "colors.colorPalette.green.light.1200": {
    "value": "var(--ids-colors-color-palette-green-light-1200)",
    "variable": "var(--ids-colors-color-palette-green-light-1200)"
  },
  "colors.colorPalette.green.light.a100": {
    "value": "var(--ids-colors-color-palette-green-light-a100)",
    "variable": "var(--ids-colors-color-palette-green-light-a100)"
  },
  "colors.colorPalette.green.light.a200": {
    "value": "var(--ids-colors-color-palette-green-light-a200)",
    "variable": "var(--ids-colors-color-palette-green-light-a200)"
  },
  "colors.colorPalette.green.light.a300": {
    "value": "var(--ids-colors-color-palette-green-light-a300)",
    "variable": "var(--ids-colors-color-palette-green-light-a300)"
  },
  "colors.colorPalette.orange.light.100": {
    "value": "var(--ids-colors-color-palette-orange-light-100)",
    "variable": "var(--ids-colors-color-palette-orange-light-100)"
  },
  "colors.colorPalette.orange.light.200": {
    "value": "var(--ids-colors-color-palette-orange-light-200)",
    "variable": "var(--ids-colors-color-palette-orange-light-200)"
  },
  "colors.colorPalette.orange.light.300": {
    "value": "var(--ids-colors-color-palette-orange-light-300)",
    "variable": "var(--ids-colors-color-palette-orange-light-300)"
  },
  "colors.colorPalette.orange.light.400": {
    "value": "var(--ids-colors-color-palette-orange-light-400)",
    "variable": "var(--ids-colors-color-palette-orange-light-400)"
  },
  "colors.colorPalette.orange.light.500": {
    "value": "var(--ids-colors-color-palette-orange-light-500)",
    "variable": "var(--ids-colors-color-palette-orange-light-500)"
  },
  "colors.colorPalette.orange.light.600": {
    "value": "var(--ids-colors-color-palette-orange-light-600)",
    "variable": "var(--ids-colors-color-palette-orange-light-600)"
  },
  "colors.colorPalette.orange.light.650": {
    "value": "var(--ids-colors-color-palette-orange-light-650)",
    "variable": "var(--ids-colors-color-palette-orange-light-650)"
  },
  "colors.colorPalette.orange.light.700": {
    "value": "var(--ids-colors-color-palette-orange-light-700)",
    "variable": "var(--ids-colors-color-palette-orange-light-700)"
  },
  "colors.colorPalette.orange.light.800": {
    "value": "var(--ids-colors-color-palette-orange-light-800)",
    "variable": "var(--ids-colors-color-palette-orange-light-800)"
  },
  "colors.colorPalette.orange.light.900": {
    "value": "var(--ids-colors-color-palette-orange-light-900)",
    "variable": "var(--ids-colors-color-palette-orange-light-900)"
  },
  "colors.colorPalette.orange.light.1000": {
    "value": "var(--ids-colors-color-palette-orange-light-1000)",
    "variable": "var(--ids-colors-color-palette-orange-light-1000)"
  },
  "colors.colorPalette.orange.light.1100": {
    "value": "var(--ids-colors-color-palette-orange-light-1100)",
    "variable": "var(--ids-colors-color-palette-orange-light-1100)"
  },
  "colors.colorPalette.orange.light.1200": {
    "value": "var(--ids-colors-color-palette-orange-light-1200)",
    "variable": "var(--ids-colors-color-palette-orange-light-1200)"
  },
  "colors.colorPalette.orange.light.a100": {
    "value": "var(--ids-colors-color-palette-orange-light-a100)",
    "variable": "var(--ids-colors-color-palette-orange-light-a100)"
  },
  "colors.colorPalette.orange.light.a200": {
    "value": "var(--ids-colors-color-palette-orange-light-a200)",
    "variable": "var(--ids-colors-color-palette-orange-light-a200)"
  },
  "colors.colorPalette.orange.light.a300": {
    "value": "var(--ids-colors-color-palette-orange-light-a300)",
    "variable": "var(--ids-colors-color-palette-orange-light-a300)"
  },
  "colors.colorPalette.violet.light.100": {
    "value": "var(--ids-colors-color-palette-violet-light-100)",
    "variable": "var(--ids-colors-color-palette-violet-light-100)"
  },
  "colors.colorPalette.violet.light.200": {
    "value": "var(--ids-colors-color-palette-violet-light-200)",
    "variable": "var(--ids-colors-color-palette-violet-light-200)"
  },
  "colors.colorPalette.violet.light.300": {
    "value": "var(--ids-colors-color-palette-violet-light-300)",
    "variable": "var(--ids-colors-color-palette-violet-light-300)"
  },
  "colors.colorPalette.violet.light.400": {
    "value": "var(--ids-colors-color-palette-violet-light-400)",
    "variable": "var(--ids-colors-color-palette-violet-light-400)"
  },
  "colors.colorPalette.violet.light.500": {
    "value": "var(--ids-colors-color-palette-violet-light-500)",
    "variable": "var(--ids-colors-color-palette-violet-light-500)"
  },
  "colors.colorPalette.violet.light.600": {
    "value": "var(--ids-colors-color-palette-violet-light-600)",
    "variable": "var(--ids-colors-color-palette-violet-light-600)"
  },
  "colors.colorPalette.violet.light.700": {
    "value": "var(--ids-colors-color-palette-violet-light-700)",
    "variable": "var(--ids-colors-color-palette-violet-light-700)"
  },
  "colors.colorPalette.violet.light.800": {
    "value": "var(--ids-colors-color-palette-violet-light-800)",
    "variable": "var(--ids-colors-color-palette-violet-light-800)"
  },
  "colors.colorPalette.violet.light.900": {
    "value": "var(--ids-colors-color-palette-violet-light-900)",
    "variable": "var(--ids-colors-color-palette-violet-light-900)"
  },
  "colors.colorPalette.violet.light.1000": {
    "value": "var(--ids-colors-color-palette-violet-light-1000)",
    "variable": "var(--ids-colors-color-palette-violet-light-1000)"
  },
  "colors.colorPalette.violet.light.1100": {
    "value": "var(--ids-colors-color-palette-violet-light-1100)",
    "variable": "var(--ids-colors-color-palette-violet-light-1100)"
  },
  "colors.colorPalette.violet.light.1200": {
    "value": "var(--ids-colors-color-palette-violet-light-1200)",
    "variable": "var(--ids-colors-color-palette-violet-light-1200)"
  },
  "colors.colorPalette.violet.light.a100": {
    "value": "var(--ids-colors-color-palette-violet-light-a100)",
    "variable": "var(--ids-colors-color-palette-violet-light-a100)"
  },
  "colors.colorPalette.violet.light.a200": {
    "value": "var(--ids-colors-color-palette-violet-light-a200)",
    "variable": "var(--ids-colors-color-palette-violet-light-a200)"
  },
  "colors.colorPalette.violet.light.a300": {
    "value": "var(--ids-colors-color-palette-violet-light-a300)",
    "variable": "var(--ids-colors-color-palette-violet-light-a300)"
  },
  "colors.colorPalette.red.light.100": {
    "value": "var(--ids-colors-color-palette-red-light-100)",
    "variable": "var(--ids-colors-color-palette-red-light-100)"
  },
  "colors.colorPalette.red.light.200": {
    "value": "var(--ids-colors-color-palette-red-light-200)",
    "variable": "var(--ids-colors-color-palette-red-light-200)"
  },
  "colors.colorPalette.red.light.300": {
    "value": "var(--ids-colors-color-palette-red-light-300)",
    "variable": "var(--ids-colors-color-palette-red-light-300)"
  },
  "colors.colorPalette.red.light.400": {
    "value": "var(--ids-colors-color-palette-red-light-400)",
    "variable": "var(--ids-colors-color-palette-red-light-400)"
  },
  "colors.colorPalette.red.light.500": {
    "value": "var(--ids-colors-color-palette-red-light-500)",
    "variable": "var(--ids-colors-color-palette-red-light-500)"
  },
  "colors.colorPalette.red.light.600": {
    "value": "var(--ids-colors-color-palette-red-light-600)",
    "variable": "var(--ids-colors-color-palette-red-light-600)"
  },
  "colors.colorPalette.red.light.700": {
    "value": "var(--ids-colors-color-palette-red-light-700)",
    "variable": "var(--ids-colors-color-palette-red-light-700)"
  },
  "colors.colorPalette.red.light.800": {
    "value": "var(--ids-colors-color-palette-red-light-800)",
    "variable": "var(--ids-colors-color-palette-red-light-800)"
  },
  "colors.colorPalette.red.light.900": {
    "value": "var(--ids-colors-color-palette-red-light-900)",
    "variable": "var(--ids-colors-color-palette-red-light-900)"
  },
  "colors.colorPalette.red.light.1000": {
    "value": "var(--ids-colors-color-palette-red-light-1000)",
    "variable": "var(--ids-colors-color-palette-red-light-1000)"
  },
  "colors.colorPalette.red.light.1100": {
    "value": "var(--ids-colors-color-palette-red-light-1100)",
    "variable": "var(--ids-colors-color-palette-red-light-1100)"
  },
  "colors.colorPalette.red.light.1200": {
    "value": "var(--ids-colors-color-palette-red-light-1200)",
    "variable": "var(--ids-colors-color-palette-red-light-1200)"
  },
  "colors.colorPalette.red.light.a100": {
    "value": "var(--ids-colors-color-palette-red-light-a100)",
    "variable": "var(--ids-colors-color-palette-red-light-a100)"
  },
  "colors.colorPalette.red.light.a200": {
    "value": "var(--ids-colors-color-palette-red-light-a200)",
    "variable": "var(--ids-colors-color-palette-red-light-a200)"
  },
  "colors.colorPalette.red.light.a300": {
    "value": "var(--ids-colors-color-palette-red-light-a300)",
    "variable": "var(--ids-colors-color-palette-red-light-a300)"
  },
  "colors.colorPalette.focusIndicator": {
    "value": "var(--ids-colors-color-palette-focus-indicator)",
    "variable": "var(--ids-colors-color-palette-focus-indicator)"
  },
  "colors.colorPalette.chat.normal": {
    "value": "var(--ids-colors-color-palette-chat-normal)",
    "variable": "var(--ids-colors-color-palette-chat-normal)"
  },
  "colors.colorPalette.normal": {
    "value": "var(--ids-colors-color-palette-normal)",
    "variable": "var(--ids-colors-color-palette-normal)"
  },
  "colors.colorPalette.rating.normal": {
    "value": "var(--ids-colors-color-palette-rating-normal)",
    "variable": "var(--ids-colors-color-palette-rating-normal)"
  },
  "colors.colorPalette.text.inverse": {
    "value": "var(--ids-colors-color-palette-text-inverse)",
    "variable": "var(--ids-colors-color-palette-text-inverse)"
  },
  "colors.colorPalette.inverse": {
    "value": "var(--ids-colors-color-palette-inverse)",
    "variable": "var(--ids-colors-color-palette-inverse)"
  },
  "colors.colorPalette.1": {
    "value": "var(--ids-colors-color-palette-1)",
    "variable": "var(--ids-colors-color-palette-1)"
  },
  "colors.colorPalette.2": {
    "value": "var(--ids-colors-color-palette-2)",
    "variable": "var(--ids-colors-color-palette-2)"
  },
  "colors.colorPalette.3": {
    "value": "var(--ids-colors-color-palette-3)",
    "variable": "var(--ids-colors-color-palette-3)"
  },
  "colors.colorPalette.4": {
    "value": "var(--ids-colors-color-palette-4)",
    "variable": "var(--ids-colors-color-palette-4)"
  },
  "colors.colorPalette.5": {
    "value": "var(--ids-colors-color-palette-5)",
    "variable": "var(--ids-colors-color-palette-5)"
  },
  "colors.colorPalette.6": {
    "value": "var(--ids-colors-color-palette-6)",
    "variable": "var(--ids-colors-color-palette-6)"
  },
  "colors.colorPalette.7": {
    "value": "var(--ids-colors-color-palette-7)",
    "variable": "var(--ids-colors-color-palette-7)"
  },
  "colors.colorPalette.8": {
    "value": "var(--ids-colors-color-palette-8)",
    "variable": "var(--ids-colors-color-palette-8)"
  },
  "colors.colorPalette.9": {
    "value": "var(--ids-colors-color-palette-9)",
    "variable": "var(--ids-colors-color-palette-9)"
  },
  "colors.colorPalette.10": {
    "value": "var(--ids-colors-color-palette-10)",
    "variable": "var(--ids-colors-color-palette-10)"
  },
  "colors.colorPalette.11": {
    "value": "var(--ids-colors-color-palette-11)",
    "variable": "var(--ids-colors-color-palette-11)"
  },
  "colors.colorPalette.12": {
    "value": "var(--ids-colors-color-palette-12)",
    "variable": "var(--ids-colors-color-palette-12)"
  },
  "colors.colorPalette.a1": {
    "value": "var(--ids-colors-color-palette-a1)",
    "variable": "var(--ids-colors-color-palette-a1)"
  },
  "colors.colorPalette.a2": {
    "value": "var(--ids-colors-color-palette-a2)",
    "variable": "var(--ids-colors-color-palette-a2)"
  },
  "colors.colorPalette.a3": {
    "value": "var(--ids-colors-color-palette-a3)",
    "variable": "var(--ids-colors-color-palette-a3)"
  },
  "colors.colorPalette.mediumBg.normal": {
    "value": "var(--ids-colors-color-palette-medium-bg-normal)",
    "variable": "var(--ids-colors-color-palette-medium-bg-normal)"
  },
  "colors.colorPalette.gradient.purpleBlue": {
    "value": "var(--ids-colors-color-palette-gradient-purple-blue)",
    "variable": "var(--ids-colors-color-palette-gradient-purple-blue)"
  },
  "colors.colorPalette.bg.base": {
    "value": "var(--ids-colors-color-palette-bg-base)",
    "variable": "var(--ids-colors-color-palette-bg-base)"
  },
  "colors.colorPalette.base": {
    "value": "var(--ids-colors-color-palette-base)",
    "variable": "var(--ids-colors-color-palette-base)"
  },
  "colors.colorPalette.bg.highest": {
    "value": "var(--ids-colors-color-palette-bg-highest)",
    "variable": "var(--ids-colors-color-palette-bg-highest)"
  },
  "colors.colorPalette.highest": {
    "value": "var(--ids-colors-color-palette-highest)",
    "variable": "var(--ids-colors-color-palette-highest)"
  },
  "colors.colorPalette.bg.low": {
    "value": "var(--ids-colors-color-palette-bg-low)",
    "variable": "var(--ids-colors-color-palette-bg-low)"
  },
  "colors.colorPalette.low": {
    "value": "var(--ids-colors-color-palette-low)",
    "variable": "var(--ids-colors-color-palette-low)"
  },
  "colors.colorPalette.border.base": {
    "value": "var(--ids-colors-color-palette-border-base)",
    "variable": "var(--ids-colors-color-palette-border-base)"
  },
  "colors.colorPalette.border.highest": {
    "value": "var(--ids-colors-color-palette-border-highest)",
    "variable": "var(--ids-colors-color-palette-border-highest)"
  },
  "colors.colorPalette.fg.base": {
    "value": "var(--ids-colors-color-palette-fg-base)",
    "variable": "var(--ids-colors-color-palette-fg-base)"
  },
  "colors.colorPalette.fg.low": {
    "value": "var(--ids-colors-color-palette-fg-low)",
    "variable": "var(--ids-colors-color-palette-fg-low)"
  },
  "colors.colorPalette.ghostBg.base": {
    "value": "var(--ids-colors-color-palette-ghost-bg-base)",
    "variable": "var(--ids-colors-color-palette-ghost-bg-base)"
  },
  "colors.colorPalette.text.base": {
    "value": "var(--ids-colors-color-palette-text-base)",
    "variable": "var(--ids-colors-color-palette-text-base)"
  },
  "colors.colorPalette.bg.high": {
    "value": "var(--ids-colors-color-palette-bg-high)",
    "variable": "var(--ids-colors-color-palette-bg-high)"
  },
  "colors.colorPalette.high": {
    "value": "var(--ids-colors-color-palette-high)",
    "variable": "var(--ids-colors-color-palette-high)"
  },
  "colors.colorPalette.border.high": {
    "value": "var(--ids-colors-color-palette-border-high)",
    "variable": "var(--ids-colors-color-palette-border-high)"
  },
  "colors.colorPalette.border.low": {
    "value": "var(--ids-colors-color-palette-border-low)",
    "variable": "var(--ids-colors-color-palette-border-low)"
  },
  "colors.colorPalette.pink.1": {
    "value": "var(--ids-colors-color-palette-pink-1)",
    "variable": "var(--ids-colors-color-palette-pink-1)"
  },
  "colors.colorPalette.pink.2": {
    "value": "var(--ids-colors-color-palette-pink-2)",
    "variable": "var(--ids-colors-color-palette-pink-2)"
  },
  "colors.colorPalette.pink.3": {
    "value": "var(--ids-colors-color-palette-pink-3)",
    "variable": "var(--ids-colors-color-palette-pink-3)"
  },
  "colors.colorPalette.pink.4": {
    "value": "var(--ids-colors-color-palette-pink-4)",
    "variable": "var(--ids-colors-color-palette-pink-4)"
  },
  "colors.colorPalette.pink.5": {
    "value": "var(--ids-colors-color-palette-pink-5)",
    "variable": "var(--ids-colors-color-palette-pink-5)"
  },
  "colors.colorPalette.pink.6": {
    "value": "var(--ids-colors-color-palette-pink-6)",
    "variable": "var(--ids-colors-color-palette-pink-6)"
  },
  "colors.colorPalette.pink.7": {
    "value": "var(--ids-colors-color-palette-pink-7)",
    "variable": "var(--ids-colors-color-palette-pink-7)"
  },
  "colors.colorPalette.pink.8": {
    "value": "var(--ids-colors-color-palette-pink-8)",
    "variable": "var(--ids-colors-color-palette-pink-8)"
  },
  "colors.colorPalette.pink.9": {
    "value": "var(--ids-colors-color-palette-pink-9)",
    "variable": "var(--ids-colors-color-palette-pink-9)"
  },
  "colors.colorPalette.pink.10": {
    "value": "var(--ids-colors-color-palette-pink-10)",
    "variable": "var(--ids-colors-color-palette-pink-10)"
  },
  "colors.colorPalette.pink.11": {
    "value": "var(--ids-colors-color-palette-pink-11)",
    "variable": "var(--ids-colors-color-palette-pink-11)"
  },
  "colors.colorPalette.pink.12": {
    "value": "var(--ids-colors-color-palette-pink-12)",
    "variable": "var(--ids-colors-color-palette-pink-12)"
  },
  "colors.colorPalette.pink.a1": {
    "value": "var(--ids-colors-color-palette-pink-a1)",
    "variable": "var(--ids-colors-color-palette-pink-a1)"
  },
  "colors.colorPalette.pink.a2": {
    "value": "var(--ids-colors-color-palette-pink-a2)",
    "variable": "var(--ids-colors-color-palette-pink-a2)"
  },
  "colors.colorPalette.pink.a3": {
    "value": "var(--ids-colors-color-palette-pink-a3)",
    "variable": "var(--ids-colors-color-palette-pink-a3)"
  },
  "colors.colorPalette.purple.1": {
    "value": "var(--ids-colors-color-palette-purple-1)",
    "variable": "var(--ids-colors-color-palette-purple-1)"
  },
  "colors.colorPalette.purple.2": {
    "value": "var(--ids-colors-color-palette-purple-2)",
    "variable": "var(--ids-colors-color-palette-purple-2)"
  },
  "colors.colorPalette.purple.3": {
    "value": "var(--ids-colors-color-palette-purple-3)",
    "variable": "var(--ids-colors-color-palette-purple-3)"
  },
  "colors.colorPalette.purple.4": {
    "value": "var(--ids-colors-color-palette-purple-4)",
    "variable": "var(--ids-colors-color-palette-purple-4)"
  },
  "colors.colorPalette.purple.5": {
    "value": "var(--ids-colors-color-palette-purple-5)",
    "variable": "var(--ids-colors-color-palette-purple-5)"
  },
  "colors.colorPalette.purple.6": {
    "value": "var(--ids-colors-color-palette-purple-6)",
    "variable": "var(--ids-colors-color-palette-purple-6)"
  },
  "colors.colorPalette.purple.7": {
    "value": "var(--ids-colors-color-palette-purple-7)",
    "variable": "var(--ids-colors-color-palette-purple-7)"
  },
  "colors.colorPalette.purple.8": {
    "value": "var(--ids-colors-color-palette-purple-8)",
    "variable": "var(--ids-colors-color-palette-purple-8)"
  },
  "colors.colorPalette.purple.9": {
    "value": "var(--ids-colors-color-palette-purple-9)",
    "variable": "var(--ids-colors-color-palette-purple-9)"
  },
  "colors.colorPalette.purple.10": {
    "value": "var(--ids-colors-color-palette-purple-10)",
    "variable": "var(--ids-colors-color-palette-purple-10)"
  },
  "colors.colorPalette.purple.11": {
    "value": "var(--ids-colors-color-palette-purple-11)",
    "variable": "var(--ids-colors-color-palette-purple-11)"
  },
  "colors.colorPalette.purple.12": {
    "value": "var(--ids-colors-color-palette-purple-12)",
    "variable": "var(--ids-colors-color-palette-purple-12)"
  },
  "colors.colorPalette.purple.a1": {
    "value": "var(--ids-colors-color-palette-purple-a1)",
    "variable": "var(--ids-colors-color-palette-purple-a1)"
  },
  "colors.colorPalette.purple.a2": {
    "value": "var(--ids-colors-color-palette-purple-a2)",
    "variable": "var(--ids-colors-color-palette-purple-a2)"
  },
  "colors.colorPalette.purple.a3": {
    "value": "var(--ids-colors-color-palette-purple-a3)",
    "variable": "var(--ids-colors-color-palette-purple-a3)"
  },
  "colors.colorPalette.fg.lower": {
    "value": "var(--ids-colors-color-palette-fg-lower)",
    "variable": "var(--ids-colors-color-palette-fg-lower)"
  },
  "colors.colorPalette.lower": {
    "value": "var(--ids-colors-color-palette-lower)",
    "variable": "var(--ids-colors-color-palette-lower)"
  },
  "colors.colorPalette.fg.lowest": {
    "value": "var(--ids-colors-color-palette-fg-lowest)",
    "variable": "var(--ids-colors-color-palette-fg-lowest)"
  },
  "colors.colorPalette.lowest": {
    "value": "var(--ids-colors-color-palette-lowest)",
    "variable": "var(--ids-colors-color-palette-lowest)"
  },
  "colors.colorPalette.ghostBg.high": {
    "value": "var(--ids-colors-color-palette-ghost-bg-high)",
    "variable": "var(--ids-colors-color-palette-ghost-bg-high)"
  },
  "colors.colorPalette.ghostBg.highest": {
    "value": "var(--ids-colors-color-palette-ghost-bg-highest)",
    "variable": "var(--ids-colors-color-palette-ghost-bg-highest)"
  },
  "colors.colorPalette.surface.base": {
    "value": "var(--ids-colors-color-palette-surface-base)",
    "variable": "var(--ids-colors-color-palette-surface-base)"
  },
  "colors.colorPalette.surface.high": {
    "value": "var(--ids-colors-color-palette-surface-high)",
    "variable": "var(--ids-colors-color-palette-surface-high)"
  },
  "colors.colorPalette.fill.base": {
    "value": "var(--ids-colors-color-palette-fill-base)",
    "variable": "var(--ids-colors-color-palette-fill-base)"
  },
  "colors.colorPalette.icon.base": {
    "value": "var(--ids-colors-color-palette-icon-base)",
    "variable": "var(--ids-colors-color-palette-icon-base)"
  },
  "colors.colorPalette.text.low": {
    "value": "var(--ids-colors-color-palette-text-low)",
    "variable": "var(--ids-colors-color-palette-text-low)"
  },
  "colors.colorPalette.text.lower": {
    "value": "var(--ids-colors-color-palette-text-lower)",
    "variable": "var(--ids-colors-color-palette-text-lower)"
  },
  "colors.colorPalette.text.lowest": {
    "value": "var(--ids-colors-color-palette-text-lowest)",
    "variable": "var(--ids-colors-color-palette-text-lowest)"
  },
  "colors.colorPalette.surface.low": {
    "value": "var(--ids-colors-color-palette-surface-low)",
    "variable": "var(--ids-colors-color-palette-surface-low)"
  },
  "colors.colorPalette.surface.highest": {
    "value": "var(--ids-colors-color-palette-surface-highest)",
    "variable": "var(--ids-colors-color-palette-surface-highest)"
  },
  "colors.colorPalette.surface.transparent": {
    "value": "var(--ids-colors-color-palette-surface-transparent)",
    "variable": "var(--ids-colors-color-palette-surface-transparent)"
  },
  "colors.colorPalette.transparent": {
    "value": "var(--ids-colors-color-palette-transparent)",
    "variable": "var(--ids-colors-color-palette-transparent)"
  },
  "colors.colorPalette.fill.high": {
    "value": "var(--ids-colors-color-palette-fill-high)",
    "variable": "var(--ids-colors-color-palette-fill-high)"
  },
  "colors.colorPalette.icon.low": {
    "value": "var(--ids-colors-color-palette-icon-low)",
    "variable": "var(--ids-colors-color-palette-icon-low)"
  },
  "colors.colorPalette.primary.stop1": {
    "value": "var(--ids-colors-color-palette-primary-stop1)",
    "variable": "var(--ids-colors-color-palette-primary-stop1)"
  },
  "colors.colorPalette.stop1": {
    "value": "var(--ids-colors-color-palette-stop1)",
    "variable": "var(--ids-colors-color-palette-stop1)"
  },
  "colors.colorPalette.primary.stop2": {
    "value": "var(--ids-colors-color-palette-primary-stop2)",
    "variable": "var(--ids-colors-color-palette-primary-stop2)"
  },
  "colors.colorPalette.stop2": {
    "value": "var(--ids-colors-color-palette-stop2)",
    "variable": "var(--ids-colors-color-palette-stop2)"
  },
  "colors.colorPalette.primary.default": {
    "value": "var(--ids-colors-color-palette-primary-default)",
    "variable": "var(--ids-colors-color-palette-primary-default)"
  },
  "colors.colorPalette.primary.horizontal": {
    "value": "var(--ids-colors-color-palette-primary-horizontal)",
    "variable": "var(--ids-colors-color-palette-primary-horizontal)"
  },
  "colors.colorPalette.horizontal": {
    "value": "var(--ids-colors-color-palette-horizontal)",
    "variable": "var(--ids-colors-color-palette-horizontal)"
  },
  "colors.colorPalette.primary.vertical": {
    "value": "var(--ids-colors-color-palette-primary-vertical)",
    "variable": "var(--ids-colors-color-palette-primary-vertical)"
  },
  "colors.colorPalette.vertical": {
    "value": "var(--ids-colors-color-palette-vertical)",
    "variable": "var(--ids-colors-color-palette-vertical)"
  },
  "colors.colorPalette.glow.stop1": {
    "value": "var(--ids-colors-color-palette-glow-stop1)",
    "variable": "var(--ids-colors-color-palette-glow-stop1)"
  },
  "colors.colorPalette.glow.stop2": {
    "value": "var(--ids-colors-color-palette-glow-stop2)",
    "variable": "var(--ids-colors-color-palette-glow-stop2)"
  },
  "colors.colorPalette.secondary.stop1": {
    "value": "var(--ids-colors-color-palette-secondary-stop1)",
    "variable": "var(--ids-colors-color-palette-secondary-stop1)"
  },
  "colors.colorPalette.secondary.stop2": {
    "value": "var(--ids-colors-color-palette-secondary-stop2)",
    "variable": "var(--ids-colors-color-palette-secondary-stop2)"
  },
  "colors.colorPalette.secondary.default": {
    "value": "var(--ids-colors-color-palette-secondary-default)",
    "variable": "var(--ids-colors-color-palette-secondary-default)"
  },
  "colors.colorPalette.tertiary.stop1": {
    "value": "var(--ids-colors-color-palette-tertiary-stop1)",
    "variable": "var(--ids-colors-color-palette-tertiary-stop1)"
  },
  "colors.colorPalette.tertiary.stop2": {
    "value": "var(--ids-colors-color-palette-tertiary-stop2)",
    "variable": "var(--ids-colors-color-palette-tertiary-stop2)"
  },
  "colors.colorPalette.tertiary.default": {
    "value": "var(--ids-colors-color-palette-tertiary-default)",
    "variable": "var(--ids-colors-color-palette-tertiary-default)"
  },
  "colors.colorPalette.dim.stop1": {
    "value": "var(--ids-colors-color-palette-dim-stop1)",
    "variable": "var(--ids-colors-color-palette-dim-stop1)"
  },
  "colors.colorPalette.dim.stop2": {
    "value": "var(--ids-colors-color-palette-dim-stop2)",
    "variable": "var(--ids-colors-color-palette-dim-stop2)"
  },
  "colors.colorPalette.dim.fadeOutLeft": {
    "value": "var(--ids-colors-color-palette-dim-fade-out-left)",
    "variable": "var(--ids-colors-color-palette-dim-fade-out-left)"
  },
  "colors.colorPalette.fadeOutLeft": {
    "value": "var(--ids-colors-color-palette-fade-out-left)",
    "variable": "var(--ids-colors-color-palette-fade-out-left)"
  },
  "colors.colorPalette.dim.fadeOutRight": {
    "value": "var(--ids-colors-color-palette-dim-fade-out-right)",
    "variable": "var(--ids-colors-color-palette-dim-fade-out-right)"
  },
  "colors.colorPalette.fadeOutRight": {
    "value": "var(--ids-colors-color-palette-fade-out-right)",
    "variable": "var(--ids-colors-color-palette-fade-out-right)"
  },
  "colors.colorPalette.dim.fadeOutTop": {
    "value": "var(--ids-colors-color-palette-dim-fade-out-top)",
    "variable": "var(--ids-colors-color-palette-dim-fade-out-top)"
  },
  "colors.colorPalette.fadeOutTop": {
    "value": "var(--ids-colors-color-palette-fade-out-top)",
    "variable": "var(--ids-colors-color-palette-fade-out-top)"
  },
  "colors.colorPalette.dim.fadeOutBottom": {
    "value": "var(--ids-colors-color-palette-dim-fade-out-bottom)",
    "variable": "var(--ids-colors-color-palette-dim-fade-out-bottom)"
  },
  "colors.colorPalette.fadeOutBottom": {
    "value": "var(--ids-colors-color-palette-fade-out-bottom)",
    "variable": "var(--ids-colors-color-palette-fade-out-bottom)"
  },
  "colors.colorPalette.fill.low": {
    "value": "var(--ids-colors-color-palette-fill-low)",
    "variable": "var(--ids-colors-color-palette-fill-low)"
  },
  "colors.colorPalette.filled.bg.default": {
    "value": "var(--ids-colors-color-palette-filled-bg-default)",
    "variable": "var(--ids-colors-color-palette-filled-bg-default)"
  },
  "colors.colorPalette.bg.default": {
    "value": "var(--ids-colors-color-palette-bg-default)",
    "variable": "var(--ids-colors-color-palette-bg-default)"
  },
  "colors.colorPalette.filled.bg.selected": {
    "value": "var(--ids-colors-color-palette-filled-bg-selected)",
    "variable": "var(--ids-colors-color-palette-filled-bg-selected)"
  },
  "colors.colorPalette.bg.selected": {
    "value": "var(--ids-colors-color-palette-bg-selected)",
    "variable": "var(--ids-colors-color-palette-bg-selected)"
  },
  "colors.colorPalette.selected": {
    "value": "var(--ids-colors-color-palette-selected)",
    "variable": "var(--ids-colors-color-palette-selected)"
  },
  "colors.colorPalette.filled.fg.default": {
    "value": "var(--ids-colors-color-palette-filled-fg-default)",
    "variable": "var(--ids-colors-color-palette-filled-fg-default)"
  },
  "colors.colorPalette.fg.default": {
    "value": "var(--ids-colors-color-palette-fg-default)",
    "variable": "var(--ids-colors-color-palette-fg-default)"
  },
  "colors.colorPalette.filled.fg.selected": {
    "value": "var(--ids-colors-color-palette-filled-fg-selected)",
    "variable": "var(--ids-colors-color-palette-filled-fg-selected)"
  },
  "colors.colorPalette.fg.selected": {
    "value": "var(--ids-colors-color-palette-fg-selected)",
    "variable": "var(--ids-colors-color-palette-fg-selected)"
  },
  "colors.colorPalette.filled.text.default": {
    "value": "var(--ids-colors-color-palette-filled-text-default)",
    "variable": "var(--ids-colors-color-palette-filled-text-default)"
  },
  "colors.colorPalette.text.default": {
    "value": "var(--ids-colors-color-palette-text-default)",
    "variable": "var(--ids-colors-color-palette-text-default)"
  },
  "colors.colorPalette.filled.text.selected": {
    "value": "var(--ids-colors-color-palette-filled-text-selected)",
    "variable": "var(--ids-colors-color-palette-filled-text-selected)"
  },
  "colors.colorPalette.text.selected": {
    "value": "var(--ids-colors-color-palette-text-selected)",
    "variable": "var(--ids-colors-color-palette-text-selected)"
  },
  "colors.colorPalette.outlined.bg.default": {
    "value": "var(--ids-colors-color-palette-outlined-bg-default)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-default)"
  },
  "colors.colorPalette.outlined.bg.selected": {
    "value": "var(--ids-colors-color-palette-outlined-bg-selected)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-selected)"
  },
  "colors.colorPalette.outlined.border.default": {
    "value": "var(--ids-colors-color-palette-outlined-border-default)",
    "variable": "var(--ids-colors-color-palette-outlined-border-default)"
  },
  "colors.colorPalette.border.default": {
    "value": "var(--ids-colors-color-palette-border-default)",
    "variable": "var(--ids-colors-color-palette-border-default)"
  },
  "colors.colorPalette.outlined.border.selected": {
    "value": "var(--ids-colors-color-palette-outlined-border-selected)",
    "variable": "var(--ids-colors-color-palette-outlined-border-selected)"
  },
  "colors.colorPalette.border.selected": {
    "value": "var(--ids-colors-color-palette-border-selected)",
    "variable": "var(--ids-colors-color-palette-border-selected)"
  },
  "colors.colorPalette.outlined.fg.default": {
    "value": "var(--ids-colors-color-palette-outlined-fg-default)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-default)"
  },
  "colors.colorPalette.outlined.fg.selected": {
    "value": "var(--ids-colors-color-palette-outlined-fg-selected)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-selected)"
  },
  "colors.colorPalette.outlined.text.default": {
    "value": "var(--ids-colors-color-palette-outlined-text-default)",
    "variable": "var(--ids-colors-color-palette-outlined-text-default)"
  },
  "colors.colorPalette.outlined.text.selected": {
    "value": "var(--ids-colors-color-palette-outlined-text-selected)",
    "variable": "var(--ids-colors-color-palette-outlined-text-selected)"
  },
  "colors.colorPalette.subtle.bg.default": {
    "value": "var(--ids-colors-color-palette-subtle-bg-default)",
    "variable": "var(--ids-colors-color-palette-subtle-bg-default)"
  },
  "colors.colorPalette.subtle.bg.selected": {
    "value": "var(--ids-colors-color-palette-subtle-bg-selected)",
    "variable": "var(--ids-colors-color-palette-subtle-bg-selected)"
  },
  "colors.colorPalette.subtle.border.default": {
    "value": "var(--ids-colors-color-palette-subtle-border-default)",
    "variable": "var(--ids-colors-color-palette-subtle-border-default)"
  },
  "colors.colorPalette.subtle.border.selected": {
    "value": "var(--ids-colors-color-palette-subtle-border-selected)",
    "variable": "var(--ids-colors-color-palette-subtle-border-selected)"
  },
  "colors.colorPalette.subtle.fg.default": {
    "value": "var(--ids-colors-color-palette-subtle-fg-default)",
    "variable": "var(--ids-colors-color-palette-subtle-fg-default)"
  },
  "colors.colorPalette.subtle.fg.selected": {
    "value": "var(--ids-colors-color-palette-subtle-fg-selected)",
    "variable": "var(--ids-colors-color-palette-subtle-fg-selected)"
  },
  "colors.colorPalette.subtle.text.default": {
    "value": "var(--ids-colors-color-palette-subtle-text-default)",
    "variable": "var(--ids-colors-color-palette-subtle-text-default)"
  },
  "colors.colorPalette.subtle.text.selected": {
    "value": "var(--ids-colors-color-palette-subtle-text-selected)",
    "variable": "var(--ids-colors-color-palette-subtle-text-selected)"
  },
  "colors.colorPalette.impact.fg.default": {
    "value": "var(--ids-colors-color-palette-impact-fg-default)",
    "variable": "var(--ids-colors-color-palette-impact-fg-default)"
  },
  "colors.colorPalette.impact.text.default": {
    "value": "var(--ids-colors-color-palette-impact-text-default)",
    "variable": "var(--ids-colors-color-palette-impact-text-default)"
  },
  "colors.colorPalette.surface.bg": {
    "value": "var(--ids-colors-color-palette-surface-bg)",
    "variable": "var(--ids-colors-color-palette-surface-bg)"
  },
  "colors.colorPalette.bg": {
    "value": "var(--ids-colors-color-palette-bg)",
    "variable": "var(--ids-colors-color-palette-bg)"
  },
  "colors.colorPalette.surface.border": {
    "value": "var(--ids-colors-color-palette-surface-border)",
    "variable": "var(--ids-colors-color-palette-surface-border)"
  },
  "colors.colorPalette.border": {
    "value": "var(--ids-colors-color-palette-border)",
    "variable": "var(--ids-colors-color-palette-border)"
  },
  "colors.colorPalette.fill.bg.brand": {
    "value": "var(--ids-colors-color-palette-fill-bg-brand)",
    "variable": "var(--ids-colors-color-palette-fill-bg-brand)"
  },
  "colors.colorPalette.bg.brand": {
    "value": "var(--ids-colors-color-palette-bg-brand)",
    "variable": "var(--ids-colors-color-palette-bg-brand)"
  },
  "colors.colorPalette.brand": {
    "value": "var(--ids-colors-color-palette-brand)",
    "variable": "var(--ids-colors-color-palette-brand)"
  },
  "colors.colorPalette.fill.bg.neutral": {
    "value": "var(--ids-colors-color-palette-fill-bg-neutral)",
    "variable": "var(--ids-colors-color-palette-fill-bg-neutral)"
  },
  "colors.colorPalette.bg.neutral": {
    "value": "var(--ids-colors-color-palette-bg-neutral)",
    "variable": "var(--ids-colors-color-palette-bg-neutral)"
  },
  "colors.colorPalette.neutral": {
    "value": "var(--ids-colors-color-palette-neutral)",
    "variable": "var(--ids-colors-color-palette-neutral)"
  },
  "colors.colorPalette.fill.bg.green": {
    "value": "var(--ids-colors-color-palette-fill-bg-green)",
    "variable": "var(--ids-colors-color-palette-fill-bg-green)"
  },
  "colors.colorPalette.bg.green": {
    "value": "var(--ids-colors-color-palette-bg-green)",
    "variable": "var(--ids-colors-color-palette-bg-green)"
  },
  "colors.colorPalette.green": {
    "value": "var(--ids-colors-color-palette-green)",
    "variable": "var(--ids-colors-color-palette-green)"
  },
  "colors.colorPalette.fill.bg.orange": {
    "value": "var(--ids-colors-color-palette-fill-bg-orange)",
    "variable": "var(--ids-colors-color-palette-fill-bg-orange)"
  },
  "colors.colorPalette.bg.orange": {
    "value": "var(--ids-colors-color-palette-bg-orange)",
    "variable": "var(--ids-colors-color-palette-bg-orange)"
  },
  "colors.colorPalette.orange": {
    "value": "var(--ids-colors-color-palette-orange)",
    "variable": "var(--ids-colors-color-palette-orange)"
  },
  "colors.colorPalette.fill.bg.blue": {
    "value": "var(--ids-colors-color-palette-fill-bg-blue)",
    "variable": "var(--ids-colors-color-palette-fill-bg-blue)"
  },
  "colors.colorPalette.bg.blue": {
    "value": "var(--ids-colors-color-palette-bg-blue)",
    "variable": "var(--ids-colors-color-palette-bg-blue)"
  },
  "colors.colorPalette.blue": {
    "value": "var(--ids-colors-color-palette-blue)",
    "variable": "var(--ids-colors-color-palette-blue)"
  },
  "colors.colorPalette.fill.bg.red": {
    "value": "var(--ids-colors-color-palette-fill-bg-red)",
    "variable": "var(--ids-colors-color-palette-fill-bg-red)"
  },
  "colors.colorPalette.bg.red": {
    "value": "var(--ids-colors-color-palette-bg-red)",
    "variable": "var(--ids-colors-color-palette-bg-red)"
  },
  "colors.colorPalette.red": {
    "value": "var(--ids-colors-color-palette-red)",
    "variable": "var(--ids-colors-color-palette-red)"
  },
  "colors.colorPalette.fill.fg.default": {
    "value": "var(--ids-colors-color-palette-fill-fg-default)",
    "variable": "var(--ids-colors-color-palette-fill-fg-default)"
  },
  "colors.colorPalette.fill.fg.icon": {
    "value": "var(--ids-colors-color-palette-fill-fg-icon)",
    "variable": "var(--ids-colors-color-palette-fill-fg-icon)"
  },
  "colors.colorPalette.fg.icon": {
    "value": "var(--ids-colors-color-palette-fg-icon)",
    "variable": "var(--ids-colors-color-palette-fg-icon)"
  },
  "colors.colorPalette.icon": {
    "value": "var(--ids-colors-color-palette-icon)",
    "variable": "var(--ids-colors-color-palette-icon)"
  },
  "colors.colorPalette.fill.fg.text": {
    "value": "var(--ids-colors-color-palette-fill-fg-text)",
    "variable": "var(--ids-colors-color-palette-fill-fg-text)"
  },
  "colors.colorPalette.fg.text": {
    "value": "var(--ids-colors-color-palette-fg-text)",
    "variable": "var(--ids-colors-color-palette-fg-text)"
  },
  "colors.colorPalette.text": {
    "value": "var(--ids-colors-color-palette-text)",
    "variable": "var(--ids-colors-color-palette-text)"
  },
  "colors.colorPalette.fill.fg.orange": {
    "value": "var(--ids-colors-color-palette-fill-fg-orange)",
    "variable": "var(--ids-colors-color-palette-fill-fg-orange)"
  },
  "colors.colorPalette.fg.orange": {
    "value": "var(--ids-colors-color-palette-fg-orange)",
    "variable": "var(--ids-colors-color-palette-fg-orange)"
  },
  "colors.colorPalette.outlined.bg.brand": {
    "value": "var(--ids-colors-color-palette-outlined-bg-brand)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-brand)"
  },
  "colors.colorPalette.outlined.bg.neutral": {
    "value": "var(--ids-colors-color-palette-outlined-bg-neutral)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-neutral)"
  },
  "colors.colorPalette.outlined.bg.green": {
    "value": "var(--ids-colors-color-palette-outlined-bg-green)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-green)"
  },
  "colors.colorPalette.outlined.bg.orange": {
    "value": "var(--ids-colors-color-palette-outlined-bg-orange)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-orange)"
  },
  "colors.colorPalette.outlined.bg.blue": {
    "value": "var(--ids-colors-color-palette-outlined-bg-blue)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-blue)"
  },
  "colors.colorPalette.outlined.bg.red": {
    "value": "var(--ids-colors-color-palette-outlined-bg-red)",
    "variable": "var(--ids-colors-color-palette-outlined-bg-red)"
  },
  "colors.colorPalette.outlined.border.brand": {
    "value": "var(--ids-colors-color-palette-outlined-border-brand)",
    "variable": "var(--ids-colors-color-palette-outlined-border-brand)"
  },
  "colors.colorPalette.border.brand": {
    "value": "var(--ids-colors-color-palette-border-brand)",
    "variable": "var(--ids-colors-color-palette-border-brand)"
  },
  "colors.colorPalette.outlined.border.neutral": {
    "value": "var(--ids-colors-color-palette-outlined-border-neutral)",
    "variable": "var(--ids-colors-color-palette-outlined-border-neutral)"
  },
  "colors.colorPalette.border.neutral": {
    "value": "var(--ids-colors-color-palette-border-neutral)",
    "variable": "var(--ids-colors-color-palette-border-neutral)"
  },
  "colors.colorPalette.outlined.border.green": {
    "value": "var(--ids-colors-color-palette-outlined-border-green)",
    "variable": "var(--ids-colors-color-palette-outlined-border-green)"
  },
  "colors.colorPalette.border.green": {
    "value": "var(--ids-colors-color-palette-border-green)",
    "variable": "var(--ids-colors-color-palette-border-green)"
  },
  "colors.colorPalette.outlined.border.orange": {
    "value": "var(--ids-colors-color-palette-outlined-border-orange)",
    "variable": "var(--ids-colors-color-palette-outlined-border-orange)"
  },
  "colors.colorPalette.border.orange": {
    "value": "var(--ids-colors-color-palette-border-orange)",
    "variable": "var(--ids-colors-color-palette-border-orange)"
  },
  "colors.colorPalette.outlined.border.blue": {
    "value": "var(--ids-colors-color-palette-outlined-border-blue)",
    "variable": "var(--ids-colors-color-palette-outlined-border-blue)"
  },
  "colors.colorPalette.border.blue": {
    "value": "var(--ids-colors-color-palette-border-blue)",
    "variable": "var(--ids-colors-color-palette-border-blue)"
  },
  "colors.colorPalette.outlined.border.red": {
    "value": "var(--ids-colors-color-palette-outlined-border-red)",
    "variable": "var(--ids-colors-color-palette-outlined-border-red)"
  },
  "colors.colorPalette.border.red": {
    "value": "var(--ids-colors-color-palette-border-red)",
    "variable": "var(--ids-colors-color-palette-border-red)"
  },
  "colors.colorPalette.outlined.fg.brand": {
    "value": "var(--ids-colors-color-palette-outlined-fg-brand)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-brand)"
  },
  "colors.colorPalette.fg.brand": {
    "value": "var(--ids-colors-color-palette-fg-brand)",
    "variable": "var(--ids-colors-color-palette-fg-brand)"
  },
  "colors.colorPalette.outlined.fg.neutral": {
    "value": "var(--ids-colors-color-palette-outlined-fg-neutral)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-neutral)"
  },
  "colors.colorPalette.fg.neutral": {
    "value": "var(--ids-colors-color-palette-fg-neutral)",
    "variable": "var(--ids-colors-color-palette-fg-neutral)"
  },
  "colors.colorPalette.outlined.fg.green": {
    "value": "var(--ids-colors-color-palette-outlined-fg-green)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-green)"
  },
  "colors.colorPalette.fg.green": {
    "value": "var(--ids-colors-color-palette-fg-green)",
    "variable": "var(--ids-colors-color-palette-fg-green)"
  },
  "colors.colorPalette.outlined.fg.orange": {
    "value": "var(--ids-colors-color-palette-outlined-fg-orange)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-orange)"
  },
  "colors.colorPalette.outlined.fg.blue": {
    "value": "var(--ids-colors-color-palette-outlined-fg-blue)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-blue)"
  },
  "colors.colorPalette.fg.blue": {
    "value": "var(--ids-colors-color-palette-fg-blue)",
    "variable": "var(--ids-colors-color-palette-fg-blue)"
  },
  "colors.colorPalette.outlined.fg.red": {
    "value": "var(--ids-colors-color-palette-outlined-fg-red)",
    "variable": "var(--ids-colors-color-palette-outlined-fg-red)"
  },
  "colors.colorPalette.fg.red": {
    "value": "var(--ids-colors-color-palette-fg-red)",
    "variable": "var(--ids-colors-color-palette-fg-red)"
  },
  "colors.colorPalette.outlined.text.brand": {
    "value": "var(--ids-colors-color-palette-outlined-text-brand)",
    "variable": "var(--ids-colors-color-palette-outlined-text-brand)"
  },
  "colors.colorPalette.text.brand": {
    "value": "var(--ids-colors-color-palette-text-brand)",
    "variable": "var(--ids-colors-color-palette-text-brand)"
  },
  "colors.colorPalette.outlined.text.neutral": {
    "value": "var(--ids-colors-color-palette-outlined-text-neutral)",
    "variable": "var(--ids-colors-color-palette-outlined-text-neutral)"
  },
  "colors.colorPalette.text.neutral": {
    "value": "var(--ids-colors-color-palette-text-neutral)",
    "variable": "var(--ids-colors-color-palette-text-neutral)"
  },
  "colors.colorPalette.outlined.text.green": {
    "value": "var(--ids-colors-color-palette-outlined-text-green)",
    "variable": "var(--ids-colors-color-palette-outlined-text-green)"
  },
  "colors.colorPalette.text.green": {
    "value": "var(--ids-colors-color-palette-text-green)",
    "variable": "var(--ids-colors-color-palette-text-green)"
  },
  "colors.colorPalette.outlined.text.orange": {
    "value": "var(--ids-colors-color-palette-outlined-text-orange)",
    "variable": "var(--ids-colors-color-palette-outlined-text-orange)"
  },
  "colors.colorPalette.text.orange": {
    "value": "var(--ids-colors-color-palette-text-orange)",
    "variable": "var(--ids-colors-color-palette-text-orange)"
  },
  "colors.colorPalette.outlined.text.blue": {
    "value": "var(--ids-colors-color-palette-outlined-text-blue)",
    "variable": "var(--ids-colors-color-palette-outlined-text-blue)"
  },
  "colors.colorPalette.text.blue": {
    "value": "var(--ids-colors-color-palette-text-blue)",
    "variable": "var(--ids-colors-color-palette-text-blue)"
  },
  "colors.colorPalette.outlined.text.red": {
    "value": "var(--ids-colors-color-palette-outlined-text-red)",
    "variable": "var(--ids-colors-color-palette-outlined-text-red)"
  },
  "colors.colorPalette.text.red": {
    "value": "var(--ids-colors-color-palette-text-red)",
    "variable": "var(--ids-colors-color-palette-text-red)"
  },
  "colors.colorPalette.text.bg.brand": {
    "value": "var(--ids-colors-color-palette-text-bg-brand)",
    "variable": "var(--ids-colors-color-palette-text-bg-brand)"
  },
  "colors.colorPalette.text.bg.neutral": {
    "value": "var(--ids-colors-color-palette-text-bg-neutral)",
    "variable": "var(--ids-colors-color-palette-text-bg-neutral)"
  },
  "colors.colorPalette.text.bg.green": {
    "value": "var(--ids-colors-color-palette-text-bg-green)",
    "variable": "var(--ids-colors-color-palette-text-bg-green)"
  },
  "colors.colorPalette.text.bg.orange": {
    "value": "var(--ids-colors-color-palette-text-bg-orange)",
    "variable": "var(--ids-colors-color-palette-text-bg-orange)"
  },
  "colors.colorPalette.text.bg.blue": {
    "value": "var(--ids-colors-color-palette-text-bg-blue)",
    "variable": "var(--ids-colors-color-palette-text-bg-blue)"
  },
  "colors.colorPalette.text.bg.red": {
    "value": "var(--ids-colors-color-palette-text-bg-red)",
    "variable": "var(--ids-colors-color-palette-text-bg-red)"
  },
  "colors.colorPalette.text.fg.brand": {
    "value": "var(--ids-colors-color-palette-text-fg-brand)",
    "variable": "var(--ids-colors-color-palette-text-fg-brand)"
  },
  "colors.colorPalette.text.fg.neutral": {
    "value": "var(--ids-colors-color-palette-text-fg-neutral)",
    "variable": "var(--ids-colors-color-palette-text-fg-neutral)"
  },
  "colors.colorPalette.text.fg.green": {
    "value": "var(--ids-colors-color-palette-text-fg-green)",
    "variable": "var(--ids-colors-color-palette-text-fg-green)"
  },
  "colors.colorPalette.text.fg.orange": {
    "value": "var(--ids-colors-color-palette-text-fg-orange)",
    "variable": "var(--ids-colors-color-palette-text-fg-orange)"
  },
  "colors.colorPalette.text.fg.blue": {
    "value": "var(--ids-colors-color-palette-text-fg-blue)",
    "variable": "var(--ids-colors-color-palette-text-fg-blue)"
  },
  "colors.colorPalette.text.fg.red": {
    "value": "var(--ids-colors-color-palette-text-fg-red)",
    "variable": "var(--ids-colors-color-palette-text-fg-red)"
  },
  "colors.colorPalette.text.text.brand": {
    "value": "var(--ids-colors-color-palette-text-text-brand)",
    "variable": "var(--ids-colors-color-palette-text-text-brand)"
  },
  "colors.colorPalette.text.text.neutral": {
    "value": "var(--ids-colors-color-palette-text-text-neutral)",
    "variable": "var(--ids-colors-color-palette-text-text-neutral)"
  },
  "colors.colorPalette.text.text.green": {
    "value": "var(--ids-colors-color-palette-text-text-green)",
    "variable": "var(--ids-colors-color-palette-text-text-green)"
  },
  "colors.colorPalette.text.text.orange": {
    "value": "var(--ids-colors-color-palette-text-text-orange)",
    "variable": "var(--ids-colors-color-palette-text-text-orange)"
  },
  "colors.colorPalette.text.text.blue": {
    "value": "var(--ids-colors-color-palette-text-text-blue)",
    "variable": "var(--ids-colors-color-palette-text-text-blue)"
  },
  "colors.colorPalette.text.text.red": {
    "value": "var(--ids-colors-color-palette-text-text-red)",
    "variable": "var(--ids-colors-color-palette-text-text-red)"
  },
  "colors.colorPalette.transparency.text.brand": {
    "value": "var(--ids-colors-color-palette-transparency-text-brand)",
    "variable": "var(--ids-colors-color-palette-transparency-text-brand)"
  },
  "colors.colorPalette.transparency.text.neutral": {
    "value": "var(--ids-colors-color-palette-transparency-text-neutral)",
    "variable": "var(--ids-colors-color-palette-transparency-text-neutral)"
  },
  "colors.colorPalette.transparency.text.green": {
    "value": "var(--ids-colors-color-palette-transparency-text-green)",
    "variable": "var(--ids-colors-color-palette-transparency-text-green)"
  },
  "colors.colorPalette.transparency.text.orange": {
    "value": "var(--ids-colors-color-palette-transparency-text-orange)",
    "variable": "var(--ids-colors-color-palette-transparency-text-orange)"
  },
  "colors.colorPalette.transparency.text.blue": {
    "value": "var(--ids-colors-color-palette-transparency-text-blue)",
    "variable": "var(--ids-colors-color-palette-transparency-text-blue)"
  },
  "colors.colorPalette.transparency.text.red": {
    "value": "var(--ids-colors-color-palette-transparency-text-red)",
    "variable": "var(--ids-colors-color-palette-transparency-text-red)"
  },
  "colors.colorPalette.transparency.icon.brand": {
    "value": "var(--ids-colors-color-palette-transparency-icon-brand)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-brand)"
  },
  "colors.colorPalette.icon.brand": {
    "value": "var(--ids-colors-color-palette-icon-brand)",
    "variable": "var(--ids-colors-color-palette-icon-brand)"
  },
  "colors.colorPalette.transparency.icon.neutral": {
    "value": "var(--ids-colors-color-palette-transparency-icon-neutral)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-neutral)"
  },
  "colors.colorPalette.icon.neutral": {
    "value": "var(--ids-colors-color-palette-icon-neutral)",
    "variable": "var(--ids-colors-color-palette-icon-neutral)"
  },
  "colors.colorPalette.transparency.icon.green": {
    "value": "var(--ids-colors-color-palette-transparency-icon-green)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-green)"
  },
  "colors.colorPalette.icon.green": {
    "value": "var(--ids-colors-color-palette-icon-green)",
    "variable": "var(--ids-colors-color-palette-icon-green)"
  },
  "colors.colorPalette.transparency.icon.orange": {
    "value": "var(--ids-colors-color-palette-transparency-icon-orange)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-orange)"
  },
  "colors.colorPalette.icon.orange": {
    "value": "var(--ids-colors-color-palette-icon-orange)",
    "variable": "var(--ids-colors-color-palette-icon-orange)"
  },
  "colors.colorPalette.transparency.icon.blue": {
    "value": "var(--ids-colors-color-palette-transparency-icon-blue)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-blue)"
  },
  "colors.colorPalette.icon.blue": {
    "value": "var(--ids-colors-color-palette-icon-blue)",
    "variable": "var(--ids-colors-color-palette-icon-blue)"
  },
  "colors.colorPalette.transparency.icon.red": {
    "value": "var(--ids-colors-color-palette-transparency-icon-red)",
    "variable": "var(--ids-colors-color-palette-transparency-icon-red)"
  },
  "colors.colorPalette.icon.red": {
    "value": "var(--ids-colors-color-palette-icon-red)",
    "variable": "var(--ids-colors-color-palette-icon-red)"
  },
  "colors.colorPalette.track.default": {
    "value": "var(--ids-colors-color-palette-track-default)",
    "variable": "var(--ids-colors-color-palette-track-default)"
  },
  "colors.colorPalette.indicator.brand.bg": {
    "value": "var(--ids-colors-color-palette-indicator-brand-bg)",
    "variable": "var(--ids-colors-color-palette-indicator-brand-bg)"
  },
  "colors.colorPalette.brand.bg": {
    "value": "var(--ids-colors-color-palette-brand-bg)",
    "variable": "var(--ids-colors-color-palette-brand-bg)"
  },
  "colors.colorPalette.indicator.brand.border": {
    "value": "var(--ids-colors-color-palette-indicator-brand-border)",
    "variable": "var(--ids-colors-color-palette-indicator-brand-border)"
  },
  "colors.colorPalette.brand.border": {
    "value": "var(--ids-colors-color-palette-brand-border)",
    "variable": "var(--ids-colors-color-palette-brand-border)"
  },
  "colors.colorPalette.indicator.green.bg": {
    "value": "var(--ids-colors-color-palette-indicator-green-bg)",
    "variable": "var(--ids-colors-color-palette-indicator-green-bg)"
  },
  "colors.colorPalette.green.bg": {
    "value": "var(--ids-colors-color-palette-green-bg)",
    "variable": "var(--ids-colors-color-palette-green-bg)"
  },
  "colors.colorPalette.indicator.green.border": {
    "value": "var(--ids-colors-color-palette-indicator-green-border)",
    "variable": "var(--ids-colors-color-palette-indicator-green-border)"
  },
  "colors.colorPalette.green.border": {
    "value": "var(--ids-colors-color-palette-green-border)",
    "variable": "var(--ids-colors-color-palette-green-border)"
  },
  "colors.colorPalette.indicator.orange.bg": {
    "value": "var(--ids-colors-color-palette-indicator-orange-bg)",
    "variable": "var(--ids-colors-color-palette-indicator-orange-bg)"
  },
  "colors.colorPalette.orange.bg": {
    "value": "var(--ids-colors-color-palette-orange-bg)",
    "variable": "var(--ids-colors-color-palette-orange-bg)"
  },
  "colors.colorPalette.indicator.orange.border": {
    "value": "var(--ids-colors-color-palette-indicator-orange-border)",
    "variable": "var(--ids-colors-color-palette-indicator-orange-border)"
  },
  "colors.colorPalette.orange.border": {
    "value": "var(--ids-colors-color-palette-orange-border)",
    "variable": "var(--ids-colors-color-palette-orange-border)"
  },
  "colors.colorPalette.list.border": {
    "value": "var(--ids-colors-color-palette-list-border)",
    "variable": "var(--ids-colors-color-palette-list-border)"
  },
  "colors.colorPalette.thumb.default": {
    "value": "var(--ids-colors-color-palette-thumb-default)",
    "variable": "var(--ids-colors-color-palette-thumb-default)"
  },
  "colors.colorPalette.trigger.default": {
    "value": "var(--ids-colors-color-palette-trigger-default)",
    "variable": "var(--ids-colors-color-palette-trigger-default)"
  },
  "colors.colorPalette.trigger.hover": {
    "value": "var(--ids-colors-color-palette-trigger-hover)",
    "variable": "var(--ids-colors-color-palette-trigger-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--ids-colors-color-palette-hover)",
    "variable": "var(--ids-colors-color-palette-hover)"
  },
  "colors.colorPalette.trigger.selected": {
    "value": "var(--ids-colors-color-palette-trigger-selected)",
    "variable": "var(--ids-colors-color-palette-trigger-selected)"
  },
  "colors.colorPalette.dismiss": {
    "value": "var(--ids-colors-color-palette-dismiss)",
    "variable": "var(--ids-colors-color-palette-dismiss)"
  },
  "colors.colorPalette.container.bg.default": {
    "value": "var(--ids-colors-color-palette-container-bg-default)",
    "variable": "var(--ids-colors-color-palette-container-bg-default)"
  },
  "colors.colorPalette.container.bg.disabled": {
    "value": "var(--ids-colors-color-palette-container-bg-disabled)",
    "variable": "var(--ids-colors-color-palette-container-bg-disabled)"
  },
  "colors.colorPalette.bg.disabled": {
    "value": "var(--ids-colors-color-palette-bg-disabled)",
    "variable": "var(--ids-colors-color-palette-bg-disabled)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--ids-colors-color-palette-disabled)",
    "variable": "var(--ids-colors-color-palette-disabled)"
  },
  "colors.colorPalette.container.bg.errorDisabled": {
    "value": "var(--ids-colors-color-palette-container-bg-error-disabled)",
    "variable": "var(--ids-colors-color-palette-container-bg-error-disabled)"
  },
  "colors.colorPalette.bg.errorDisabled": {
    "value": "var(--ids-colors-color-palette-bg-error-disabled)",
    "variable": "var(--ids-colors-color-palette-bg-error-disabled)"
  },
  "colors.colorPalette.errorDisabled": {
    "value": "var(--ids-colors-color-palette-error-disabled)",
    "variable": "var(--ids-colors-color-palette-error-disabled)"
  },
  "colors.colorPalette.container.bg.warningDisabled": {
    "value": "var(--ids-colors-color-palette-container-bg-warning-disabled)",
    "variable": "var(--ids-colors-color-palette-container-bg-warning-disabled)"
  },
  "colors.colorPalette.bg.warningDisabled": {
    "value": "var(--ids-colors-color-palette-bg-warning-disabled)",
    "variable": "var(--ids-colors-color-palette-bg-warning-disabled)"
  },
  "colors.colorPalette.warningDisabled": {
    "value": "var(--ids-colors-color-palette-warning-disabled)",
    "variable": "var(--ids-colors-color-palette-warning-disabled)"
  },
  "colors.colorPalette.container.bg.successDisabled": {
    "value": "var(--ids-colors-color-palette-container-bg-success-disabled)",
    "variable": "var(--ids-colors-color-palette-container-bg-success-disabled)"
  },
  "colors.colorPalette.bg.successDisabled": {
    "value": "var(--ids-colors-color-palette-bg-success-disabled)",
    "variable": "var(--ids-colors-color-palette-bg-success-disabled)"
  },
  "colors.colorPalette.successDisabled": {
    "value": "var(--ids-colors-color-palette-success-disabled)",
    "variable": "var(--ids-colors-color-palette-success-disabled)"
  },
  "colors.colorPalette.container.border.default": {
    "value": "var(--ids-colors-color-palette-container-border-default)",
    "variable": "var(--ids-colors-color-palette-container-border-default)"
  },
  "colors.colorPalette.container.border.hover": {
    "value": "var(--ids-colors-color-palette-container-border-hover)",
    "variable": "var(--ids-colors-color-palette-container-border-hover)"
  },
  "colors.colorPalette.border.hover": {
    "value": "var(--ids-colors-color-palette-border-hover)",
    "variable": "var(--ids-colors-color-palette-border-hover)"
  },
  "colors.colorPalette.container.border.focus": {
    "value": "var(--ids-colors-color-palette-container-border-focus)",
    "variable": "var(--ids-colors-color-palette-container-border-focus)"
  },
  "colors.colorPalette.border.focus": {
    "value": "var(--ids-colors-color-palette-border-focus)",
    "variable": "var(--ids-colors-color-palette-border-focus)"
  },
  "colors.colorPalette.focus": {
    "value": "var(--ids-colors-color-palette-focus)",
    "variable": "var(--ids-colors-color-palette-focus)"
  },
  "colors.colorPalette.container.border.error": {
    "value": "var(--ids-colors-color-palette-container-border-error)",
    "variable": "var(--ids-colors-color-palette-container-border-error)"
  },
  "colors.colorPalette.border.error": {
    "value": "var(--ids-colors-color-palette-border-error)",
    "variable": "var(--ids-colors-color-palette-border-error)"
  },
  "colors.colorPalette.error": {
    "value": "var(--ids-colors-color-palette-error)",
    "variable": "var(--ids-colors-color-palette-error)"
  },
  "colors.colorPalette.container.border.errorHover": {
    "value": "var(--ids-colors-color-palette-container-border-error-hover)",
    "variable": "var(--ids-colors-color-palette-container-border-error-hover)"
  },
  "colors.colorPalette.border.errorHover": {
    "value": "var(--ids-colors-color-palette-border-error-hover)",
    "variable": "var(--ids-colors-color-palette-border-error-hover)"
  },
  "colors.colorPalette.errorHover": {
    "value": "var(--ids-colors-color-palette-error-hover)",
    "variable": "var(--ids-colors-color-palette-error-hover)"
  },
  "colors.colorPalette.container.border.errorFocus": {
    "value": "var(--ids-colors-color-palette-container-border-error-focus)",
    "variable": "var(--ids-colors-color-palette-container-border-error-focus)"
  },
  "colors.colorPalette.border.errorFocus": {
    "value": "var(--ids-colors-color-palette-border-error-focus)",
    "variable": "var(--ids-colors-color-palette-border-error-focus)"
  },
  "colors.colorPalette.errorFocus": {
    "value": "var(--ids-colors-color-palette-error-focus)",
    "variable": "var(--ids-colors-color-palette-error-focus)"
  },
  "colors.colorPalette.container.border.warning": {
    "value": "var(--ids-colors-color-palette-container-border-warning)",
    "variable": "var(--ids-colors-color-palette-container-border-warning)"
  },
  "colors.colorPalette.border.warning": {
    "value": "var(--ids-colors-color-palette-border-warning)",
    "variable": "var(--ids-colors-color-palette-border-warning)"
  },
  "colors.colorPalette.warning": {
    "value": "var(--ids-colors-color-palette-warning)",
    "variable": "var(--ids-colors-color-palette-warning)"
  },
  "colors.colorPalette.container.border.warningHover": {
    "value": "var(--ids-colors-color-palette-container-border-warning-hover)",
    "variable": "var(--ids-colors-color-palette-container-border-warning-hover)"
  },
  "colors.colorPalette.border.warningHover": {
    "value": "var(--ids-colors-color-palette-border-warning-hover)",
    "variable": "var(--ids-colors-color-palette-border-warning-hover)"
  },
  "colors.colorPalette.warningHover": {
    "value": "var(--ids-colors-color-palette-warning-hover)",
    "variable": "var(--ids-colors-color-palette-warning-hover)"
  },
  "colors.colorPalette.container.border.warningFocus": {
    "value": "var(--ids-colors-color-palette-container-border-warning-focus)",
    "variable": "var(--ids-colors-color-palette-container-border-warning-focus)"
  },
  "colors.colorPalette.border.warningFocus": {
    "value": "var(--ids-colors-color-palette-border-warning-focus)",
    "variable": "var(--ids-colors-color-palette-border-warning-focus)"
  },
  "colors.colorPalette.warningFocus": {
    "value": "var(--ids-colors-color-palette-warning-focus)",
    "variable": "var(--ids-colors-color-palette-warning-focus)"
  },
  "colors.colorPalette.container.border.success": {
    "value": "var(--ids-colors-color-palette-container-border-success)",
    "variable": "var(--ids-colors-color-palette-container-border-success)"
  },
  "colors.colorPalette.border.success": {
    "value": "var(--ids-colors-color-palette-border-success)",
    "variable": "var(--ids-colors-color-palette-border-success)"
  },
  "colors.colorPalette.success": {
    "value": "var(--ids-colors-color-palette-success)",
    "variable": "var(--ids-colors-color-palette-success)"
  },
  "colors.colorPalette.container.border.successHover": {
    "value": "var(--ids-colors-color-palette-container-border-success-hover)",
    "variable": "var(--ids-colors-color-palette-container-border-success-hover)"
  },
  "colors.colorPalette.border.successHover": {
    "value": "var(--ids-colors-color-palette-border-success-hover)",
    "variable": "var(--ids-colors-color-palette-border-success-hover)"
  },
  "colors.colorPalette.successHover": {
    "value": "var(--ids-colors-color-palette-success-hover)",
    "variable": "var(--ids-colors-color-palette-success-hover)"
  },
  "colors.colorPalette.container.border.successFocus": {
    "value": "var(--ids-colors-color-palette-container-border-success-focus)",
    "variable": "var(--ids-colors-color-palette-container-border-success-focus)"
  },
  "colors.colorPalette.border.successFocus": {
    "value": "var(--ids-colors-color-palette-border-success-focus)",
    "variable": "var(--ids-colors-color-palette-border-success-focus)"
  },
  "colors.colorPalette.successFocus": {
    "value": "var(--ids-colors-color-palette-success-focus)",
    "variable": "var(--ids-colors-color-palette-success-focus)"
  },
  "colors.colorPalette.container.icon.error": {
    "value": "var(--ids-colors-color-palette-container-icon-error)",
    "variable": "var(--ids-colors-color-palette-container-icon-error)"
  },
  "colors.colorPalette.icon.error": {
    "value": "var(--ids-colors-color-palette-icon-error)",
    "variable": "var(--ids-colors-color-palette-icon-error)"
  },
  "colors.colorPalette.container.icon.warning": {
    "value": "var(--ids-colors-color-palette-container-icon-warning)",
    "variable": "var(--ids-colors-color-palette-container-icon-warning)"
  },
  "colors.colorPalette.icon.warning": {
    "value": "var(--ids-colors-color-palette-icon-warning)",
    "variable": "var(--ids-colors-color-palette-icon-warning)"
  },
  "colors.colorPalette.container.icon.success": {
    "value": "var(--ids-colors-color-palette-container-icon-success)",
    "variable": "var(--ids-colors-color-palette-container-icon-success)"
  },
  "colors.colorPalette.icon.success": {
    "value": "var(--ids-colors-color-palette-icon-success)",
    "variable": "var(--ids-colors-color-palette-icon-success)"
  },
  "colors.colorPalette.container.text.disabled": {
    "value": "var(--ids-colors-color-palette-container-text-disabled)",
    "variable": "var(--ids-colors-color-palette-container-text-disabled)"
  },
  "colors.colorPalette.text.disabled": {
    "value": "var(--ids-colors-color-palette-text-disabled)",
    "variable": "var(--ids-colors-color-palette-text-disabled)"
  },
  "colors.colorPalette.container.text.errorDisabled": {
    "value": "var(--ids-colors-color-palette-container-text-error-disabled)",
    "variable": "var(--ids-colors-color-palette-container-text-error-disabled)"
  },
  "colors.colorPalette.text.errorDisabled": {
    "value": "var(--ids-colors-color-palette-text-error-disabled)",
    "variable": "var(--ids-colors-color-palette-text-error-disabled)"
  },
  "colors.colorPalette.container.text.warningDisabled": {
    "value": "var(--ids-colors-color-palette-container-text-warning-disabled)",
    "variable": "var(--ids-colors-color-palette-container-text-warning-disabled)"
  },
  "colors.colorPalette.text.warningDisabled": {
    "value": "var(--ids-colors-color-palette-text-warning-disabled)",
    "variable": "var(--ids-colors-color-palette-text-warning-disabled)"
  },
  "colors.colorPalette.container.text.successDisabled": {
    "value": "var(--ids-colors-color-palette-container-text-success-disabled)",
    "variable": "var(--ids-colors-color-palette-container-text-success-disabled)"
  },
  "colors.colorPalette.text.successDisabled": {
    "value": "var(--ids-colors-color-palette-text-success-disabled)",
    "variable": "var(--ids-colors-color-palette-text-success-disabled)"
  },
  "colors.colorPalette.iconChecked": {
    "value": "var(--ids-colors-color-palette-icon-checked)",
    "variable": "var(--ids-colors-color-palette-icon-checked)"
  },
  "colors.colorPalette.hoverBg": {
    "value": "var(--ids-colors-color-palette-hover-bg)",
    "variable": "var(--ids-colors-color-palette-hover-bg)"
  },
  "colors.colorPalette.label": {
    "value": "var(--ids-colors-color-palette-label)",
    "variable": "var(--ids-colors-color-palette-label)"
  },
  "colors.colorPalette.description": {
    "value": "var(--ids-colors-color-palette-description)",
    "variable": "var(--ids-colors-color-palette-description)"
  },
  "colors.colorPalette.endIcon": {
    "value": "var(--ids-colors-color-palette-end-icon)",
    "variable": "var(--ids-colors-color-palette-end-icon)"
  },
  "colors.colorPalette.checkedBg": {
    "value": "var(--ids-colors-color-palette-checked-bg)",
    "variable": "var(--ids-colors-color-palette-checked-bg)"
  },
  "colors.colorPalette.checkedBorder": {
    "value": "var(--ids-colors-color-palette-checked-border)",
    "variable": "var(--ids-colors-color-palette-checked-border)"
  },
  "colors.colorPalette.checkIcon": {
    "value": "var(--ids-colors-color-palette-check-icon)",
    "variable": "var(--ids-colors-color-palette-check-icon)"
  },
  "colors.colorPalette.checkedText": {
    "value": "var(--ids-colors-color-palette-checked-text)",
    "variable": "var(--ids-colors-color-palette-checked-text)"
  },
  "colors.colorPalette.track": {
    "value": "var(--ids-colors-color-palette-track)",
    "variable": "var(--ids-colors-color-palette-track)"
  },
  "colors.colorPalette.checkedTrack": {
    "value": "var(--ids-colors-color-palette-checked-track)",
    "variable": "var(--ids-colors-color-palette-checked-track)"
  },
  "colors.colorPalette.thumb": {
    "value": "var(--ids-colors-color-palette-thumb)",
    "variable": "var(--ids-colors-color-palette-thumb)"
  },
  "colors.colorPalette.trigger.bg": {
    "value": "var(--ids-colors-color-palette-trigger-bg)",
    "variable": "var(--ids-colors-color-palette-trigger-bg)"
  },
  "colors.colorPalette.trigger.border.focused": {
    "value": "var(--ids-colors-color-palette-trigger-border-focused)",
    "variable": "var(--ids-colors-color-palette-trigger-border-focused)"
  },
  "colors.colorPalette.border.focused": {
    "value": "var(--ids-colors-color-palette-border-focused)",
    "variable": "var(--ids-colors-color-palette-border-focused)"
  },
  "colors.colorPalette.focused": {
    "value": "var(--ids-colors-color-palette-focused)",
    "variable": "var(--ids-colors-color-palette-focused)"
  },
  "colors.colorPalette.trigger.border.filled": {
    "value": "var(--ids-colors-color-palette-trigger-border-filled)",
    "variable": "var(--ids-colors-color-palette-trigger-border-filled)"
  },
  "colors.colorPalette.border.filled": {
    "value": "var(--ids-colors-color-palette-border-filled)",
    "variable": "var(--ids-colors-color-palette-border-filled)"
  },
  "colors.colorPalette.filled": {
    "value": "var(--ids-colors-color-palette-filled)",
    "variable": "var(--ids-colors-color-palette-filled)"
  },
  "colors.colorPalette.trigger.border.hoverFilled": {
    "value": "var(--ids-colors-color-palette-trigger-border-hover-filled)",
    "variable": "var(--ids-colors-color-palette-trigger-border-hover-filled)"
  },
  "colors.colorPalette.border.hoverFilled": {
    "value": "var(--ids-colors-color-palette-border-hover-filled)",
    "variable": "var(--ids-colors-color-palette-border-hover-filled)"
  },
  "colors.colorPalette.hoverFilled": {
    "value": "var(--ids-colors-color-palette-hover-filled)",
    "variable": "var(--ids-colors-color-palette-hover-filled)"
  },
  "colors.colorPalette.trigger.border.hover": {
    "value": "var(--ids-colors-color-palette-trigger-border-hover)",
    "variable": "var(--ids-colors-color-palette-trigger-border-hover)"
  },
  "colors.colorPalette.trigger.text.focused": {
    "value": "var(--ids-colors-color-palette-trigger-text-focused)",
    "variable": "var(--ids-colors-color-palette-trigger-text-focused)"
  },
  "colors.colorPalette.text.focused": {
    "value": "var(--ids-colors-color-palette-text-focused)",
    "variable": "var(--ids-colors-color-palette-text-focused)"
  },
  "colors.colorPalette.valueText.filled": {
    "value": "var(--ids-colors-color-palette-value-text-filled)",
    "variable": "var(--ids-colors-color-palette-value-text-filled)"
  },
  "colors.colorPalette.indicator.color": {
    "value": "var(--ids-colors-color-palette-indicator-color)",
    "variable": "var(--ids-colors-color-palette-indicator-color)"
  },
  "colors.colorPalette.color": {
    "value": "var(--ids-colors-color-palette-color)",
    "variable": "var(--ids-colors-color-palette-color)"
  },
  "colors.colorPalette.indicator.colorFocused": {
    "value": "var(--ids-colors-color-palette-indicator-color-focused)",
    "variable": "var(--ids-colors-color-palette-indicator-color-focused)"
  },
  "colors.colorPalette.colorFocused": {
    "value": "var(--ids-colors-color-palette-color-focused)",
    "variable": "var(--ids-colors-color-palette-color-focused)"
  },
  "colors.colorPalette.clearTrigger.color": {
    "value": "var(--ids-colors-color-palette-clear-trigger-color)",
    "variable": "var(--ids-colors-color-palette-clear-trigger-color)"
  },
  "colors.colorPalette.content.bg": {
    "value": "var(--ids-colors-color-palette-content-bg)",
    "variable": "var(--ids-colors-color-palette-content-bg)"
  },
  "colors.colorPalette.item.bg.selected": {
    "value": "var(--ids-colors-color-palette-item-bg-selected)",
    "variable": "var(--ids-colors-color-palette-item-bg-selected)"
  },
  "colors.colorPalette.item.bg.selectedHover": {
    "value": "var(--ids-colors-color-palette-item-bg-selected-hover)",
    "variable": "var(--ids-colors-color-palette-item-bg-selected-hover)"
  },
  "colors.colorPalette.bg.selectedHover": {
    "value": "var(--ids-colors-color-palette-bg-selected-hover)",
    "variable": "var(--ids-colors-color-palette-bg-selected-hover)"
  },
  "colors.colorPalette.selectedHover": {
    "value": "var(--ids-colors-color-palette-selected-hover)",
    "variable": "var(--ids-colors-color-palette-selected-hover)"
  },
  "colors.colorPalette.item.color.selected": {
    "value": "var(--ids-colors-color-palette-item-color-selected)",
    "variable": "var(--ids-colors-color-palette-item-color-selected)"
  },
  "colors.colorPalette.color.selected": {
    "value": "var(--ids-colors-color-palette-color-selected)",
    "variable": "var(--ids-colors-color-palette-color-selected)"
  },
  "colors.colorPalette.item.color.hover": {
    "value": "var(--ids-colors-color-palette-item-color-hover)",
    "variable": "var(--ids-colors-color-palette-item-color-hover)"
  },
  "colors.colorPalette.color.hover": {
    "value": "var(--ids-colors-color-palette-color-hover)",
    "variable": "var(--ids-colors-color-palette-color-hover)"
  },
  "colors.colorPalette.item.iconColor.hover": {
    "value": "var(--ids-colors-color-palette-item-icon-color-hover)",
    "variable": "var(--ids-colors-color-palette-item-icon-color-hover)"
  },
  "colors.colorPalette.iconColor.hover": {
    "value": "var(--ids-colors-color-palette-icon-color-hover)",
    "variable": "var(--ids-colors-color-palette-icon-color-hover)"
  },
  "colors.colorPalette.item.iconColor.selected": {
    "value": "var(--ids-colors-color-palette-item-icon-color-selected)",
    "variable": "var(--ids-colors-color-palette-item-icon-color-selected)"
  },
  "colors.colorPalette.iconColor.selected": {
    "value": "var(--ids-colors-color-palette-icon-color-selected)",
    "variable": "var(--ids-colors-color-palette-icon-color-selected)"
  },
  "colors.colorPalette.item.indicator.color": {
    "value": "var(--ids-colors-color-palette-item-indicator-color)",
    "variable": "var(--ids-colors-color-palette-item-indicator-color)"
  },
  "colors.colorPalette.separator.color": {
    "value": "var(--ids-colors-color-palette-separator-color)",
    "variable": "var(--ids-colors-color-palette-separator-color)"
  },
  "colors.colorPalette.active.bg": {
    "value": "var(--ids-colors-color-palette-active-bg)",
    "variable": "var(--ids-colors-color-palette-active-bg)"
  },
  "colors.colorPalette.active.color": {
    "value": "var(--ids-colors-color-palette-active-color)",
    "variable": "var(--ids-colors-color-palette-active-color)"
  },
  "colors.colorPalette.active.iconColor": {
    "value": "var(--ids-colors-color-palette-active-icon-color)",
    "variable": "var(--ids-colors-color-palette-active-icon-color)"
  },
  "colors.colorPalette.iconColor": {
    "value": "var(--ids-colors-color-palette-icon-color)",
    "variable": "var(--ids-colors-color-palette-icon-color)"
  },
  "colors.colorPalette.emptyState.color": {
    "value": "var(--ids-colors-color-palette-empty-state-color)",
    "variable": "var(--ids-colors-color-palette-empty-state-color)"
  },
  "colors.colorPalette.trigger.bg.default": {
    "value": "var(--ids-colors-color-palette-trigger-bg-default)",
    "variable": "var(--ids-colors-color-palette-trigger-bg-default)"
  },
  "colors.colorPalette.trigger.bg.disabled": {
    "value": "var(--ids-colors-color-palette-trigger-bg-disabled)",
    "variable": "var(--ids-colors-color-palette-trigger-bg-disabled)"
  },
  "colors.colorPalette.trigger.placeholderColor": {
    "value": "var(--ids-colors-color-palette-trigger-placeholder-color)",
    "variable": "var(--ids-colors-color-palette-trigger-placeholder-color)"
  },
  "colors.colorPalette.placeholderColor": {
    "value": "var(--ids-colors-color-palette-placeholder-color)",
    "variable": "var(--ids-colors-color-palette-placeholder-color)"
  },
  "colors.colorPalette.icon.color": {
    "value": "var(--ids-colors-color-palette-icon-color)",
    "variable": "var(--ids-colors-color-palette-icon-color)"
  },
  "colors.colorPalette.error.bg": {
    "value": "var(--ids-colors-color-palette-error-bg)",
    "variable": "var(--ids-colors-color-palette-error-bg)"
  },
  "colors.colorPalette.error.text": {
    "value": "var(--ids-colors-color-palette-error-text)",
    "variable": "var(--ids-colors-color-palette-error-text)"
  },
  "colors.colorPalette.error.icon": {
    "value": "var(--ids-colors-color-palette-error-icon)",
    "variable": "var(--ids-colors-color-palette-error-icon)"
  },
  "colors.colorPalette.error.border": {
    "value": "var(--ids-colors-color-palette-error-border)",
    "variable": "var(--ids-colors-color-palette-error-border)"
  },
  "colors.colorPalette.error.confirmButton": {
    "value": "var(--ids-colors-color-palette-error-confirm-button)",
    "variable": "var(--ids-colors-color-palette-error-confirm-button)"
  },
  "colors.colorPalette.confirmButton": {
    "value": "var(--ids-colors-color-palette-confirm-button)",
    "variable": "var(--ids-colors-color-palette-confirm-button)"
  },
  "colors.colorPalette.error.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-error-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-error-close-button-icon)"
  },
  "colors.colorPalette.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-close-button-icon)"
  },
  "colors.colorPalette.warning.bg": {
    "value": "var(--ids-colors-color-palette-warning-bg)",
    "variable": "var(--ids-colors-color-palette-warning-bg)"
  },
  "colors.colorPalette.warning.text": {
    "value": "var(--ids-colors-color-palette-warning-text)",
    "variable": "var(--ids-colors-color-palette-warning-text)"
  },
  "colors.colorPalette.warning.icon": {
    "value": "var(--ids-colors-color-palette-warning-icon)",
    "variable": "var(--ids-colors-color-palette-warning-icon)"
  },
  "colors.colorPalette.warning.border": {
    "value": "var(--ids-colors-color-palette-warning-border)",
    "variable": "var(--ids-colors-color-palette-warning-border)"
  },
  "colors.colorPalette.warning.confirmButton": {
    "value": "var(--ids-colors-color-palette-warning-confirm-button)",
    "variable": "var(--ids-colors-color-palette-warning-confirm-button)"
  },
  "colors.colorPalette.warning.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-warning-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-warning-close-button-icon)"
  },
  "colors.colorPalette.success.bg": {
    "value": "var(--ids-colors-color-palette-success-bg)",
    "variable": "var(--ids-colors-color-palette-success-bg)"
  },
  "colors.colorPalette.success.text": {
    "value": "var(--ids-colors-color-palette-success-text)",
    "variable": "var(--ids-colors-color-palette-success-text)"
  },
  "colors.colorPalette.success.icon": {
    "value": "var(--ids-colors-color-palette-success-icon)",
    "variable": "var(--ids-colors-color-palette-success-icon)"
  },
  "colors.colorPalette.success.border": {
    "value": "var(--ids-colors-color-palette-success-border)",
    "variable": "var(--ids-colors-color-palette-success-border)"
  },
  "colors.colorPalette.success.confirmButton": {
    "value": "var(--ids-colors-color-palette-success-confirm-button)",
    "variable": "var(--ids-colors-color-palette-success-confirm-button)"
  },
  "colors.colorPalette.success.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-success-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-success-close-button-icon)"
  },
  "colors.colorPalette.info.bg": {
    "value": "var(--ids-colors-color-palette-info-bg)",
    "variable": "var(--ids-colors-color-palette-info-bg)"
  },
  "colors.colorPalette.info.text": {
    "value": "var(--ids-colors-color-palette-info-text)",
    "variable": "var(--ids-colors-color-palette-info-text)"
  },
  "colors.colorPalette.info.icon": {
    "value": "var(--ids-colors-color-palette-info-icon)",
    "variable": "var(--ids-colors-color-palette-info-icon)"
  },
  "colors.colorPalette.info.border": {
    "value": "var(--ids-colors-color-palette-info-border)",
    "variable": "var(--ids-colors-color-palette-info-border)"
  },
  "colors.colorPalette.info.confirmButton": {
    "value": "var(--ids-colors-color-palette-info-confirm-button)",
    "variable": "var(--ids-colors-color-palette-info-confirm-button)"
  },
  "colors.colorPalette.info.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-info-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-info-close-button-icon)"
  },
  "colors.colorPalette.basic.bg": {
    "value": "var(--ids-colors-color-palette-basic-bg)",
    "variable": "var(--ids-colors-color-palette-basic-bg)"
  },
  "colors.colorPalette.basic.text": {
    "value": "var(--ids-colors-color-palette-basic-text)",
    "variable": "var(--ids-colors-color-palette-basic-text)"
  },
  "colors.colorPalette.basic.icon": {
    "value": "var(--ids-colors-color-palette-basic-icon)",
    "variable": "var(--ids-colors-color-palette-basic-icon)"
  },
  "colors.colorPalette.basic.border": {
    "value": "var(--ids-colors-color-palette-basic-border)",
    "variable": "var(--ids-colors-color-palette-basic-border)"
  },
  "colors.colorPalette.basic.confirmButton": {
    "value": "var(--ids-colors-color-palette-basic-confirm-button)",
    "variable": "var(--ids-colors-color-palette-basic-confirm-button)"
  },
  "colors.colorPalette.basic.closeButtonIcon": {
    "value": "var(--ids-colors-color-palette-basic-close-button-icon)",
    "variable": "var(--ids-colors-color-palette-basic-close-button-icon)"
  },
  "colors.colorPalette.track.white": {
    "value": "var(--ids-colors-color-palette-track-white)",
    "variable": "var(--ids-colors-color-palette-track-white)"
  },
  "colors.colorPalette.white": {
    "value": "var(--ids-colors-color-palette-white)",
    "variable": "var(--ids-colors-color-palette-white)"
  },
  "colors.colorPalette.track.green": {
    "value": "var(--ids-colors-color-palette-track-green)",
    "variable": "var(--ids-colors-color-palette-track-green)"
  },
  "colors.colorPalette.track.neutral": {
    "value": "var(--ids-colors-color-palette-track-neutral)",
    "variable": "var(--ids-colors-color-palette-track-neutral)"
  },
  "colors.colorPalette.track.brand": {
    "value": "var(--ids-colors-color-palette-track-brand)",
    "variable": "var(--ids-colors-color-palette-track-brand)"
  },
  "colors.colorPalette.track.inverse": {
    "value": "var(--ids-colors-color-palette-track-inverse)",
    "variable": "var(--ids-colors-color-palette-track-inverse)"
  },
  "colors.colorPalette.indicator.white": {
    "value": "var(--ids-colors-color-palette-indicator-white)",
    "variable": "var(--ids-colors-color-palette-indicator-white)"
  },
  "colors.colorPalette.indicator.green": {
    "value": "var(--ids-colors-color-palette-indicator-green)",
    "variable": "var(--ids-colors-color-palette-indicator-green)"
  },
  "colors.colorPalette.indicator.neutral": {
    "value": "var(--ids-colors-color-palette-indicator-neutral)",
    "variable": "var(--ids-colors-color-palette-indicator-neutral)"
  },
  "colors.colorPalette.indicator.brand": {
    "value": "var(--ids-colors-color-palette-indicator-brand)",
    "variable": "var(--ids-colors-color-palette-indicator-brand)"
  },
  "colors.colorPalette.indicator.inverse": {
    "value": "var(--ids-colors-color-palette-indicator-inverse)",
    "variable": "var(--ids-colors-color-palette-indicator-inverse)"
  },
  "colors.colorPalette.line.color": {
    "value": "var(--ids-colors-color-palette-line-color)",
    "variable": "var(--ids-colors-color-palette-line-color)"
  },
  "colors.colorPalette.pinned.borderColor": {
    "value": "var(--ids-colors-color-palette-pinned-border-color)",
    "variable": "var(--ids-colors-color-palette-pinned-border-color)"
  },
  "colors.colorPalette.borderColor": {
    "value": "var(--ids-colors-color-palette-border-color)",
    "variable": "var(--ids-colors-color-palette-border-color)"
  },
  "colors.colorPalette.row.selected.bg": {
    "value": "var(--ids-colors-color-palette-row-selected-bg)",
    "variable": "var(--ids-colors-color-palette-row-selected-bg)"
  },
  "colors.colorPalette.selected.bg": {
    "value": "var(--ids-colors-color-palette-selected-bg)",
    "variable": "var(--ids-colors-color-palette-selected-bg)"
  },
  "colors.colorPalette.row.selected.outlineColor": {
    "value": "var(--ids-colors-color-palette-row-selected-outline-color)",
    "variable": "var(--ids-colors-color-palette-row-selected-outline-color)"
  },
  "colors.colorPalette.selected.outlineColor": {
    "value": "var(--ids-colors-color-palette-selected-outline-color)",
    "variable": "var(--ids-colors-color-palette-selected-outline-color)"
  },
  "colors.colorPalette.outlineColor": {
    "value": "var(--ids-colors-color-palette-outline-color)",
    "variable": "var(--ids-colors-color-palette-outline-color)"
  },
  "colors.colorPalette.cell.focus.outlineColor": {
    "value": "var(--ids-colors-color-palette-cell-focus-outline-color)",
    "variable": "var(--ids-colors-color-palette-cell-focus-outline-color)"
  },
  "colors.colorPalette.focus.outlineColor": {
    "value": "var(--ids-colors-color-palette-focus-outline-color)",
    "variable": "var(--ids-colors-color-palette-focus-outline-color)"
  },
  "colors.colorPalette.dragging.bg": {
    "value": "var(--ids-colors-color-palette-dragging-bg)",
    "variable": "var(--ids-colors-color-palette-dragging-bg)"
  },
  "colors.colorPalette.content.border": {
    "value": "var(--ids-colors-color-palette-content-border)",
    "variable": "var(--ids-colors-color-palette-content-border)"
  },
  "colors.colorPalette.day.text.default": {
    "value": "var(--ids-colors-color-palette-day-text-default)",
    "variable": "var(--ids-colors-color-palette-day-text-default)"
  },
  "colors.colorPalette.day.text.today": {
    "value": "var(--ids-colors-color-palette-day-text-today)",
    "variable": "var(--ids-colors-color-palette-day-text-today)"
  },
  "colors.colorPalette.text.today": {
    "value": "var(--ids-colors-color-palette-text-today)",
    "variable": "var(--ids-colors-color-palette-text-today)"
  },
  "colors.colorPalette.today": {
    "value": "var(--ids-colors-color-palette-today)",
    "variable": "var(--ids-colors-color-palette-today)"
  },
  "colors.colorPalette.day.text.selected": {
    "value": "var(--ids-colors-color-palette-day-text-selected)",
    "variable": "var(--ids-colors-color-palette-day-text-selected)"
  },
  "colors.colorPalette.day.text.inRange": {
    "value": "var(--ids-colors-color-palette-day-text-in-range)",
    "variable": "var(--ids-colors-color-palette-day-text-in-range)"
  },
  "colors.colorPalette.text.inRange": {
    "value": "var(--ids-colors-color-palette-text-in-range)",
    "variable": "var(--ids-colors-color-palette-text-in-range)"
  },
  "colors.colorPalette.inRange": {
    "value": "var(--ids-colors-color-palette-in-range)",
    "variable": "var(--ids-colors-color-palette-in-range)"
  },
  "colors.colorPalette.day.text.rangeEnd": {
    "value": "var(--ids-colors-color-palette-day-text-range-end)",
    "variable": "var(--ids-colors-color-palette-day-text-range-end)"
  },
  "colors.colorPalette.text.rangeEnd": {
    "value": "var(--ids-colors-color-palette-text-range-end)",
    "variable": "var(--ids-colors-color-palette-text-range-end)"
  },
  "colors.colorPalette.rangeEnd": {
    "value": "var(--ids-colors-color-palette-range-end)",
    "variable": "var(--ids-colors-color-palette-range-end)"
  },
  "colors.colorPalette.day.text.disabled": {
    "value": "var(--ids-colors-color-palette-day-text-disabled)",
    "variable": "var(--ids-colors-color-palette-day-text-disabled)"
  },
  "colors.colorPalette.day.bg.hover": {
    "value": "var(--ids-colors-color-palette-day-bg-hover)",
    "variable": "var(--ids-colors-color-palette-day-bg-hover)"
  },
  "colors.colorPalette.bg.hover": {
    "value": "var(--ids-colors-color-palette-bg-hover)",
    "variable": "var(--ids-colors-color-palette-bg-hover)"
  },
  "colors.colorPalette.day.bg.selected": {
    "value": "var(--ids-colors-color-palette-day-bg-selected)",
    "variable": "var(--ids-colors-color-palette-day-bg-selected)"
  },
  "colors.colorPalette.day.bg.inRange": {
    "value": "var(--ids-colors-color-palette-day-bg-in-range)",
    "variable": "var(--ids-colors-color-palette-day-bg-in-range)"
  },
  "colors.colorPalette.bg.inRange": {
    "value": "var(--ids-colors-color-palette-bg-in-range)",
    "variable": "var(--ids-colors-color-palette-bg-in-range)"
  },
  "colors.colorPalette.day.bg.rangeEnd": {
    "value": "var(--ids-colors-color-palette-day-bg-range-end)",
    "variable": "var(--ids-colors-color-palette-day-bg-range-end)"
  },
  "colors.colorPalette.bg.rangeEnd": {
    "value": "var(--ids-colors-color-palette-bg-range-end)",
    "variable": "var(--ids-colors-color-palette-bg-range-end)"
  },
  "colors.colorPalette.day.border.hover": {
    "value": "var(--ids-colors-color-palette-day-border-hover)",
    "variable": "var(--ids-colors-color-palette-day-border-hover)"
  },
  "colors.colorPalette.day.border.focus": {
    "value": "var(--ids-colors-color-palette-day-border-focus)",
    "variable": "var(--ids-colors-color-palette-day-border-focus)"
  },
  "colors.colorPalette.weekday.text": {
    "value": "var(--ids-colors-color-palette-weekday-text)",
    "variable": "var(--ids-colors-color-palette-weekday-text)"
  },
  "colors.colorPalette.footer.bg": {
    "value": "var(--ids-colors-color-palette-footer-bg)",
    "variable": "var(--ids-colors-color-palette-footer-bg)"
  },
  "colors.colorPalette.footer.borderTop": {
    "value": "var(--ids-colors-color-palette-footer-border-top)",
    "variable": "var(--ids-colors-color-palette-footer-border-top)"
  },
  "colors.colorPalette.borderTop": {
    "value": "var(--ids-colors-color-palette-border-top)",
    "variable": "var(--ids-colors-color-palette-border-top)"
  },
  "colors.colorPalette.gridBorderBottom.color": {
    "value": "var(--ids-colors-color-palette-grid-border-bottom-color)",
    "variable": "var(--ids-colors-color-palette-grid-border-bottom-color)"
  },
  "colors.colorPalette.input.borderOpen": {
    "value": "var(--ids-colors-color-palette-input-border-open)",
    "variable": "var(--ids-colors-color-palette-input-border-open)"
  },
  "colors.colorPalette.borderOpen": {
    "value": "var(--ids-colors-color-palette-border-open)",
    "variable": "var(--ids-colors-color-palette-border-open)"
  },
  "colors.colorPalette.input.text.default": {
    "value": "var(--ids-colors-color-palette-input-text-default)",
    "variable": "var(--ids-colors-color-palette-input-text-default)"
  },
  "colors.colorPalette.input.text.filled": {
    "value": "var(--ids-colors-color-palette-input-text-filled)",
    "variable": "var(--ids-colors-color-palette-input-text-filled)"
  },
  "colors.colorPalette.text.filled": {
    "value": "var(--ids-colors-color-palette-text-filled)",
    "variable": "var(--ids-colors-color-palette-text-filled)"
  },
  "colors.colorPalette.input.text.disabled": {
    "value": "var(--ids-colors-color-palette-input-text-disabled)",
    "variable": "var(--ids-colors-color-palette-input-text-disabled)"
  },
  "colors.colorPalette.ring": {
    "value": "var(--ids-colors-color-palette-ring)",
    "variable": "var(--ids-colors-color-palette-ring)"
  },
  "colors.colorPalette.color.base": {
    "value": "var(--ids-colors-color-palette-color-base)",
    "variable": "var(--ids-colors-color-palette-color-base)"
  },
  "colors.colorPalette.color.highlight": {
    "value": "var(--ids-colors-color-palette-color-highlight)",
    "variable": "var(--ids-colors-color-palette-color-highlight)"
  },
  "colors.colorPalette.highlight": {
    "value": "var(--ids-colors-color-palette-highlight)",
    "variable": "var(--ids-colors-color-palette-highlight)"
  },
  "colors.colorPalette.field.label": {
    "value": "var(--ids-colors-color-palette-field-label)",
    "variable": "var(--ids-colors-color-palette-field-label)"
  },
  "colors.colorPalette.scrim": {
    "value": "var(--ids-colors-color-palette-scrim)",
    "variable": "var(--ids-colors-color-palette-scrim)"
  },
  "colors.colorPalette.darken.hover": {
    "value": "var(--ids-colors-color-palette-darken-hover)",
    "variable": "var(--ids-colors-color-palette-darken-hover)"
  },
  "colors.colorPalette.darken.pressed": {
    "value": "var(--ids-colors-color-palette-darken-pressed)",
    "variable": "var(--ids-colors-color-palette-darken-pressed)"
  },
  "colors.colorPalette.pressed": {
    "value": "var(--ids-colors-color-palette-pressed)",
    "variable": "var(--ids-colors-color-palette-pressed)"
  },
  "colors.colorPalette.lighten.hover": {
    "value": "var(--ids-colors-color-palette-lighten-hover)",
    "variable": "var(--ids-colors-color-palette-lighten-hover)"
  },
  "colors.colorPalette.lighten.pressed": {
    "value": "var(--ids-colors-color-palette-lighten-pressed)",
    "variable": "var(--ids-colors-color-palette-lighten-pressed)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar